export const ModalCloseIcon = ({ onClick, className }) => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
      className={className}
      style={{ cursor: "pointer" }}
    >
      <circle cx="12.5" cy="12.5" r="12.5" fill="var(--primary-bg-color)" />
      <path
        d="M17.4348 7.56641L7.56641 17.4348"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.56517 7.56641L17.4336 17.4348"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const TooltipCloseIcon = ({
  width = "14",
  height = "14",
  onClick,
  className,
}) => {
  return (
    <svg
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      onClick={onClick}
      className={className}
      style={{ cursor: "pointer" }}
    >
      <path
        d="M15 1L1 15M1 1L15 15"
        stroke="#252525"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const SuccessIcon = ({ width = "20", height = "20" }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 66 66"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ cursor: "pointer" }}
    >
      <path
        d="M33 0C14.817 0 0 14.817 0 33C0 51.183 14.817 66 33 66C51.183 66 66 51.183 66 33C66 14.817 51.183 0 33 0ZM48.543 28.7429L32.043 45.2429C31.383 45.8699 30.558 46.2 29.7 46.2C28.842 46.2 28.017 45.8699 27.357 45.2429L17.457 35.3429C16.17 34.0559 16.17 31.9441 17.457 30.6571C18.744 29.3701 20.856 29.3701 22.143 30.6571L29.7 38.2473L43.857 24.0571C45.144 22.7701 47.256 22.7701 48.543 24.0571C49.83 25.3441 49.83 27.4559 48.543 28.7429Z"
        fill="#02BF90"
      />
    </svg>
  );
};

export const ErrorIcon = ({ width = "20", height = "20" }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 0C5.388 0 0 5.388 0 12C0 18.612 5.388 24 12 24C18.612 24 24 18.612 24 12C24 5.388 18.612 0 12 0ZM12 18C11.34 18 10.8 17.46 10.8 16.8C10.8 16.14 11.34 15.6 12 15.6C12.66 15.6 13.2 16.14 13.2 16.8C13.2 17.46 12.66 18 12 18ZM13.2 12C13.2 12.66 12.66 13.2 12 13.2C11.34 13.2 10.8 12.66 10.8 12V7.2C10.8 6.54 11.34 6 12 6C12.66 6 13.2 6.54 13.2 7.2V12Z"
        fill="#B11313"
      />
    </svg>
  );
};

export const CloseIcon = ({ fillColor, handleClick, className }) => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={handleClick}
      className={className}
      style={{ cursor: "pointer" }}
    >
      <circle cx="12.5" cy="12.5" r="12.5" fill={fillColor} />
      <path
        d="M17.4309 7.56641L7.5625 17.4348"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.56908 7.56641L17.4375 17.4348"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const BellIcon = ({ onClick }) => {
  return (
    <svg
      width="36"
      height="37"
      viewBox="0 0 36 37"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
      style={{ cursor: "pointer" }}
    >
      <rect
        y="0.75"
        width="36"
        height="36"
        rx="6"
        fill="var(--primary-bg-fade-color)"
      />
      <path
        d="M20.8357 25.05C20.8357 26.5412 19.5661 27.75 18 27.75C16.4339 27.75 15.1643 26.5412 15.1643 25.05M19.6981 13.5647C20.1097 13.1598 20.3631 12.6081 20.3631 12C20.3631 10.7574 19.3051 9.75 18 9.75C16.6949 9.75 15.6369 10.7574 15.6369 12C15.6369 12.6081 15.8903 13.1598 16.3019 13.5647M23.6714 18.03C23.6714 16.7888 23.0738 15.5984 22.0103 14.7207C20.9467 13.8431 19.5041 13.35 18 13.35C16.4959 13.35 15.0533 13.8431 13.9897 14.7207C12.9262 15.5984 12.3286 16.7888 12.3286 18.03C12.3286 20.0836 11.7938 21.5855 11.1264 22.6602C10.3657 23.8851 9.98541 24.4975 10.0004 24.6438C10.0176 24.8111 10.0492 24.864 10.1918 24.9632C10.3164 25.05 10.9425 25.05 12.1946 25.05H23.8054C25.0575 25.05 25.6836 25.05 25.8082 24.9632C25.9508 24.864 25.9824 24.8111 25.9996 24.6438C26.0146 24.4975 25.6343 23.8851 24.8736 22.6602C24.2062 21.5855 23.6714 20.0836 23.6714 18.03Z"
        stroke="var(--primary-bg-color)"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const SearchIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19 19L14.65 14.65M17 9C17 13.4183 13.4183 17 9 17C4.58172 17 1 13.4183 1 9C1 4.58172 4.58172 1 9 1C13.4183 1 17 4.58172 17 9Z"
        stroke="var(--primary-bg-color)"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const EyeIcon = ({ onClick }) => {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
      style={{ cursor: "pointer" }}
    >
      <rect width="28" height="28" rx="6" fill="var(--primary-bg-fade-color)" />
      <path
        d="M7.18763 14.4847C7.09079 14.3314 7.04237 14.2547 7.01527 14.1364C6.99491 14.0476 6.99491 13.9075 7.01527 13.8187C7.04237 13.7005 7.09079 13.6238 7.18763 13.4704C7.98789 12.2033 10.3699 9 14 9C17.6301 9 20.0121 12.2033 20.8124 13.4704C20.9092 13.6238 20.9576 13.7005 20.9847 13.8187C21.0051 13.9075 21.0051 14.0476 20.9847 14.1364C20.9576 14.2547 20.9092 14.3314 20.8124 14.4847C20.0121 15.7518 17.6301 18.9551 14 18.9551C10.3699 18.9551 7.98789 15.7518 7.18763 14.4847Z"
        stroke="var(--primary-bg-color)"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14 16.1108C15.1782 16.1108 16.1332 15.1557 16.1332 13.9776C16.1332 12.7994 15.1782 11.8443 14 11.8443C12.8218 11.8443 11.8668 12.7994 11.8668 13.9776C11.8668 15.1557 12.8218 16.1108 14 16.1108Z"
        stroke="var(--primary-bg-color)"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const EditIcon = ({ onClick }) => {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
      style={{ cursor: "pointer" }}
    >
      <rect width="28" height="28" rx="6" fill="#E6E6E6" />
      <path
        d="M13.262 8.47597H10.3397C9.17072 8.47597 8.58621 8.47597 8.13971 8.70348C7.74695 8.9036 7.42763 9.22292 7.22751 9.61568C7 10.0622 7 10.6467 7 11.8157V17.6603C7 18.8293 7 19.4138 7.22751 19.8603C7.42763 20.2531 7.74695 20.5724 8.13971 20.7725C8.58621 21 9.17072 21 10.3397 21H16.1843C17.3533 21 17.9378 21 18.3843 20.7725C18.7771 20.5724 19.0964 20.2531 19.2965 19.8603C19.524 19.4138 19.524 18.8293 19.524 17.6603V14.738M11.1747 16.8253H12.3398C12.6801 16.8253 12.8503 16.8253 13.0105 16.7869C13.1525 16.7528 13.2882 16.6966 13.4127 16.6203C13.5531 16.5342 13.6735 16.4139 13.9141 16.1732L20.5677 9.51964C21.1441 8.94324 21.1441 8.0087 20.5677 7.4323C19.9913 6.8559 19.0568 6.8559 18.4804 7.4323L11.8268 14.0859C11.5861 14.3265 11.4658 14.4469 11.3797 14.5873C11.3034 14.7118 11.2472 14.8475 11.2131 14.9895C11.1747 15.1497 11.1747 15.3199 11.1747 15.6602V16.8253Z"
        stroke="#4A4759"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const DeleteIcon = ({ onClick }) => {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
      style={{ cursor: "pointer" }}
    >
      <rect width="28" height="28" rx="6" fill="#FFC5C8" />
      <path
        d="M11.6667 7H16.3333M7 9.33333H21M19.4444 9.33333L18.899 17.515C18.8172 18.7425 18.7762 19.3563 18.5111 19.8217C18.2777 20.2314 17.9256 20.5608 17.5013 20.7664C17.0193 21 16.4042 21 15.1739 21H12.8261C11.5958 21 10.9807 21 10.4987 20.7664C10.0744 20.5608 9.72229 20.2314 9.48888 19.8217C9.22375 19.3563 9.18284 18.7425 9.101 17.515L8.55556 9.33333M12.4444 12.8333V16.7222M15.5556 12.8333V16.7222"
        stroke="#E4222D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const DownArrowIcon = ({ customClass }) => {
  return (
    <svg
      width="11"
      height="8"
      viewBox="0 0 12 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={customClass}
    >
      <path
        d="M1 1L6 7L11 1"
        stroke="#4A4759"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const UpArrowIcon = ({ customClass }) => {
  return (
    <svg
      width="11"
      height="13"
      viewBox="0 0 12 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={customClass}
    >
      <path
        d="M11 10L6 4L1 10"
        stroke="#4A4759"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const DashbordIcon = ({ customClass }) => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={customClass}
    >
      <path
        d="M7.39443 1.31846C7.16938 1.14343 7.05685 1.05591 6.9326 1.02226C6.82296 0.992579 6.70741 0.992579 6.59777 1.02226C6.47352 1.05591 6.36099 1.14343 6.13594 1.31846L1.79136 4.69758C1.50094 4.92346 1.35574 5.0364 1.25112 5.17784C1.15846 5.30313 1.08943 5.44428 1.04742 5.59434C1 5.76375 1 5.94771 1 6.31563V10.9502C1 11.6677 1 12.0264 1.13964 12.3005C1.26247 12.5415 1.45846 12.7375 1.69952 12.8604C1.97357 13 2.33233 13 3.04984 13H4.331C4.51037 13 4.60006 13 4.66858 12.9651C4.72884 12.9344 4.77784 12.8854 4.80855 12.8251C4.84346 12.7566 4.84346 12.6669 4.84346 12.4875V8.25974C4.84346 7.90098 4.84346 7.7216 4.91328 7.58458C4.97469 7.46404 5.07268 7.36605 5.19322 7.30463C5.33024 7.23482 5.50962 7.23482 5.86838 7.23482H7.66199C8.02075 7.23482 8.20013 7.23482 8.33715 7.30463C8.45768 7.36605 8.55568 7.46404 8.61709 7.58458C8.68691 7.7216 8.68691 7.90098 8.68691 8.25974V12.4875C8.68691 12.6669 8.68691 12.7566 8.72182 12.8251C8.75253 12.8854 8.80153 12.9344 8.86179 12.9651C8.93031 13 9.02 13 9.19937 13H10.4805C11.198 13 11.5568 13 11.8308 12.8604C12.0719 12.7375 12.2679 12.5415 12.3907 12.3005C12.5304 12.0264 12.5304 11.6677 12.5304 10.9502V6.31563C12.5304 5.94771 12.5304 5.76375 12.4829 5.59434C12.4409 5.44428 12.3719 5.30313 12.2792 5.17784C12.1746 5.0364 12.0294 4.92346 11.739 4.69758L7.39443 1.31846Z"
        stroke="#4A4759"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const UserManagementIcon = () => {
  return (
    <svg
      width="14"
      height="13"
      viewBox="0 0 14 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13 11.8V10.6C13 9.4817 12.2351 8.54204 11.2 8.27561M9.1 1.17446C9.97955 1.53049 10.6 2.39279 10.6 3.4C10.6 4.40721 9.97955 5.26951 9.1 5.62555M10 11.8C10 10.6817 10 10.1226 9.81731 9.68156C9.57373 9.09349 9.10651 8.62627 8.51844 8.38269C8.07739 8.2 7.51826 8.2 6.4 8.2H4.6C3.48174 8.2 2.92261 8.2 2.48156 8.38269C1.89349 8.62627 1.42627 9.09349 1.18269 9.68156C1 10.1226 1 10.6817 1 11.8M7.9 3.4C7.9 4.72548 6.82548 5.8 5.5 5.8C4.17452 5.8 3.1 4.72548 3.1 3.4C3.1 2.07452 4.17452 1 5.5 1C6.82548 1 7.9 2.07452 7.9 3.4Z"
        stroke="#4A4759"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const EstlablishmentIcon = () => {
  return (
    <svg
      width="13"
      height="14"
      viewBox="0 0 13 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.81007 11.4227L5.16074 12.2113C5.26498 12.4461 5.43511 12.6456 5.65047 12.7856C5.86584 12.9256 6.1172 13 6.37407 13C6.63094 13 6.8823 12.9256 7.09767 12.7856C7.31304 12.6456 7.48316 12.4461 7.5874 12.2113L7.93807 11.4227C8.0629 11.1428 8.27287 10.9095 8.53807 10.756C8.80494 10.6021 9.11367 10.5365 9.42007 10.5687L10.2781 10.66C10.5335 10.687 10.7912 10.6394 11.0201 10.5228C11.2489 10.4062 11.4391 10.2258 11.5674 10.0033C11.6959 9.78101 11.7571 9.52617 11.7436 9.26973C11.7302 9.01329 11.6425 8.76628 11.4914 8.55867L10.9834 7.86067C10.8025 7.61028 10.7059 7.30889 10.7074 7C10.7073 6.69195 10.8049 6.39181 10.9861 6.14267L11.4941 5.44467C11.6452 5.23705 11.7328 4.99004 11.7463 4.7336C11.7598 4.47717 11.6986 4.22232 11.5701 4C11.4417 3.77754 11.2516 3.59709 11.0227 3.48054C10.7939 3.36398 10.5361 3.31632 10.2807 3.34333L9.42274 3.43467C9.11634 3.46685 8.80761 3.40127 8.54074 3.24733C8.27501 3.09295 8.06498 2.85841 7.94074 2.57733L7.5874 1.78867C7.48316 1.5539 7.31304 1.35443 7.09767 1.21444C6.8823 1.07445 6.63094 0.999958 6.37407 1C6.1172 0.999958 5.86584 1.07445 5.65047 1.21444C5.43511 1.35443 5.26498 1.5539 5.16074 1.78867L4.81007 2.57733C4.68583 2.85841 4.4758 3.09295 4.21007 3.24733C3.9432 3.40127 3.63447 3.46685 3.32807 3.43467L2.46741 3.34333C2.212 3.31632 1.95425 3.36398 1.72539 3.48054C1.49654 3.59709 1.30641 3.77754 1.17807 4C1.04956 4.22232 0.988342 4.47717 1.00183 4.7336C1.01532 4.99004 1.10295 5.23705 1.25407 5.44467L1.76207 6.14267C1.94324 6.39181 2.04079 6.69195 2.04074 7C2.04079 7.30805 1.94324 7.60819 1.76207 7.85733L1.25407 8.55533C1.10295 8.76295 1.01532 9.00996 1.00183 9.2664C0.988342 9.52283 1.04956 9.77768 1.17807 10C1.30654 10.2223 1.49669 10.4027 1.72551 10.5192C1.95433 10.6358 2.21202 10.6835 2.46741 10.6567L3.32541 10.5653C3.63181 10.5332 3.94053 10.5987 4.20741 10.7527C4.47412 10.9066 4.68513 11.1412 4.81007 11.4227Z"
        stroke="#4A4759"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.373 8.8C7.36711 8.8 8.173 7.99411 8.173 7C8.173 6.00589 7.36711 5.2 6.373 5.2C5.37889 5.2 4.573 6.00589 4.573 7C4.573 7.99411 5.37889 8.8 6.373 8.8Z"
        stroke="#4A4759"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const PathologyIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="14"
      viewBox="0 0 16 14"
      fill="none"
    >
      <path
        d="M11.3333 13C10.0447 13 9 11.9553 9 10.6667L9 1L13.6667 1L13.6667 10.6667C13.6667 11.9553 12.622 13 11.3333 13Z"
        stroke="#4A4759"
        strokeWidth="1.5"
      />
      <path
        d="M14.333 1L8.33301 1"
        stroke="#4A4759"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M11 3.66602L9 3.66602"
        stroke="#4A4759"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M6.33333 10.2493C6.33333 12.2744 5 12.9993 3.66667 12.9993C2.33333 12.9993 1 12.2744 1 10.2493C1 8.2243 3.66667 5.66602 3.66667 5.66602C3.66667 5.66602 6.33333 8.2243 6.33333 10.2493Z"
        stroke="#4A4759"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        d="M9 6.99935C9.72202 6.42173 10.5316 5.58497 11.514 6.1744C12.3343 6.66659 13.0228 6.14894 13.6667 5.66602"
        stroke="#4A4759"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const DropDownIcon = ({ fillColor, handleClick, customClass }) => {
  return (
    <svg
      width="14"
      height="8"
      viewBox="0 0 14 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={(e) => {
        handleClick && handleClick(e);
      }}
      className={customClass}
      style={{ cursor: "pointer" }}
    >
      <path
        d="M2 0.000395298L7.293 5.2934L12.586 0.000395298L14 1.4144L8.707 6.7074C8.33194 7.08234 7.82333 7.29297 7.293 7.29297C6.76267 7.29297 6.25406 7.08234 5.879 6.7074L0.585998 1.4144L2 0.000395298Z"
        fill={fillColor}
      />
    </svg>
  );
};

export const LeftSideArrowIcon = ({ fillColor, customClass, handleClick }) => {
  return (
    <svg
      width="6"
      height="10"
      viewBox="0 0 6 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={customClass}
      onClick={handleClick}
      style={{ cursor: "pointer" }}
    >
      <path
        d="M5 9L1 5L5 1"
        stroke={fillColor ? fillColor : "black"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const RightSideArrowIcon = ({ fillColor, customClass, handleClick }) => {
  return (
    <svg
      width="6"
      height="10"
      viewBox="0 0 6 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={customClass}
      onClick={handleClick}
      style={{ cursor: "pointer" }}
    >
      <path
        d="M0.999999 1L5 5L1 9"
        stroke={fillColor ? fillColor : "black"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const MasterDataIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
    >
      <path
        d="M1 7C1 4.17157 1 2.75736 1.87868 1.87868C2.75736 1 4.17157 1 7 1C9.82843 1 11.2426 1 12.1213 1.87868C13 2.75736 13 4.17157 13 7C13 9.82843 13 11.2426 12.1213 12.1213C11.2426 13 9.82843 13 7 13C4.17157 13 2.75736 13 1.87868 12.1213C1 11.2426 1 9.82843 1 7Z"
        stroke="#4A4759"
        strokeWidth="1.5"
      />
      <path
        d="M1 7H13"
        stroke="#4A4759"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7 4L10 4"
        stroke="#4A4759"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7 10L10 10"
        stroke="#4A4759"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4 4L4.0001 4"
        stroke="#4A4759"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4 10L4.0001 10"
        stroke="#4A4759"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const LogOutIcon = () => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.66667 10.3333L13 7M13 7L9.66667 3.66667M13 7H5M5 1H4.2C3.0799 1 2.51984 1 2.09202 1.21799C1.7157 1.40973 1.40973 1.71569 1.21799 2.09202C1 2.51984 1 3.07989 1 4.2V9.8C1 10.9201 1 11.4802 1.21799 11.908C1.40973 12.2843 1.71569 12.5903 2.09202 12.782C2.51984 13 3.0799 13 4.2 13H5"
        stroke="#4A4759"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const SelectSearchIcon = () => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.3008 10.3008L13.0008 13.0008"
        stroke="#74788D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.8 6.4C11.8 3.41766 9.38234 1 6.4 1C3.41766 1 1 3.41766 1 6.4C1 9.38234 3.41766 11.8 6.4 11.8C9.38234 11.8 11.8 9.38234 11.8 6.4Z"
        stroke="#74788D"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const HiddenEyeIcon = ({ onClick }) => {
  return (
    <svg
      width="20"
      height="16"
      viewBox="0 0 22 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
      style={{ cursor: "pointer" }}
    >
      <path
        d="M9.74294 3.09232C10.1494 3.03223 10.5686 3 11.0004 3C16.1054 3 19.4553 7.50484 20.5807 9.28682C20.7169 9.5025 20.785 9.61034 20.8231 9.77667C20.8518 9.90159 20.8517 10.0987 20.8231 10.2236C20.7849 10.3899 20.7164 10.4985 20.5792 10.7156C20.2793 11.1901 19.8222 11.8571 19.2165 12.5805M5.72432 4.71504C3.56225 6.1817 2.09445 8.21938 1.42111 9.28528C1.28428 9.50187 1.21587 9.61016 1.17774 9.77648C1.1491 9.9014 1.14909 10.0984 1.17771 10.2234C1.21583 10.3897 1.28393 10.4975 1.42013 10.7132C2.54554 12.4952 5.89541 17 11.0004 17C13.0588 17 14.8319 16.2676 16.2888 15.2766M2.00042 1L20.0004 19M8.8791 7.87868C8.3362 8.42157 8.00042 9.17157 8.00042 10C8.00042 11.6569 9.34356 13 11.0004 13C11.8288 13 12.5788 12.6642 13.1217 12.1213"
        stroke="#7A7A7A"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const PasswordEyeIcon = ({ onClick }) => {
  return (
    <svg
      width="20"
      height="16"
      viewBox="0 0 22 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ cursor: "pointer" }}
      onClick={onClick}
    >
      <path
        d="M1.42012 8.71318C1.28394 8.49754 1.21584 8.38972 1.17772 8.22342C1.14909 8.0985 1.14909 7.9015 1.17772 7.77658C1.21584 7.61028 1.28394 7.50246 1.42012 7.28682C2.54553 5.50484 5.8954 1 11.0004 1C16.1054 1 19.4553 5.50484 20.5807 7.28682C20.7169 7.50246 20.785 7.61028 20.8231 7.77658C20.8517 7.9015 20.8517 8.0985 20.8231 8.22342C20.785 8.38972 20.7169 8.49754 20.5807 8.71318C19.4553 10.4952 16.1054 15 11.0004 15C5.8954 15 2.54553 10.4952 1.42012 8.71318Z"
        stroke="#7A7A7A"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.0004 11C12.6573 11 14.0004 9.65685 14.0004 8C14.0004 6.34315 12.6573 5 11.0004 5C9.34355 5 8.0004 6.34315 8.0004 8C8.0004 9.65685 9.34355 11 11.0004 11Z"
        stroke="#7A7A7A"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ActiveToggleSwitch = ({ onClick }) => {
  return (
    <svg
      width="40"
      height="20"
      viewBox="0 0 49 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ cursor: "pointer" }}
      onClick={onClick}
    >
      <rect width="49" height="28" rx="14" fill="var(--primary-bg-color)" />
      <circle cx="35" cy="14" r="12" fill="white" />
    </svg>
  );
};

export const ToggleOffIcon = ({ onClick }) => {
  return (
    <svg
      width="40"
      height="20"
      viewBox="0 0 49 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ cursor: "pointer" }}
      onClick={onClick}
    >
      <rect width="49" height="28" rx="14" fill="#DCDBDB" />
      <circle cx="14" cy="14" r="12" fill="white" />
    </svg>
  );
};

export const InfoIcon = ({ onClick, stroke = "#959595" }) => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
      style={{ cursor: "pointer" }}
    >
      <path
        d="M11 15V11M11 7H11.01M21 11C21 16.5228 16.5228 21 11 21C5.47715 21 1 16.5228 1 11C1 5.47715 5.47715 1 11 1C16.5228 1 21 5.47715 21 11Z"
        stroke={stroke}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const BookMarkIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="24" height="24" rx="8" fill="#F8F9FA" />
      <path
        d="M9.49935 20.3337H14.4993C18.666 20.3337 20.3327 18.667 20.3327 14.5003V9.50033C20.3327 5.33366 18.666 3.66699 14.4993 3.66699H9.49935C5.33268 3.66699 3.66602 5.33366 3.66602 9.50033V14.5003C3.66602 18.667 5.33268 20.3337 9.49935 20.3337Z"
        stroke="#004A54"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.1673 4.0332V12.3499C16.1673 13.9915 14.9923 14.6332 13.5507 13.7665L12.4507 13.1082C12.2007 12.9582 11.8007 12.9582 11.5507 13.1082L10.4507 13.7665C9.00898 14.6249 7.83398 13.9915 7.83398 12.3499V4.0332"
        stroke="#004A54"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.49935 20.3337H14.4993C18.666 20.3337 20.3327 18.667 20.3327 14.5003V9.50033C20.3327 5.33366 18.666 3.66699 14.4993 3.66699H9.49935C5.33268 3.66699 3.66602 5.33366 3.66602 9.50033V14.5003C3.66602 18.667 5.33268 20.3337 9.49935 20.3337Z"
        stroke="#004A54"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.1673 4.0332V12.3499C16.1673 13.9915 14.9923 14.6332 13.5507 13.7665L12.4507 13.1082C12.2007 12.9582 11.8007 12.9582 11.5507 13.1082L10.4507 13.7665C9.00898 14.6249 7.83398 13.9915 7.83398 12.3499V4.0332"
        fill="#DBF2EB"
      />
      <path
        d="M16.1673 4.0332V12.3499C16.1673 13.9915 14.9923 14.6332 13.5507 13.7665L12.4507 13.1082C12.2007 12.9582 11.8007 12.9582 11.5507 13.1082L10.4507 13.7665C9.00898 14.6249 7.83398 13.9915 7.83398 12.3499V4.0332"
        stroke="#004A54"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ToogleIcon = ({ onClick, customClass }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="34"
      height="25"
      viewBox="0 0 34 25"
      fill="none"
      onClick={onClick}
      style={{ cursor: "pointer" }}
      className={customClass}
    >
      <g filter="url(#filter0_i_1979_13258)">
        <rect
          y="0.0996094"
          width="33"
          height="19.8"
          rx="9.9"
          fill="var(--primary-bg-color)"
        />
      </g>
      <g filter="url(#filter1_d_1979_13258)">
        <rect x="16" y="3" width="14" height="14" rx="7" fill="white" />
      </g>
      <defs>
        <filter
          id="filter0_i_1979_13258"
          x="0"
          y="0.0996094"
          width="33"
          height="20.7998"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1.5" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_1979_13258"
          />
        </filter>
        <filter
          id="filter1_d_1979_13258"
          x="12"
          y="3"
          width="22"
          height="22"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1979_13258"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_1979_13258"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};
export const PlusIcon = ({ onClick, customClass }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      onClick={onClick}
      style={{ cursor: "pointer" }}
      className={customClass}
    >
      <circle cx="12.5" cy="12.5" r="12.5" fill="var(--primary-bg-color)" />
      <path
        d="M12.5015 5.52197L12.5015 19.478"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.52197 12.5015L19.478 12.5015"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const MinusIcon = ({ onClick, customClass }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      onClick={onClick}
      style={{ cursor: "pointer" }}
      className={customClass}
    >
      <circle cx="12.5" cy="12.5" r="12.5" fill="#E4222D" />
      <path
        d="M5.52197 12.5015L19.478 12.5015"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const UploadIcon = () => {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="69"
        height="60"
        viewBox="0 0 69 60"
        fill="none"
      >
        <path
          d="M36.1384 14.7458L36.2306 14.7733L36.2346 14.7688C36.6723 14.8481 37.1065 14.586 37.2351 14.1519C38.4067 10.2152 42.0978 7.46504 46.2102 7.46504C46.6971 7.46504 47.0919 7.07016 47.0919 6.5833C47.0919 6.09643 46.697 5.70156 46.2102 5.70156C41.156 5.70156 36.9089 9.06665 35.5451 13.6493C35.406 14.1162 35.6719 14.6067 36.1384 14.7458Z"
          fill="var(--primary-bg-color)"
          stroke="#F9FFF9"
          strokeWidth="0.3"
        />
        <path
          d="M56.4531 42.4384H52.0628C51.6588 42.4384 51.3311 42.1107 51.3311 41.7067C51.3311 41.3027 51.6588 40.9749 52.0628 40.9749H56.4531C62.505 40.9749 67.4291 36.0509 67.4291 29.999C67.4291 23.9471 62.505 19.023 56.4531 19.023H56.3475C56.1354 19.023 55.9336 18.9311 55.7946 18.7706C55.6555 18.6101 55.5928 18.3974 55.6231 18.1873C55.6885 17.7315 55.7214 17.2737 55.7214 16.8279C55.7214 11.5829 51.4538 7.31531 46.2089 7.31531C44.1684 7.31531 42.2225 7.95296 40.5812 9.15978C40.2206 9.42478 39.7084 9.30718 39.4999 8.91047C34.8518 0.0596993 22.7117 -1.12887 16.4176 6.57053C13.7662 9.81417 12.7244 14.0336 13.5592 18.146C13.6512 18.6002 13.3036 19.0236 12.8421 19.0236H12.5489C6.49697 19.0236 1.57291 23.9477 1.57291 29.9996C1.57291 36.0514 6.49697 40.9755 12.5489 40.9755H16.9392C17.3432 40.9755 17.6709 41.3032 17.6709 41.7072C17.6709 42.1113 17.3432 42.439 16.9392 42.439H12.5489C5.68988 42.439 0.109375 36.8585 0.109375 29.9995C0.109375 23.3329 5.38093 17.8742 11.9744 17.5731C11.3551 13.3066 12.5395 9.00295 15.2844 5.64437C22.0231 -2.5996 34.9374 -1.67556 40.3965 7.51707C42.1381 6.42522 44.1309 5.85244 46.2086 5.85244C52.5632 5.85244 57.5985 11.261 57.1579 17.58C63.6907 17.9463 68.8923 23.3763 68.8923 29.999C68.8923 36.8585 63.3118 42.4384 56.4528 42.4384L56.4531 42.4384Z"
          fill="var(--primary-bg-color)"
        />
        <path
          d="M15.9594 41.2935C15.9594 51.4634 24.233 59.737 34.4029 59.737C44.5728 59.737 52.8463 51.4633 52.8463 41.2935C52.8463 31.1235 44.5728 22.85 34.4029 22.85C24.2329 22.85 15.9594 31.1237 15.9594 41.2935ZM17.7232 41.2935C17.7232 32.0966 25.2058 24.6138 34.4029 24.6138C43.5998 24.6138 51.0825 32.0964 51.0825 41.2935C51.0825 50.4904 43.5998 57.9732 34.4029 57.9732C25.206 57.9732 17.7232 50.4905 17.7232 41.2935Z"
          fill="var(--primary-bg-color)"
          stroke="#F9FFF9"
          strokeWidth="0.3"
        />
        <path
          d="M34.7369 49.1934C34.4411 49.1934 34.2012 48.9534 34.2012 48.6577V34.7291C34.2012 34.4333 34.4411 34.1934 34.7369 34.1934C35.0327 34.1934 35.2726 34.4333 35.2726 34.7291V48.6577C35.2726 48.9538 35.0327 49.1934 34.7369 49.1934Z"
          fill="var(--primary-bg-color)"
        />
        <path
          d="M39.0231 39.5525C38.8862 39.5525 38.7488 39.5 38.6443 39.3956L34.7375 35.4887L30.8306 39.3956C30.6217 39.6049 30.2823 39.6049 30.073 39.3956C29.8637 39.1863 29.8637 38.8472 30.073 38.6379L34.3586 34.3523C34.5676 34.143 34.907 34.143 35.1163 34.3523L39.4019 38.6379C39.6112 38.8472 39.6112 39.1863 39.4019 39.3956C39.2975 39.5004 39.1601 39.5525 39.0231 39.5525H39.0231Z"
          fill="var(--primary-bg-color)"
        />
      </svg>
    </>
  );
};

export const ToogleOffIcon = ({ onClick }) => {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="34"
        height="20"
        viewBox="0 0 34 20"
        fill="none"
        style={{ cursor: "pointer" }}
        onClick={onClick}
      >
        <g filter="url(#filter0_i_1979_13263)">
          <rect
            x="0.0618896"
            y="0.0996094"
            width="33"
            height="19.8"
            rx="9.9"
            fill="#CBCBCB"
          />
        </g>
        <rect x="3.06189" y="3" width="14" height="14" rx="7" fill="white" />
        <defs>
          <filter
            id="filter0_i_1979_13263"
            x="0.0618896"
            y="0.0996094"
            width="33"
            height="20.8008"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="BackgroundImageFix"
              result="shape"
            />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="1" />
            <feGaussianBlur stdDeviation="1.5" />
            <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
            />
            <feBlend
              mode="normal"
              in2="shape"
              result="effect1_innerShadow_1979_13263"
            />
          </filter>
        </defs>
      </svg>
    </>
  );
};
export const SpecialtyIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
    >
      <path
        d="M1 7C1 4.17157 1 2.75736 1.87868 1.87868C2.75736 1 4.17157 1 7 1C9.82843 1 11.2426 1 12.1213 1.87868C13 2.75736 13 4.17157 13 7C13 9.82843 13 11.2426 12.1213 12.1213C11.2426 13 9.82843 13 7 13C4.17157 13 2.75736 13 1.87868 12.1213C1 11.2426 1 9.82843 1 7Z"
        stroke="#4A4759"
        strokeWidth="1.5"
      />
      <path
        d="M1 7H13"
        stroke="#4A4759"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7 4L10 4"
        stroke="#4A4759"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7 10L10 10"
        stroke="#4A4759"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4 4L4.0001 4"
        stroke="#4A4759"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4 10L4.0001 10"
        stroke="#4A4759"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const MaterialsIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
    >
      <path
        d="M1 7C1 4.17157 1 2.75736 1.87868 1.87868C2.75736 1 4.17157 1 7 1C9.82843 1 11.2426 1 12.1213 1.87868C13 2.75736 13 4.17157 13 7C13 9.82843 13 11.2426 12.1213 12.1213C11.2426 13 9.82843 13 7 13C4.17157 13 2.75736 13 1.87868 12.1213C1 11.2426 1 9.82843 1 7Z"
        stroke="#4A4759"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        d="M5.73653 9.21104C5.73653 9.73426 5.31238 10.1584 4.78917 10.1584C4.26595 10.1584 3.8418 9.73426 3.8418 9.21104C3.8418 8.68782 4.26595 8.26367 4.78917 8.26367C5.31238 8.26367 5.73653 8.68782 5.73653 9.21104Z"
        stroke="#4A4759"
        strokeWidth="1.5"
      />
      <path
        d="M10.1584 4.78896C10.1584 4.26574 9.73426 3.84159 9.21104 3.84159C8.68782 3.84159 8.26367 4.26574 8.26367 4.78896C8.26367 5.31218 8.68782 5.73633 9.21104 5.73633C9.73426 5.73633 10.1584 5.31218 10.1584 4.78896Z"
        stroke="#4A4759"
        strokeWidth="1.5"
      />
      <path
        d="M4.78906 8.26285V3.8418"
        stroke="#4A4759"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M9.21094 5.73715V10.1582"
        stroke="#4A4759"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
};
export const TreatmentIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="14"
      viewBox="0 0 16 14"
      fill="none"
    >
      <path
        d="M1 7.375C1 5.31261 1 4.28141 1.68342 3.6407C2.36683 3 3.46678 3 5.66667 3H9.66667C11.8666 3 12.9665 3 13.6499 3.6407C14.3333 4.28141 14.3333 5.31261 14.3333 7.375V8.625C14.3333 10.6874 14.3333 11.7186 13.6499 12.3593C12.9665 13 11.8666 13 9.66667 13H5.66667C3.46678 13 2.36683 13 1.68342 12.3593C1 11.7186 1 10.6874 1 8.625V7.375Z"
        stroke="#4A4759"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.66602 8H9.66602M7.66602 6L7.66602 10"
        stroke="#4A4759"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.0007 3C11.0007 1.34533 10.6553 1 9.00065 1H6.33398C4.67932 1 4.33398 1.34533 4.33398 3"
        stroke="#4A4759"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const ComplimentaryExaminationsIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="13"
      height="16"
      viewBox="0 0 13 16"
      fill="none"
    >
      <path
        d="M7.875 1.18867V4.08005C7.875 4.47209 7.875 4.6681 7.94993 4.81784C8.01585 4.94956 8.12102 5.05664 8.25038 5.12375C8.39745 5.20005 8.58996 5.20005 8.975 5.20005H11.8147M9.25 8.7H3.75M9.25 11.5H3.75M5.125 5.9H3.75M7.875 1H4.3C3.14489 1 2.56734 1 2.12614 1.22889C1.73806 1.43022 1.42254 1.75148 1.2248 2.14662C1 2.59583 1 3.18389 1 4.36V11.64C1 12.8161 1 13.4042 1.2248 13.8534C1.42254 14.2485 1.73806 14.5698 2.12614 14.7711C2.56734 15 3.14489 15 4.3 15H8.7C9.85511 15 10.4327 15 10.8739 14.7711C11.2619 14.5698 11.5775 14.2485 11.7752 13.8534C12 13.4042 12 12.8161 12 11.64V5.2L7.875 1Z"
        stroke="#4A4759"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const DomainIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
    >
      <path
        d="M6.08235 13C3.68651 13 2.48859 13 1.74429 12.2971C1 11.5941 1 10.4627 1 8.2L1 5.8C1 3.53726 1 2.40589 1.74429 1.70294C2.48859 1 3.68651 1 6.08235 1L6.71765 1C9.11349 1 10.3114 1 11.0557 1.70294C11.8 2.40589 11.8 3.53726 11.8 5.8"
        stroke="#4A4759"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M4 4H8.8"
        stroke="#4A4759"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M4 7H7.6"
        stroke="#4A4759"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M8.19922 12.9996C9.30229 11.3507 11.8705 11.2607 12.9992 12.9996M11.7992 8.75682C11.7992 9.39593 11.262 9.91403 10.5992 9.91403C9.93648 9.91403 9.39922 9.39593 9.39922 8.75682C9.39922 8.11771 9.93648 7.59961 10.5992 7.59961C11.262 7.59961 11.7992 8.11771 11.7992 8.75682Z"
        stroke="#4A4759"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const BackSideIcon = ({ handleClick }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="8"
      height="14"
      viewBox="0 0 8 14"
      fill="none"
      onClick={handleClick}
      style={{ cursor: "pointer" }}
    >
      <path
        d="M6.99995 1C6.99995 1 1.00001 5.41893 1 7.00005C0.999987 8.58116 7 13 7 13"
        stroke="#141B34"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const UploadAudioIcon = ({ handleClick }) => {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={handleClick}
      style={{ cursor: "pointer" }}
    >
      <rect width="28" height="28" rx="6" fill="#D9F3EA" />
      <path
        d="M7 14C7 10.7002 7 9.05025 8.02513 8.02513C9.05025 7 10.7002 7 14 7C17.2998 7 18.9497 7 19.9749 8.02513C21 9.05025 21 10.7002 21 14C21 17.2998 21 18.9497 19.9749 19.9749C18.9497 21 17.2998 21 14 21C10.7002 21 9.05025 21 8.02513 19.9749C7 18.9497 7 17.2998 7 14Z"
        stroke="#00AF74"
        strokeWidth="1.5"
      />
      <path
        d="M14.735 15.8417C14.735 16.8591 13.9103 17.6839 12.8929 17.6839C11.8755 17.6839 11.0508 16.8591 11.0508 15.8417C11.0508 14.8244 11.8755 13.9996 12.8929 13.9996C13.9103 13.9996 14.735 14.8244 14.735 15.8417ZM14.735 15.8417V10.3154C14.9806 10.6839 15.1771 12.2312 16.9455 12.526"
        stroke="#00AF74"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const AccordionUpArrowIcon = ({ customClass }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="9"
      viewBox="0 0 15 9"
      fill="none"
      className={customClass}
    >
      <path
        d="M1 7.5L6.35101 1.9882C6.98295 1.33727 8.01705 1.33727 8.64899 1.9882L14 7.5"
        stroke="white"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const AccordionDownArrowIcon = ({ customClass }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="9"
      viewBox="0 0 15 9"
      fill="none"
      className={customClass}
    >
      <path
        d="M1 1.67383L6.35101 7.18563C6.98295 7.83656 8.01705 7.83656 8.64899 7.18563L14 1.67383"
        stroke="white"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const SecondIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="10"
      viewBox="0 0 22 10"
      fill="none"
    >
      <path
        d="M3.576 9.25783C3.024 9.25783 2.528 9.16183 2.088 8.96983C1.656 8.76983 1.316 8.49783 1.068 8.15383C0.82 7.80183 0.692 7.39783 0.684 6.94183H1.848C1.888 7.33383 2.048 7.66583 2.328 7.93783C2.616 8.20183 3.032 8.33383 3.576 8.33383C4.096 8.33383 4.504 8.20583 4.8 7.94983C5.104 7.68583 5.256 7.34983 5.256 6.94183C5.256 6.62183 5.168 6.36183 4.992 6.16183C4.816 5.96183 4.596 5.80983 4.332 5.70583C4.068 5.60183 3.712 5.48983 3.264 5.36983C2.712 5.22583 2.268 5.08183 1.932 4.93783C1.604 4.79383 1.32 4.56983 1.08 4.26583C0.848 3.95383 0.732 3.53783 0.732 3.01783C0.732 2.56183 0.848 2.15783 1.08 1.80583C1.312 1.45383 1.636 1.18183 2.052 0.989828C2.476 0.797828 2.96 0.701828 3.504 0.701828C4.288 0.701828 4.928 0.897828 5.424 1.28983C5.928 1.68183 6.212 2.20183 6.276 2.84983H5.076C5.036 2.52983 4.868 2.24983 4.572 2.00983C4.276 1.76183 3.884 1.63783 3.396 1.63783C2.94 1.63783 2.568 1.75783 2.28 1.99783C1.992 2.22983 1.848 2.55783 1.848 2.98183C1.848 3.28583 1.932 3.53383 2.1 3.72583C2.276 3.91783 2.488 4.06583 2.736 4.16983C2.992 4.26583 3.348 4.37783 3.804 4.50583C4.356 4.65783 4.8 4.80983 5.136 4.96183C5.472 5.10583 5.76 5.33383 6 5.64583C6.24 5.94983 6.36 6.36583 6.36 6.89383C6.36 7.30183 6.252 7.68583 6.036 8.04583C5.82 8.40583 5.5 8.69783 5.076 8.92183C4.652 9.14583 4.152 9.25783 3.576 9.25783ZM13.967 5.63383C13.967 5.84183 13.955 6.06183 13.931 6.29383H8.67497C8.71497 6.94183 8.93497 7.44983 9.33497 7.81783C9.74297 8.17783 10.235 8.35783 10.811 8.35783C11.283 8.35783 11.675 8.24983 11.987 8.03383C12.307 7.80983 12.531 7.51383 12.659 7.14583H13.835C13.659 7.77783 13.307 8.29383 12.779 8.69383C12.251 9.08583 11.595 9.28183 10.811 9.28183C10.187 9.28183 9.62697 9.14183 9.13097 8.86183C8.64297 8.58183 8.25897 8.18583 7.97897 7.67383C7.69897 7.15383 7.55897 6.55383 7.55897 5.87383C7.55897 5.19383 7.69497 4.59783 7.96697 4.08583C8.23897 3.57383 8.61897 3.18183 9.10697 2.90983C9.60297 2.62983 10.171 2.48983 10.811 2.48983C11.435 2.48983 11.987 2.62583 12.467 2.89783C12.947 3.16983 13.315 3.54583 13.571 4.02583C13.835 4.49783 13.967 5.03383 13.967 5.63383ZM12.839 5.40583C12.839 4.98983 12.747 4.63383 12.563 4.33783C12.379 4.03383 12.127 3.80583 11.807 3.65383C11.495 3.49383 11.147 3.41383 10.763 3.41383C10.211 3.41383 9.73897 3.58983 9.34697 3.94183C8.96297 4.29383 8.74297 4.78183 8.68697 5.40583H12.839ZM15.0004 5.87383C15.0004 5.19383 15.1364 4.60183 15.4084 4.09783C15.6804 3.58583 16.0564 3.18983 16.5364 2.90983C17.0244 2.62983 17.5804 2.48983 18.2044 2.48983C19.0124 2.48983 19.6764 2.68583 20.1964 3.07783C20.7244 3.46983 21.0724 4.01383 21.2404 4.70983H20.0644C19.9524 4.30983 19.7324 3.99383 19.4044 3.76183C19.0844 3.52983 18.6844 3.41383 18.2044 3.41383C17.5804 3.41383 17.0764 3.62983 16.6924 4.06183C16.3084 4.48583 16.1164 5.08983 16.1164 5.87383C16.1164 6.66583 16.3084 7.27783 16.6924 7.70983C17.0764 8.14183 17.5804 8.35783 18.2044 8.35783C18.6844 8.35783 19.0844 8.24583 19.4044 8.02183C19.7244 7.79783 19.9444 7.47783 20.0644 7.06183H21.2404C21.0644 7.73383 20.7124 8.27383 20.1844 8.68183C19.6564 9.08183 18.9964 9.28183 18.2044 9.28183C17.5804 9.28183 17.0244 9.14183 16.5364 8.86183C16.0564 8.58183 15.6804 8.18583 15.4084 7.67383C15.1364 7.16183 15.0004 6.56183 15.0004 5.87383Z"
        fill="#92949D"
      />
    </svg>
  );
};

export const MinuteIcon = () => {
  return (
    <svg
      width="23"
      height="10"
      viewBox="0 0 23 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.832 2.47783C9.344 2.47783 9.8 2.58583 10.2 2.80183C10.6 3.00983 10.916 3.32583 11.148 3.74983C11.38 4.17383 11.496 4.68983 11.496 5.29783V9.17383H10.416V5.45383C10.416 4.79783 10.252 4.29783 9.924 3.95383C9.604 3.60183 9.168 3.42583 8.616 3.42583C8.048 3.42583 7.596 3.60983 7.26 3.97783C6.924 4.33783 6.756 4.86183 6.756 5.54983V9.17383H5.676V5.45383C5.676 4.79783 5.512 4.29783 5.184 3.95383C4.864 3.60183 4.428 3.42583 3.876 3.42583C3.308 3.42583 2.856 3.60983 2.52 3.97783C2.184 4.33783 2.016 4.86183 2.016 5.54983V9.17383H0.924V2.59783H2.016V3.54583C2.232 3.20183 2.52 2.93783 2.88 2.75383C3.248 2.56983 3.652 2.47783 4.092 2.47783C4.644 2.47783 5.132 2.60183 5.556 2.84983C5.98 3.09783 6.296 3.46183 6.504 3.94183C6.688 3.47783 6.992 3.11783 7.416 2.86183C7.84 2.60583 8.312 2.47783 8.832 2.47783ZM13.8513 1.52983C13.6433 1.52983 13.4673 1.45783 13.3233 1.31383C13.1793 1.16983 13.1073 0.993828 13.1073 0.785827C13.1073 0.577828 13.1793 0.401828 13.3233 0.257828C13.4673 0.113828 13.6433 0.0418277 13.8513 0.0418277C14.0513 0.0418277 14.2193 0.113828 14.3553 0.257828C14.4993 0.401828 14.5713 0.577828 14.5713 0.785827C14.5713 0.993828 14.4993 1.16983 14.3553 1.31383C14.2193 1.45783 14.0513 1.52983 13.8513 1.52983ZM14.3793 2.59783V9.17383H13.2873V2.59783H14.3793ZM19.4444 2.47783C20.2444 2.47783 20.8924 2.72183 21.3884 3.20983C21.8844 3.68983 22.1324 4.38583 22.1324 5.29783V9.17383H21.0524V5.45383C21.0524 4.79783 20.8884 4.29783 20.5604 3.95383C20.2324 3.60183 19.7844 3.42583 19.2164 3.42583C18.6404 3.42583 18.1804 3.60583 17.8364 3.96583C17.5004 4.32583 17.3324 4.84983 17.3324 5.53783V9.17383H16.2404V2.59783H17.3324V3.53383C17.5484 3.19783 17.8404 2.93783 18.2084 2.75383C18.5844 2.56983 18.9964 2.47783 19.4444 2.47783Z"
        fill="#92949D"
      />
    </svg>
  );
};

export const LockIcon = () => {
  return (
    <svg
      width="14"
      height="17"
      viewBox="0 0 14 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.7991 8.77134L13.5422 8.66916L12.7991 8.77134ZM10.3303 6.52731L10.364 5.77806L10.3303 6.52731ZM10.3303 15.9272L10.364 16.6765L10.3303 15.9272ZM12.7991 13.6832L12.0561 13.581L12.7991 13.6832ZM3.66974 6.52731L3.70347 7.27655L3.66974 6.52731ZM1.20086 8.77134L1.94386 8.87352L1.20086 8.77134ZM3.66974 15.9272L3.63602 16.6765L3.66974 15.9272ZM1.20086 13.6832L1.94387 13.581L1.20086 13.6832ZM2.91667 6.45455C2.91667 6.86876 3.25245 7.20455 3.66667 7.20455C4.08088 7.20455 4.41667 6.86876 4.41667 6.45455H2.91667ZM9.58333 6.45455C9.58333 6.86876 9.91912 7.20455 10.3333 7.20455C10.7475 7.20455 11.0833 6.86876 11.0833 6.45455H9.58333ZM7 15.25C5.82239 15.25 4.75436 15.2253 3.70347 15.178L3.63602 16.6765C4.71005 16.7248 5.80057 16.75 7 16.75V15.25ZM10.2965 15.178C9.24564 15.2253 8.17762 15.25 7 15.25V16.75C8.19943 16.75 9.28995 16.7248 10.364 16.6765L10.2965 15.178ZM13.5422 13.7854C13.6537 12.9745 13.75 12.1142 13.75 11.2273H12.25C12.25 12.011 12.1648 12.7911 12.0561 13.581L13.5422 13.7854ZM13.75 11.2273C13.75 10.3403 13.6537 9.48007 13.5422 8.66916L12.0561 8.87352C12.1648 9.66339 12.25 10.4436 12.25 11.2273H13.75ZM7 7.20455C8.17762 7.20455 9.24564 7.22925 10.2965 7.27655L10.364 5.77806C9.28995 5.72972 8.19943 5.70455 7 5.70455V7.20455ZM3.70347 7.27655C4.75436 7.22925 5.82239 7.20455 7 7.20455V5.70455C5.80057 5.70455 4.71005 5.72972 3.63602 5.77806L3.70347 7.27655ZM0.457852 8.66916C0.346331 9.48007 0.25 10.3403 0.25 11.2273H1.75C1.75 10.4436 1.83524 9.6634 1.94386 8.87352L0.457852 8.66916ZM0.25 11.2273C0.25 12.1142 0.346331 12.9745 0.457852 13.7854L1.94387 13.581C1.83524 12.7911 1.75 12.011 1.75 11.2273H0.25ZM13.5422 8.66916C13.3243 7.08538 11.9894 5.85122 10.364 5.77806L10.2965 7.27655C11.1964 7.31705 11.9366 8.00451 12.0561 8.87352L13.5422 8.66916ZM10.364 16.6765C11.9894 16.6033 13.3243 15.3692 13.5422 13.7854L12.0561 13.581C11.9366 14.45 11.1964 15.1375 10.2965 15.178L10.364 16.6765ZM3.63602 5.77806C2.01057 5.85122 0.67566 7.08538 0.457852 8.66916L1.94386 8.87352C2.06338 8.00451 2.80362 7.31705 3.70347 7.27655L3.63602 5.77806ZM3.70347 15.178C2.80362 15.1375 2.06338 14.45 1.94387 13.581L0.457852 13.7854C0.67566 15.3692 2.01057 16.6033 3.63602 16.6765L3.70347 15.178ZM4.41667 6.45455V4.40909H2.91667V6.45455H4.41667ZM9.58333 4.40909V6.45455H11.0833V4.40909H9.58333ZM11.0833 4.40909C11.0833 2.12807 9.27096 0.25 7 0.25V1.75C8.41094 1.75 9.58333 2.92454 9.58333 4.40909H11.0833ZM4.41667 4.40909C4.41667 2.92454 5.58906 1.75 7 1.75V0.25C4.72904 0.25 2.91667 2.12807 2.91667 4.40909H4.41667Z"
        fill="#ACACA7"
      />
    </svg>
  );
};

export const TargetGroupIcon = () => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.7806 11.4284H11.0607C11.7178 11.4284 12.2404 11.129 12.7096 10.7104C13.9017 9.64698 11.0995 8.57122 10.1429 8.57122M9 2.89623C9.12975 2.87049 9.2645 2.85693 9.40272 2.85693C10.4427 2.85693 11.2857 3.62445 11.2857 4.57122C11.2857 5.51799 10.4427 6.2855 9.40272 6.2855C9.2645 6.2855 9.12975 6.27195 9 6.24621"
        stroke="#4A4759"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M2.70361 9.20639C2.02991 9.56743 0.263507 10.3046 1.33936 11.2271C1.86491 11.6777 2.45023 12 3.18613 12H7.3853C8.12119 12 8.70652 11.6777 9.23207 11.2271C10.3079 10.3046 8.54152 9.56743 7.86782 9.20639C6.28801 8.35977 4.28342 8.35977 2.70361 9.20639Z"
        stroke="#4A4759"
        strokeWidth="1.5"
      />
      <path
        d="M7.57143 4.28571C7.57143 5.54808 6.54808 6.57143 5.28571 6.57143C4.02335 6.57143 3 5.54808 3 4.28571C3 3.02335 4.02335 2 5.28571 2C6.54808 2 7.57143 3.02335 7.57143 4.28571Z"
        stroke="#4A4759"
        strokeWidth="1.5"
      />
    </svg>
  );
};

export const ClinicalCaseIcon = () => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.2016 5.2V4.49091C11.2016 3.47496 11.2016 2.96699 11.0502 2.56129C10.807 1.90906 10.2925 1.39459 9.64028 1.15132C9.23457 1 8.7266 1 7.71065 1C5.93275 1 5.0438 1 4.33381 1.26481C3.19242 1.69053 2.29209 2.59085 1.86637 3.73225C1.60156 4.44224 1.60156 5.33119 1.60156 7.10909L1.60156 8.63636C1.60156 10.478 1.60156 11.3988 2.08026 12.0383C2.21742 12.2215 2.38008 12.3841 2.5633 12.5213C3.20277 13 4.12358 13 5.9652 13H6.40156C7.10342 13 8.50156 13 8.50156 13"
        stroke="#4A4759"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.39844 8.4H6.90263C7.29956 8.4 7.49803 8.4 7.65752 8.50454C7.81701 8.60909 7.90576 8.79736 8.08328 9.1739L9.03844 11.2L10.3584 7L11.3136 9.0261C11.4911 9.40264 11.5799 9.59091 11.7394 9.69546C11.8988 9.8 12.0973 9.8 12.4942 9.8H12.9984"
        stroke="#4A4759"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.60156 7C1.60156 5.89543 2.49699 5 3.60156 5H4.26823C4.57822 5 4.73321 5 4.86038 4.96593C5.20547 4.87346 5.47502 4.60391 5.56749 4.25882C5.60156 4.13165 5.60156 3.97666 5.60156 3.66667V3C5.60156 1.89543 6.49699 1 7.60156 1"
        stroke="#4A4759"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const VirtualPatientIcon = () => {
  return (
    <svg
      width="14"
      height="18"
      viewBox="0 0 14 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.2324 6.6C11.4508 7.66825 12.2403 9.47749 11.5313 11.1641C11.3785 11.5275 11.0281 11.7631 10.6403 11.7631C10.246 11.7631 9.59838 11.6368 9.47254 12.15L8.59474 15.7299C8.4117 16.4763 7.75388 17 6.99921 17C6.24454 17 5.58672 16.4763 5.40369 15.7299L4.52588 12.15C4.40005 11.6368 3.75241 11.7631 3.35812 11.7631C2.97034 11.7631 2.61988 11.5275 2.46712 11.1641C1.75815 9.47749 2.54768 7.66825 3.76607 6.6M9.39916 3.4C9.39916 4.72548 7.9926 6.2 6.99916 6.2C6.00573 6.2 4.59916 4.72548 4.59916 3.4C4.59916 2.07452 5.67368 1 6.99916 1C8.32465 1 9.39916 2.07452 9.39916 3.4Z"
        stroke="#4A4759"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
};
export const PlayIcon = ({ onClick }) => {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="28"
        height="28"
        viewBox="0 0 28 28"
        fill="none"
        style={{ cursor: "pointer" }}
        onClick={onClick}
      >
        <rect width="27.0667" height="28" rx="6" fill="#D9F3EA" />
        <path
          d="M19.9645 14.7896C19.6347 16.0431 18.0756 16.9288 14.9574 18.7003C11.943 20.4129 10.4358 21.2691 9.22118 20.9249C8.71901 20.7826 8.26148 20.5124 7.89249 20.1401C7 19.2396 7 17.4931 7 14C7 10.5069 7 8.76036 7.89249 7.8599C8.26148 7.48762 8.71901 7.21736 9.22118 7.07506C10.4358 6.73087 11.943 7.58714 14.9574 9.29966C18.0756 11.0712 19.6347 11.9569 19.9645 13.2104C20.1007 13.7278 20.1007 14.2722 19.9645 14.7896Z"
          stroke="#00AF74"
          strokeWidth="1.5"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};

export const UnCheckIcon = ({ handleClick }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      onClick={handleClick}
      style={{ cursor: "pointer" }}
    >
      <rect width="20" height="20" rx="4" fill="#ECECEC" />
    </svg>
  );
};
export const CheckIcon = ({ handleClick, fillColor }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      onClick={handleClick}
      style={{ cursor: "pointer" }}
    >
      <rect
        width="20"
        height="20"
        rx="4"
        fill={fillColor ? fillColor : "#026a26"}
      />
      <path
        d="M14.364 7L8.36399 13L5.63672 10.2727"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const CaseManagementIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
    >
      <path
        d="M11.4008 5.2V4.49091C11.4008 3.47496 11.4008 2.96699 11.2495 2.56129C11.0062 1.90906 10.4917 1.39459 9.8395 1.15132C9.43379 1 8.92582 1 7.90987 1C6.13197 1 5.24302 1 4.53303 1.26481C3.39164 1.69053 2.49131 2.59085 2.06559 3.73225C1.80078 4.44224 1.80078 5.33119 1.80078 7.10909V8.63636C1.80078 10.478 1.80078 11.3988 2.27948 12.0383C2.41664 12.2215 2.5793 12.3841 2.76251 12.5213C3.40198 13 4.3228 13 6.16442 13H8.70078M6.60078 8.4H7.10498C7.50191 8.4 7.70037 8.4 7.85986 8.50454C8.01935 8.60909 8.10811 8.79736 8.28562 9.1739L9.24078 11.2L10.5608 7L11.5159 9.0261C11.6935 9.40264 11.7822 9.59091 11.9417 9.69546C12.1012 9.8 12.2997 9.8 12.6966 9.8H13.2008M1.80078 7C1.80078 5.89543 2.69621 5 3.80078 5H4.46745C4.77744 5 4.93243 5 5.0596 4.96593C5.40469 4.87346 5.67424 4.60391 5.76671 4.25882C5.80078 4.13165 5.80078 3.97666 5.80078 3.66667V3C5.80078 1.89543 6.69621 1 7.80078 1"
        stroke="#4A4759"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const CopyIcon = ({ onClick }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      onClick={onClick}
      style={{ cursor: "pointer" }}
    >
      <rect width="27.9984" height="28.0004" rx="6" fill="#E6E6E6" />
      <path
        d="M17.4999 11.9C17.4983 9.83004 17.4669 8.75785 16.8644 8.0237C16.7481 7.88192 16.6181 7.75192 16.4763 7.63557C15.7019 7 14.5512 7 12.25 7C9.94876 7 8.79814 7 8.0237 7.63557C7.88192 7.75192 7.75192 7.88192 7.63557 8.0237C7 8.79814 7 9.94876 7 12.25C7 14.5512 7 15.7019 7.63557 16.4763C7.75192 16.6181 7.88192 16.7481 8.0237 16.8644C8.75785 17.4669 9.83004 17.4983 11.9 17.4999"
        stroke="#4A4759"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.3984 11.1504C14.9842 11.1504 14.6484 11.4862 14.6484 11.9004C14.6484 12.3146 14.9842 12.6504 15.3984 12.6504V11.1504ZM17.4984 12.6504C17.9127 12.6504 18.2484 12.3146 18.2484 11.9004C18.2484 11.4862 17.9127 11.1504 17.4984 11.1504V12.6504ZM12.6484 15.4004C12.6484 14.9862 12.3127 14.6504 11.8984 14.6504C11.4842 14.6504 11.1484 14.9862 11.1484 15.4004H12.6484ZM11.1484 17.5004C11.1484 17.9146 11.4842 18.2504 11.8984 18.2504C12.3127 18.2504 12.6484 17.9146 12.6484 17.5004H11.1484ZM13.7183 12.644C14.129 12.5902 14.4182 12.2136 14.3644 11.8029C14.3105 11.3922 13.9339 11.1029 13.5232 11.1568L13.7183 12.644ZM12.4275 12.3389L11.951 11.7597L11.951 11.7597L12.4275 12.3389ZM11.1631 13.1527C11.0816 13.5588 11.3446 13.9541 11.7507 14.0357C12.1568 14.1173 12.5522 13.8542 12.6338 13.4481L11.1631 13.1527ZM20.2631 13.4481C20.3447 13.8542 20.74 14.1173 21.1461 14.0357C21.5522 13.9541 21.8153 13.5588 21.7338 13.1527L20.2631 13.4481ZM20.4694 12.3389L19.9929 12.9181L19.9929 12.9181L20.4694 12.3389ZM19.3736 11.1568C18.9629 11.1029 18.5864 11.3922 18.5325 11.8029C18.4786 12.2136 18.7679 12.5902 19.1786 12.644L19.3736 11.1568ZM19.1786 20.2568C18.7679 20.3106 18.4786 20.6872 18.5325 21.0979C18.5864 21.5086 18.9629 21.7979 19.3736 21.744L19.1786 20.2568ZM20.4694 20.5619L20.9458 21.1411V21.1411L20.4694 20.5619ZM21.7338 19.7481C21.8153 19.342 21.5522 18.9466 21.1461 18.8651C20.74 18.7835 20.3447 19.0466 20.2631 19.4527L21.7338 19.7481ZM12.6338 19.4527C12.5522 19.0466 12.1568 18.7835 11.7507 18.8651C11.3446 18.9466 11.0816 19.342 11.1631 19.7481L12.6338 19.4527ZM12.4275 20.5619L12.904 19.9827L12.904 19.9827L12.4275 20.5619ZM13.5232 21.744C13.9339 21.7979 14.3105 21.5086 14.3644 21.0979C14.4182 20.6872 14.129 20.3106 13.7183 20.2568L13.5232 21.744ZM15.3984 20.2504C14.9842 20.2504 14.6484 20.5862 14.6484 21.0004C14.6484 21.4146 14.9842 21.7504 15.3984 21.7504V20.2504ZM17.4984 21.7504C17.9127 21.7504 18.2484 21.4146 18.2484 21.0004C18.2484 20.5862 17.9127 20.2504 17.4984 20.2504V21.7504ZM21.7484 15.4004C21.7484 14.9862 21.4127 14.6504 20.9984 14.6504C20.5842 14.6504 20.2484 14.9862 20.2484 15.4004H21.7484ZM20.2484 17.5004C20.2484 17.9146 20.5842 18.2504 20.9984 18.2504C21.4127 18.2504 21.7484 17.9146 21.7484 17.5004H20.2484ZM15.3984 11.9004V12.6504H17.4984V11.9004V11.1504H15.3984V11.9004ZM11.8984 15.4004H11.1484V17.5004H11.8984H12.6484V15.4004H11.8984ZM13.6207 11.9004L13.5232 11.1568C12.9321 11.2343 12.3974 11.3925 11.951 11.7597L12.4275 12.3389L12.904 12.9181C13.0439 12.803 13.2622 12.7038 13.7183 12.644L13.6207 11.9004ZM11.8984 13.3004L12.6338 13.4481C12.6939 13.1485 12.7827 13.0179 12.904 12.9181L12.4275 12.3389L11.951 11.7597C11.4952 12.1347 11.2718 12.6117 11.1631 13.1527L11.8984 13.3004ZM20.9984 13.3004L21.7338 13.1527C21.6251 12.6117 21.4017 12.1347 20.9458 11.7597L20.4694 12.3389L19.9929 12.9181C20.1142 13.0179 20.203 13.1485 20.2631 13.4481L20.9984 13.3004ZM19.2761 11.9004L19.1786 12.644C19.6346 12.7038 19.853 12.803 19.9929 12.9181L20.4694 12.3389L20.9458 11.7597C20.4994 11.3925 19.9648 11.2343 19.3736 11.1568L19.2761 11.9004ZM19.2761 21.0004L19.3736 21.744C19.9648 21.6665 20.4994 21.5083 20.9458 21.1411L20.4694 20.5619L19.9929 19.9827C19.853 20.0978 19.6346 20.197 19.1786 20.2568L19.2761 21.0004ZM20.9984 19.6004L20.2631 19.4527C20.203 19.7523 20.1142 19.8829 19.9929 19.9827L20.4694 20.5619L20.9458 21.1411C21.4017 20.7661 21.6251 20.2891 21.7338 19.7481L20.9984 19.6004ZM11.8984 19.6004L11.1631 19.7481C11.2718 20.2891 11.4952 20.7661 11.951 21.1411L12.4275 20.5619L12.904 19.9827C12.7827 19.8829 12.6939 19.7523 12.6338 19.4527L11.8984 19.6004ZM13.6207 21.0004L13.7183 20.2568C13.2622 20.197 13.0439 20.0978 12.904 19.9827L12.4275 20.5619L11.951 21.1411C12.3974 21.5083 12.9321 21.6665 13.5232 21.744L13.6207 21.0004ZM15.3984 21.0004V21.7504H17.4984V21.0004V20.2504H15.3984V21.0004ZM20.9984 15.4004H20.2484V17.5004H20.9984H21.7484V15.4004H20.9984Z"
        fill="#4A4759"
      />
    </svg>
  );
};

export const MonitorIcon = () => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.69922 10.5996V12.9996"
        stroke="#4A4759"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.5 10.5996L2.5 12.9996"
        stroke="#4A4759"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.89844 10.5996L10.8984 12.9996"
        stroke="#4A4759"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1 7C1 8.69706 1 9.54558 1.52721 10.0728C2.05442 10.6 2.90294 10.6 4.6 10.6H8.8C10.4971 10.6 11.3456 10.6 11.8728 10.0728C12.4 9.54558 12.4 8.69706 12.4 7V4.6C12.4 2.90294 12.4 2.05442 11.8728 1.52721C11.3456 1 10.4971 1 8.8 1H4.6C2.90294 1 2.05442 1 1.52721 1.52721C1 2.05442 1 2.90294 1 4.6V7Z"
        stroke="#4A4759"
        strokeWidth="1.5"
      />
      <path
        d="M4.30078 7.6V5.8M6.70078 7.6V4M9.10078 7.6V6.4"
        stroke="#4A4759"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const DummyIcon = () => {
  return (
    <svg
      width="39"
      height="47"
      viewBox="0 0 39 47"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M35.7242 46.1237C37.79 44.1406 39.0003 41.7638 39.0003 39.1974C39.0003 32.3148 30.3095 26.73 19.5919 26.73C8.87433 26.73 0.183594 32.3099 0.183594 39.1974C0.183594 41.7589 1.39388 44.1406 3.45963 46.1237H35.7242Z"
        fill="#DBDFE7"
      />
      <path
        d="M19.5913 21.5631C25.3092 21.5631 29.9444 16.9323 29.9444 11.2198C29.9444 5.50734 25.3092 0.876465 19.5913 0.876465C13.8735 0.876465 9.23828 5.50734 9.23828 11.2198C9.23828 16.9323 13.8735 21.5631 19.5913 21.5631Z"
        fill="#DBDFE7"
      />
    </svg>
  );
};

export const VirtualPatientNoDatIcon = () => {
  return (
    <svg
      width="57"
      height="56"
      viewBox="0 0 57 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M40.6217 41.0665C40.1266 41.0665 39.6518 40.8698 39.3017 40.5198C38.9517 40.1697 38.755 39.6949 38.755 39.1998C38.7614 36.9033 37.9947 34.6715 36.5785 32.8637C35.1623 31.0559 33.1789 29.7773 30.9477 29.2337C30.567 29.1404 30.2253 28.9297 29.971 28.6314C29.7168 28.3331 29.5629 27.9623 29.5312 27.5716C29.4995 27.1809 29.5916 26.7902 29.7944 26.4548C29.9972 26.1194 30.3004 25.8563 30.6611 25.7029C31.8527 25.2013 32.8339 24.3028 33.4384 23.1601C34.0429 22.0173 34.2334 20.7005 33.9775 19.4333C33.7217 18.166 33.0352 17.0263 32.0347 16.2076C31.0341 15.3889 29.7811 14.9416 28.4883 14.9416C27.1955 14.9416 25.9425 15.3889 24.942 16.2076C23.9414 17.0263 23.255 18.166 22.9991 19.4333C22.7432 20.7005 22.9337 22.0173 23.5382 23.1601C24.1427 24.3028 25.124 25.2013 26.3155 25.7029C26.6762 25.8563 26.9794 26.1194 27.1823 26.4548C27.3851 26.7902 27.4771 27.1809 27.4454 27.5716C27.4137 27.9623 27.2598 28.3331 27.0056 28.6314C26.7514 28.9297 26.4097 29.1404 26.029 29.2337C23.7978 29.7773 21.8144 31.0559 20.3981 32.8637C18.9819 34.6715 18.2153 36.9033 18.2217 39.1998C18.2217 39.6949 18.025 40.1697 17.6749 40.5198C17.3249 40.8698 16.8501 41.0665 16.355 41.0665C15.8599 41.0665 15.3851 40.8698 15.0351 40.5198C14.685 40.1697 14.4883 39.6949 14.4883 39.1998C14.4825 36.6985 15.149 34.2416 16.4181 32.086C17.6871 29.9305 19.5121 28.1556 21.7021 26.947C20.4504 25.6214 19.6144 23.9582 19.2973 22.1629C18.9801 20.3675 19.1958 18.5186 19.9176 16.8444C20.6393 15.1702 21.8357 13.744 23.3588 12.742C24.8819 11.74 26.6652 11.2061 28.4883 11.2061C30.3115 11.2061 32.0947 11.74 33.6179 12.742C35.141 13.744 36.3373 15.1702 37.0591 16.8444C37.7809 18.5186 37.9965 20.3675 37.6794 22.1629C37.3623 23.9582 36.5262 25.6214 35.2746 26.947C37.4646 28.1556 39.2895 29.9305 40.5586 32.086C41.8276 34.2416 42.4941 36.6985 42.4883 39.1998C42.4883 39.6949 42.2917 40.1697 41.9416 40.5198C41.5915 40.8698 41.1167 41.0665 40.6217 41.0665Z"
        fill="#026A26"
      />
      <path
        d="M28.4877 56C24.5586 55.9961 20.6743 55.1653 17.0873 53.5616C13.5003 51.9579 10.2911 49.6172 7.66811 46.6917C5.04516 43.7663 3.06728 40.3215 1.86308 36.5815C0.65887 32.8414 0.255294 28.8898 0.678589 24.9835C1.10188 21.0772 2.34257 17.3038 4.31999 13.9085C6.2974 10.5132 8.96727 7.57209 12.156 5.2764C15.3447 2.98071 18.9809 1.38183 22.8281 0.583721C26.6754 -0.214386 30.6475 -0.193853 34.4863 0.643986C34.9702 0.749684 35.3923 1.04329 35.6598 1.46022C35.9272 1.87716 36.0181 2.38326 35.9124 2.86719C35.8067 3.35112 35.5131 3.77324 35.0962 4.04069C34.6792 4.30815 34.1731 4.39902 33.6892 4.29332C28.4182 3.14054 22.9133 3.77894 18.046 6.10744C13.1787 8.43594 9.2272 12.3215 6.81711 17.1489C4.40702 21.9763 3.67606 27.4697 4.73996 32.7594C5.80386 38.049 8.60182 42.8327 12.6909 46.3529C16.7799 49.8731 21.9264 51.9288 27.3154 52.1945C32.7044 52.4602 38.0281 50.9206 42.4436 47.8196C46.859 44.7186 50.1139 40.2334 51.6929 35.074C53.2719 29.9146 53.0848 24.376 51.1612 19.3349C50.9842 18.8725 50.9982 18.3588 51.2 17.9066C51.4018 17.4545 51.7749 17.1011 52.2373 16.9241C52.6997 16.7471 53.2135 16.7611 53.6656 16.9629C54.1177 17.1647 54.4712 17.5379 54.6481 18.0003C56.2656 22.241 56.8285 26.8113 56.2884 31.3178C55.7483 35.8243 54.1215 40.1321 51.5478 43.8706C48.974 47.6091 45.5306 50.6663 41.5136 52.7792C37.4967 54.8921 33.0265 55.9974 28.4877 56Z"
        fill="#026A26"
      />
      <path
        d="M45.286 19.5998C44.9323 19.5996 44.586 19.499 44.2873 19.3096C43.927 19.0789 43.5931 18.8094 43.2914 18.506L37.9061 13.1514C37.6022 12.8523 37.3315 12.5213 37.0988 12.164C36.2247 10.898 35.827 9.36353 35.9759 7.83239C36.1249 6.30124 36.811 4.87223 37.9126 3.79848C38.8612 2.85467 40.0729 2.21974 41.3888 1.97705C42.7047 1.73436 44.0632 1.89525 45.286 2.43861C46.5999 1.85063 48.0699 1.70746 49.4726 2.03085C50.8753 2.35424 52.1342 3.12652 53.0581 4.23044C53.9819 5.33435 54.5204 6.70959 54.5916 8.14734C54.6628 9.58509 54.2629 11.0068 53.4526 12.1966C53.2245 12.541 52.9612 12.8607 52.6668 13.1505L47.2796 18.5069C46.9782 18.81 46.6446 19.0791 46.2846 19.3096C45.986 19.499 45.6396 19.5996 45.286 19.5998ZM42.5868 5.59982C42.2054 5.59921 41.8276 5.67402 41.4752 5.81994C41.1228 5.96586 40.8028 6.18001 40.5334 6.45008C40.0549 6.91685 39.7578 7.5385 39.6952 8.20407C39.6326 8.86963 39.8087 9.53577 40.1918 10.0835C40.2904 10.2362 40.4053 10.3776 40.5344 10.5054L45.286 15.2253L50.0338 10.5045C50.1457 10.3958 50.2458 10.2757 50.3325 10.1461C50.3465 10.1256 50.3605 10.1041 50.3754 10.0835C50.7583 9.53683 50.9346 8.87191 50.8729 8.20732C50.8112 7.54272 50.5155 6.92163 50.0385 6.45475C49.5574 5.98477 48.9298 5.69372 48.2602 5.63004C47.5907 5.56636 46.9195 5.73389 46.3584 6.10475C46.0441 6.32565 45.6692 6.4442 45.285 6.4442C44.9009 6.4442 44.526 6.32565 44.2117 6.10475C43.735 5.77312 43.1675 5.59677 42.5868 5.59982Z"
        fill="#026A26"
      />
    </svg>
  );
};

export const VerifiedIcon = () => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="12" height="12" rx="6" fill="#07BC8A" />
      <path
        d="M8.19531 3.90039C8.3279 3.90039 8.45506 3.95314 8.54883 4.04688L8.61133 4.12305C8.66553 4.20451 8.69531 4.3011 8.69531 4.40039C8.69522 4.49978 8.66572 4.59627 8.61133 4.67773L8.54883 4.75391L5.34863 7.95312C5.25487 8.04686 5.1277 8.09961 4.99512 8.09961C4.89561 8.0996 4.79934 8.07006 4.71777 8.01562L4.6416 7.95312L3.04199 6.35352L3.04004 6.35254C2.97174 6.28181 2.92616 6.1929 2.9082 6.09766L2.90039 6.00098C2.90153 5.86987 2.95417 5.74407 3.04688 5.65137L3.12207 5.58984C3.20253 5.53597 3.29728 5.50577 3.39551 5.50488C3.49382 5.50403 3.58945 5.53243 3.6709 5.58496L3.74707 5.64551L3.74902 5.64648L4.99512 6.89258L7.8418 4.04688L7.91797 3.98438C7.99954 3.92995 8.0958 3.90039 8.19531 3.90039Z"
        fill="white"
        stroke="white"
        strokeWidth="0.2"
      />
    </svg>
  );
};

export const HeartIcon = ({ fillColor }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
    >
      <circle cx="15" cy="15" r="15" fill={fillColor ? fillColor : "#8B8D95"} />
      <path
        d="M17.06 10.1325V7H14.4235V9.25568C14.4235 9.49795 14.2263 9.6951 13.9841 9.6951H13.5446V11.4841C15.0334 11.698 16.1812 12.9817 16.1812 14.5287V15.847H15.3023V14.5287C15.3023 13.3171 14.3166 12.3316 13.1052 12.3316H12.6658C12.6658 12.0868 12.6658 7.24276 12.6658 7C12.4532 7 11.1222 7 10.9081 7V11.4528H10V13.2105H13.1052C13.832 13.2105 14.4235 13.8019 14.4235 14.5287V15.847H13.5446V14.5287C13.5446 14.2864 13.3475 14.0893 13.1052 14.0893C12.0818 14.0893 11.8572 14.0893 10.9081 14.0893V14.5287C10.9081 18.6854 14.2841 22 18.3803 22C18.4254 22 18.4711 21.9997 18.5162 21.9988C19.6517 21.9786 20.5753 21.0169 20.5753 19.8545V15.4075C20.5753 13.1003 19.1754 11.0189 17.06 10.1325Z"
        fill="white"
      />
    </svg>
  );
};

export const LungsIcon = ({ fillColor }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
    >
      <circle cx="15" cy="15" r="15" fill={fillColor ? fillColor : "#8B8D95"} />
      <path
        d="M18.6055 10.6953C17.6363 10.6953 16.8477 11.484 16.8477 12.4531V13.9493L19.1478 15.0898H20.8027C21.0453 15.0898 21.2422 15.2867 21.2422 15.5293C21.2422 15.7719 21.0453 15.9688 20.8027 15.9688H19.5811L19.9326 17.7266H20.8027C21.0453 17.7266 21.2422 17.9234 21.2422 18.166C21.2422 18.4086 21.0453 18.6055 20.8027 18.6055H20.1084L20.3548 19.8377C20.4022 20.0756 20.2481 20.307 20.01 20.3548C19.7735 20.402 19.5409 20.2496 19.4929 20.01C19.3994 19.5428 18.7466 16.2791 18.6562 15.827L16.8477 14.9302V18.1757C16.8477 20.6469 18.72 23 21.6816 23C21.6846 22.9987 23 22.9606 23 21.6816V16.4082C23 13.7794 21.2291 10.6953 18.6055 10.6953Z"
        fill="white"
      />
      <path
        d="M10.1973 15.0898H11.8522L14.1523 13.9493V12.4531C14.1523 11.4844 13.3637 10.6953 12.3945 10.6953C9.78301 10.6953 8 13.7671 8 16.4082V21.6816C8 22.4064 8.60117 22.9977 9.31836 23C12.3002 23 14.1523 20.6287 14.1523 18.1757V14.9302L12.3438 15.827C12.2544 16.2742 11.6 19.5458 11.5071 20.01C11.4594 20.2481 11.2276 20.4022 10.99 20.3548C10.7521 20.307 10.5978 20.0756 10.6452 19.8377L10.8916 18.6055H10.1973C9.95469 18.6055 9.75781 18.4086 9.75781 18.166C9.75781 17.9234 9.95469 17.7266 10.1973 17.7266H11.0674L11.4189 15.9688H10.1973C9.95469 15.9688 9.75781 15.7719 9.75781 15.5293C9.75781 15.2867 9.95469 15.0898 10.1973 15.0898Z"
        fill="white"
      />
      <path
        d="M15.9395 13.499V8.43945C15.9395 8.19676 15.7427 8 15.5 8C15.2573 8 15.0605 8.19676 15.0605 8.43945V13.499L14.1523 13.9493V14.9302L15.5 14.2619L16.8477 14.9302V13.9493L15.9395 13.499Z"
        fill="white"
      />
    </svg>
  );
};

export const LiverIcon = ({ fillColor }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
    >
      <circle cx="15" cy="15" r="15" fill={fillColor ? fillColor : "#8B8D95"} />
      <path
        d="M21.9984 10.3755L21.9959 9.8877H18.6591V12.9714C18.6591 13.3186 18.6093 13.6585 18.5156 13.9828C19.4371 13.9548 20.2985 13.5824 20.9517 12.9265C21.6314 12.2441 22.0031 11.3382 21.9984 10.3755Z"
        fill="white"
      />
      <path
        d="M12.828 19.4831C13.5451 19.4831 14.1285 18.9003 14.1285 18.1838V17.6191L10.7344 19.4831H12.828Z"
        fill="white"
      />
      <path
        d="M10.2868 9.82246C9.65345 10.0548 9.08131 10.4074 8.5864 10.8704C8.09148 11.3335 7.70181 11.8807 7.42817 12.4969C7.14408 13.1367 7 13.8194 7 14.5259V17.2996C7 17.9895 7.35484 18.611 7.94922 18.9622C8.25543 19.1432 8.59387 19.2339 8.93292 19.2339C9.25193 19.2339 9.5715 19.1535 9.86488 18.9924L16.3583 15.4263C17.2546 14.934 17.8114 13.9935 17.8114 12.9717V9.88794L12.3415 9.52868C11.6357 9.48235 10.9446 9.58119 10.2868 9.82246Z"
        fill="white"
      />
    </svg>
  );
};

export const Intestines = ({ fillColor }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
    >
      <circle cx="15" cy="15" r="15" fill={fillColor ? fillColor : "#8B8D95"} />
      <path
        d="M23 15.4242C23 14.9065 22.7885 14.4384 22.4474 14.101C22.3755 14.0299 22.3755 13.9135 22.4474 13.8423C22.7885 13.5049 23 13.0368 23 12.5191C23 12.1083 22.8667 11.7289 22.6413 11.421C22.5945 11.357 22.5931 11.2699 22.64 11.206C22.8799 10.8792 23.0159 10.4713 22.9985 10.0309C22.9612 9.08454 22.2053 8.30843 21.2601 8.24808C20.7138 8.21318 20.2145 8.41436 19.8533 8.75909C19.7835 8.82565 19.673 8.82515 19.6032 8.75859C19.2692 8.43999 18.8171 8.24415 18.319 8.24415C17.8209 8.24415 17.3688 8.43999 17.0348 8.75862C16.9648 8.82535 16.8543 8.82535 16.7843 8.75862C16.4502 8.43999 15.9981 8.24415 15.5 8.24415C15.0019 8.24415 14.5498 8.43999 14.2158 8.75862C14.1458 8.82535 14.0352 8.82535 13.9653 8.75862C13.6312 8.43999 13.1791 8.24415 12.681 8.24415C12.1829 8.24415 11.7308 8.43999 11.3968 8.75859C11.327 8.82515 11.2165 8.82565 11.1467 8.75909C10.7855 8.4143 10.2862 8.21316 9.73989 8.24805C8.79468 8.3084 8.03882 9.08451 8.00149 10.0309C7.98412 10.4713 8.12011 10.8791 8.35999 11.206C8.40692 11.2699 8.40552 11.357 8.35867 11.421C8.1333 11.7289 8 12.1083 8 12.5191C8 13.0368 8.21152 13.5049 8.55261 13.8423C8.6245 13.9135 8.6245 14.0299 8.55261 14.101C8.21152 14.4384 8 14.9065 8 15.4242C8 16.0906 8.35018 16.675 8.87639 17.004C8.93015 17.0376 8.96328 17.096 8.96328 17.1594V18.1865C8.96328 18.6828 9.36563 19.0852 9.862 19.0852C10.3583 19.0852 10.7607 18.6829 10.7607 18.1865V17.1594C10.7607 17.096 10.7938 17.0376 10.8476 17.004C11.3738 16.675 11.724 16.0906 11.724 15.4242C11.724 14.9065 11.5124 14.4384 11.1714 14.101C11.0995 14.0299 11.0995 13.9135 11.1714 13.8423C11.5125 13.5049 11.724 13.0368 11.724 12.5191C11.724 12.345 11.7 12.1766 11.6553 12.0169C11.6135 11.8677 11.7651 11.7349 11.9059 11.7995C12.1419 11.9077 12.4044 11.9681 12.681 11.9681C13.1791 11.9681 13.6312 11.7722 13.9653 11.4536C14.0352 11.3869 14.1458 11.3869 14.2157 11.4536C14.5498 11.7722 15.0019 11.9681 15.5 11.9681C15.9981 11.9681 16.4502 11.7722 16.7843 11.4536C16.8542 11.3869 16.9648 11.3869 17.0347 11.4536C17.3688 11.7722 17.8209 11.9681 18.319 11.9681C18.5956 11.9681 18.8581 11.9077 19.094 11.7995C19.2349 11.7349 19.3865 11.8677 19.3447 12.0169C19.3 12.1766 19.276 12.345 19.276 12.5191C19.276 13.0368 19.4875 13.5049 19.8286 13.8423C19.9005 13.9135 19.9005 14.0299 19.8286 14.101C19.4875 14.4384 19.276 14.9065 19.276 15.4242C19.276 15.6054 19.3019 15.7805 19.3502 15.9461C19.3934 16.094 19.2424 16.2265 19.1017 16.1636C18.8702 16.0602 18.6138 16.0027 18.3439 16.0027C17.8262 16.0027 17.3581 16.2142 17.0207 16.5553C16.9496 16.6271 16.8332 16.6273 16.7622 16.5555C16.4044 16.1937 15.8996 15.9776 15.3445 16.005C14.3863 16.0523 13.6132 16.8359 13.578 17.7946C13.5539 18.4532 13.8722 19.0387 14.3687 19.3881C14.4178 19.4226 14.4476 19.4784 14.4476 19.5384V22.3545C14.4476 22.5758 14.627 22.7552 14.8483 22.7552H16.0292C16.2505 22.7552 16.4299 22.5758 16.4299 22.3545V19.5382C16.4299 19.4786 16.4591 19.4229 16.5079 19.3886C16.5993 19.3244 16.6846 19.2522 16.7629 19.173C16.8336 19.1015 16.9499 19.1025 17.0207 19.174C17.3581 19.5151 17.8262 19.7266 18.3439 19.7266C18.8363 19.7266 19.2839 19.5352 19.6168 19.2229C19.6862 19.1578 19.7951 19.1572 19.8644 19.2224C20.2129 19.5495 20.687 19.7441 21.2068 19.7253C22.1769 19.6903 22.9651 18.9008 22.9988 17.9307C23.0141 17.4882 22.8746 17.079 22.6307 16.7524C22.5825 16.6878 22.5839 16.5993 22.632 16.5347C22.863 16.2247 23 15.8406 23 15.4242Z"
        fill="white"
      />
      <defs>
        <radialGradient
          id="paint0_radial_3401_17513"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(15 15) rotate(84.447) scale(18.0849 18.6277)"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#F1F1F1" />
        </radialGradient>
      </defs>
    </svg>
  );
};

export const DialogueIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="63"
      height="40"
      viewBox="0 0 63 40"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M32.0153 7.27183C26.6918 4.89831 20.1344 4.37088 14.0107 6.27674C3.10651 9.66645 -2.29459 19.4876 1.94661 28.2118C3.0994 30.5854 4.85166 32.6284 7.00569 34.2846L4.17111 37.9205C2.60932 39.9248 9.78725 41.356 14.3279 37.9557C19.0168 39.3482 24.3403 39.4255 29.3711 37.8607C36.5419 35.6314 41.3331 30.6205 42.5669 24.9698C43.3604 20.2261 39.8207 10.8162 32.0153 7.27183Z"
        fill="#99E6FC"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26.689 5.59961C26.5621 5.83164 26.4386 6.06728 26.3224 6.30991C22.0213 15.15 27.4999 25.1084 38.5558 28.5474C39.342 28.7935 40.1351 28.9975 40.9284 29.1627C41.6971 27.8336 42.2505 26.4235 42.5678 24.9677C44.246 20.4984 40.6923 11.6337 32.0161 7.26983C30.3449 6.52435 28.5505 5.96175 26.689 5.59961Z"
        fill="#62DBFB"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M32.0145 7.27194C31.8593 7.53216 31.7149 7.80286 31.5809 8.07718C28.4116 14.5965 32.4482 21.9386 40.5991 24.4739C41.2513 24.6744 41.907 24.8397 42.5662 24.9698C45.7215 25.5922 48.9439 25.4058 51.8417 24.5443C55.2367 27.0866 60.6025 26.0142 59.4356 24.5161L57.3168 21.8015C58.9279 20.5638 60.2359 19.0342 61.0996 17.2584C64.2689 10.7391 60.2323 3.40047 52.0779 0.865152C44.2726 -1.56464 35.5224 1.29764 32.0145 7.27194Z"
        fill="#FFD15B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M48.2783 1.80368C56.4292 4.339 60.4659 11.6776 57.2964 18.197C56.4327 19.9727 55.1247 21.5023 53.5136 22.7366L56.2388 26.0595C58.4457 26.179 60.1486 25.4266 59.44 24.5158L57.3211 21.8012C58.9323 20.5635 60.2403 19.0339 61.1039 17.2581C64.2733 10.7388 60.2367 3.40017 52.0823 0.864848C47.954 -0.418655 43.5647 -0.225178 39.8242 1.12507C42.5741 0.741726 45.4861 0.935203 48.2783 1.80368Z"
        fill="#FFC344"
      />
      <path
        d="M46.9991 9.8188H41.3371C40.8231 9.8188 40.4062 9.40209 40.4062 8.88791C40.4062 8.37374 40.823 7.95703 41.3371 7.95703H46.9991C47.5131 7.95703 47.9299 8.37374 47.9299 8.88791C47.9299 9.40209 47.5132 9.8188 46.9991 9.8188Z"
        fill="#00366D"
      />
      <path
        d="M52.2485 13.9672H41.3371C40.8231 13.9672 40.4062 13.5505 40.4062 13.0364C40.4062 12.5222 40.823 12.1055 41.3371 12.1055H52.2485C52.7625 12.1055 53.1794 12.5222 53.1794 13.0364C53.1794 13.5506 52.7625 13.9672 52.2485 13.9672Z"
        fill="#00366D"
      />
      <path
        d="M49.2976 18.1137H41.3371C40.8231 18.1137 40.4062 17.697 40.4062 17.1828C40.4062 16.6687 40.823 16.252 41.3371 16.252H49.2976C49.8117 16.252 50.2285 16.6687 50.2285 17.1828C50.2285 17.697 49.8117 18.1137 49.2976 18.1137Z"
        fill="#00366D"
      />
      <path
        d="M21.953 17.4086H13.3332C12.8192 17.4086 12.4023 16.9919 12.4023 16.4778C12.4023 15.9636 12.8191 15.5469 13.3332 15.5469H21.953C22.467 15.5469 22.8838 15.9636 22.8838 16.4778C22.8837 16.992 22.467 17.4086 21.953 17.4086Z"
        fill="#00366D"
      />
      <path
        d="M29.9524 22.0415H13.3332C12.8192 22.0415 12.4023 21.6247 12.4023 21.1106C12.4023 20.5964 12.8191 20.1797 13.3332 20.1797H29.9524C30.4664 20.1797 30.8833 20.5964 30.8833 21.1106C30.8831 21.6247 30.4664 22.0415 29.9524 22.0415Z"
        fill="#00366D"
      />
      <path
        d="M25.4574 26.6801H13.3332C12.8192 26.6801 12.4023 26.2634 12.4023 25.7492C12.4023 25.2351 12.8191 24.8184 13.3332 24.8184H25.4574C25.9714 24.8184 26.3882 25.2351 26.3882 25.7492C26.3882 26.2634 25.9714 26.6801 25.4574 26.6801Z"
        fill="#00366D"
      />
    </svg>
  );
};

export const TopArrowIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="13"
      height="18"
      viewBox="0 0 13 18"
      fill="none"
    >
      <path
        d="M5.91558 0.239555L0.228078 5.96688C0.0800748 6.1212 -0.00182101 6.32787 3.02137e-05 6.5424C0.00188144 6.75693 0.0873314 6.96214 0.237976 7.11384C0.38862 7.26554 0.592405 7.35158 0.805439 7.35345C1.01847 7.35531 1.22371 7.27284 1.37695 7.1238L5.67752 2.79312L5.67752 17.1818C5.67752 17.3988 5.76312 17.6069 5.91549 17.7604C6.06786 17.9138 6.27453 18 6.49002 18C6.7055 18 6.91217 17.9138 7.06454 17.7604C7.21691 17.6069 7.30252 17.3988 7.30252 17.1818L7.30252 2.79312L11.6031 7.1238C11.678 7.20195 11.7677 7.26428 11.8668 7.30716C11.9659 7.35004 12.0726 7.37261 12.1804 7.37356C12.2883 7.3745 12.3953 7.3538 12.4952 7.31266C12.595 7.27152 12.6857 7.21077 12.762 7.13394C12.8383 7.05712 12.8986 6.96577 12.9395 6.86522C12.9803 6.76467 13.0009 6.65693 13 6.54829C12.999 6.43965 12.9766 6.33229 12.934 6.23246C12.8915 6.13264 12.8296 6.04236 12.752 5.96688L7.06445 0.239555C6.91209 0.086168 6.70546 -2.93105e-07 6.49002 -2.83688e-07C6.27457 -2.7427e-07 6.06794 0.086168 5.91558 0.239555Z"
        fill="#4A4759"
      />
    </svg>
  );
};
export const RightArrowIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="13"
      viewBox="0 0 18 13"
      fill="none"
    >
      <path
        d="M17.7604 5.91558L12.0331 0.228079C11.8788 0.0800753 11.6721 -0.0018205 11.4576 3.07145e-05C11.2431 0.00188193 11.0379 0.0873319 10.8862 0.237976C10.7345 0.38862 10.6484 0.592405 10.6466 0.80544C10.6447 1.01847 10.7272 1.22371 10.8762 1.37695L15.2069 5.67752H0.81819C0.601192 5.67752 0.393083 5.76312 0.239642 5.91549C0.0862019 6.06786 0 6.27453 0 6.49002C0 6.7055 0.0862019 6.91217 0.239642 7.06454C0.393083 7.21691 0.601192 7.30252 0.81819 7.30252H15.2069L10.8762 11.6031C10.7981 11.678 10.7357 11.7677 10.6928 11.8668C10.65 11.9659 10.6274 12.0726 10.6264 12.1804C10.6255 12.2883 10.6462 12.3953 10.6873 12.4952C10.7285 12.595 10.7892 12.6857 10.8661 12.762C10.9429 12.8383 11.0342 12.8986 11.1348 12.9395C11.2353 12.9803 11.3431 13.0009 11.4517 13C11.5604 12.999 11.6677 12.9766 11.7675 12.934C11.8674 12.8915 11.9576 12.8296 12.0331 12.752L17.7604 7.06445C17.9138 6.91209 18 6.70546 18 6.49002C18 6.27457 17.9138 6.06795 17.7604 5.91558Z"
        fill="#4A4759"
      />
    </svg>
  );
};
export const RightIcon = () => {
  return (
    <svg
      width="8"
      height="14"
      viewBox="0 0 8 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 13L7 7L1 1"
        stroke="#252525"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const CorrectIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
    >
      <rect width="28" height="28" rx="6" fill="#D9F3EA" />
      <path
        d="M14 21C17.866 21 21 17.866 21 14C21 10.134 17.866 7 14 7C10.134 7 7 10.134 7 14C7 17.866 10.134 21 14 21Z"
        fill="#026A26"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.8143 17.4139L9.25418 14.6738C8.90369 14.2987 8.92381 13.7052 9.29894 13.3547C9.67407 13.0042 10.2676 13.0244 10.6181 13.3995L12.5929 15.513L15.7187 12.5925C15.7468 12.5662 15.7761 12.5421 15.8065 12.5199L17.2765 11.1466C17.6516 10.7961 18.2452 10.8162 18.5956 11.1914C18.9461 11.5664 18.9259 12.16 18.5508 12.5105L14.0613 16.7053L14.0565 16.7001L12.5034 18.1512L11.8143 17.4139Z"
        fill="white"
      />
    </svg>
  );
};

export const BlockIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="27"
      height="27"
      viewBox="0 0 27 27"
      fill="none"
    >
      <rect width="27" height="27" rx="6" fill="#FFE7E5" />
      <path
        d="M13.5 7C9.9101 7 7 9.9101 7 13.5C7 17.0899 9.9101 20 13.5 20C17.0899 20 20 17.0899 20 13.5C20 9.9101 17.0899 7 13.5 7ZM9.37501 16.0612C9.30973 15.956 9.24811 15.848 9.19098 15.7376C8.8638 15.1097 8.67004 14.4026 8.64699 13.6521C8.56231 10.9053 10.7976 8.61969 13.5454 8.64486C14.3358 8.65194 15.0809 8.84831 15.7385 9.19017C15.8488 9.24758 15.9566 9.3092 16.0617 9.37473C16.1094 9.40437 16.1173 9.47069 16.0777 9.51027L9.5108 16.0771C9.47122 16.1167 9.4049 16.1089 9.37501 16.0612ZM13.5 18.3554C12.6928 18.3554 11.9317 18.1582 11.2624 17.8098C11.152 17.7524 11.0437 17.6908 10.9386 17.6255C10.8906 17.5956 10.8828 17.5293 10.9223 17.4897L17.4897 10.9223C17.5293 10.8828 17.5956 10.8906 17.6255 10.9386C17.6908 11.0437 17.7524 11.152 17.8098 11.2624C18.1583 11.9325 18.3554 12.6928 18.3554 13.5C18.3554 16.1815 16.1823 18.3554 13.5 18.3554Z"
        fill="#F44336"
      />
    </svg>
  );
};
export const DebriefingIcon = () => {
  return (
    <svg
      width="50"
      height="50"
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M25.0928 42.0013H23.9102C23.6081 42.0013 23.3633 41.7565 23.3633 41.4545V38.448L24.5015 38.0234L25.6396 38.448V41.4545C25.6396 41.7565 25.3949 42.0013 25.0928 42.0013Z"
        fill="#C4E2FF"
      />
      <path
        d="M20.7867 33.5799H15.998L15.3814 32.8594L14.011 33.3778L13.3203 34.9205L14.1912 35.7914C14.4342 36.0344 14.7637 36.1709 15.1073 36.1709H16.7467L18.3032 36.7269L20.7867 36.1709C21.5023 36.1709 22.0822 35.5909 22.0822 34.8754C22.0822 34.1598 21.5023 33.5799 20.7867 33.5799Z"
        fill="#FED2A4"
      />
      <path
        d="M12.7528 30.8357L10.0646 29.1323L9.04094 29.0547H8.78828H8.74002C7.76234 29.1563 7 29.9827 7 30.9873V41.3156C7 41.6931 7.30605 41.9992 7.68359 41.9992H12.1462C12.5238 41.9992 12.8298 41.6931 12.8298 41.3156V35.378L12.4192 33.9922L12.7528 30.8357Z"
        fill="#FE5694"
      />
      <path
        d="M13.0483 30.1328C12.4565 29.4412 11.5917 29.043 10.6815 29.043H8.94158C8.87288 29.043 8.80514 29.0467 8.73828 29.0536C9.55798 29.1178 10.3233 29.503 10.8621 30.1328L11.7278 31.1445C12.0662 31.5401 12.1074 32.1101 11.8292 32.5501L10.8256 34.1376C10.7056 34.3274 10.642 34.5472 10.642 34.7717V41.3145C10.642 41.6921 10.3359 41.9981 9.95836 41.9981H12.1446C12.5221 41.9981 12.8282 41.6921 12.8282 41.3145V34.4281L13.3179 34.9179L15.379 32.8568L13.0483 30.1328Z"
        fill="#FD3581"
      />
      <path
        d="M7.66012 27.6956L7.91086 27.9659L8.30222 28.306L9.3704 28.7102L10.737 28.4888L11.7313 27.7863L12.2864 26.5737L12.171 25.467L11.7571 24.7356L11.1761 24.1796C10.8075 23.9781 10.3846 23.8633 9.93478 23.8633C8.50381 23.8633 7.34375 25.0233 7.34375 26.4543C7.34375 26.904 7.45853 27.327 7.66012 27.6956Z"
        fill="#FED2A4"
      />
      <path
        d="M11.1762 24.1797C11.3777 24.5483 11.4925 24.9712 11.4925 25.421C11.4925 26.852 10.3325 28.0121 8.90149 28.0121C8.45169 28.0121 8.02882 27.8973 7.66016 27.6957C8.09998 28.4999 8.95365 29.0454 9.93482 29.0454C11.3658 29.0454 12.5258 27.8853 12.5258 26.4543C12.5258 25.4731 11.9803 24.6194 11.1762 24.1797Z"
        fill="#FFBD86"
      />
      <path
        d="M28.2135 33.5799H33.0023L33.6188 32.8594H35.4127L35.6799 34.9205L34.809 35.7914C34.5661 36.0344 34.2365 36.1709 33.893 36.1709H32.2536L29.8502 36.7269L28.2135 36.1709C27.498 36.1709 26.918 35.5909 26.918 34.8754C26.918 34.1598 27.498 33.5799 28.2135 33.5799Z"
        fill="#FED2A4"
      />
      <path
        d="M35.6822 34.9178L33.6211 32.8567L35.9518 30.1328C36.5436 29.4412 37.4084 29.043 38.3187 29.043H40.0585C41.1317 29.043 42.0018 29.913 42.0018 30.9862V41.3145C42.0018 41.6921 41.6957 41.9981 41.3182 41.9981H36.8555C36.478 41.9981 36.1719 41.6921 36.1719 41.3145V34.4281L35.6822 34.9178Z"
        fill="#62DBFB"
      />
      <path
        d="M40.0557 29.043H38.3159C38.248 29.043 38.1805 29.0459 38.1133 29.0503C39.1103 29.1331 39.8938 29.9679 39.8938 30.9862V41.3145C39.8938 41.6921 39.5877 41.9981 39.2102 41.9981H41.3154C41.6929 41.9981 41.999 41.6921 41.999 41.3145V30.9862C41.999 29.913 41.129 29.043 40.0557 29.043Z"
        fill="#01D0FB"
      />
      <path
        d="M36.789 27.6956L37.0234 27.9434L37.8959 28.4792L38.993 28.739L40.1189 28.1712L41.0525 27.2473L41.2064 25.9001V25.4381L40.8888 24.7645L40.305 24.1796C39.9364 23.9781 39.5135 23.8633 39.0637 23.8633C37.6327 23.8633 36.4727 25.0233 36.4727 26.4543C36.4727 26.904 36.5874 27.327 36.789 27.6956Z"
        fill="#FED2A4"
      />
      <path
        d="M40.3051 24.1797C40.5067 24.5483 40.6214 24.9712 40.6214 25.421C40.6214 26.852 39.4614 28.0121 38.0304 28.0121C37.5807 28.0121 37.1577 27.8973 36.7891 27.6957C37.2289 28.4999 38.0826 29.0454 39.0637 29.0454C40.4947 29.0454 41.6548 27.8853 41.6548 26.4543C41.6548 25.4731 41.1093 24.6194 40.3051 24.1797Z"
        fill="#FFBD86"
      />
      <path
        d="M23.5322 11.8359H36.1671C36.9529 11.8359 37.5899 12.4729 37.5899 13.2587V20.0879C37.5899 20.8737 36.9529 21.5107 36.1671 21.5107H32.4088V23.8577C32.4088 24.1112 32.1023 24.2382 31.9231 24.0589L29.3748 21.5106H23.5321C22.7463 21.5106 22.1094 20.8737 22.1094 20.0879V13.2587C22.1094 12.473 22.7464 11.8359 23.5322 11.8359Z"
        fill="#00F2A6"
      />
      <path
        d="M23.5321 11.8359C22.7463 11.8359 22.1094 12.4729 22.1094 13.2587V18.6652H25.4687C27.3515 18.6652 28.8833 17.1334 28.8833 15.2506V11.8359H23.5321Z"
        fill="#05E39C"
      />
      <path
        d="M34.8294 14.9121H26.8916C26.6084 14.9121 26.3789 14.6826 26.3789 14.3994C26.3789 14.1163 26.6084 13.8867 26.8916 13.8867H34.8294C35.1126 13.8867 35.3421 14.1163 35.3421 14.3994C35.3421 14.6826 35.1126 14.9121 34.8294 14.9121Z"
        fill="#EAF6FF"
      />
      <path
        d="M34.8304 17.1895H25.4697C25.1865 17.1895 24.957 16.9599 24.957 16.6768C24.957 16.3936 25.1865 16.1641 25.4697 16.1641H34.8304C35.1136 16.1641 35.3431 16.3936 35.3431 16.6768C35.3431 16.9599 35.1135 17.1895 34.8304 17.1895Z"
        fill="#EAF6FF"
      />
      <path
        d="M29.738 19.4629H25.4697C25.1865 19.4629 24.957 19.2333 24.957 18.9502C24.957 18.6671 25.1865 18.4375 25.4697 18.4375H29.738C30.0212 18.4375 30.2507 18.6671 30.2507 18.9502C30.2507 19.2333 30.0212 19.4629 29.738 19.4629Z"
        fill="#EAF6FF"
      />
      <path
        d="M23.8124 16.6681L23.9832 16.648L24.32 16.5486L24.9552 16.231L25.9945 11.9998L25.7892 9.09986L25.0687 7.52158L24.1604 7.054L23.7851 7H23.6183H12.8329C12.0472 7 11.4102 7.63697 11.4102 8.42276V15.252C11.4102 16.0378 12.0471 16.6748 12.8329 16.6748H16.5913V19.0218C16.5913 19.2752 16.8978 19.4022 17.077 19.2229L19.6252 16.6747H23.6772L23.8124 16.6681Z"
        fill="#FFE177"
      />
      <path
        d="M25.4668 7H23.6172C24.403 7 25.04 7.63697 25.04 8.42276V15.252C25.04 16.0378 24.403 16.6748 23.6172 16.6748H25.4668C26.2526 16.6748 26.8896 16.0378 26.8896 15.252V8.42276C26.8896 7.63697 26.2526 7 25.4668 7Z"
        fill="#FFD15B"
      />
      <path
        d="M24.1323 10.0723H14.1729C13.8896 10.0723 13.6602 9.84272 13.6602 9.55957C13.6602 9.27643 13.8896 9.04688 14.1729 9.04688H24.1322C24.4154 9.04688 24.6449 9.27643 24.6449 9.55957C24.6449 9.84272 24.4154 10.0723 24.1323 10.0723Z"
        fill="#EAF6FF"
      />
      <path
        d="M24.1323 12.3496H14.1729C13.8896 12.3496 13.6602 12.1201 13.6602 11.8369C13.6602 11.5538 13.8896 11.3242 14.1729 11.3242H24.1322C24.4154 11.3242 24.6449 11.5538 24.6449 11.8369C24.6449 12.1201 24.4154 12.3496 24.1323 12.3496Z"
        fill="#EAF6FF"
      />
      <path
        d="M18.4411 14.627H14.1729C13.8896 14.627 13.6602 14.3974 13.6602 14.1143C13.6602 13.8311 13.8896 13.6016 14.1729 13.6016H18.4411C18.7244 13.6016 18.9538 13.8311 18.9538 14.1143C18.9538 14.3974 18.7243 14.627 18.4411 14.627Z"
        fill="#EAF6FF"
      />
      <path
        d="M30.5282 38.4408L30.5847 38.4288L30.7279 38.3674L31.1682 38.0655L31.4232 37.5506V36.9203L31.2985 36.5498L30.8217 36.237L30.5341 36.1749L30.4332 36.1719H30.4034H16.7449C16.4306 36.1719 16.1758 36.4267 16.1758 36.741V37.8792C16.1758 38.1935 16.4306 38.4482 16.7449 38.4482H30.4328L30.4961 38.4446L30.5282 38.4408Z"
        fill="#D77F4A"
      />
      <path
        d="M32.2559 36.1719H30.4062C30.7206 36.1719 30.9753 36.4267 30.9753 36.741V37.8792C30.9753 38.1935 30.7206 38.4482 30.4062 38.4482H32.2559C32.5702 38.4482 32.8249 38.1935 32.8249 37.8792V36.741C32.8249 36.4267 32.5702 36.1719 32.2559 36.1719Z"
        fill="#C86D36"
      />
    </svg>
  );
};
export const PositionIcon = () => {
  return (
    <svg
      width="35"
      height="35"
      viewBox="0 0 35 35"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.02902 2.48582C5.66535 2.2953 5.2515 2.1875 4.8125 2.1875C3.36273 2.1875 2.1875 3.36273 2.1875 4.8125V6.125C2.1875 6.51314 2.27179 6.8816 2.423 7.21314L2.9886 7.34152H4.66525L6.94682 5.85826L6.02902 2.48582Z"
        fill="#FFD15B"
      />
      <path
        d="M31.4787 6.9192C31.4824 6.88064 31.8863 6.12356 31.8863 6.08405L31.4041 2.48582C31.0404 2.2953 30.6266 2.1875 30.1875 2.1875C28.7394 2.1875 27.5625 3.36123 27.5625 4.8125V5.35938L31.4787 6.9192Z"
        fill="#0055A3"
      />
      <path
        d="M24.0625 17.4626V18.5938L27.0197 20.1144L26.25 16.4062H25.1189C24.5354 16.4062 24.0625 16.8792 24.0625 17.4626Z"
        fill="#FFE5C2"
      />
      <path
        d="M31.6228 25.7837C32.0462 25.7837 32.6583 27.2607 33.0276 27.1101L34.8906 34.5625C34.9462 34.7847 34.7781 35 34.549 35H33.0874C32.9258 35 32.785 34.89 32.7458 34.7332L30.8984 27.3437L31.6228 25.7837Z"
        fill="#B2CAEC"
      />
      <path
        d="M3.6052 26.0723C3.18185 26.0723 2.34062 27.2605 1.97141 27.1099L0.108348 34.5623C0.0527722 34.7845 0.220868 34.9998 0.44994 34.9998H1.91153C2.07313 34.9998 2.21395 34.8898 2.25312 34.7331L4.10054 27.3435L3.6052 26.0723Z"
        fill="#B2CAEC"
      />
      <path
        d="M11.3166 10.8199L8.63538 13.5012C8.49784 13.6387 8.27492 13.6387 8.13745 13.5012L6.0663 11.43L4.51953 12.9769L7.63952 16.0969C8.05207 16.5094 8.7209 16.5094 9.13338 16.0969L12.3655 12.8648C12.778 12.4522 12.778 11.7834 12.3655 11.3709L11.8146 10.8201C11.6771 10.6824 11.4542 10.6824 11.3166 10.8199Z"
        fill="#FFCEBF"
      />
      <path
        d="M2.1875 13.8292C2.1875 13.4403 1.87223 13.125 1.48326 13.125H0.704238C0.315273 13.125 0 13.4403 0 13.8292V24.1747C0 25.925 1.4188 27.3438 3.169 27.3438H7.65625L9.21354 25.1562L2.1875 13.8292Z"
        fill="#0055A3"
      />
      <path
        d="M31.9212 24.6145L32.8125 13.1044V11.2522C32.8125 10.4744 33.4431 9.84375 34.221 9.84375H34.6479C34.8424 9.84375 35 10.0014 35 10.1959V24.1747C35 25.925 33.5812 27.3438 31.831 27.3438H27.3438V25.1562H31.7561C32.3396 25.1562 31.9212 25.198 31.9212 24.6145Z"
        fill="#0055A3"
      />
      <path
        d="M7.39945 4.37502C7.2615 3.55259 6.74108 2.85983 6.02734 2.48584V5.86279L7.39945 4.37502Z"
        fill="#FEB237"
      />
      <path
        d="M4.37468 7.65603L4.66493 7.34131H2.98828L4.37468 7.65603Z"
        fill="#FFD15B"
      />
      <path
        d="M12.0312 32.351V30.6248L10.601 28.5215L8.75 30.6248L9.84375 34.9998H12.9441C13.1834 34.9998 13.3775 34.8058 13.3775 34.5664V34.041C13.3774 33.2167 12.8021 32.5269 12.0312 32.351Z"
        fill="#0055A3"
      />
      <path
        d="M2.95132 20.9424L2.83203 23.0674C2.83203 24.221 3.12393 25.1562 4.27756 25.1562H8.7512V30.6249H12.0325V21.875L2.95132 20.9424Z"
        fill="#8AC9FE"
      />
      <path
        d="M7.10938 19.617L6.24777 11.0739C6.01173 10.9858 5.7562 10.9375 5.48939 10.9375H4.35436C3.15766 10.9375 2.1875 11.9077 2.1875 13.1044V15.3125L3.84686 21.0915L6.71515 21.4196C6.90956 21.4196 7.10938 19.8115 7.10938 19.617Z"
        fill="#FE646F"
      />
      <path
        d="M6.24701 11.0737V20.1142C6.24701 20.3087 6.08938 20.4663 5.89489 20.4663H3.60547V21.8748H7.65549L9.21278 20.2342L7.65549 18.5935V13.1041C7.65549 12.1742 7.06972 11.3811 6.24701 11.0737Z"
        fill="#FD4755"
      />
      <path
        d="M3.84846 15.8404C3.55677 15.8404 3.32031 15.6039 3.32031 15.3123V13.1248C3.32031 12.8331 3.55677 12.5967 3.84846 12.5967C4.14015 12.5967 4.3766 12.8331 4.3766 13.1248V15.3123C4.3766 15.6039 4.14015 15.8404 3.84846 15.8404Z"
        fill="#FD4755"
      />
      <path
        d="M6.57519 7.55084L6.02783 4.375H4.72593C4.53145 4.375 4.37381 4.53264 4.37381 4.72712V4.78598C4.37381 5.84685 3.69493 6.78877 2.68854 7.12428L2.42188 7.21321C2.4417 7.25669 2.46269 7.29948 2.48477 7.34159L5.91969 8.16539C6.29539 8.25542 6.64081 7.93174 6.57519 7.55084Z"
        fill="#FFDFCF"
      />
      <path
        d="M7.39969 4.375H6.02751V7.05988C6.02751 7.2152 5.90111 7.34159 5.7458 7.34159H2.48438C2.92304 8.17879 3.80029 8.75 4.81099 8.75H5.74587C6.67932 8.75 7.43599 7.99333 7.43599 7.05988V4.8125C7.43599 4.66341 7.42354 4.51726 7.39969 4.375Z"
        fill="#FFCEBF"
      />
      <path
        d="M22.9673 32.351V30.6248L24.3976 28.5215L26.2485 30.6248V34.9998H22.0545C21.8152 34.9998 21.6211 34.8058 21.6211 34.5664V34.041C21.6212 33.2167 22.1964 32.5269 22.9673 32.351Z"
        fill="#0055A3"
      />
      <path
        d="M31.9211 20.6343L22.9688 21.8751V30.6251H26.25V25.1563H30.3477C31.709 25.1563 32.458 24.0528 32.458 22.6916L31.9211 20.6343Z"
        fill="#8AC9FE"
      />
      <path
        d="M31.404 26.6769V18.5938H32.8125V13.1044C32.8125 11.9077 31.8423 10.9375 30.6456 10.9375H29.5106C28.3139 10.9375 27.3438 11.9077 27.3438 13.1044V15.3499L28.1382 15.9465L27.3438 16.4062H26.25V18.5938L26.8407 19.5406L26.25 27.6605L31.0519 27.029C31.2464 27.029 31.404 26.8714 31.404 26.6769Z"
        fill="#EAF6FF"
      />
      <path
        d="M27.3449 18.5938C27.0532 18.5938 26.8168 18.8302 26.8168 19.1219C26.8168 19.4136 27.0532 19.65 27.3449 19.65H31.4052V26.6769C31.4052 26.8714 31.2476 27.029 31.0531 27.029H26.0664L27.3449 28.4375H32.4616C32.656 28.4375 32.8137 28.2799 32.8137 28.0854V18.5938H27.3449Z"
        fill="#C4E2FF"
      />
      <path
        d="M29.9208 24.0625H27.3438L26.25 22.8512L27.3438 20.7812H30.625V23.3583C30.625 23.7472 30.3097 24.0625 29.9208 24.0625Z"
        fill="white"
      />
      <path
        d="M9.84375 34.9998H7.83228C7.73507 34.9998 7.65625 34.921 7.65625 34.8238V21.8748L8.88549 21.0615L9.84375 21.8748V34.9998Z"
        fill="#F6AB31"
      />
      <path
        d="M25.1562 34.9998H27.1677C27.2649 34.9998 27.3438 34.921 27.3438 34.8238V21.8748L26.1226 21.0615L25.1562 21.8748V34.9998Z"
        fill="#F6AB31"
      />
      <path
        d="M4.375 25.1562H3.24386C2.66041 25.1562 2.1875 24.6833 2.1875 24.0999V15.3125H4.375V25.1562Z"
        fill="#FFDFCF"
      />
      <path
        d="M31.3984 6.24203L29.7107 4.55431C29.6035 4.44712 29.4398 4.4206 29.3042 4.48834L27.5625 5.35924V7.05975C27.5625 7.15572 27.5705 7.24986 27.5859 7.34146L30.5242 8.20661C31.1555 8.20654 31.3393 6.85809 31.3984 6.24203Z"
        fill="#FFE5C2"
      />
      <path
        d="M31.404 2.48584V6.12502C31.404 6.16453 31.4021 6.20363 31.3984 6.24219L31.688 7.35228H32.5086C32.7025 6.98621 32.8125 6.56867 32.8125 6.12502V4.81252C32.8125 3.80183 32.2413 2.9245 31.404 2.48584Z"
        fill="#004281"
      />
      <path
        d="M30.625 12.5967C30.3333 12.5967 30.0969 12.8331 30.0969 13.1248V15.3497H27.3438V16.4061H30.625C30.9167 16.4061 31.1531 16.1696 31.1531 15.8779V13.1248C31.1531 12.8331 30.9167 12.5967 30.625 12.5967Z"
        fill="#C4E2FF"
      />
      <path
        d="M26.4856 21.4196L25.9353 18.5938H7.65625V20.4665L26.4856 21.4196Z"
        fill="#FFD15B"
      />
      <path
        d="M25.9353 18.5938V20.1144C25.9353 20.3089 25.7776 20.4665 25.5832 20.4665H7.65625V21.875H27.3438V18.5938H25.9353Z"
        fill="#FEB237"
      />
      <path
        d="M30.1876 7.34154H27.5859C27.7201 8.14094 28.4152 8.75002 29.2527 8.75002H30.1876C31.1927 8.75002 32.0677 8.18421 32.5086 7.35228L31.3985 6.24219C31.3393 6.85824 30.8189 7.34154 30.1876 7.34154Z"
        fill="#FED2A4"
      />
    </svg>
  );
};

export const ExpandIcon = ({ onClick }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      onClick={onClick}
      style={{ cursor: "pointer" }}
    >
      <rect width="28" height="28" rx="6" fill="#D9F3EA" />
      <path
        d="M14 21C17.866 21 21 17.866 21 14C21 10.134 17.866 7 14 7C10.134 7 7 10.134 7 14C7 17.866 10.134 21 14 21Z"
        fill="#026A26"
      />
      <path
        d="M16.8008 13.475H14.5258V11.2C14.5258 11.0607 14.4705 10.9272 14.372 10.8288C14.2736 10.7303 14.14 10.675 14.0008 10.675C13.8615 10.675 13.728 10.7303 13.6296 10.8288C13.5311 10.9272 13.4758 11.0607 13.4758 11.2V13.475H11.2008C11.0615 13.475 10.928 13.5303 10.8296 13.6288C10.7311 13.7272 10.6758 13.8607 10.6758 14C10.6758 14.1392 10.7311 14.2728 10.8296 14.3712C10.928 14.4697 11.0615 14.525 11.2008 14.525H13.4758V16.8C13.4758 16.9392 13.5311 17.0728 13.6296 17.1712C13.728 17.2697 13.8615 17.325 14.0008 17.325C14.14 17.325 14.2736 17.2697 14.372 17.1712C14.4705 17.0728 14.5258 16.9392 14.5258 16.8V14.525H16.8008C16.94 14.525 17.0736 14.4697 17.172 14.3712C17.2705 14.2728 17.3258 14.1392 17.3258 14C17.3258 13.8607 17.2705 13.7272 17.172 13.6288C17.0736 13.5303 16.94 13.475 16.8008 13.475Z"
        fill="#EDEBEA"
      />
    </svg>
  );
};
export const MessageIcon = () => {
  return (
    <svg
      width="50"
      height="34"
      viewBox="0 0 50 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.5469 6.68202C21.2315 4.758 15.916 4.33046 10.952 5.87538C2.11288 8.62314 -2.26534 16.5844 1.17265 23.6563C2.10712 25.5804 3.52753 27.2365 5.27362 28.579L2.97587 31.5264C1.70985 33.1511 7.52841 34.3112 11.2092 31.5549C15.01 32.6837 19.3254 32.7464 23.4034 31.4779C29.2162 29.6708 33.1 25.6089 34.1002 21.0283C34.7433 17.183 31.874 9.55517 25.5469 6.68202Z"
        fill="#99E6FC"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.2284 5.32812C21.1256 5.51621 21.0255 5.70723 20.9313 5.90391C17.4448 13.0698 21.8858 21.1423 30.8479 23.93C31.4852 24.1295 32.1282 24.2948 32.7712 24.4288C33.3943 23.3514 33.8429 22.2083 34.1001 21.0282C35.4605 17.4054 32.5798 10.2194 25.5467 6.68203C24.192 6.07773 22.7374 5.62168 21.2284 5.32812Z"
        fill="#62DBFB"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.548 6.68187C25.4222 6.89281 25.3051 7.11224 25.1965 7.33461C22.6274 12.6193 25.8996 18.5709 32.5068 20.6261C33.0355 20.7886 33.567 20.9226 34.1014 21.0281C36.6591 21.5326 39.2712 21.3815 41.6203 20.6831C44.3723 22.744 48.7219 21.8746 47.776 20.6603L46.0584 18.4598C47.3645 17.4565 48.4247 16.2165 49.1248 14.7771C51.694 9.49242 48.4218 3.54359 41.8118 1.48842C35.4846 -0.481213 28.3915 1.839 25.548 6.68187Z"
        fill="#FFD15B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M38.728 2.24969C45.3353 4.30487 48.6075 10.2537 46.0383 15.5384C45.3381 16.9778 44.2778 18.2178 42.9719 19.2182L45.181 21.9119C46.9699 22.0088 48.3503 21.3988 47.7759 20.6605L46.0583 18.46C47.3644 17.4567 48.4246 16.2168 49.1247 14.7773C51.6938 9.49266 48.4217 3.54383 41.8116 1.48866C38.4651 0.448229 34.9071 0.605064 31.875 1.6996C34.1041 1.38885 36.4646 1.54569 38.728 2.24969Z"
        fill="#FFC344"
      />
      <path
        d="M37.6958 8.74746H33.1062C32.6895 8.74746 32.3516 8.40967 32.3516 7.99287C32.3516 7.57607 32.6894 7.23828 33.1062 7.23828H37.6958C38.1125 7.23828 38.4504 7.57607 38.4504 7.99287C38.4504 8.40967 38.1126 8.74746 37.6958 8.74746Z"
        fill="#00366D"
      />
      <path
        d="M41.9511 12.1083H33.1062C32.6895 12.1083 32.3516 11.7705 32.3516 11.3537C32.3516 10.9369 32.6894 10.5991 33.1062 10.5991H41.9511C42.3678 10.5991 42.7057 10.9369 42.7057 11.3537C42.7057 11.7706 42.3678 12.1083 41.9511 12.1083Z"
        fill="#00366D"
      />
      <path
        d="M39.5591 15.4716H33.1062C32.6895 15.4716 32.3516 15.1338 32.3516 14.717C32.3516 14.3002 32.6894 13.9624 33.1062 13.9624H39.5591C39.9758 13.9624 40.3137 14.3002 40.3137 14.717C40.3137 15.1338 39.9758 15.4716 39.5591 15.4716Z"
        fill="#00366D"
      />
      <path
        d="M17.3903 14.8988H10.403C9.98633 14.8988 9.64844 14.561 9.64844 14.1442C9.64844 13.7274 9.98623 13.3896 10.403 13.3896H17.3903C17.807 13.3896 18.1449 13.7274 18.1449 14.1442C18.1448 14.5611 17.807 14.8988 17.3903 14.8988Z"
        fill="#00366D"
      />
      <path
        d="M23.8748 18.6557H10.403C9.98633 18.6557 9.64844 18.3179 9.64844 17.9011C9.64844 17.4843 9.98623 17.1465 10.403 17.1465H23.8748C24.2915 17.1465 24.6294 17.4843 24.6294 17.9011C24.6293 18.3179 24.2915 18.6557 23.8748 18.6557Z"
        fill="#00366D"
      />
      <path
        d="M20.2311 22.4125H10.403C9.98633 22.4125 9.64844 22.0747 9.64844 21.6579C9.64844 21.2411 9.98623 20.9033 10.403 20.9033H20.2311C20.6478 20.9033 20.9856 21.2411 20.9856 21.6579C20.9856 22.0747 20.6478 22.4125 20.2311 22.4125Z"
        fill="#00366D"
      />
    </svg>
  );
};

export const ViewIcon = () => {
  return (
    <svg
      width="50"
      height="50"
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_6004_24847)">
        <path
          d="M11.7759 33.9346C11.5562 33.9346 11.339 33.8361 11.1947 33.6485L8.37275 29.978C6.9585 28.1386 6.21094 25.9369 6.21094 23.6111V15.563C6.21094 15.1584 6.53887 14.8306 6.94336 14.8306C7.34785 14.8306 7.67578 15.1584 7.67578 15.563V23.6111C7.67578 25.6111 8.31836 27.504 9.53398 29.0853L12.356 32.7558C12.6025 33.0765 12.5424 33.5362 12.2217 33.7829C12.0888 33.8851 11.9316 33.9346 11.7759 33.9346Z"
          fill="#BAD6E5"
        />
        <path
          d="M23.0445 32.008C22.8892 32.008 22.7326 31.9589 22.5998 31.8572C22.2785 31.6113 22.2175 31.1517 22.4634 30.8304L23.8111 29.0695C25.0189 27.4915 25.6572 25.6041 25.6572 23.6111V15.563C25.6572 15.1584 25.9852 14.8306 26.3897 14.8306C26.7942 14.8306 27.1221 15.1584 27.1221 15.563V23.6111C27.1221 25.9286 26.3794 28.124 24.9742 29.9599L23.6266 31.7207C23.4824 31.9091 23.2647 32.008 23.0445 32.008Z"
          fill="#BAD6E5"
        />
        <path
          d="M38.7327 39.3517C40.8658 39.3517 42.7181 37.2235 43.649 35.4598L43.365 35.3786C42.6237 35.1668 42.1126 34.4893 42.1126 33.7183V31.7212C41.149 32.3824 39.9837 32.7677 38.733 32.7677C37.4823 32.7677 36.317 32.3824 35.3534 31.7212V33.7183C35.3534 34.4893 34.8423 35.1668 34.101 35.3786L33.8164 35.46C34.7475 37.2236 36.5997 39.3517 38.7327 39.3517Z"
          fill="#FFCEBF"
        />
        <path
          d="M32.5188 24.8394H31.105C30.1452 24.8394 29.3672 25.6174 29.3672 26.5771C29.3672 28.463 30.896 29.9919 32.7819 29.9919H32.8476L32.5188 24.8394Z"
          fill="#FFDFCF"
        />
        <path
          d="M46.3636 24.8394H44.9498L44.6211 29.9919H44.6867C46.5726 29.9919 48.1015 28.4631 48.1015 26.5771C48.1013 25.6175 47.3232 24.8394 46.3636 24.8394Z"
          fill="#FFCEBF"
        />
        <path
          d="M9.60566 12.8281H7.24482C6.17978 12.8281 5.31641 13.6915 5.31641 14.7565C5.31641 16.8493 7.01289 18.5458 9.10566 18.5458H9.17852L9.60566 12.8281Z"
          fill="#FFE5C2"
        />
        <path
          d="M23.6523 12.8281H26.0132C27.0782 12.8281 27.9416 13.6915 27.9416 14.7565C27.9416 16.8493 26.2451 18.5458 24.1523 18.5458H24.0795L23.6523 12.8281Z"
          fill="#FFE5C2"
        />
        <path
          d="M22.1029 23.5863C23.5939 22.2248 24.5748 20.3073 24.7127 18.1461C24.72 18.0314 24.9005 15.2027 25.0838 12.3302L8.23047 12.0117C8.38936 14.5013 8.56553 17.2626 8.62188 18.1461C8.76182 20.3393 9.76963 22.2813 11.2979 23.6462C11.8377 24.1283 12.1538 24.812 12.1538 25.5357V26.122C12.1538 27.2908 11.5477 28.3453 10.6008 28.9458L16.6679 31.9445L22.8212 28.9458C21.8743 28.3453 21.2682 27.2908 21.2682 26.122V25.4571C21.2682 24.7433 21.5758 24.0678 22.1029 23.5863Z"
          fill="#FFF3DE"
        />
        <path
          d="M45.2718 35.9233L43.65 35.46C42.719 37.2237 40.8667 38.4259 38.7337 38.4259C36.6007 38.4259 34.7484 37.2238 33.8175 35.4602L32.1965 35.9232C29.3981 36.7228 27.4688 39.2805 27.4688 42.1909V50H49.511C49.7807 50 49.9993 49.7813 49.9993 49.5117V42.1907C49.9993 39.2805 48.0701 36.7229 45.2718 35.9233Z"
          fill="#FD8087"
        />
        <path
          d="M39.5833 45.1388C40.7339 45.1388 41.6666 44.206 41.6666 43.0555C41.6666 41.9049 40.7339 40.9722 39.5833 40.9722C38.4327 40.9722 37.5 41.9049 37.5 43.0555C37.5 44.206 38.4327 45.1388 39.5833 45.1388Z"
          fill="#D8E8F0"
        />
        <path
          d="M39.0958 43.788H35.1147C33.324 43.788 31.8672 42.3312 31.8672 40.5404V40.2778C31.8672 39.8732 32.1951 39.5454 32.5996 39.5454C33.0041 39.5454 33.332 39.8732 33.332 40.2778V40.5404C33.332 41.5233 34.1317 42.3231 35.1147 42.3231H39.0958C39.5003 42.3231 39.8282 42.651 39.8282 43.0556C39.8282 43.4602 39.5003 43.788 39.0958 43.788Z"
          fill="#0681AF"
        />
        <path
          d="M45.2718 35.9233L44.0789 35.5825C45.2639 36.7749 45.9749 38.4117 45.9749 40.1786V45.4727C45.9749 46.8617 44.8488 47.9879 43.4597 47.9879H27.4688V50H49.511C49.7807 50 49.9993 49.7813 49.9993 49.5117V42.1907C49.9993 39.2805 48.0701 36.7229 45.2718 35.9233Z"
          fill="#FE646F"
        />
        <path
          d="M37.5097 50L37.1328 47.0537L41.6876 42.4989C41.8841 42.3024 42.2025 42.3024 42.399 42.4989L44.4033 44.5032C45.1435 45.2434 45.2657 46.3211 44.6764 46.9104L41.5867 50H37.5097Z"
          fill="#FFF3DE"
        />
        <path
          d="M45.7424 25.3226L45.9096 22.9828C46.2071 18.8193 42.9096 15.2778 38.7356 15.2778C34.5617 15.2778 31.2643 18.819 31.5616 22.9824L31.7381 25.4534L45.7424 25.3226Z"
          fill="#FDB97E"
        />
        <path
          d="M43.5745 22.9951L42.022 19.89C41.8641 19.5741 41.4325 19.5243 41.2087 19.7975C40.2819 20.9286 37.9787 23.3735 34.1464 24.6509L31.7383 25.4536L31.8402 26.8813C32.0985 30.499 35.1088 33.3019 38.7356 33.3019C42.3624 33.3019 45.3726 30.4992 45.6311 26.8817L45.7425 25.3229C44.8184 24.7754 44.0622 23.9705 43.5745 22.9951Z"
          fill="#FFEEE6"
        />
        <path
          d="M43.5743 22.9948L42.0218 19.8896C41.8636 19.5733 41.433 19.5249 41.2079 19.7978C40.8758 20.2005 40.3783 20.7616 39.7474 21.3435C40.0318 21.8217 40.3838 22.2521 40.7896 22.6227C41.3639 23.1472 41.676 23.899 41.6205 24.6749L41.6066 24.8692C41.348 28.4866 38.3379 31.2893 34.7112 31.2893C34.4028 31.2893 34.0989 31.269 33.8008 31.2297C35.0591 32.5117 36.8104 33.3015 38.7355 33.3015C42.3623 33.3015 45.3725 30.4988 45.631 26.8813L45.7424 25.3225C44.8182 24.7751 44.0621 23.9702 43.5743 22.9948Z"
          fill="#FFDFCF"
        />
        <path
          d="M33.3333 45.3448V37.6485C33.3333 34.1921 30.9848 31.1775 27.6333 30.3321L23.7992 29.3649C23.4449 29.2764 23.1157 29.133 22.8199 28.9454L22.6076 29.0496C18.8877 30.8752 14.5321 30.8753 10.8122 29.0497L10.5995 28.9453C10.3036 29.1329 9.97451 29.2763 9.62022 29.3648L5.71553 30.341C2.35645 31.181 0 34.199 0 37.6615V49.5115C0 49.7812 0.218652 49.9998 0.488281 49.9998H37.5V46.8393C37.5 46.2836 37.0496 45.8332 36.4939 45.8332H33.8217C33.552 45.8331 33.3333 45.6146 33.3333 45.3448Z"
          fill="#D8ECFE"
        />
        <path
          d="M23.0379 29.4886L21.8059 30.2277C18.6198 32.1394 14.6394 32.1393 11.4533 30.2276L10.2215 29.4885C9.9491 29.325 9.90281 28.9491 10.1274 28.7245L10.6831 28.1688C10.9257 27.9263 11.2777 27.8288 11.6104 27.912L13.5795 28.4043C15.5821 28.905 17.6771 28.905 19.6797 28.4043L21.6487 27.912C21.9815 27.8288 22.3336 27.9264 22.576 28.1688L23.1317 28.7245C23.3565 28.9493 23.3102 29.3252 23.0379 29.4886Z"
          fill="#EAF6FF"
        />
        <path
          d="M18.7674 22.4345C22.4341 20.3393 24.8048 16.544 25.078 12.3298C25.1143 11.7689 25.1545 11.1559 25.1989 10.485C25.1989 10.4848 25.1989 10.4846 25.1989 10.4843L25.4698 6.23877C25.5394 5.14756 24.9491 4.1206 23.9711 3.63164L22.5593 2.92578C22.3779 2.83506 22.2633 2.64961 22.2633 2.44668V2.4377C22.2633 1.09141 21.1718 0 19.8255 0H15.2362C11.0248 0 7.68835 3.55684 7.95651 7.75967C8.06989 9.53711 8.16403 11.0194 8.24255 12.258C8.51003 16.4786 10.8812 20.2813 14.5531 22.3796L14.7381 22.4853C15.959 23.1829 17.4571 23.1833 18.678 22.4856C18.7075 22.4687 18.7373 22.4517 18.7674 22.4345Z"
          fill="#0681AF"
        />
        <path
          d="M23.9726 3.63164L22.5608 2.92578C22.3794 2.83506 22.2647 2.64961 22.2647 2.44668V2.4377C22.2648 1.09141 21.1734 0 19.8271 0H18.2034C18.2277 0.138184 18.2404 0.280371 18.2404 0.425586C18.2404 0.633984 18.3582 0.824512 18.5445 0.917676L19.9481 1.61953C20.9262 2.1085 21.5165 3.13545 21.4469 4.22676L21.176 8.47226V8.47295C21.1316 9.14375 21.0915 9.75674 21.0552 10.3175C20.7819 14.5319 18.4114 18.3271 14.7445 20.4225L14.6552 20.4735C14.0175 20.838 13.3039 21.0119 12.5938 20.9955C13.1959 21.5134 13.8514 21.9777 14.5546 22.3796L14.7396 22.4853C15.9604 23.1829 17.4586 23.1833 18.6795 22.4856C18.7091 22.4687 18.7389 22.4518 18.7688 22.4346C22.4355 20.3394 24.8062 16.5441 25.0795 12.3299C25.1158 11.769 25.156 11.156 25.2004 10.4851C25.2004 10.4849 25.2004 10.4847 25.2004 10.4844L25.4713 6.23887C25.5409 5.14756 24.9506 4.1207 23.9726 3.63164Z"
          fill="#017297"
        />
        <path
          d="M38.2651 28.3888H38.0918C37.6873 28.3888 37.3594 28.0609 37.3594 27.6563C37.3594 27.2518 37.6873 26.9239 38.0918 26.9239H38.2651C38.4756 26.9239 38.6468 26.7527 38.6468 26.5423V25.0815C38.6468 24.677 38.9747 24.3491 39.3792 24.3491C39.7837 24.3491 40.1116 24.677 40.1116 25.0815V26.5423C40.1117 27.5604 39.2833 28.3888 38.2651 28.3888Z"
          fill="#FFDFCF"
        />
        <path
          d="M38.7327 31.2396C37.6171 31.2396 36.5013 30.8149 35.652 29.9656C35.366 29.6795 35.366 29.2158 35.652 28.9299C35.9381 28.6438 36.4018 28.6439 36.6878 28.9298C37.8153 30.0574 39.65 30.0574 40.7775 28.9298C41.0636 28.6439 41.5273 28.6438 41.8133 28.9299C42.0993 29.2159 42.0993 29.6796 41.8133 29.9656C40.964 30.815 39.8484 31.2396 38.7327 31.2396Z"
          fill="#FFDFCF"
        />
        <path
          d="M37.0234 30.8921C37.5681 31.1237 38.1507 31.2396 38.7333 31.2396C39.8489 31.2396 40.9646 30.8149 41.814 29.9656C42.1 29.6795 42.1 29.2158 41.814 28.9299C41.528 28.6438 41.0643 28.6439 40.7782 28.9298C40.2944 29.4136 39.6805 29.6899 39.0479 29.7585C38.4469 30.2434 37.7636 30.6291 37.0234 30.8921Z"
          fill="#FFCEBF"
        />
        <path
          d="M6.28906 50.0002V38.8892C6.28906 38.4846 5.96113 38.1567 5.55664 38.1567C5.15215 38.1567 4.82422 38.4846 4.82422 38.8892V50.0002H6.28906Z"
          fill="#C4E2FF"
        />
        <path
          d="M28.5117 50.0002V38.8892C28.5117 38.4846 28.1838 38.1567 27.7793 38.1567C27.3748 38.1567 27.0469 38.4846 27.0469 38.8892V50.0002H28.5117Z"
          fill="#C4E2FF"
        />
        <path
          d="M34.0684 47.9548C34.4729 47.9548 34.8008 47.627 34.8008 47.2224V45.8335H33.8242C33.5546 45.8335 33.3359 45.6148 33.3359 45.3452V47.2224C33.3359 47.6269 33.6639 47.9548 34.0684 47.9548Z"
          fill="#C4E2FF"
        />
      </g>
      <defs>
        <clipPath id="clip0_6004_24847">
          <rect width="50" height="50" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const ActionCloseIcon = () => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11 1L1 10.9993M11 11L1 1.00066"
        stroke="white"
        strokeWidth="1.9"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ReasonOfConsultation = () => {
  return (
    <svg
      width="36"
      height="35"
      viewBox="0 0 36 35"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_6828_20580)">
        <path
          d="M6.52902 2.48582C6.16535 2.2953 5.7515 2.1875 5.3125 2.1875C3.86273 2.1875 2.6875 3.36273 2.6875 4.8125V6.125C2.6875 6.51314 2.77179 6.8816 2.923 7.21314L3.4886 7.34152H5.16525L7.44682 5.85826L6.52902 2.48582Z"
          fill="#FFD15B"
        />
        <path
          d="M31.9787 6.9192C31.9824 6.88064 32.3863 6.12356 32.3863 6.08405L31.9041 2.48582C31.5404 2.2953 31.1266 2.1875 30.6875 2.1875C29.2394 2.1875 28.0625 3.36123 28.0625 4.8125V5.35938L31.9787 6.9192Z"
          fill="#0055A3"
        />
        <path
          d="M25.0741 5.06675C25.0492 3.75623 24.0053 2.20092 23.2618 1.2201C22.281 0.476688 21.0682 0.0260634 19.7577 0.00111225C16.3426 -0.0637608 13.5612 2.71764 13.6261 6.13267C13.651 7.44319 14.1016 8.65602 14.8451 9.63685C15.8259 10.3803 17.4996 11.6292 18.8101 11.6541C22.2252 11.719 25.139 8.48178 25.0741 5.06675Z"
          fill="#FE646F"
        />
        <path
          d="M24.5625 17.4626V18.5938L27.5197 20.1144L26.75 16.4062H25.6189C25.0354 16.4062 24.5625 16.8792 24.5625 17.4626Z"
          fill="#FFE5C2"
        />
        <path
          d="M32.1228 25.7832C32.5462 25.7832 33.1583 27.2602 33.5276 27.1096L35.3906 34.562C35.4462 34.7842 35.2781 34.9995 35.049 34.9995H33.5874C33.4258 34.9995 33.285 34.8895 33.2458 34.7327L31.3984 27.3432L32.1228 25.7832Z"
          fill="#B2CAEC"
        />
        <path
          d="M4.1052 26.0723C3.68185 26.0723 2.84062 27.2605 2.47141 27.1099L0.608348 34.5623C0.552772 34.7845 0.720868 34.9998 0.94994 34.9998H2.41153C2.57313 34.9998 2.71395 34.8898 2.75312 34.7331L4.60054 27.3435L4.1052 26.0723Z"
          fill="#B2CAEC"
        />
        <path
          d="M11.8166 10.8199L9.13538 13.5012C8.99784 13.6387 8.77492 13.6387 8.63745 13.5012L6.5663 11.43L5.01953 12.9769L8.13952 16.0969C8.55207 16.5094 9.2209 16.5094 9.63338 16.0969L12.8655 12.8648C13.278 12.4522 13.278 11.7834 12.8655 11.3709L12.3146 10.8201C12.1771 10.6824 11.9542 10.6824 11.8166 10.8199Z"
          fill="#FFCEBF"
        />
        <path
          d="M24.8261 9.54564C24.7632 9.35677 24.7797 9.14896 24.8778 8.97566C25.3993 8.05459 25.6849 6.9823 25.6524 5.84098C25.5989 3.95952 24.6689 2.28827 23.2605 1.2207C24.0039 2.20152 24.4545 3.41436 24.4795 4.72487C24.5444 8.1399 21.7629 10.9213 18.3479 10.8564C17.0374 10.8316 15.8246 10.3809 14.8438 9.63745C15.9113 11.0459 17.5826 11.9759 19.464 12.0293C20.6054 12.0618 21.6776 11.7762 22.5987 11.2548C22.772 11.1567 22.9798 11.1401 23.1687 11.2031L24.9868 11.8092C25.2621 11.9009 25.524 11.639 25.4322 11.3638L24.8261 9.54564Z"
          fill="#FD4755"
        />
        <path
          d="M2.6875 13.8292C2.6875 13.4403 2.37223 13.125 1.98326 13.125H1.20424C0.815273 13.125 0.5 13.4403 0.5 13.8292V24.1747C0.5 25.925 1.9188 27.3438 3.669 27.3438H8.15625L9.71354 25.1562L2.6875 13.8292Z"
          fill="#0055A3"
        />
        <path
          d="M32.4212 24.6145L33.3125 13.1044V11.2522C33.3125 10.4744 33.9431 9.84375 34.721 9.84375H35.1479C35.3424 9.84375 35.5 10.0014 35.5 10.1959V24.1747C35.5 25.925 34.0812 27.3438 32.331 27.3438H27.8438V25.1562H32.2561C32.8396 25.1562 32.4212 25.198 32.4212 24.6145Z"
          fill="#0055A3"
        />
        <path
          d="M7.90336 4.37551C7.76541 3.55308 7.24499 2.86032 6.53125 2.48633V5.86328L7.90336 4.37551Z"
          fill="#FEB237"
        />
        <path
          d="M4.87468 7.65652L5.16493 7.3418H3.48828L4.87468 7.65652Z"
          fill="#FFD15B"
        />
        <path
          d="M12.5312 32.351V30.6248L11.101 28.5215L9.25 30.6248L10.3438 34.9998H13.4441C13.6834 34.9998 13.8775 34.8058 13.8775 34.5664V34.041C13.8774 33.2167 13.3021 32.5269 12.5312 32.351Z"
          fill="#0055A3"
        />
        <path
          d="M3.45132 20.9434L3.33203 23.0684C3.33203 24.222 3.62393 25.1572 4.77756 25.1572H9.2512V30.6259H12.5325V21.876L3.45132 20.9434Z"
          fill="#8AC9FE"
        />
        <path
          d="M7.60938 19.617L6.74777 11.0739C6.51173 10.9858 6.2562 10.9375 5.98939 10.9375H4.85436C3.65766 10.9375 2.6875 11.9077 2.6875 13.1044V15.3125L4.34686 21.0915L7.21515 21.4196C7.40956 21.4196 7.60938 19.8115 7.60938 19.617Z"
          fill="#FE646F"
        />
        <path
          d="M6.74701 11.0742V20.1147C6.74701 20.3092 6.58938 20.4668 6.39489 20.4668H4.10547V21.8753H8.15549L9.71278 20.2346L8.15549 18.594V13.1046C8.15549 12.1747 7.56972 11.3816 6.74701 11.0742Z"
          fill="#FD4755"
        />
        <path
          d="M4.34846 15.8414C4.05677 15.8414 3.82031 15.6049 3.82031 15.3132V13.1258C3.82031 12.8341 4.05677 12.5977 4.34846 12.5977C4.64015 12.5977 4.8766 12.8341 4.8766 13.1258V15.3132C4.8766 15.6049 4.64015 15.8414 4.34846 15.8414Z"
          fill="#FD4755"
        />
        <path
          d="M7.07519 7.55084L6.52783 4.375H5.22593C5.03145 4.375 4.87381 4.53264 4.87381 4.72712V4.78598C4.87381 5.84685 4.19493 6.78877 3.18854 7.12428L2.92188 7.21321C2.9417 7.25669 2.96269 7.29948 2.98477 7.34159L6.41969 8.16539C6.79539 8.25542 7.14081 7.93174 7.07519 7.55084Z"
          fill="#FFDFCF"
        />
        <path
          d="M7.89969 4.375H6.52751V7.05988C6.52751 7.2152 6.40111 7.34159 6.2458 7.34159H2.98438C3.42304 8.17879 4.30029 8.75 5.31099 8.75H6.24587C7.17932 8.75 7.93599 7.99333 7.93599 7.05988V4.8125C7.93599 4.66341 7.92354 4.51726 7.89969 4.375Z"
          fill="#FFCEBF"
        />
        <path
          d="M23.4673 32.351V30.6248L24.8976 28.5215L26.7485 30.6248V34.9998H22.5545C22.3152 34.9998 22.1211 34.8058 22.1211 34.5664V34.041C22.1212 33.2167 22.6964 32.5269 23.4673 32.351Z"
          fill="#0055A3"
        />
        <path
          d="M32.4211 20.6348L23.4688 21.8756V30.6256H26.75V25.1568H30.8477C32.209 25.1568 32.958 24.0533 32.958 22.692L32.4211 20.6348Z"
          fill="#8AC9FE"
        />
        <path
          d="M31.904 26.6769V18.5938H33.3125V13.1044C33.3125 11.9077 32.3423 10.9375 31.1456 10.9375H30.0106C28.8139 10.9375 27.8438 11.9077 27.8438 13.1044V15.3499L28.6382 15.9465L27.8438 16.4062H26.75V18.5938L27.3407 19.5406L26.75 27.6605L31.5519 27.029C31.7464 27.029 31.904 26.8714 31.904 26.6769Z"
          fill="#EAF6FF"
        />
        <path
          d="M27.8449 18.5938C27.5532 18.5938 27.3168 18.8302 27.3168 19.1219C27.3168 19.4136 27.5532 19.65 27.8449 19.65H31.9052V26.6769C31.9052 26.8714 31.7476 27.029 31.5531 27.029H26.5664L27.8449 28.4375H32.9616C33.156 28.4375 33.3137 28.2799 33.3137 28.0854V18.5938H27.8449Z"
          fill="#C4E2FF"
        />
        <path
          d="M30.4208 24.0625H27.8438L26.75 22.8512L27.8438 20.7812H31.125V23.3583C31.125 23.7472 30.8097 24.0625 30.4208 24.0625Z"
          fill="white"
        />
        <path
          d="M10.3438 35.0008H8.33228C8.23507 35.0008 8.15625 34.922 8.15625 34.8247V21.8758L9.38549 21.0625L10.3438 21.8758V35.0008Z"
          fill="#F6AB31"
        />
        <path
          d="M25.6562 35.0008H27.6677C27.7649 35.0008 27.8438 34.922 27.8438 34.8247V21.8758L26.6226 21.0625L25.6562 21.8758V35.0008Z"
          fill="#F6AB31"
        />
        <path
          d="M4.875 25.1562H3.74386C3.16041 25.1562 2.6875 24.6833 2.6875 24.0999V15.3125H4.875V25.1562Z"
          fill="#FFDFCF"
        />
        <path
          d="M22.5698 4.92188H21.0865C20.892 4.92188 20.7344 4.76424 20.7344 4.56976V3.08649C20.7344 2.89201 20.5767 2.73438 20.3823 2.73438H18.899C18.7045 2.73438 18.5469 2.89201 18.5469 3.08649V4.56976C18.5469 4.76424 18.3892 4.92188 18.1948 4.92188H16.7115C16.517 4.92188 16.3594 5.07951 16.3594 5.27399V6.75726C16.3594 6.95174 16.517 7.10938 16.7115 7.10938H18.1948C18.3892 7.10938 18.5469 7.26701 18.5469 7.46149V8.94476C18.5469 9.13924 18.7045 9.29688 18.899 9.29688H20.3823C20.5767 9.29688 20.7344 9.13924 20.7344 8.94476V7.46149C20.7344 7.26701 20.892 7.10938 21.0865 7.10938H22.5698C22.7642 7.10938 22.9219 6.95174 22.9219 6.75726V5.27399C22.9219 5.07951 22.7642 4.92188 22.5698 4.92188Z"
          fill="white"
        />
        <path
          d="M31.8984 6.24203L30.2107 4.55431C30.1035 4.44712 29.9398 4.4206 29.8042 4.48834L28.0625 5.35924V7.05975C28.0625 7.15572 28.0705 7.24986 28.0859 7.34146L31.0242 8.20661C31.6555 8.20654 31.8393 6.85809 31.8984 6.24203Z"
          fill="#FFE5C2"
        />
        <path
          d="M31.904 2.48633V6.12551C31.904 6.16502 31.9021 6.20412 31.8984 6.24268L32.188 7.35276H33.0086C33.2025 6.9867 33.3125 6.56916 33.3125 6.12551V4.81301C33.3125 3.80231 32.7413 2.92499 31.904 2.48633Z"
          fill="#004281"
        />
        <path
          d="M31.125 12.5977C30.8333 12.5977 30.5969 12.8341 30.5969 13.1258V15.3507H27.8438V16.4071H31.125C31.4167 16.4071 31.6531 16.1706 31.6531 15.8789V13.1258C31.6531 12.8341 31.4167 12.5977 31.125 12.5977Z"
          fill="#C4E2FF"
        />
        <path
          d="M26.9856 21.4196L26.4353 18.5938H8.15625V20.4665L26.9856 21.4196Z"
          fill="#FFD15B"
        />
        <path
          d="M26.4353 18.5938V20.1144C26.4353 20.3089 26.2776 20.4665 26.0832 20.4665H8.15625V21.875H27.8438V18.5938H26.4353Z"
          fill="#FEB237"
        />
        <path
          d="M30.6876 7.34154H28.0859C28.2201 8.14094 28.9152 8.75002 29.7527 8.75002H30.6876C31.6927 8.75002 32.5677 8.18421 33.0086 7.35228L31.8985 6.24219C31.8393 6.85824 31.3189 7.34154 30.6876 7.34154Z"
          fill="#FED2A4"
        />
      </g>
      <defs>
        <clipPath id="clip0_6828_20580">
          <rect
            width="35"
            height="35"
            fill="white"
            transform="translate(0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const PhysicalExamIcon = () => {
  return (
    <svg
      width="36"
      height="35"
      viewBox="0 0 36 35"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M32.0651 3.41797H3.94727C3.26942 3.41867 2.61954 3.68826 2.14023 4.16757C1.66092 4.64688 1.39133 5.29676 1.39062 5.97461V26.4799C1.39249 27.1566 1.66272 27.8049 2.14202 28.2827C2.62132 28.7604 3.27055 29.0284 3.94727 29.0281H4.32878L4.80538 31.113C4.83468 31.2466 4.90896 31.3661 5.0158 31.4514C5.12264 31.5368 5.25556 31.5829 5.39231 31.582H8.99738C9.1339 31.5831 9.26665 31.5373 9.37347 31.4523C9.48028 31.3673 9.55468 31.2482 9.58425 31.1149L10.0613 29.0281H25.9426L26.4192 31.113C26.4485 31.2467 26.5229 31.3662 26.6298 31.4516C26.7367 31.537 26.8697 31.583 27.0065 31.582H30.6116C30.7481 31.5831 30.8808 31.5373 30.9876 31.4523C31.0944 31.3673 31.1688 31.2482 31.1984 31.1149L31.6754 29.0281H32.065C32.7406 29.0273 33.3884 28.7586 33.8661 28.2809C34.3438 27.8032 34.6125 27.1555 34.6133 26.4799V5.97461C34.6137 5.2979 34.3456 4.64867 33.8679 4.16936C33.3902 3.69006 32.7418 3.41983 32.0651 3.41797Z"
        fill="#8D9DA7"
      />
      <path
        d="M31.4578 6.30078H4.54688C4.39586 6.30078 4.27344 6.4232 4.27344 6.57422V21.7008C4.27344 21.8519 4.39586 21.9743 4.54688 21.9743H31.4578C31.6088 21.9743 31.7312 21.8519 31.7312 21.7008V6.57422C31.7312 6.4232 31.6088 6.30078 31.4578 6.30078Z"
        fill="#9CE6FB"
      />
      <path
        d="M1.39062 24.3086V26.479C1.39249 27.1557 1.66272 27.8041 2.14202 28.2818C2.62132 28.7595 3.27055 29.0276 3.94727 29.0272H32.0651C32.7407 29.0264 33.3884 28.7577 33.8661 28.28C34.3438 27.8023 34.6125 27.1546 34.6133 26.479V24.3086H1.39062Z"
        fill="#E9F1F3"
      />
      <path
        d="M25.8801 27.2148H11.1641C11.019 27.2148 10.8799 27.1572 10.7774 27.0547C10.6748 26.9521 10.6172 26.813 10.6172 26.668C10.6172 26.5229 10.6748 26.3838 10.7774 26.2813C10.8799 26.1787 11.019 26.1211 11.1641 26.1211H25.8801C26.0252 26.1211 26.1643 26.1787 26.2668 26.2813C26.3694 26.3838 26.427 26.5229 26.427 26.668C26.427 26.813 26.3694 26.9521 26.2668 27.0547C26.1643 27.1572 26.0252 27.2148 25.8801 27.2148Z"
        fill="#8D9DA7"
      />
      <path
        d="M4.54688 27.6755C4.40183 27.6755 4.26274 27.6179 4.16018 27.5153C4.05762 27.4128 4 27.2737 4 27.1286V26.209C4 26.0639 4.05762 25.9248 4.16018 25.8223C4.26274 25.7197 4.40183 25.6621 4.54688 25.6621C4.69192 25.6621 4.83101 25.7197 4.93357 25.8223C5.03613 25.9248 5.09375 26.0639 5.09375 26.209V27.1288C5.09371 27.2738 5.03608 27.4128 4.93353 27.5154C4.83097 27.6179 4.69189 27.6755 4.54688 27.6755Z"
        fill="#8D9DA7"
      />
      <path
        d="M6.28906 27.6755C6.14402 27.6755 6.00492 27.6179 5.90236 27.5153C5.7998 27.4128 5.74219 27.2737 5.74219 27.1286V26.209C5.74219 26.0639 5.7998 25.9248 5.90236 25.8223C6.00492 25.7197 6.14402 25.6621 6.28906 25.6621C6.4341 25.6621 6.5732 25.7197 6.67576 25.8223C6.77832 25.9248 6.83594 26.0639 6.83594 26.209V27.1288C6.8359 27.2738 6.77827 27.4128 6.67571 27.5154C6.57316 27.6179 6.43408 27.6755 6.28906 27.6755Z"
        fill="#8D9DA7"
      />
      <path
        d="M8.02734 27.6755C7.8823 27.6755 7.7432 27.6179 7.64064 27.5153C7.53809 27.4128 7.48047 27.2737 7.48047 27.1286V26.209C7.48047 26.0639 7.53809 25.9248 7.64064 25.8223C7.7432 25.7197 7.8823 25.6621 8.02734 25.6621C8.17238 25.6621 8.31148 25.7197 8.41404 25.8223C8.5166 25.9248 8.57422 26.0639 8.57422 26.209V27.1288C8.57418 27.2738 8.51655 27.4128 8.41399 27.5154C8.31144 27.6179 8.17236 27.6755 8.02734 27.6755Z"
        fill="#8D9DA7"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M29.8359 27.2148C29.981 27.2148 30.1201 27.1572 30.2226 27.0547C30.3252 26.9521 30.3828 26.813 30.3828 26.668C30.3828 26.5229 30.3252 26.3838 30.2226 26.2813C30.1201 26.1787 29.981 26.1211 29.8359 26.1211C29.6909 26.1211 29.5518 26.1787 29.4492 26.2813C29.3467 26.3838 29.2891 26.5229 29.2891 26.668C29.2891 26.813 29.3467 26.9521 29.4492 27.0547C29.5518 27.1572 29.6909 27.2148 29.8359 27.2148Z"
        fill="#1EB07C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M31.4531 27.2148C31.5613 27.2148 31.667 27.1828 31.757 27.1227C31.8469 27.0626 31.917 26.9772 31.9584 26.8772C31.9998 26.7773 32.0106 26.6674 31.9895 26.5613C31.9684 26.4552 31.9163 26.3578 31.8398 26.2813C31.7633 26.2048 31.6659 26.1527 31.5598 26.1316C31.4537 26.1105 31.3438 26.1213 31.2438 26.1627C31.1439 26.2041 31.0585 26.2742 30.9984 26.3641C30.9383 26.4541 30.9062 26.5598 30.9062 26.668C30.9078 26.8125 30.9659 26.9508 31.0681 27.053C31.1703 27.1552 31.3086 27.2133 31.4531 27.2148Z"
        fill="#FB4A59"
      />
      <path
        d="M12.3434 9.18038C12.0345 8.87232 11.6251 8.6858 11.19 8.65494C10.7549 8.62408 10.3232 8.75096 9.97397 9.01235C9.6608 8.77649 9.2791 8.6495 8.88705 8.65073H8.88063C8.64482 8.65047 8.41131 8.69712 8.1937 8.78797C7.97609 8.87882 7.77873 9.01205 7.61311 9.1799C7.42945 9.35962 7.29031 9.57975 7.20678 9.82275C7.12325 10.0658 7.09764 10.3249 7.132 10.5796C7.30467 12.0766 9.2443 13.3329 9.83472 13.6824C9.87688 13.7073 9.92498 13.7205 9.97397 13.7205C10.023 13.7205 10.0711 13.7073 10.1132 13.6824C10.7067 13.3312 12.6556 12.0691 12.8159 10.5796C12.85 10.3257 12.8251 10.0674 12.7431 9.82475C12.6612 9.58209 12.5244 9.36159 12.3434 9.18038Z"
        fill="#FB4A59"
      />
      <path
        d="M12.3421 9.18151C12.1245 8.96433 11.8552 8.80612 11.5595 8.7218C11.2639 8.63747 10.9516 8.6298 10.6521 8.69951C10.9815 8.77534 11.2829 8.94238 11.5218 9.18151C11.7028 9.36271 11.8396 9.5832 11.9215 9.82584C12.0034 10.0685 12.0283 10.3267 11.9942 10.5806C11.8534 11.8892 10.3324 13.0219 9.5625 13.516C9.669 13.5844 9.76129 13.6407 9.83334 13.6834C9.8755 13.7083 9.9236 13.7215 9.97259 13.7215C10.0216 13.7215 10.0697 13.7083 10.1118 13.6834C10.7053 13.3322 12.6542 12.0701 12.8146 10.5806C12.8486 10.3267 12.8237 10.0685 12.7418 9.82584C12.6599 9.5832 12.5231 9.36271 12.3421 9.18151Z"
        fill="#F82F40"
      />
      <path
        d="M26.8977 10.7578H24.0234C23.8784 10.7578 23.7393 10.7002 23.6367 10.5976C23.5342 10.4951 23.4766 10.356 23.4766 10.2109C23.4766 10.0659 23.5342 9.9268 23.6367 9.82424C23.7393 9.72168 23.8784 9.66406 24.0234 9.66406H26.8977C27.0427 9.66406 27.1818 9.72168 27.2844 9.82424C27.3869 9.9268 27.4446 10.0659 27.4446 10.2109C27.4446 10.356 27.3869 10.4951 27.2844 10.5976C27.1818 10.7002 27.0427 10.7578 26.8977 10.7578Z"
        fill="#8D9DA7"
      />
      <path
        d="M28.6057 12.6973H24.0234C23.8784 12.6973 23.7393 12.6396 23.6367 12.5371C23.5342 12.4345 23.4766 12.2954 23.4766 12.1504C23.4766 12.0054 23.5342 11.8663 23.6367 11.7637C23.7393 11.6611 23.8784 11.6035 24.0234 11.6035H28.6057C28.7507 11.6035 28.8898 11.6611 28.9924 11.7637C29.095 11.8663 29.1526 12.0054 29.1526 12.1504C29.1526 12.2954 29.095 12.4345 28.9924 12.5371C28.8898 12.6396 28.7507 12.6973 28.6057 12.6973Z"
        fill="#8D9DA7"
      />
      <path
        d="M25.9414 29.0273L26.0811 29.6385H29.4433C29.5561 29.6385 29.6675 29.664 29.7692 29.7129C29.8709 29.7619 29.9602 29.8332 30.0306 29.9214C30.1009 30.0097 30.1505 30.1126 30.1756 30.2227C30.2007 30.3327 30.2007 30.447 30.1755 30.557L29.9412 31.5813H30.6104C30.7468 31.5824 30.8796 31.5366 30.9864 31.4516C31.0932 31.3665 31.1676 31.2475 31.1971 31.1142L31.6742 29.0273H25.9414Z"
        fill="#7E939E"
      />
      <path
        d="M4.46785 29.6385H7.8297C7.94255 29.6386 8.05396 29.664 8.15563 29.713C8.2573 29.762 8.34663 29.8332 8.41698 29.9215C8.48733 30.0097 8.53689 30.1127 8.56198 30.2227C8.58707 30.3327 8.58704 30.447 8.56189 30.557L8.32804 31.5813H8.997C9.13352 31.5824 9.26627 31.5366 9.37308 31.4516C9.4799 31.3666 9.5543 31.2475 9.58387 31.1142L10.0609 29.0273H4.32812L4.46785 29.6385Z"
        fill="#7E939E"
      />
      <path
        d="M32.5599 5.97461V24.3095H34.6107V5.97461C34.611 5.2979 34.343 4.64867 33.8653 4.16936C33.3875 3.69006 32.7392 3.41983 32.0625 3.41797H30.0117C30.6884 3.41983 31.3368 3.69006 31.8145 4.16936C32.2922 4.64867 32.5603 5.2979 32.5599 5.97461Z"
        fill="#7E939E"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M32.5599 24.3086V26.479C32.5591 27.1546 32.2904 27.8023 31.8127 28.28C31.335 28.7577 30.6873 29.0264 30.0117 29.0272H32.0625C32.7381 29.0264 33.3858 28.7577 33.8635 28.28C34.3412 27.8023 34.6099 27.1546 34.6107 26.479V24.3086H32.5599Z"
        fill="#D1D9DB"
      />
      <path
        d="M31.4578 6.30078H30.1136C30.1861 6.30078 30.2556 6.32959 30.3069 6.38087C30.3582 6.43215 30.387 6.5017 30.387 6.57422V19.5639C30.387 19.7218 30.3559 19.8781 30.2955 20.024C30.235 20.1699 30.1465 20.3025 30.0348 20.4141C29.9231 20.5258 29.7906 20.6144 29.6447 20.6748C29.4988 20.7352 29.3424 20.7663 29.1845 20.7663H4.27344V21.7008C4.27344 21.7734 4.30225 21.8429 4.35353 21.8942C4.40481 21.9455 4.47435 21.9743 4.54688 21.9743H31.4578C31.5303 21.9743 31.5998 21.9455 31.6511 21.8942C31.7024 21.8429 31.7312 21.7734 31.7312 21.7008V6.57422C31.7312 6.5017 31.7024 6.43215 31.6511 6.38087C31.5998 6.32959 31.5303 6.30078 31.4578 6.30078Z"
        fill="#68DBF9"
      />
      <path
        d="M23.4839 19.6361H23.4703C23.3681 19.6335 23.2687 19.6023 23.1834 19.5462C23.0981 19.49 23.0302 19.411 22.9874 19.3182L21.0512 15.1158L18.5308 19.235C18.4764 19.324 18.3976 19.3956 18.3039 19.4412C18.2101 19.4869 18.1053 19.5049 18.0016 19.4929C17.898 19.481 17.8 19.4396 17.7191 19.3738C17.6382 19.308 17.5778 19.2204 17.5451 19.1213L15.7845 13.7988L12.4349 19.1732C12.3857 19.252 12.3174 19.317 12.2362 19.3621C12.155 19.4072 12.0636 19.4308 11.9708 19.4308H11.9697C11.8767 19.4306 11.7853 19.4067 11.704 19.3614C11.6228 19.316 11.5545 19.2506 11.5056 19.1715L9.67041 16.2035H4.27344V15.1097H9.97502C10.0682 15.1097 10.1599 15.1335 10.2413 15.1789C10.3227 15.2243 10.3912 15.2897 10.4402 15.369L11.9724 17.8471L15.473 12.2303C15.528 12.1421 15.6069 12.0714 15.7006 12.0265C15.7943 11.9815 15.8989 11.9642 16.0021 11.9765C16.1052 11.9888 16.2028 12.0303 16.2832 12.0961C16.3637 12.1618 16.4237 12.2492 16.4564 12.3478L18.2132 17.6584L20.6527 13.6713C20.7044 13.5868 20.7781 13.5179 20.8659 13.472C20.9537 13.4261 21.0523 13.405 21.1512 13.4108C21.2501 13.4166 21.3455 13.4491 21.4274 13.505C21.5092 13.5608 21.5743 13.6378 21.6158 13.7278L23.5156 17.8505L24.905 15.1976C24.9468 15.1178 25.0076 15.0496 25.0821 14.999C25.1566 14.9484 25.2424 14.9169 25.3319 14.9075C25.4215 14.898 25.512 14.9108 25.5954 14.9447C25.6788 14.9786 25.7526 15.0326 25.8101 15.1019L26.4509 15.8734H31.7316V16.9672H26.1944C26.1141 16.9672 26.0348 16.9495 25.9621 16.9154C25.8894 16.8812 25.8251 16.8315 25.7738 16.7697L25.4935 16.4321L23.9691 19.343C23.9227 19.4315 23.853 19.5056 23.7674 19.5573C23.6819 19.609 23.5839 19.6362 23.4839 19.6361Z"
        fill="#1EB07C"
      />
    </svg>
  );
};

export const DiagnosisEvoked = () => {
  return (
    <svg
      width="30"
      height="35"
      viewBox="0 0 30 35"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.3707 0.4321V29.4634C22.3707 29.702 22.1772 29.8955 21.9386 29.8955H0.678194C0.439551 29.8955 0.246094 29.702 0.246094 29.4634V0.4321C0.246094 0.193457 0.439551 0 0.678194 0H21.9386C22.1772 0 22.3707 0.193457 22.3707 0.4321Z"
        fill="#DDEBFD"
      />
      <path
        d="M21.9405 0H19.9961C20.2347 0 20.4282 0.193457 20.4282 0.4321V29.4634C20.4282 29.702 20.2347 29.8955 19.9961 29.8955H21.9405C22.1792 29.8955 22.3726 29.702 22.3726 29.4634V0.4321C22.3726 0.193457 22.1792 0 21.9405 0Z"
        fill="#BED9FD"
      />
      <path
        d="M8.07817 4.84526H9.99955C10.0729 4.84526 10.1324 4.78579 10.1324 4.71244V2.79106C10.1324 2.68101 10.2216 2.5918 10.3316 2.5918H12.2872C12.3973 2.5918 12.4865 2.68101 12.4865 2.79106V4.71244C12.4865 4.78579 12.5459 4.84526 12.6193 4.84526H14.5407C14.6507 4.84526 14.7399 4.93447 14.7399 5.04453V7.00009C14.7399 7.11015 14.6507 7.19936 14.5407 7.19936H12.6193C12.5459 7.19936 12.4865 7.25883 12.4865 7.33218V9.25355C12.4865 9.36361 12.3973 9.45282 12.2872 9.45282H10.3316C10.2216 9.45282 10.1324 9.36361 10.1324 9.25355V7.33218C10.1324 7.25883 10.0729 7.19936 9.99955 7.19936H8.07817C7.96811 7.19936 7.87891 7.11015 7.87891 7.00009V5.04453C7.87891 4.93447 7.96811 4.84526 8.07817 4.84526Z"
        fill="#DF646E"
      />
      <path
        d="M18.4028 13.5605V15.2127C18.4028 15.4015 18.2498 15.5545 18.061 15.5545H4.55664C4.3679 15.5545 4.21484 15.4015 4.21484 15.2127V13.5605C4.21484 13.3718 4.3679 13.2188 4.55664 13.2188H18.061C18.2498 13.2188 18.4028 13.3717 18.4028 13.5605Z"
        fill="#6CBFF8"
      />
      <path
        d="M26.0294 16.9744L29.1739 18.7899C29.7302 19.111 29.9208 19.8222 29.5996 20.3785L27.7994 23.4964L24.6092 23.0651L22.6406 20.518L24.4408 17.4C24.7619 16.8438 25.4732 16.6532 26.0294 16.9744Z"
        fill="#407194"
      />
      <path
        d="M4.21484 13.2188H11.3088V15.5545H4.21484V13.2188Z"
        fill="#5392F9"
      />
      <path
        d="M24.6105 23.0643L21.0546 22.4219L18.0508 27.6247L20.3939 32.0011L25.9043 27.6247L26.9448 25.8226L24.6105 23.0643Z"
        fill="#6CBFF8"
      />
      <path
        d="M20.6912 22.2138L27.303 26.0312C27.7847 26.3093 28.4005 26.1443 28.6786 25.6626L28.8932 25.291C29.1713 24.8093 29.0063 24.1935 28.5246 23.9154L21.9128 20.098C21.4311 19.8199 20.8153 19.9849 20.5372 20.4666L20.3226 20.8382C20.0445 21.3198 20.2095 21.9358 20.6912 22.2138Z"
        fill="#FFA95F"
      />
      <path
        d="M28.5243 23.9155L26.9013 22.9785C27.3588 23.2427 27.5155 23.8277 27.2513 24.2851L26.9863 24.7442C26.7222 25.2018 26.1372 25.3585 25.6797 25.0944L27.3027 26.0314C27.7843 26.3095 28.4002 26.1445 28.6783 25.6629L28.8929 25.2912C29.1709 24.8095 29.0059 24.1936 28.5243 23.9155Z"
        fill="#FF8B5A"
      />
      <path
        d="M25.4166 24.9414L23.8672 27.625L24.9063 28.5137L25.9029 27.625L26.9434 25.8229L25.4166 24.9414Z"
        fill="#5FA7EE"
      />
      <path
        d="M22.6276 33.2986C21.6885 34.9252 19.6087 35.4824 17.9822 34.5434C16.3556 33.6043 15.7984 31.5245 16.7374 29.8979L18.0497 27.625H25.9032L22.6276 33.2986Z"
        fill="#5392F9"
      />
      <path
        d="M23.8693 27.6251L20.8601 32.8372C20.1602 34.0493 18.7216 34.5684 17.4414 34.1548C17.5644 34.2625 17.6968 34.3629 17.8381 34.4542C19.4799 35.5138 21.6604 34.9768 22.6293 33.2987L25.905 27.625H23.8693V27.6251Z"
        fill="#4071F7"
      />
      <path
        d="M29.1722 18.7893L27.7374 17.9609C28.2658 18.266 28.4468 18.9416 28.1418 19.47L26.3125 22.6384L27.7977 23.4959L29.5979 20.3779C29.9191 19.8217 29.7285 19.1104 29.1722 18.7893Z"
        fill="#365F7E"
      />
      <path
        d="M17.2244 19.0993H16.2742C15.9825 19.0993 15.7461 18.8628 15.7461 18.5711C15.7461 18.2794 15.9825 18.043 16.2742 18.043H17.2244C17.5162 18.043 17.7526 18.2794 17.7526 18.5711C17.7526 18.8628 17.5162 19.0993 17.2244 19.0993Z"
        fill="#5392F9"
      />
      <path
        d="M10.1308 19.0993H5.39143C5.09974 19.0993 4.86328 18.8628 4.86328 18.5711C4.86328 18.2794 5.09974 18.043 5.39143 18.043H10.1308C10.4225 18.043 10.6589 18.2794 10.6589 18.5711C10.6589 18.8628 10.4225 19.0993 10.1308 19.0993Z"
        fill="#6CBFF8"
      />
      <path
        d="M17.2244 22.1559H16.2742C15.9825 22.1559 15.7461 21.9194 15.7461 21.6278C15.7461 21.3361 15.9825 21.0996 16.2742 21.0996H17.2244C17.5162 21.0996 17.7526 21.3361 17.7526 21.6278C17.7526 21.9194 17.5162 22.1559 17.2244 22.1559Z"
        fill="#5392F9"
      />
      <path
        d="M10.1308 22.1559H5.39143C5.09974 22.1559 4.86328 21.9194 4.86328 21.6278C4.86328 21.3361 5.09974 21.0996 5.39143 21.0996H10.1308C10.4225 21.0996 10.6589 21.3361 10.6589 21.6278C10.6589 21.9194 10.4225 22.1559 10.1308 22.1559Z"
        fill="#6CBFF8"
      />
      <path
        d="M17.2244 25.2106H16.2742C15.9825 25.2106 15.7461 24.9741 15.7461 24.6824C15.7461 24.3908 15.9825 24.1543 16.2742 24.1543H17.2244C17.5162 24.1543 17.7526 24.3908 17.7526 24.6824C17.7526 24.9741 17.5162 25.2106 17.2244 25.2106Z"
        fill="#5392F9"
      />
      <path
        d="M10.1308 25.2106H5.39143C5.09974 25.2106 4.86328 24.9741 4.86328 24.6824C4.86328 24.3908 5.09974 24.1543 5.39143 24.1543H10.1308C10.4225 24.1543 10.6589 24.3908 10.6589 24.6824C10.6589 24.9741 10.4225 25.2106 10.1308 25.2106Z"
        fill="#6CBFF8"
      />
    </svg>
  );
};

export const ComplimentaryExamIcon = () => {
  return (
    <svg
      width="36"
      height="35"
      viewBox="0 0 36 35"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.3329 18.9286L17.3462 18.1816L16.5408 20.2046H14.043V21.5432C14.043 22.0539 14.457 22.468 14.9677 22.468H17.8755C18.3862 22.468 18.8002 22.0539 18.8002 21.5432V19.8685C18.8002 19.4993 18.6273 19.1515 18.3329 18.9286Z"
        fill="#C4E2FF"
      />
      <path
        d="M17.506 5.47126L15.8934 9.4065C15.3553 10.7199 13.5933 11.2417 12.28 10.7037L11.5448 12.4987L8.93137 11.4283L9.66658 9.6325C8.9877 8.86209 8.70743 7.99871 8.67291 7.1635C8.64119 6.41981 9.35069 5.75085 9.60143 5.13883L11.4009 3.21875L16.8786 5.21416L17.506 5.47126Z"
        fill="#FFDFCF"
      />
      <path
        d="M17.5073 5.47097L15.8947 9.40621C15.8559 9.49986 15.8115 9.59003 15.7601 9.67596C15.5643 10.0112 15.2805 10.283 14.9475 10.4851C14.1743 10.9556 13.1334 11.0527 12.2812 10.7035C12.534 10.6471 12.765 10.5302 12.9566 10.3675C13.1488 10.2049 13.3017 9.99643 13.3989 9.75628L15.2651 5.13867L16.8799 5.214L17.5073 5.47097Z"
        fill="#FFCEBF"
      />
      <path
        d="M19.0768 4.05832L18.5571 5.32522C18.3093 5.93157 17.6163 6.22169 17.0106 5.97313L15.6966 5.43515L13.8304 4.67034C13.688 4.61196 13.5253 4.68012 13.467 4.82258L13.2814 5.27587C13.2139 5.44082 13.0254 5.51984 12.8605 5.45237L12.307 5.22597C11.7719 5.00626 11.143 5.21961 10.8838 5.73723C10.7936 5.91749 10.7584 6.10972 10.7697 6.29641C10.7711 6.31924 10.7733 6.342 10.7761 6.36463C10.8039 6.587 10.6627 6.79468 10.4423 6.83494L8.67183 7.15835C8.64011 6.41542 8.80704 5.69143 9.05772 5.07947L10.2986 2.05129C10.5302 1.48507 11.1775 1.21396 11.7436 1.44563L12.3669 1.70129L13.0507 1.04422C13.4415 0.668857 14.0183 0.559004 14.5204 0.763945L16.1507 1.43154L18.3542 2.33368C19.0304 2.61047 19.3536 3.38225 19.0768 4.05832Z"
        fill="#678D98"
      />
      <path
        d="M14.1422 15.0102L12.7302 24.619L3.28516 24.0618L5.78807 13.6394C6.00039 12.1947 7.34372 11.195 8.78904 11.4074L11.8122 11.8516C13.3227 12.0857 14.3649 13.4944 14.1422 15.0102Z"
        fill="#EAF6FF"
      />
      <path
        d="M8.78626 11.4072L9.97708 11.5825L7.83203 11.441C8.13623 11.3734 8.45882 11.3593 8.78626 11.4072Z"
        fill="#D8ECFE"
      />
      <path
        d="M14.1385 15.0095L12.7265 24.6186L10.6732 24.2574L12.0725 14.7341C12.295 13.2186 11.4871 11.8158 9.97656 11.582L11.8089 11.851C13.3195 12.0856 14.361 13.494 14.1385 15.0095Z"
        fill="#D8ECFE"
      />
      <path
        d="M17.3462 18.1829L17.2046 19.5788C17.1696 19.9239 16.8867 20.1907 16.5408 20.2059H14.043L14.1409 17.4315L16.6256 17.3444C17.0521 17.3239 17.3893 17.7578 17.3462 18.1829Z"
        fill="#FFB09E"
      />
      <path
        d="M11.1362 20.2057L6.17246 21.2422C3.22562 21.6066 2.98527 18.758 3.49824 17.8807L5.86621 13.5176C6.41677 12.6363 7.6037 12.4151 8.43488 13.0389C9.14609 13.5727 9.35206 14.5506 8.91654 15.3259L7.23832 18.1583L11.2342 17.4313L11.1362 20.2057Z"
        fill="#D8ECFE"
      />
      <path
        d="M14.44 18.1829L14.2983 19.5788C14.2633 19.9239 13.9804 20.1907 13.6345 20.2059H11.1367L11.2347 17.4315L13.7193 17.3444C14.1459 17.3239 14.4831 17.7578 14.44 18.1829Z"
        fill="#FFDFCF"
      />
      <path
        d="M15.4228 18.9286L14.4361 18.1816L13.6306 20.2046H11.1328V21.5432C11.1328 22.0539 11.5469 22.468 12.0576 22.468H14.9653C15.476 22.468 15.8901 22.0539 15.8901 21.5432V19.8685C15.8901 19.4993 15.7171 19.1515 15.4228 18.9286Z"
        fill="#D8ECFE"
      />
      <path
        d="M0.5 32.2908L18.268 31.459L35.5 32.2908V33.6453C35.5 34.0274 35.1902 34.3373 34.8081 34.3373H1.19193C0.809805 34.3373 0.5 34.0275 0.5 33.6454L0.5 32.2908Z"
        fill="#D8ECFE"
      />
      <path
        d="M35.5002 32.291V33.6452C35.5002 34.0276 35.1904 34.3375 34.808 34.3375H32.6953C33.0777 34.3375 33.3876 34.0276 33.3876 33.6452V32.291H35.5002Z"
        fill="#C4E2FF"
      />
      <path
        d="M0.5 29.2677V32.2921H35.5V25.0625H5.05021L0.5 29.2677Z"
        fill="#EAF6FF"
      />
      <path
        d="M33.3867 25.0625H35.4994V32.2921H33.3867V25.0625Z"
        fill="#D8ECFE"
      />
      <path
        d="M32.8137 22.7941L32.6334 24.3216C32.5454 25.0639 32.0983 25.716 31.4363 26.0639L29.1863 27.2477L29.5863 29.5977C28.9221 29.5977 28.7482 29.6674 28.0694 29.3554C27.3074 29.0054 26.6116 28.4159 26.1545 27.4927H24.206L23.5039 24.6575H26.1545C26.1545 23.7322 26.6419 22.8019 27.3735 22.2625C27.6869 22.0315 28.0454 21.8724 28.4299 21.8167C28.5292 21.8026 28.6313 21.7949 28.7341 21.7949H31.9256C32.4616 21.7948 32.8764 22.2624 32.8137 22.7941Z"
        fill="#FFA78F"
      />
      <path
        d="M21.5509 30.2904L10.4712 28.9329L8.03516 26.3795L9.59983 22.4688H21.5717C23.1166 22.4688 24.2048 23.0464 24.2048 24.5906V27.6364C24.2047 29.1022 23.0166 30.2904 21.5509 30.2904Z"
        fill="#FFE177"
      />
      <path
        d="M34.4438 27.4351C34.9776 29.7372 32.2339 30.1654 32.2339 30.1654C31.6536 30.6823 30.9924 30.6429 30.9924 30.6429C30.6424 30.6429 30.2902 30.5563 30.0262 30.3823C29.7613 30.2076 29.5846 29.9464 29.5846 29.5964L29.2043 27.3618C29.1915 27.2868 29.2031 27.2097 29.2372 27.1417L31.9241 21.7935C31.9241 21.7935 33.453 20.8936 34.4558 21.5358C36.1804 22.6407 34.9748 24.2513 34.9748 24.2513C36.4107 26.4746 34.4438 27.4351 34.4438 27.4351Z"
        fill="#8EBAC5"
      />
      <path
        d="M9.60034 22.4688V30.2904H0.5V25.1227C0.5 24.6392 0.841182 24.2229 1.31532 24.1279L9.60034 22.4688Z"
        fill="#8AC9FE"
      />
      <path
        d="M9.60093 22.4688V30.2898H7.48828V22.892L9.60093 22.4688Z"
        fill="#60B7FF"
      />
      <path
        d="M16.4981 26.5605L17.3494 28.6761L16.4981 30.29H6.70845C6.29562 30.29 5.96094 29.9553 5.96094 29.5425V28.7435C5.96094 28.2109 6.33609 27.7522 6.85802 27.6465L8.96602 27.2196L16.4981 26.5605Z"
        fill="#FFA78F"
      />
      <path
        d="M33.4424 16.5753H22.2101C21.0736 16.5753 20.1523 15.654 20.1523 14.5176V7.31166C20.1523 6.17519 21.0736 5.25391 22.2101 5.25391H33.4424C34.5788 5.25391 35.5001 6.17519 35.5001 7.31166V14.5176C35.5001 15.654 34.5788 16.5753 33.4424 16.5753Z"
        fill="#8AC9FE"
      />
      <path
        d="M22.4998 28.3833C22.5231 29.4313 21.6805 30.29 20.6354 30.29H16.5V26.5605H20.5979C21.6181 26.5605 22.4779 27.3639 22.4998 28.3833Z"
        fill="#FFD15B"
      />
      <path
        d="M35.5015 7.37366V14.4554C35.5015 15.6265 34.5522 16.5751 33.3818 16.5751H31.5156C32.6861 16.5751 33.6353 15.6265 33.6353 14.4554V7.37366C33.6353 6.20321 32.686 5.25391 31.5156 5.25391H33.3818C34.5522 5.25391 35.5015 6.20321 35.5015 7.37366Z"
        fill="#60B7FF"
      />
      <path
        d="M33.635 7.49085V10.7387L33.189 11.1628L33.635 11.7951V14.3381C33.635 14.5571 33.4576 14.7345 33.2385 14.7345H22.416C22.197 14.7345 22.0195 14.5571 22.0195 14.3381V11.7951L22.3828 11.4212L22.0195 10.7388V7.49092C22.0195 7.27189 22.197 7.09375 22.416 7.09375H33.2385C33.4576 7.09368 33.635 7.27183 33.635 7.49085Z"
        fill="#9CF8D2"
      />
      <path
        d="M19.0755 4.05835L18.5559 5.32525C18.308 5.9316 17.615 6.22172 17.0094 5.97316L15.6953 5.43518L16.4267 3.62604C16.7218 2.8961 16.6169 2.06526 16.1495 1.43164L18.353 2.33378C19.0291 2.6105 19.3523 3.38228 19.0755 4.05835Z"
        fill="#5F8189"
      />
      <path
        d="M34.4451 27.4351C34.9789 29.7372 32.2352 30.1654 32.2352 30.1654C31.6549 30.6823 30.9937 30.6429 30.9937 30.6429C30.6437 30.6429 30.2915 30.5563 30.0275 30.3823C29.7626 30.2076 29.5859 29.9464 29.5859 29.5964C29.5859 29.5964 32.0775 28.8196 32.8197 25.9739C33.562 23.1281 31.9254 21.7935 31.9254 21.7935C31.9254 21.7935 33.4543 20.8936 34.4571 21.5358C36.1817 22.6407 34.9761 24.2513 34.9761 24.2513C36.412 26.4746 34.4451 27.4351 34.4451 27.4351Z"
        fill="#7CA1B1"
      />
      <path
        d="M15.759 9.67649C15.5632 10.0117 15.2794 10.2835 14.9463 10.4857L14.0471 10.1167C13.7766 10.0061 13.6478 9.69761 13.7583 9.42794C13.8689 9.15751 14.1774 9.02865 14.447 9.13919L15.759 9.67649Z"
        fill="#FFB09E"
      />
      <path
        d="M28.4313 21.8164V23.2396C28.4313 23.5319 28.1954 23.7678 27.9031 23.7678C27.6116 23.7678 27.375 23.5319 27.375 23.2396V22.2622C27.6883 22.0312 28.0468 21.8721 28.4313 21.8164Z"
        fill="#DB7163"
      />
      <path
        d="M22.0195 10.7389H24.8505L25.5885 9.19103C25.6766 9.00652 25.8624 8.88819 26.0681 8.88963C26.2724 8.89106 26.4582 9.01008 26.5442 9.19595L27.7076 11.7037L28.9681 8.60231C29.0491 8.40373 29.242 8.27344 29.4561 8.27344H29.4576C29.6717 8.27344 29.8646 8.40229 29.9456 8.60088L30.8245 10.7389H33.635V11.7952H30.4709C30.2562 11.7952 30.0639 11.6656 29.9822 11.4678L29.4604 10.1974L28.2287 13.2263C28.1491 13.4214 27.9625 13.5502 27.7519 13.5552C27.7477 13.5552 27.7435 13.5558 27.7393 13.5558C27.5337 13.5558 27.3471 13.4368 27.2604 13.2495L26.059 10.6594L25.6611 11.4939C25.5731 11.6777 25.3879 11.7953 25.1844 11.7953H22.0196L22.0195 10.7389Z"
        fill="#678D98"
      />
    </svg>
  );
};

export const DiagnosisRetained = () => {
  return (
    <svg
      width="30"
      height="35"
      viewBox="0 0 30 35"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.75 19.5996L13.25 9.09961L23.4 14.6996L24.45 19.2496L20.6 27.9996L16.05 31.4996C14.65 30.2163 11.78 27.5096 11.5 26.9496C11.22 26.3896 10.2167 21.8163 9.75 19.5996Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26.6484 18.1053L23.0951 17.1191L20.8323 25.242C20.226 27.4199 18.7455 29.1328 16.8728 30.1069C16.6968 30.5362 16.4887 30.9394 16.2486 31.3186C16.1146 31.5322 15.9705 31.7379 15.8164 31.9355C19.6238 32.4006 23.3291 30.019 24.3855 26.2281L26.6484 18.1053Z"
        fill="#DDDAEC"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.144 14.6381L18.2755 15.784L26.6465 18.1056L28.9094 9.98274C30.0718 5.8105 27.6009 1.44671 23.4194 0.286833C19.2359 -0.872972 14.8643 1.59037 13.6999 5.76459L12.3594 10.5816C12.3594 13.5242 13.1397 14.3606 14.144 14.6381Z"
        fill="#EB5468"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.3592 8.9972L23.0965 17.12L26.6497 18.1061L28.9126 9.98327C30.075 5.81103 27.6041 1.44724 23.4226 0.287361C22.8104 0.117711 22.1962 0.0258784 21.5859 0.00390625C24.695 1.73273 26.3516 5.43384 25.3592 8.9972Z"
        fill="#E5384F"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.48309 8.46875C3.79374 8.46875 0.804688 11.4532 0.804688 15.1343C0.804688 17.7315 2.29126 19.9793 4.46403 21.0813C6.9509 22.1872 10.006 22.1592 12.3289 19.7218C13.4653 18.528 14.1635 16.9111 14.1635 15.1343C14.1635 14.9667 14.1576 14.801 14.1455 14.6373C14.0295 13.0722 13.3732 11.6589 12.3608 10.5809C11.1424 9.28123 9.40777 8.46875 7.48309 8.46875Z"
        fill="#FFD772"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.5595 27.1136L17.3163 28.6487C18.0486 24.9876 16.0859 21.2146 12.4845 19.7833C12.4325 19.7633 12.3805 19.7433 12.3285 19.7234C11.5462 19.4319 10.7439 19.2702 9.94964 19.2323C7.94293 19.1326 5.98022 19.8073 4.46365 21.0829C3.84942 21.5959 3.31124 22.2088 2.87109 22.9094L9.5595 27.1136Z"
        fill="#B1E4F9"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.25 31.3193L9.55352 27.9795L1.80679 25.582C1.07854 29.2392 3.04124 33.0102 6.63855 34.4395C7.5949 34.8188 8.58322 35.0004 9.55359 35.0004H9.56761C11.9945 34.9984 14.3193 33.8725 15.8178 31.9361C15.9719 31.7385 16.1159 31.5329 16.25 31.3193Z"
        fill="#B1E4F9"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.13093 8.67578C10.6615 10.3088 12.6262 16.2636 8.80078 19.26C9.18093 19.2221 9.56509 19.2121 9.95122 19.2321C10.7455 19.27 11.5478 19.4317 12.3301 19.7231C13.4665 18.5294 14.1647 16.9124 14.1647 15.1357C14.1647 14.968 14.1587 14.8023 14.1467 14.6386C14.0306 13.0735 13.3744 11.6602 12.362 10.5822C11.5018 9.66594 10.3874 8.99318 9.13093 8.67578Z"
        fill="#FBBA58"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.2495 31.3192L12.5182 29.8359C12.4422 30.0895 12.3602 30.335 12.2681 30.5786C11.5899 32.3912 10.4915 33.9243 9.125 34.9883C9.26704 34.9963 9.41113 35.0003 9.55318 35.0003H9.56719C11.9941 34.9983 14.3189 33.8724 15.8174 31.936C15.9715 31.7384 16.1155 31.5328 16.2495 31.3192Z"
        fill="#75CEF8"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.0098 26.9381L17.3153 28.6489C18.0476 24.9877 16.0849 21.2148 12.4836 19.7834C12.4315 19.7635 12.3795 19.7435 12.3275 19.7236C11.8213 19.5339 11.3071 19.4002 10.793 19.3203C11.0591 19.6717 11.3052 20.045 11.5292 20.4402C12.4736 22.1031 13.0258 24.1233 13.0258 26.3013C13.0258 26.5149 13.0218 26.7265 13.0098 26.9381Z"
        fill="#75CEF8"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.3162 28.6475L8.98725 25.3377L2.87104 22.9082C2.61892 23.3074 2.39885 23.7367 2.21681 24.1918C2.03476 24.651 1.8987 25.1141 1.80469 25.5812L10.6839 29.1086L16.2479 31.3185C16.502 30.9173 16.7221 30.4861 16.9041 30.0289C17.0862 29.5738 17.2222 29.1107 17.3162 28.6475Z"
        fill="#75CEF8"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.5156 29.8361L16.2469 31.3193C16.501 30.918 16.7211 30.4868 16.9032 30.0297C17.0852 29.5746 17.2213 29.1115 17.3153 28.6483L13.0097 26.9375C12.9598 27.9496 12.7897 28.9237 12.5156 29.8361Z"
        fill="#60B7FF"
      />
      <path
        d="M9.18672 15.0134H9.17271C8.88101 15.0134 8.64453 14.7769 8.64453 14.4852C8.64453 14.1935 8.88101 13.957 9.17271 13.957H9.18672C9.47842 13.957 9.7149 14.1935 9.7149 14.4852C9.7149 14.7769 9.47842 15.0134 9.18672 15.0134Z"
        fill="#FBBA58"
      />
      <path
        d="M7.70625 17.8845H7.69224C7.40054 17.8845 7.16406 17.648 7.16406 17.3563C7.16406 17.0646 7.40054 16.8281 7.69224 16.8281H7.70625C7.99795 16.8281 8.23443 17.0646 8.23443 17.3563C8.23443 17.648 7.99795 17.8845 7.70625 17.8845Z"
        fill="#FBBA58"
      />
      <path
        d="M4.87236 15.7771H4.8563C4.56461 15.7771 4.32812 15.5406 4.32812 15.2489C4.32812 14.9572 4.56461 14.7207 4.8563 14.7207H4.87236C5.16405 14.7207 5.40053 14.9572 5.40053 15.2489C5.40053 15.5406 5.16405 15.7771 4.87236 15.7771Z"
        fill="#FBBA58"
      />
      <path
        d="M6.80782 12.3454H6.7938C6.50211 12.3454 6.26562 12.1089 6.26562 11.8172C6.26562 11.5255 6.50211 11.2891 6.7938 11.2891H6.80782C7.09951 11.2891 7.33599 11.5255 7.33599 11.8172C7.33599 12.1089 7.09951 12.3454 6.80782 12.3454Z"
        fill="#FBBA58"
      />
    </svg>
  );
};

export const ClinicalTreatmentIcon = () => {
  return (
    <svg
      width="36"
      height="35"
      viewBox="0 0 36 35"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_6828_20777)">
        <path
          d="M6.84024 12.6895H6.00981C5.70015 12.9667 5.35938 13.2648 5.35938 13.2648V15.6064H7.24315V13.1064L6.84024 12.6895Z"
          fill="#6B7ED9"
        />
        <path
          d="M5.48437 14.1369C5.48437 13.367 6.086 12.7392 6.84458 12.6938L6.84034 12.6895H4.46697C3.66758 12.6895 3.01953 13.3375 3.01953 14.1369V16.7425H3.42278L4.37346 15.6064H5.4843L5.48437 14.1369Z"
          fill="#4D66D2"
        />
        <path
          d="M31.5338 12.6895H29.1605L28.8125 13.0652V17.9597H31.7703L32.5273 18.9478H32.9812V14.137C32.9813 13.3375 32.3332 12.6895 31.5338 12.6895Z"
          fill="#6B7ED9"
        />
        <path
          d="M29.1591 4.33651L28.3182 3.96881L25.0611 0.729395L24.8226 0H9.88687L9.16328 0.447686L8.74219 1.43356V15.8183H11.8863L14.1163 17.9594H28.5529L29.1592 17.5V4.33651H29.1591Z"
          fill="#DBEDFF"
        />
        <path
          d="M9.30461 1.3369C9.30461 0.598623 9.90323 0 10.6416 0H8.17682C7.43847 0 6.83984 0.598623 6.83984 1.3369V15.2948L7.14302 15.8183H9.60778L9.30461 15.2948V1.3369Z"
          fill="#B5DCFF"
        />
        <path
          d="M24.8203 0L29.1568 4.33651H26.1573C25.4189 4.33651 24.8204 3.73796 24.8204 2.99961V0L24.8203 0Z"
          fill="#B5DCFF"
        />
        <path
          d="M31.5313 17.5001H14.7561C14.3706 17.5001 14.001 17.3462 13.7292 17.0727L12.3876 15.7222C12.1159 15.4487 11.7463 15.2949 11.3607 15.2949H6.22433L5.35938 15.8184V34.274L6.1006 35.0001H31.5313C32.3307 35.0001 32.9788 34.352 32.9788 33.5526V18.9475C32.9788 18.1481 32.3307 17.5001 31.5313 17.5001Z"
          fill="#8896E0"
        />
        <path
          d="M5.48437 33.5527V16.7424C5.48437 15.943 6.13241 15.2949 6.93181 15.2949H4.46697C3.66758 15.2949 3.01953 15.943 3.01953 16.7424V33.5527C3.01953 34.3521 3.66758 35.0001 4.46697 35.0001H6.93181C6.13241 35.0001 5.48437 34.3521 5.48437 33.5527Z"
          fill="#6B7ED9"
        />
        <path
          d="M18.9017 4.4707H18.4425L17.7734 5.49951V6.96076L18.1784 7.54175L18.7223 7.74211C19.3735 7.46231 19.8296 6.81536 19.8296 6.0617C19.8296 5.37947 19.4556 4.78488 18.9017 4.4707Z"
          fill="#FFCEBE"
        />
        <path
          d="M17.9727 6.06272C17.9727 5.38049 18.3467 4.7859 18.9006 4.47172C18.6347 4.32092 18.3277 4.23438 18.0001 4.23438C16.9904 4.23438 16.1719 5.05291 16.1719 6.06265C16.1719 7.07238 16.9904 7.89092 18.0001 7.89092C18.3276 7.89092 18.6347 7.80438 18.9006 7.65357C18.3467 7.33953 17.9727 6.74501 17.9727 6.06272Z"
          fill="#FFB1A0"
        />
        <path
          d="M19.2081 9.92188H18.2049L17.5355 10.219L16.9688 10.9937V13.4057L17.3412 13.7111H20.5497C20.93 13.7111 21.2383 13.4028 21.2383 13.0225V11.9522C21.2383 10.8308 20.3293 9.92188 19.2081 9.92188Z"
          fill="#FF7AB9"
        />
        <path
          d="M17.0926 13.0224V11.9521C17.0926 10.8308 18.0015 9.92188 19.1228 9.92188H16.8467C15.7254 9.92188 14.8164 10.8308 14.8164 11.9521V13.0224C14.8164 13.4027 15.1247 13.711 15.505 13.711H17.7812C17.4009 13.711 17.0926 13.4027 17.0926 13.0224Z"
          fill="#FF5CA8"
        />
        <path
          d="M21.6846 24.8914H19.918C19.629 24.8914 19.3947 24.657 19.3947 24.368V22.6014C19.3947 22.3124 19.1604 22.0781 18.8713 22.0781H18.6573L18.2836 22.4721V24.532H16.5806C16.5117 24.7407 16.3156 24.8915 16.0838 24.8915H15.7377L15.4844 25.2714V27.3488L15.8381 27.6789H16.0839C16.233 27.6789 16.3673 27.7417 16.4627 27.8418H18.1253L18.319 28.2644V30.1482L18.6625 30.4922H18.8714C19.1605 30.4922 19.3948 30.2579 19.3948 29.9689V28.2023C19.3948 27.9133 19.6291 27.6789 19.9182 27.6789H21.6848C21.9738 27.6789 22.2081 27.4447 22.2081 27.1556V25.4147C22.2079 25.1257 21.9737 24.8914 21.6846 24.8914Z"
          fill="#DBEDFF"
        />
        <path
          d="M18.5078 29.9688V28.2022C18.5078 27.9132 18.2735 27.6789 17.9844 27.6789H16.2178C15.9288 27.6789 15.6945 27.4446 15.6945 27.1555V25.4147C15.6945 25.1257 15.9288 24.8913 16.2178 24.8913H17.9844C18.2734 24.8913 18.5078 24.657 18.5078 24.368V22.6014C18.5078 22.3397 18.7 22.1236 18.9508 22.0849C18.9246 22.0809 18.8979 22.0781 18.8705 22.0781H17.1297C16.8406 22.0781 16.6063 22.3124 16.6063 22.6014V24.368C16.6063 24.657 16.372 24.8914 16.0829 24.8914H14.3163C14.0273 24.8914 13.793 25.1257 13.793 25.4147V27.1556C13.793 27.4446 14.0273 27.6789 14.3163 27.6789H16.0829C16.372 27.6789 16.6063 27.9133 16.6063 28.2023V29.9689C16.6063 30.2579 16.8406 30.4922 17.1297 30.4922H18.8705C18.8979 30.4922 18.9246 30.4895 18.9508 30.4854C18.7 30.4467 18.5078 30.2305 18.5078 29.9688Z"
          fill="#B5DCFF"
        />
      </g>
      <defs>
        <clipPath id="clip0_6828_20777">
          <rect
            width="35"
            height="35"
            fill="white"
            transform="translate(0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const PreviousIcon = ({ fillColor, onClick }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="34"
      height="34"
      viewBox="0 0 34 34"
      fill="none"
      onClick={onClick}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.9913 33.9917C19.2527 33.9917 21.5142 33.9987 23.7756 33.9893C25.5186 33.9823 27.2217 33.7301 28.8333 33.0322C31.4665 31.8874 32.9773 29.8184 33.5931 27.0737C33.8065 26.126 33.952 25.1407 33.959 24.1695C33.9942 19.3323 33.9907 14.4975 33.9614 9.66031C33.9508 8.08037 33.6411 6.53678 32.9913 5.08234C31.8313 2.48898 29.7681 1.02633 27.061 0.383561C25.8552 0.0950184 24.6295 -0.00116236 23.392 1.05781e-05C19.0146 0.00352939 14.6396 0.00235653 10.2587 0.0047024C8.82417 0.00587534 7.41312 0.181816 6.04548 0.625185C2.95479 1.62805 1.10742 3.77804 0.394276 6.90508C0.178455 7.84226 0.0306664 8.81697 0.0259743 9.77291C-0.0103874 14.6347 -0.00687027 19.4954 0.0212822 24.3549C0.0318375 25.9242 0.339146 27.4561 0.983089 28.9C2.13726 31.4957 4.19693 32.963 6.90524 33.6128C8.15676 33.9143 9.43175 34.0034 10.7173 33.9999C12.8086 33.994 14.9 33.9976 16.9925 33.9976C16.9913 33.9952 16.9913 33.994 16.9913 33.9917ZM2.32024 16.9982H2.31672C2.31672 14.8822 2.28387 12.7651 2.33079 10.6503C2.35542 9.59228 2.43284 8.51904 2.64631 7.48451C3.12839 5.11518 4.51363 3.46955 6.88413 2.81036C7.80606 2.55467 8.78311 2.37051 9.73671 2.35996C14.3311 2.31069 18.9267 2.31304 23.5222 2.33884C24.5051 2.34588 25.5045 2.45145 26.4698 2.64615C28.9682 3.15052 30.6197 4.6378 31.253 7.13498C31.4677 7.98301 31.6249 8.87327 31.6319 9.74476C31.6694 14.521 31.6671 19.2972 31.6401 24.0733C31.6354 24.8885 31.5146 25.7143 31.3422 26.5142C30.8367 28.8624 29.4878 30.5128 27.1302 31.1731C26.1965 31.437 25.2089 31.6271 24.2448 31.6364C19.6375 31.688 15.0302 31.6834 10.4229 31.6575C9.44934 31.6517 8.46408 31.5485 7.51283 31.3526C4.93471 30.8271 3.27266 29.2741 2.69206 26.6866C2.47858 25.7377 2.36012 24.7537 2.33666 23.7825C2.28622 21.521 2.32024 19.2596 2.32024 16.9982Z"
        fill={fillColor ? fillColor : "#026A26"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.7317 16.8809C12.7352 17.689 13.0026 18.3306 13.507 18.8514C15.3884 20.7973 17.2803 22.7373 19.177 24.6692C19.659 25.1606 20.3663 25.1536 20.8296 24.6891C21.3 24.2188 21.2859 23.5197 20.7851 23.0036C19.0315 21.202 17.2733 19.4027 15.5197 17.6034C14.9063 16.9735 14.904 16.9383 15.5268 16.3003C17.258 14.5268 18.9893 12.7533 20.7264 10.9857C21.0126 10.6948 21.205 10.3746 21.1651 9.95703C21.1182 9.482 20.866 9.14067 20.4215 8.97177C19.9605 8.79583 19.5359 8.89435 19.1875 9.24272C18.4615 9.97111 17.7448 10.7065 17.0258 11.4408C15.8845 12.6079 14.7444 13.7761 13.6055 14.9455C13.0613 15.5027 12.7375 16.1583 12.7317 16.8809Z"
        fill={fillColor ? fillColor : "#026A26"}
      />
    </svg>
  );
};

export const NextIcon = ({ fillColor, onClick }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="35"
      height="34"
      viewBox="0 0 35 34"
      fill="none"
      onClick={onClick}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.9774 33.9917C15.716 33.9917 13.4546 33.9987 11.1932 33.9893C9.45019 33.9823 7.74708 33.7301 6.13547 33.0322C3.50223 31.8874 1.99149 29.8184 1.3757 27.0737C1.16222 26.126 1.01678 25.1407 1.00974 24.1695C0.974554 19.3323 0.978072 14.4975 1.0074 9.66031C1.01795 8.08037 1.32761 6.53678 1.97741 5.08234C3.13745 2.48898 5.20064 1.02633 7.90778 0.383561C9.11355 0.0950184 10.3393 -0.00116236 11.5767 1.05781e-05C15.9541 0.00352939 20.3292 0.00235653 24.7101 0.0047024C26.1446 0.00587534 27.5556 0.181816 28.9233 0.625185C32.014 1.62805 33.8613 3.77804 34.5745 6.90508C34.7903 7.84226 34.9381 8.81697 34.9428 9.77291C34.9791 14.6347 34.9756 19.4954 34.9475 24.3549C34.9369 25.9242 34.6296 27.4561 33.9857 28.9C32.8315 31.4957 30.7718 32.963 28.0635 33.6128C26.812 33.9143 25.537 34.0034 24.2515 33.9999C22.1601 33.994 20.0688 33.9976 17.9763 33.9976C17.9774 33.9952 17.9774 33.994 17.9774 33.9917ZM32.6485 16.9982H32.652C32.652 14.8822 32.6849 12.7651 32.638 10.6503C32.6133 9.59228 32.5359 8.51904 32.3224 7.48451C31.8404 5.11518 30.4551 3.46955 28.0846 2.81036C27.1627 2.55467 26.1856 2.37051 25.232 2.35996C20.6376 2.31069 16.0421 2.31304 11.4465 2.33884C10.4636 2.34588 9.46426 2.45145 8.49894 2.64615C6.00058 3.15052 4.34909 4.6378 3.7157 7.13498C3.50106 7.98301 3.34388 8.87327 3.33685 9.74476C3.29931 14.521 3.30166 19.2972 3.32864 24.0733C3.33333 24.8885 3.45414 25.7143 3.62656 26.5142C4.1321 28.8624 5.48097 30.5128 7.83857 31.1731C8.77223 31.437 9.75984 31.6271 10.724 31.6364C15.3313 31.688 19.9386 31.6834 24.5459 31.6575C25.5194 31.6517 26.5047 31.5485 27.4559 31.3526C30.034 30.8271 31.6961 29.2741 32.2767 26.6866C32.4902 25.7377 32.6086 24.7537 32.6321 23.7825C32.6825 21.521 32.6485 19.2596 32.6485 16.9982Z"
        fill={fillColor ? fillColor : "#026A26"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.2371 16.8809C22.2336 17.689 21.9661 18.3306 21.4618 18.8514C19.5804 20.7973 17.6884 22.7373 15.7918 24.6692C15.3097 25.1606 14.6024 25.1536 14.1391 24.6891C13.6688 24.2188 13.6828 23.5197 14.1837 23.0036C15.9372 21.202 17.6955 19.4027 19.449 17.6034C20.0624 16.9735 20.0648 16.9383 19.442 16.3003C17.7107 14.5268 15.9795 12.7533 14.2423 10.9857C13.9561 10.6948 13.7638 10.3746 13.8037 9.95703C13.8506 9.482 14.1028 9.14067 14.5473 8.97177C15.0083 8.79583 15.4329 8.89435 15.7812 9.24272C16.5073 9.97111 17.2239 10.7065 17.943 11.4408C19.0842 12.6079 20.2243 13.7761 21.3632 14.9455C21.9075 15.5027 22.2312 16.1583 22.2371 16.8809Z"
        fill={fillColor ? fillColor : "#026A26"}
      />
    </svg>
  );
};

export const PointSystemIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M15 8C15 11.866 11.866 15 8 15M15 8C15 4.13401 11.866 1 8 1M15 8H13.6M8 15C4.13401 15 1 11.866 1 8M8 15V13.6M1 8C1 4.13401 4.13401 1 8 1M1 8H2.4M8 1V2.4M12.9497 12.9497L11.9598 11.9598M4.0402 4.0402L3.05025 3.05025M11.9598 4.0402L12.9497 3.05025M3.05025 12.9497L4.0402 11.9598M5.2 8L6.95 6.95L8 5.2L9.05 6.95L10.8 8L9.05 9.05L8 10.8L6.95 9.05L5.2 8Z"
        stroke="#4A4759"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ClinicalActionAddIcon = () => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 13C1 11.8447 1 11.267 1.26005 10.8426C1.40556 10.6052 1.6052 10.4056 1.84265 10.26C2.26701 10 2.84467 10 4 10C5.15533 10 5.73299 10 6.15735 10.26C6.3948 10.4056 6.59444 10.6052 6.73995 10.8426C7 11.267 7 11.8447 7 13C7 14.1553 7 14.733 6.73995 15.1574C6.59444 15.3948 6.3948 15.5944 6.15735 15.74C5.73299 16 5.15533 16 4 16C2.84467 16 2.26701 16 1.84265 15.74C1.6052 15.5944 1.40556 15.3948 1.26005 15.1574C1 14.733 1 14.1553 1 13Z"
        stroke="white"
        strokeWidth="1.5"
      />
      <path
        d="M10 13C10 11.8447 10 11.267 10.26 10.8426C10.4056 10.6052 10.6052 10.4056 10.8426 10.26C11.267 10 11.8447 10 13 10C14.1553 10 14.733 10 15.1574 10.26C15.3948 10.4056 15.5944 10.6052 15.74 10.8426C16 11.267 16 11.8447 16 13C16 14.1553 16 14.733 15.74 15.1574C15.5944 15.3948 15.3948 15.5944 15.1574 15.74C14.733 16 14.1553 16 13 16C11.8447 16 11.267 16 10.8426 15.74C10.6052 15.5944 10.4056 15.3948 10.26 15.1574C10 14.733 10 14.1553 10 13Z"
        stroke="white"
        strokeWidth="1.5"
      />
      <path
        d="M1 4C1 2.84467 1 2.26701 1.26005 1.84265C1.40556 1.6052 1.6052 1.40556 1.84265 1.26005C2.26701 1 2.84467 1 4 1C5.15533 1 5.73299 1 6.15735 1.26005C6.3948 1.40556 6.59444 1.6052 6.73995 1.84265C7 2.26701 7 2.84467 7 4C7 5.15533 7 5.73299 6.73995 6.15735C6.59444 6.3948 6.3948 6.59444 6.15735 6.73995C5.73299 7 5.15533 7 4 7C2.84467 7 2.26701 7 1.84265 6.73995C1.6052 6.59444 1.40556 6.3948 1.26005 6.15735C1 5.73299 1 5.15533 1 4Z"
        stroke="white"
        strokeWidth="1.5"
      />
      <path
        d="M10 4C10 2.84467 10 2.26701 10.26 1.84265C10.4056 1.6052 10.6052 1.40556 10.8426 1.26005C11.267 1 11.8447 1 13 1C14.1553 1 14.733 1 15.1574 1.26005C15.3948 1.40556 15.5944 1.6052 15.74 1.84265C16 2.26701 16 2.84467 16 4C16 5.15533 16 5.73299 15.74 6.15735C15.5944 6.3948 15.3948 6.59444 15.1574 6.73995C14.733 7 14.1553 7 13 7C11.8447 7 11.267 7 10.8426 6.73995C10.6052 6.59444 10.4056 6.3948 10.26 6.15735C10 5.73299 10 5.15533 10 4Z"
        stroke="white"
        strokeWidth="1.5"
      />
    </svg>
  );
};

export const ConsultationRoomIcon = () => {
  return (
    <svg
      width="92"
      height="79"
      viewBox="0 0 92 79"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M35.5843 7.90186H8.72327C8.52339 7.90589 8.33282 7.98709 8.19145 8.12844C8.05009 8.26979 7.96888 8.46034 7.96484 8.6602V26.0389C7.96888 26.2388 8.05009 26.4293 8.19145 26.5707C8.33282 26.712 8.52339 26.7932 8.72327 26.7973H35.5843C35.7842 26.7932 35.9748 26.712 36.1161 26.5707C36.2575 26.4293 36.3387 26.2388 36.3428 26.0389V8.6602C36.3387 8.46034 36.2575 8.26979 36.1161 8.12844C35.9748 7.98709 35.7842 7.90589 35.5843 7.90186ZM26.8624 18.961H23.7023V22.1208C23.7023 22.5398 23.5358 22.9417 23.2395 23.238C22.9432 23.5342 22.5413 23.7007 22.1222 23.7007C21.7031 23.7007 21.3012 23.5342 21.0049 23.238C20.7086 22.9417 20.5421 22.5398 20.5421 22.1208V18.961H17.382C16.963 18.961 16.5611 18.7946 16.2647 18.4983C15.9684 18.202 15.802 17.8002 15.802 17.3812C15.802 16.9621 15.9684 16.5603 16.2647 16.264C16.5611 15.9677 16.963 15.8013 17.382 15.8013H20.5421V12.6415C20.5421 12.2225 20.7086 11.8206 21.0049 11.5244C21.3012 11.2281 21.7031 11.0616 22.1222 11.0616C22.5413 11.0616 22.9432 11.2281 23.2395 11.5244C23.5358 11.8206 23.7023 12.2225 23.7023 12.6415V15.8013H26.8624C27.2814 15.8013 27.6833 15.9677 27.9797 16.264C28.276 16.5603 28.4424 16.9621 28.4424 17.3812C28.4424 17.8002 28.276 18.202 27.9797 18.4983C27.6833 18.7946 27.2814 18.961 26.8624 18.961Z"
        fill="#717474"
      />
      <path
        d="M34.7637 41.0748C35.6363 41.0748 36.3437 40.3675 36.3437 39.4949C36.3437 38.6224 35.6363 37.915 34.7637 37.915C33.891 37.915 33.1836 38.6224 33.1836 39.4949C33.1836 40.3675 33.891 41.0748 34.7637 41.0748Z"
        fill="#717474"
      />
      <path
        d="M41.0816 0H3.16012C2.32201 0 1.51822 0.332903 0.925579 0.925474C0.33294 1.51804 0 2.32174 0 3.15977V75.8344C0 76.6724 0.33294 77.4761 0.925579 78.0687C1.51822 78.6612 2.32201 78.9941 3.16012 78.9941H41.0816C41.9197 78.9941 42.7235 78.6612 43.3162 78.0687C43.9088 77.4761 44.2417 76.6724 44.2417 75.8344V3.15977C44.2417 2.32174 43.9088 1.51804 43.3162 0.925474C42.7235 0.332903 41.9197 0 41.0816 0ZM36.3414 43.9523V48.9764C36.3414 49.3954 36.175 49.7972 35.8786 50.0935C35.5823 50.3898 35.1804 50.5563 34.7614 50.5563C34.3423 50.5563 33.9404 50.3898 33.6441 50.0935C33.3478 49.7972 33.1813 49.3954 33.1813 48.9764V43.9523C32.1271 43.5797 31.2385 42.8463 30.6727 41.8819C30.107 40.9176 29.9004 39.7842 30.0894 38.6823C30.2785 37.5803 30.8511 36.5807 31.7061 35.86C32.561 35.1394 33.6432 34.7441 34.7614 34.7441C35.8795 34.7441 36.9617 35.1394 37.8167 35.86C38.6716 36.5807 39.2442 37.5803 39.4333 38.6823C39.6224 39.7842 39.4158 40.9176 38.85 41.8819C38.2842 42.8463 37.3957 43.5797 36.3414 43.9523ZM39.5015 26.0997C39.5015 27.1388 39.0887 28.1354 38.3538 28.8702C37.619 29.605 36.6223 30.0178 35.583 30.0178H8.72194C8.20206 30.0262 7.6857 29.931 7.20296 29.7379C6.72022 29.5447 6.28075 29.2574 5.91016 28.8928C5.53957 28.5281 5.24526 28.0933 5.0444 27.6138C4.84353 27.1343 4.74012 26.6196 4.74019 26.0997V8.72095C4.7318 8.20113 4.82696 7.68483 5.02013 7.20214C5.2133 6.71946 5.50061 6.28004 5.86532 5.90949C6.23003 5.53894 6.66484 5.24467 7.14443 5.04382C7.62402 4.84298 8.13878 4.73958 8.65874 4.73965H35.5198C36.0397 4.73126 36.556 4.82642 37.0388 5.01956C37.5215 5.21271 37.961 5.49998 38.3316 5.86465C38.7022 6.22932 38.9965 6.66409 39.1973 7.14362C39.3982 7.62315 39.5016 8.13786 39.5015 8.65776V26.0997Z"
        fill="#C8C8C8"
      />
      <path
        d="M67.9394 69.5127C65.3639 69.5127 63.1992 70.9662 63.1992 72.6725V74.2523H72.6796V72.6725C72.6796 70.9662 70.5149 69.5127 67.9394 69.5127Z"
        fill="#C8C8C8"
      />
      <path
        d="M66.3629 66.4852V58.4594H61.1487C60.0274 58.4547 58.9424 58.0618 58.0782 57.3475C57.214 56.6331 56.6239 55.6415 56.4085 54.5413L55.3024 48.9801H51.9843C51.8011 48.978 51.6194 49.0125 51.4497 49.0816C51.28 49.1507 51.1259 49.253 50.9964 49.3826C50.8668 49.5121 50.7645 49.6662 50.6954 49.8358C50.6262 50.0055 50.5917 50.1872 50.5938 50.3704V72.8837C50.5938 73.0655 50.6299 73.2456 50.7 73.4134C50.77 73.5812 50.8727 73.7334 51.002 73.8612C51.1314 73.9891 51.2848 74.09 51.4534 74.1581C51.622 74.2263 51.8025 74.2603 51.9843 74.2582H53.7224V77.418C53.7224 77.837 53.8888 78.2388 54.1852 78.5351C54.4815 78.8314 54.8834 78.9978 55.3024 78.9978C55.7215 78.9978 56.1234 78.8314 56.4197 78.5351C56.716 78.2388 56.8825 77.837 56.8825 77.418V74.2582H60.0426V72.6783C60.0426 69.6291 62.7603 67.0697 66.3629 66.4852Z"
        fill="#C8C8C8"
      />
      <path
        d="M90.2637 48.9759H88.4782V33.2876C88.4782 32.8393 88.3001 32.4093 87.983 32.0923C87.666 31.7753 87.2359 31.5972 86.7875 31.5972H82.2686C81.8202 31.5972 81.3901 31.7753 81.0731 32.0923C80.756 32.4093 80.5779 32.8393 80.5779 33.2876V48.9759H71.0975V45.8161H75.5849C76.071 45.8161 76.5372 45.623 76.8809 45.2793C77.2247 44.9356 77.4178 44.4695 77.4178 43.9835V38.1695C77.4178 37.6834 77.2247 37.2173 76.8809 36.8736C76.5372 36.5299 76.071 36.3368 75.5849 36.3368H63.45C62.9639 36.3368 62.4977 36.5299 62.154 36.8736C61.8103 37.2173 61.6172 37.6834 61.6172 38.1695V43.9835C61.6172 44.4695 61.8103 44.9356 62.154 45.2793C62.4977 45.623 62.9639 45.8161 63.45 45.8161H67.9374V48.9759H58.457L59.4525 53.9209C59.5298 54.3112 59.7411 54.6621 60.0498 54.9131C60.3585 55.1641 60.7453 55.2993 61.1431 55.2954H77.4178C77.8368 55.2954 78.2387 55.4619 78.535 55.7582C78.8314 56.0544 78.9978 56.4563 78.9978 56.8753C78.9978 57.2943 78.8314 57.6962 78.535 57.9924C78.2387 58.2887 77.8368 58.4552 77.4178 58.4552H69.5175V66.481C73.12 67.0655 75.8377 69.6408 75.8377 72.6741V74.254H85.3181V77.4138C85.3181 77.8328 85.4845 78.2346 85.7809 78.5309C86.0772 78.8272 86.4791 78.9937 86.8981 78.9937C87.3172 78.9937 87.7191 78.8272 88.0154 78.5309C88.3117 78.2346 88.4782 77.8328 88.4782 77.4138V74.254H90.2637C90.6283 74.254 90.9779 74.1092 91.2357 73.8514C91.4935 73.5937 91.6383 73.2441 91.6383 72.8795V50.3662C91.6404 50.1844 91.6064 50.0039 91.5383 49.8353C91.4701 49.6667 91.3692 49.5133 91.2413 49.384C91.1135 49.2547 90.9612 49.1521 90.7934 49.082C90.6256 49.0119 90.4455 48.9759 90.2637 48.9759Z"
        fill="#C8C8C8"
      />
      <path
        d="M55.3008 32.8611C55.2593 32.6536 55.1773 32.4564 55.0596 32.2806C54.9418 32.1048 54.7906 31.9539 54.6145 31.8365C54.4385 31.7191 54.241 31.6376 54.0334 31.5965C53.8258 31.5555 53.6122 31.5557 53.4047 31.5972C53.1972 31.6387 52.9999 31.7207 52.8241 31.8384C52.6483 31.9561 52.4974 32.1073 52.38 32.2834C52.2626 32.4594 52.1811 32.6569 52.14 32.8644C52.0989 33.072 52.0992 33.2856 52.1407 33.4931L55.3008 48.9759H58.4609L55.3008 32.8611Z"
        fill="#717474"
      />
      <path
        d="M60.043 77.4151C60.043 77.8341 60.2094 78.236 60.5058 78.5323C60.8021 78.8286 61.204 78.995 61.623 78.995C62.0421 78.995 62.444 78.8286 62.7403 78.5323C63.0366 78.236 63.2031 77.8341 63.2031 77.4151V74.2554H60.043V77.4151Z"
        fill="#C8C8C8"
      />
      <path
        d="M72.6797 77.4151C72.6797 77.8341 72.8462 78.236 73.1425 78.5323C73.4388 78.8286 73.8407 78.995 74.2597 78.995C74.6788 78.995 75.0807 78.8286 75.377 78.5323C75.6733 78.236 75.8398 77.8341 75.8398 77.4151V74.2554H72.6797V77.4151Z"
        fill="#C8C8C8"
      />
    </svg>
  );
};

export const PhysicalRoomIcon = () => {
  return (
    <svg
      width="78"
      height="79"
      viewBox="0 0 78 79"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M77.7786 47.3691V48.8361C77.7786 50.2227 76.6661 51.3673 75.2797 51.3673H73.5062C74.0543 50.658 74.3768 49.7874 74.3768 48.8361V47.3691C74.3768 45.3538 73.474 43.5319 72.0391 42.3066H72.7162C75.5215 42.3066 77.7786 44.5799 77.7786 47.3691Z"
        fill="#C8C8C8"
      />
      <path
        d="M73.179 52.9795C73.0338 54.7852 71.5183 56.2039 69.6643 56.2039H68.3906C69.1646 55.3818 69.6965 54.3015 69.7772 53.1085L69.7933 52.9795H73.179Z"
        fill="#C8C8C8"
      />
      <path
        d="M72.7557 47.3691V48.8361C72.7557 50.2227 71.6433 51.3673 70.2568 51.3673H2.89788C1.49525 51.3673 0.382812 50.2227 0.382812 48.8361V47.3691C0.382812 44.5799 2.65611 42.3066 5.44523 42.3066H67.6933C70.4986 42.3066 72.7557 44.5799 72.7557 47.3691Z"
        fill="#C8C8C8"
      />
      <path
        d="M68.1693 52.9795C68.0241 54.7852 66.5086 56.2039 64.6707 56.2039H7.16257C5.30847 56.2039 3.80911 54.7852 3.66406 52.9795H68.1693Z"
        fill="#C8C8C8"
      />
      <path
        d="M59.4404 73.4376C58.9948 73.4376 58.6342 73.077 58.6342 72.6315V71.3089C58.6342 70.4462 57.9336 69.7455 57.0708 69.7455H14.7499C13.8871 69.7455 13.1864 70.4462 13.1864 71.3089V72.6315C13.1864 73.077 12.8259 73.4376 12.3803 73.4376C11.9348 73.4376 11.5742 73.077 11.5742 72.6315V71.3089C11.5742 69.5582 12.9991 68.1333 14.7499 68.1333H57.0708C58.8216 68.1333 60.2465 69.5582 60.2465 71.3089V72.6315C60.2465 73.077 59.8859 73.4376 59.4404 73.4376Z"
        fill="#C8C8C8"
      />
      <path
        d="M54.189 69.7419C54.0961 69.7419 54.0032 69.7262 53.9103 69.6931L19.2506 56.9622C18.8333 56.8079 18.6192 56.345 18.7719 55.9262C18.9278 55.5074 19.386 55.298 19.8079 55.4476L54.4676 68.1785C54.8849 68.3328 55.099 68.7957 54.9463 69.2145C54.825 69.5404 54.518 69.7419 54.189 69.7419Z"
        fill="#C8C8C8"
      />
      <path
        d="M19.5292 69.7419C19.2002 69.7419 18.8932 69.5404 18.7719 69.2145C18.6192 68.7957 18.8333 68.3328 19.2506 68.1785L53.9103 55.4476C54.3322 55.298 54.7904 55.5074 54.9463 55.9262C55.099 56.345 54.8849 56.8079 54.4676 56.9622L19.8079 69.6931C19.715 69.7262 19.6221 69.7419 19.5292 69.7419Z"
        fill="#C8C8C8"
      />
      <path
        d="M15.979 75.4049C15.979 77.3879 14.3668 79.0001 12.3838 79.0001C10.4008 79.0001 8.80469 77.3879 8.80469 75.4049C8.80469 73.4379 10.4008 71.8257 12.3838 71.8257C14.3668 71.8257 15.979 73.4379 15.979 75.4049Z"
        fill="#C8C8C8"
      />
      <path
        d="M63.0381 75.4049C63.0381 77.3879 61.4259 79.0001 59.4429 79.0001C57.4599 79.0001 55.8477 77.3879 55.8477 75.4049C55.8477 73.4379 57.4599 71.8257 59.4429 71.8257C61.4259 71.8257 63.0381 73.4379 63.0381 75.4049Z"
        fill="#C8C8C8"
      />
      <path
        d="M21.6129 39.3979C21.6129 41.0017 20.3098 42.3049 18.7059 42.3049H9.7508C8.14686 42.3049 6.84375 41.0017 6.84375 39.3979C6.84375 37.7939 8.14686 36.4907 9.7508 36.4907H18.7059C20.3098 36.4907 21.6129 37.7939 21.6129 39.3979Z"
        fill="#717474"
      />
      <path
        d="M12.5766 7.17473C12.3546 7.17473 12.1326 7.08341 11.972 6.90235L7.29438 1.61223H0.806113C0.360547 1.61223 0 1.25168 0 0.806113C0 0.360547 0.360547 0 0.806113 0H7.65808C7.88952 0 8.10837 0.0991897 8.26266 0.272378L13.1812 5.83488C13.4756 6.16866 13.4441 6.6772 13.1104 6.9732C12.9576 7.1086 12.7671 7.17473 12.5766 7.17473Z"
        fill="#C8C8C8"
      />
      <path
        d="M20.0244 24.8136L18.5089 26.3129C17.8962 26.9256 16.9289 26.9256 16.3324 26.3291L15.6875 25.6842C15.7198 25.652 15.7359 25.6358 15.7682 25.6036L19.3796 21.9922L20.0244 22.637C20.6209 23.2336 20.6209 24.2171 20.0244 24.8136Z"
        fill="#717474"
      />
      <path
        d="M32.583 12.255L31.0514 13.7704C30.4548 14.367 29.4874 14.367 28.8909 13.7704L28.2461 13.1256L31.8575 9.51419C31.8897 9.48191 31.9058 9.46577 31.9381 9.43359L32.583 10.0784C33.1795 10.6749 33.1795 11.6584 32.583 12.255Z"
        fill="#717474"
      />
      <path
        d="M26.2978 18.5265L24.7823 20.0581C24.1858 20.6546 23.2024 20.6546 22.6059 20.0581L21.9609 19.4132L25.6529 15.7212L26.2978 16.3661C26.8943 16.9626 26.8943 17.9299 26.2978 18.5265Z"
        fill="#717474"
      />
      <path
        d="M24.5067 2.61087L8.85194 18.2656L8.67462 18.0883C6.53033 15.9279 6.53033 12.4294 8.67462 10.269L16.5262 2.41741C18.6866 0.257084 22.1851 0.273124 24.3294 2.43355L24.5067 2.61087Z"
        fill="#C8C8C8"
      />
      <path
        d="M29.465 2.99463L30.7113 4.24094C31.8545 5.38419 31.8545 7.23956 30.7207 8.37343L14.6313 24.4628C13.488 25.6061 11.6326 25.6061 10.4894 24.4628L9.24307 23.2165C8.39974 22.3732 8.39969 21.0051 9.23369 20.1711L26.4195 2.98525C27.2628 2.14192 28.6216 2.1513 29.465 2.99463Z"
        fill="#717474"
      />
    </svg>
  );
};

export const EmergencyRoomIcon = () => {
  return (
    <svg
      width="81"
      height="79"
      viewBox="0 0 81 79"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M63.2195 68.481H17.6202C11.8098 68.4828 7.09949 73.1933 7.09766 79.004H73.742C73.742 73.1915 69.0317 68.481 63.2195 68.481Z"
        fill="#C8C8C8"
      />
      <path
        d="M40.4161 19.373C28.1371 19.373 19.3711 28.1413 19.3711 41.0205V64.8133H61.4611V41.0205C61.4611 28.1413 52.7006 19.373 40.4161 19.373ZM54.4534 45.7604C53.4413 45.7604 52.6199 44.9389 52.6199 43.9268C52.6199 37.3478 49.3893 31.3098 45.1026 29.8832C44.14 29.5624 43.6192 28.5245 43.9401 27.5619C44.261 26.5993 45.2987 26.0785 46.2613 26.3994C52.0699 28.3375 56.287 35.7086 56.287 43.9268C56.287 44.9389 55.4655 45.7604 54.4534 45.7604Z"
        fill="#717474"
      />
      <path
        d="M12.356 42.2517H1.83351C0.821412 42.2517 0 41.4302 0 40.4181C0 39.4059 0.821412 38.5845 1.83351 38.5845H12.356C13.3681 38.5845 14.1895 39.4059 14.1895 40.4181C14.1895 41.4302 13.3681 42.2517 12.356 42.2517Z"
        fill="#717474"
      />
      <path
        d="M19.2209 21.9544C18.735 21.9544 18.2674 21.7619 17.9246 21.4172L10.9096 14.4C10.2055 13.6721 10.2257 12.5114 10.9554 11.8073C11.6668 11.1215 12.7926 11.1215 13.5022 11.8073L20.5172 18.8245C21.2322 19.5414 21.2322 20.7021 20.5172 21.4172C20.1725 21.7619 19.7067 21.9544 19.2209 21.9544Z"
        fill="#717474"
      />
      <path
        d="M40.4194 14.1902C39.4073 14.1902 38.5859 13.3688 38.5859 12.3566V1.8336C38.5859 0.821453 39.4073 0 40.4194 0C41.4315 0 42.253 0.821453 42.253 1.8336V12.3566C42.253 13.3688 41.4315 14.1902 40.4194 14.1902Z"
        fill="#717474"
      />
      <path
        d="M62.0093 21.5578C60.9972 21.5578 60.1758 20.7363 60.1758 19.7242C60.1758 19.2382 60.3683 18.7725 60.713 18.4278L67.728 11.4124C68.4431 10.6955 69.6055 10.6955 70.3224 11.4106C71.0393 12.1257 71.0393 13.2882 70.3224 14.0052L63.3056 21.0205C62.9627 21.3652 62.4952 21.5578 62.0093 21.5578Z"
        fill="#717474"
      />
      <path
        d="M79.0045 42.2517H68.4819C67.4698 42.2517 66.6484 41.4302 66.6484 40.4181C66.6484 39.4059 67.4698 38.5845 68.4819 38.5845H79.0045C80.0166 38.5845 80.838 39.4059 80.838 40.4181C80.838 41.4302 80.0166 42.2517 79.0045 42.2517Z"
        fill="#717474"
      />
    </svg>
  );
};
export const PositionSleepingIcon = () => {
  return (
    <svg
      width="61"
      height="60"
      viewBox="0 0 61 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="30.5" cy="30" r="30" fill="url(#paint0_radial_4380_50137)" />
      <path
        d="M14.675 39.2676C16.765 39.2676 18.4711 37.57 18.4711 35.4715C18.4711 33.3729 16.765 31.6753 14.675 31.6753C12.585 31.6753 10.8789 33.3729 10.8789 35.4715C10.8789 37.57 12.585 39.2676 14.675 39.2676Z"
        fill="#C8C8C8"
      />
      <path
        d="M22.1798 22.7231V20.5307C22.1798 20.2407 21.941 20.0018 21.6509 20.0018H19.8766C19.5865 20.0018 19.3477 20.2407 19.3477 20.5307V22.7231C19.3477 23.0131 19.5865 23.252 19.8766 23.252H21.6509C21.9495 23.252 22.1798 23.0131 22.1798 22.7231Z"
        fill="#717474"
      />
      <path
        d="M21.8904 24.4201C21.8819 24.386 21.8734 24.3604 21.8563 24.3348L21.3786 23.5158H20.1587L19.6895 24.3433C19.6042 24.4969 19.6554 24.6845 19.809 24.7698C19.8601 24.7954 19.9113 24.8125 19.9625 24.8125H21.5833C21.7881 24.8125 21.9416 24.6248 21.8904 24.4201Z"
        fill="#C8C8C8"
      />
      <path
        d="M22.3695 39.2676C20.9336 39.2676 19.7695 38.1035 19.7695 36.6676L19.7695 34.2231C19.7695 32.7872 20.9336 31.6231 22.3695 31.6231L34.8806 31.6231L34.8806 39.2676L22.3695 39.2676Z"
        fill="#717474"
      />
      <path
        d="M48.9678 33.4902C50.0233 33.4902 50.8789 34.3459 50.8789 35.4013C50.8789 36.4568 50.0233 37.3125 48.9678 37.3125L35.7678 37.3125L35.7678 33.4902L48.9678 33.4902Z"
        fill="#C8C8C8"
      />
      <defs>
        <radialGradient
          id="paint0_radial_4380_50137"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(30.5 30) rotate(84.447) scale(36.1697 37.2555)"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#F1F1F1" />
        </radialGradient>
      </defs>
    </svg>
  );
};
export const SettingFrontIcon = () => {
  return (
    <svg
      width="60"
      height="60"
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="30" cy="30" r="30" fill="url(#paint0_radial_4380_50140)" />
      <path
        d="M22.9961 14.2717C22.9961 16.6235 24.9063 18.5433 27.2678 18.5433C29.6292 18.5433 31.5394 16.6235 31.5394 14.2717C31.5394 11.9198 29.6292 10 27.2678 10C24.9063 10 22.9961 11.9198 22.9961 14.2717Z"
        fill="#C8C8C8"
      />
      <path
        d="M37.2981 22.7194H39.7645C40.0908 22.7194 40.3596 22.4507 40.3596 22.1244V20.1282C40.3596 19.8019 40.0908 19.5332 39.7645 19.5332H37.2981C36.9718 19.5332 36.7031 19.8019 36.7031 20.1282V22.1244C36.7031 22.4603 36.9718 22.7194 37.2981 22.7194Z"
        fill="#717474"
      />
      <path
        d="M35.3868 22.3933C35.4252 22.3837 35.4539 22.3741 35.4827 22.3549L36.404 21.8175V20.4452L35.4731 19.9173C35.3004 19.8214 35.0893 19.8789 34.9933 20.0517C34.9645 20.1093 34.9453 20.1668 34.9453 20.2244V22.0478C34.9453 22.2782 35.1564 22.4509 35.3868 22.3933Z"
        fill="#C8C8C8"
      />
      <path
        d="M35.1685 31.9815H31.636L31.7512 22.555C31.636 20.9615 30.724 19.7424 29.0634 19.7904H25.886C24.3693 19.7904 23.1406 21.0191 23.1406 22.5358V35.1972C23.1406 35.8596 23.3326 36.4835 23.6686 37.0115H32.2311V38.653V47.1099C32.2311 48.7034 33.527 49.9993 35.1205 49.9993C36.714 49.9993 38.0099 48.7034 38.0099 47.1099V34.8229C38.0099 33.2582 36.7428 31.9815 35.1685 31.9815Z"
        fill="#717474"
      />
      <path
        d="M23.6669 37.0116H20.8159C20.3648 37.0116 20 37.3763 20 37.8275C20 38.2787 20.3648 38.6434 20.8159 38.6434H24.8668V46.3036L21.0751 48.4635C20.6815 48.6938 20.5472 49.193 20.7679 49.5866C20.9215 49.8457 21.1903 49.9993 21.4783 49.9993C21.6223 49.9993 21.7567 49.9705 21.8911 49.8937L25.6828 47.7339L29.4745 49.8937C29.6088 49.9705 29.7432 49.9993 29.8872 49.9993C30.1752 49.9993 30.444 49.8553 30.5976 49.5866C30.8184 49.193 30.684 48.6938 30.2904 48.4635L26.4987 46.3036V38.6434H26.5947H30.348C30.7992 38.6434 31.1639 38.2787 31.1639 37.8275C31.1639 37.3763 30.7992 37.002 30.348 37.002H23.6669V37.0116Z"
        fill="#C8C8C8"
      />
      <defs>
        <radialGradient
          id="paint0_radial_4380_50140"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(30 30) rotate(84.447) scale(36.1697 37.2555)"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#F1F1F1" />
        </radialGradient>
      </defs>
    </svg>
  );
};
export const SettingBackIcon = () => {
  return (
    <svg
      width="60"
      height="60"
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="30" cy="30" r="30" fill="url(#paint0_radial_4380_50143)" />
      <path
        d="M25.9688 14.2717C25.9688 16.6331 27.8886 18.5433 30.2404 18.5433C32.5922 18.5433 34.5121 16.6235 34.5121 14.2717C34.5121 11.9198 32.6018 10 30.2404 10C27.879 10 25.9688 11.9198 25.9688 14.2717Z"
        fill="#C8C8C8"
      />
      <path
        d="M22.0614 19.543H19.595C19.2687 19.543 19 19.8117 19 20.138V22.1341C19 22.4604 19.2687 22.7291 19.595 22.7291H22.0614C22.3877 22.7291 22.6564 22.4604 22.6564 22.1341V20.138C22.6564 19.8021 22.3877 19.543 22.0614 19.543Z"
        fill="#717474"
      />
      <path
        d="M23.9704 19.8701C23.932 19.8797 23.9032 19.8893 23.8744 19.9085L22.9531 20.4459V21.8183L23.884 22.3461C24.0568 22.4421 24.2679 22.3845 24.3639 22.2118C24.3927 22.1542 24.4119 22.0966 24.4119 22.039V20.2156C24.4119 19.9949 24.2007 19.8125 23.9704 19.8701Z"
        fill="#C8C8C8"
      />
      <path
        d="M38.1411 31.9815H34.6086L34.7238 22.555C34.6086 20.9615 33.6967 19.7424 32.036 19.7904H28.8587C27.342 19.7904 26.1133 21.0191 26.1133 22.5358V35.1972C26.1133 35.8596 26.3053 36.4835 26.6412 37.0115H35.2038V38.653V47.1099C35.2038 48.7034 36.4997 49.9993 38.0931 49.9993C39.6866 49.9993 40.9825 48.7034 40.9825 47.1099V34.8229C40.9825 33.2582 39.7154 31.9815 38.1411 31.9815Z"
        fill="#717474"
      />
      <path
        d="M26.6396 37.0116H23.7886C23.3374 37.0116 22.9727 37.3763 22.9727 37.8275C22.9727 38.2787 23.3374 38.6434 23.7886 38.6434H27.8395V46.3036L24.0478 48.4635C23.6542 48.6938 23.5198 49.193 23.7406 49.5866C23.8942 49.8457 24.163 49.9993 24.4509 49.9993C24.5949 49.9993 24.7293 49.9705 24.8637 49.8937L28.6554 47.7339L32.4471 49.8937C32.5815 49.9705 32.7159 49.9993 32.8599 49.9993C33.1479 49.9993 33.4166 49.8553 33.5702 49.5866C33.791 49.193 33.6566 48.6938 33.2631 48.4635L29.4713 46.3036V38.6434H29.5673H33.3206C33.7718 38.6434 34.1366 38.2787 34.1366 37.8275C34.1366 37.3763 33.7718 37.002 33.3206 37.002H26.6396V37.0116Z"
        fill="#C8C8C8"
      />
      <defs>
        <radialGradient
          id="paint0_radial_4380_50143"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(30 30) rotate(84.447) scale(36.1697 37.2555)"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#F1F1F1" />
        </radialGradient>
      </defs>
    </svg>
  );
};
export const StandingFrontIcon = () => {
  return (
    <svg
      width="61"
      height="60"
      viewBox="0 0 61 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="30.5" cy="30" r="30" fill="url(#paint0_radial_4380_50146)" />
      <path
        d="M22.5 13.7961C22.5 15.8861 24.1976 17.5922 26.2961 17.5922C28.3946 17.5922 30.0922 15.8861 30.0922 13.7961C30.0922 11.7061 28.3946 10 26.2961 10C24.1976 10 22.5 11.7061 22.5 13.7961Z"
        fill="#C8C8C8"
      />
      <path
        d="M35.2125 21.3029H37.4049C37.6949 21.3029 37.9338 21.064 37.9338 20.774V18.9996C37.9338 18.7096 37.6949 18.4707 37.4049 18.4707H35.2125C34.9225 18.4707 34.6836 18.7096 34.6836 18.9996V20.774C34.6836 21.0725 34.9225 21.3029 35.2125 21.3029Z"
        fill="#717474"
      />
      <path
        d="M33.5135 21.0115C33.5476 21.003 33.5732 20.9945 33.5988 20.9774L34.4177 20.4997V19.2798L33.5903 18.8106C33.4367 18.7253 33.2491 18.7765 33.1637 18.9301C33.1382 18.9812 33.1211 19.0324 33.1211 19.0836V20.7044C33.1211 20.9092 33.3088 21.0627 33.5135 21.0115Z"
        fill="#C8C8C8"
      />
      <path
        d="M22.5 21.4887C22.5 20.0527 23.6641 18.8887 25.1 18.8887H27.5444C28.9804 18.8887 30.1444 20.0527 30.1444 21.4887V33.9998H22.5V21.4887Z"
        fill="#717474"
      />
      <path
        d="M28.2773 48.0889C28.2773 49.1444 27.4217 50 26.3662 50C25.3108 50 24.4551 49.1444 24.4551 48.0889L24.4551 34.8889L28.2773 34.8889L28.2773 48.0889Z"
        fill="#C8C8C8"
      />
      <defs>
        <radialGradient
          id="paint0_radial_4380_50146"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(30.5 30) rotate(84.447) scale(36.1697 37.2555)"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#F1F1F1" />
        </radialGradient>
      </defs>
    </svg>
  );
};
export const StandingBackIcon = () => {
  return (
    <svg
      width="61"
      height="60"
      viewBox="0 0 61 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="30.5" cy="30" r="30" fill="url(#paint0_radial_4380_50149)" />
      <path
        d="M30.6094 13.7961C30.6094 15.8861 32.307 17.5922 34.4055 17.5922C36.504 17.5922 38.2016 15.8861 38.2016 13.7961C38.2016 11.7061 36.504 10 34.4055 10C32.307 10 30.6094 11.7061 30.6094 13.7961Z"
        fill="#C8C8C8"
      />
      <path
        d="M26.2211 18.4686H24.0287C23.7387 18.4686 23.4998 18.7075 23.4998 18.9975V20.7719C23.4998 21.0619 23.7387 21.3008 24.0287 21.3008H26.2211C26.5111 21.3008 26.75 21.0619 26.75 20.7719V18.9975C26.75 18.6989 26.5111 18.4686 26.2211 18.4686Z"
        fill="#717474"
      />
      <path
        d="M27.9201 18.76C27.886 18.7685 27.8604 18.777 27.8348 18.7941L27.0158 19.2718V20.4917L27.8433 20.9609C27.9969 21.0462 28.1845 20.995 28.2698 20.8414C28.2954 20.7902 28.3125 20.7391 28.3125 20.6879V19.0671C28.3125 18.8623 28.1248 18.7088 27.9201 18.76Z"
        fill="#C8C8C8"
      />
      <path
        d="M30.6094 21.4887C30.6094 20.0527 31.7734 18.8887 33.2094 18.8887H35.6538C37.0898 18.8887 38.2538 20.0527 38.2538 21.4887V33.9998H30.6094V21.4887Z"
        fill="#717474"
      />
      <path
        d="M36.3906 48.0889C36.3906 49.1444 35.535 50 34.4795 50C33.424 50 32.5684 49.1444 32.5684 48.0889L32.5684 34.8889L36.3906 34.8889L36.3906 48.0889Z"
        fill="#C8C8C8"
      />
      <defs>
        <radialGradient
          id="paint0_radial_4380_50149"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(30.5 30) rotate(84.447) scale(36.1697 37.2555)"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#F1F1F1" />
        </radialGradient>
      </defs>
    </svg>
  );
};
export const ViewConsultationRoomIcon = () => {
  return (
    <svg
      width="60"
      height="60"
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="30" cy="30" r="30" fill="url(#paint0_radial_4380_50118)" />
      <path
        d="M25.4692 16.4492H13.7451C13.6579 16.451 13.5747 16.4864 13.513 16.5481C13.4513 16.6098 13.4158 16.693 13.4141 16.7803V24.3665C13.4158 24.4537 13.4513 24.5369 13.513 24.5986C13.5747 24.6603 13.6579 24.6957 13.7451 24.6975H25.4692C25.5565 24.6957 25.6396 24.6603 25.7013 24.5986C25.7631 24.5369 25.7985 24.4537 25.8003 24.3665V16.7803C25.7985 16.693 25.7631 16.6098 25.7013 16.5481C25.6396 16.4864 25.5565 16.451 25.4692 16.4492ZM21.6623 21.2768H20.283V22.6561C20.283 22.839 20.2104 23.0144 20.081 23.1438C19.9517 23.2731 19.7763 23.3458 19.5934 23.3458C19.4105 23.3458 19.235 23.2731 19.1057 23.1438C18.9764 23.0144 18.9037 22.839 18.9037 22.6561V21.2768H17.5244C17.3415 21.2768 17.1661 21.2041 17.0367 21.0748C16.9074 20.9455 16.8347 20.7701 16.8347 20.5871C16.8347 20.4042 16.9074 20.2288 17.0367 20.0995C17.1661 19.9702 17.3415 19.8975 17.5244 19.8975H18.9037V18.5182C18.9037 18.3353 18.9764 18.1599 19.1057 18.0305C19.235 17.9012 19.4105 17.8285 19.5934 17.8285C19.7763 17.8285 19.9517 17.9012 20.081 18.0305C20.2104 18.1599 20.283 18.3353 20.283 18.5182V19.8975H21.6623C21.8452 19.8975 22.0207 19.9702 22.15 20.0995C22.2793 20.2288 22.352 20.4042 22.352 20.5871C22.352 20.7701 22.2793 20.9455 22.15 21.0748C22.0207 21.2041 21.8452 21.2768 21.6623 21.2768Z"
        fill="#717474"
      />
      <path
        d="M25.1115 30.9301C25.4924 30.9301 25.8012 30.6213 25.8012 30.2404C25.8012 29.8596 25.4924 29.5508 25.1115 29.5508C24.7306 29.5508 24.4219 29.8596 24.4219 30.2404C24.4219 30.6213 24.7306 30.9301 25.1115 30.9301Z"
        fill="#717474"
      />
      <path
        d="M27.8685 13H11.3168C10.951 13 10.6002 13.1453 10.3415 13.404C10.0828 13.6627 9.9375 14.0135 9.9375 14.3793V46.1034C9.9375 46.4692 10.0828 46.8201 10.3415 47.0787C10.6002 47.3374 10.951 47.4827 11.3168 47.4827H27.8685C28.2343 47.4827 28.5852 47.3374 28.8438 47.0787C29.1025 46.8201 29.2478 46.4692 29.2478 46.1034V14.3793C29.2478 14.0135 29.1025 13.6627 28.8438 13.404C28.5852 13.1453 28.2343 13 27.8685 13ZM25.7996 32.1862V34.3793C25.7996 34.5622 25.7269 34.7376 25.5976 34.8669C25.4682 34.9963 25.2928 35.0689 25.1099 35.0689C24.927 35.0689 24.7516 34.9963 24.6222 34.8669C24.4929 34.7376 24.4202 34.5622 24.4202 34.3793V32.1862C23.9601 32.0235 23.5723 31.7034 23.3253 31.2824C23.0784 30.8614 22.9882 30.3667 23.0707 29.8857C23.1533 29.4047 23.4032 28.9683 23.7763 28.6537C24.1495 28.3391 24.6218 28.1666 25.1099 28.1666C25.598 28.1666 26.0703 28.3391 26.4435 28.6537C26.8166 28.9683 27.0665 29.4047 27.1491 29.8857C27.2316 30.3667 27.1414 30.8614 26.8945 31.2824C26.6475 31.7034 26.2597 32.0235 25.7996 32.1862ZM27.1789 24.3931C27.1789 24.8467 26.9987 25.2817 26.6779 25.6025C26.3572 25.9232 25.9221 26.1034 25.4685 26.1034H13.7444C13.5175 26.1071 13.2921 26.0656 13.0814 25.9812C12.8707 25.8969 12.6789 25.7715 12.5171 25.6123C12.3554 25.4532 12.2269 25.2634 12.1392 25.054C12.0516 24.8447 12.0064 24.62 12.0065 24.3931V16.8069C12.0028 16.58 12.0443 16.3546 12.1287 16.1439C12.213 15.9332 12.3384 15.7414 12.4976 15.5796C12.6567 15.4179 12.8465 15.2894 13.0559 15.2017C13.2652 15.1141 13.4899 15.0689 13.7168 15.069H25.4409C25.6678 15.0653 25.8932 15.1068 26.1039 15.1912C26.3146 15.2755 26.5064 15.4009 26.6682 15.5601C26.83 15.7192 26.9584 15.909 27.0461 16.1184C27.1338 16.3277 27.1789 16.5524 27.1789 16.7793V24.3931Z"
        fill="#C8C8C8"
      />
      <path
        d="M39.5924 43.3438C38.4683 43.3438 37.5234 43.9782 37.5234 44.7231V45.4127H41.6614V44.7231C41.6614 43.9782 40.7165 43.3438 39.5924 43.3438Z"
        fill="#C8C8C8"
      />
      <path
        d="M38.9023 42.0223V38.5188H36.6265C36.1371 38.5168 35.6635 38.3453 35.2863 38.0334C34.9091 37.7216 34.6516 37.2888 34.5575 36.8085L34.0747 34.3809H32.6265C32.5465 34.38 32.4672 34.395 32.3931 34.4252C32.3191 34.4554 32.2518 34.5001 32.1953 34.5566C32.1387 34.6131 32.0941 34.6804 32.0639 34.7545C32.0337 34.8285 32.0186 34.9078 32.0196 34.9878V44.8154C32.0196 44.8947 32.0353 44.9733 32.0659 45.0466C32.0965 45.1198 32.1413 45.1863 32.1977 45.2421C32.2542 45.2979 32.3211 45.342 32.3947 45.3717C32.4683 45.4014 32.5471 45.4163 32.6265 45.4154H33.3851V46.7947C33.3851 46.9776 33.4577 47.153 33.5871 47.2823C33.7164 47.4117 33.8918 47.4843 34.0747 47.4843C34.2576 47.4843 34.4331 47.4117 34.5624 47.2823C34.6917 47.153 34.7644 46.9776 34.7644 46.7947V45.4154H36.1437V44.7257C36.1437 43.3947 37.3299 42.2774 38.9023 42.0223Z"
        fill="#C8C8C8"
      />
      <path
        d="M49.3359 34.3792H48.5566V27.5309C48.5566 27.3352 48.4788 27.1475 48.3404 27.0091C48.202 26.8707 48.0143 26.793 47.8186 26.793H45.8462C45.6505 26.793 45.4628 26.8707 45.3244 27.0091C45.186 27.1475 45.1083 27.3352 45.1083 27.5309V34.3792H40.9704V32.9999H42.929C43.1412 32.9999 43.3446 32.9156 43.4947 32.7655C43.6447 32.6155 43.729 32.412 43.729 32.1999V29.6619C43.729 29.4498 43.6447 29.2463 43.4947 29.0962C43.3446 28.9462 43.1412 28.8619 42.929 28.8619H37.6324C37.4203 28.8619 37.2168 28.9462 37.0667 29.0962C36.9167 29.2463 36.8324 29.4498 36.8324 29.6619V32.1999C36.8324 32.412 36.9167 32.6155 37.0667 32.7655C37.2168 32.9156 37.4203 32.9999 37.6324 32.9999H39.5911V34.3792H35.4531L35.8876 36.5378C35.9214 36.7081 36.0136 36.8613 36.1483 36.9709C36.2831 37.0805 36.4519 37.1395 36.6255 37.1378H43.729C43.9119 37.1378 44.0873 37.2104 44.2166 37.3398C44.346 37.4691 44.4186 37.6445 44.4186 37.8274C44.4186 38.0103 44.346 38.1858 44.2166 38.3151C44.0873 38.4444 43.9119 38.5171 43.729 38.5171H40.2807V42.0205C41.8531 42.2757 43.0393 43.3998 43.0393 44.724V45.4136H47.1773V46.7929C47.1773 46.9759 47.2499 47.1513 47.3792 47.2806C47.5086 47.4099 47.684 47.4826 47.8669 47.4826C48.0498 47.4826 48.2252 47.4099 48.3546 47.2806C48.4839 47.1513 48.5566 46.9759 48.5566 46.7929V45.4136H49.3359C49.495 45.4136 49.6476 45.3504 49.7601 45.2379C49.8727 45.1254 49.9359 44.9728 49.9359 44.8136V34.9861C49.9368 34.9067 49.9219 34.8279 49.8922 34.7543C49.8624 34.6807 49.8184 34.6138 49.7626 34.5573C49.7068 34.5009 49.6403 34.4561 49.5671 34.4255C49.4938 34.3949 49.4152 34.3792 49.3359 34.3792Z"
        fill="#C8C8C8"
      />
      <path
        d="M34.0766 27.3447C34.0584 27.2541 34.0227 27.168 33.9713 27.0913C33.9199 27.0145 33.8539 26.9487 33.777 26.8974C33.7002 26.8462 33.614 26.8106 33.5234 26.7927C33.4328 26.7747 33.3395 26.7748 33.249 26.793C33.1584 26.8111 33.0723 26.8468 32.9956 26.8982C32.9188 26.9496 32.8529 27.0156 32.8017 27.0925C32.7505 27.1693 32.7149 27.2555 32.697 27.3461C32.679 27.4367 32.6791 27.53 32.6973 27.6205L34.0766 34.3792H35.4559L34.0766 27.3447Z"
        fill="#717474"
      />
      <path
        d="M36.1445 46.7934C36.1445 46.9763 36.2172 47.1517 36.3465 47.281C36.4759 47.4104 36.6513 47.483 36.8342 47.483C37.0171 47.483 37.1925 47.4104 37.3218 47.281C37.4512 47.1517 37.5238 46.9763 37.5238 46.7934V45.4141H36.1445V46.7934Z"
        fill="#C8C8C8"
      />
      <path
        d="M41.6602 46.7934C41.6602 46.9763 41.7328 47.1517 41.8622 47.281C41.9915 47.4104 42.1669 47.483 42.3498 47.483C42.5327 47.483 42.7081 47.4104 42.8375 47.281C42.9668 47.1517 43.0395 46.9763 43.0395 46.7934V45.4141H41.6602V46.7934Z"
        fill="#C8C8C8"
      />
      <defs>
        <radialGradient
          id="paint0_radial_4380_50118"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(30 30) rotate(84.447) scale(36.1697 37.2555)"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#F1F1F1" />
        </radialGradient>
      </defs>
    </svg>
  );
};
export const ViewExaminationRoomIcon = () => {
  return (
    <svg
      width="60"
      height="60"
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="30" cy="30" r="30" fill="url(#paint0_radial_4380_50121)" />
      <path
        d="M48.3469 34.1745V34.8613C48.3469 35.5104 47.8262 36.0462 47.1771 36.0462H46.347C46.6036 35.7141 46.7545 35.3066 46.7545 34.8613V34.1745C46.7545 33.2311 46.3319 32.3783 45.6602 31.8047H45.9771C47.2904 31.8047 48.3469 32.8689 48.3469 34.1745Z"
        fill="#C8C8C8"
      />
      <path
        d="M46.1947 36.8008C46.1267 37.6461 45.4173 38.3102 44.5494 38.3102H43.9531C44.3154 37.9253 44.5644 37.4197 44.6022 36.8612L44.6097 36.8008H46.1947Z"
        fill="#C8C8C8"
      />
      <path
        d="M45.9964 34.1745V34.8613C45.9964 35.5104 45.4757 36.0462 44.8266 36.0462H13.2945C12.6379 36.0462 12.1172 35.5104 12.1172 34.8613V34.1745C12.1172 32.8689 13.1814 31.8047 14.487 31.8047H43.6266C44.9398 31.8047 45.9964 32.8689 45.9964 34.1745Z"
        fill="#C8C8C8"
      />
      <path
        d="M43.8486 36.8008C43.7806 37.6461 43.0712 38.3102 42.2108 38.3102H15.2901C14.4221 38.3102 13.7202 37.6461 13.6523 36.8008H43.8486Z"
        fill="#C8C8C8"
      />
      <path
        d="M39.7626 46.3776C39.554 46.3776 39.3852 46.2088 39.3852 46.0002V45.3811C39.3852 44.9772 39.0573 44.6492 38.6534 44.6492H18.8421C18.4382 44.6492 18.1102 44.9772 18.1102 45.3811V46.0002C18.1102 46.2088 17.9414 46.3776 17.7328 46.3776C17.5242 46.3776 17.3555 46.2088 17.3555 46.0002V45.3811C17.3555 44.5615 18.0225 43.8945 18.8421 43.8945H38.6534C39.473 43.8945 40.14 44.5615 40.14 45.3811V46.0002C40.14 46.2088 39.9712 46.3776 39.7626 46.3776Z"
        fill="#C8C8C8"
      />
      <path
        d="M37.3056 44.6476C37.2622 44.6476 37.2187 44.6403 37.1752 44.6248L20.9502 38.6652C20.7549 38.5929 20.6547 38.3763 20.7262 38.1802C20.7992 37.9842 21.0136 37.8861 21.2112 37.9562L37.4361 43.9158C37.6314 43.988 37.7316 44.2047 37.6602 44.4007C37.6034 44.5533 37.4597 44.6476 37.3056 44.6476Z"
        fill="#C8C8C8"
      />
      <path
        d="M21.0807 44.6476C20.9267 44.6476 20.7829 44.5533 20.7262 44.4007C20.6547 44.2047 20.7549 43.988 20.9502 43.9158L37.1752 37.9562C37.3727 37.8861 37.5872 37.9842 37.6602 38.1802C37.7316 38.3763 37.6314 38.5929 37.4361 38.6652L21.2112 44.6248C21.1677 44.6403 21.1242 44.6476 21.0807 44.6476Z"
        fill="#C8C8C8"
      />
      <path
        d="M19.417 47.2985C19.417 48.2268 18.6623 48.9815 17.734 48.9815C16.8058 48.9815 16.0586 48.2268 16.0586 47.2985C16.0586 46.3778 16.8058 45.623 17.734 45.623C18.6623 45.623 19.417 46.3778 19.417 47.2985Z"
        fill="#C8C8C8"
      />
      <path
        d="M41.448 47.2985C41.448 48.2268 40.6933 48.9815 39.765 48.9815C38.8367 48.9815 38.082 48.2268 38.082 47.2985C38.082 46.3778 38.8367 45.623 39.765 45.623C40.6933 45.623 41.448 46.3778 41.448 47.2985Z"
        fill="#C8C8C8"
      />
      <path
        d="M22.0544 30.4429C22.0544 31.1937 21.4444 31.8038 20.6935 31.8038H16.5015C15.7506 31.8038 15.1406 31.1937 15.1406 30.4429C15.1406 29.6921 15.7506 29.082 16.5015 29.082H20.6935C21.4444 29.082 22.0544 29.6921 22.0544 30.4429Z"
        fill="#717474"
      />
      <path
        d="M17.8249 15.3586C17.721 15.3586 17.617 15.3159 17.5419 15.2311L15.3522 12.7547H12.3149C12.1063 12.7547 11.9375 12.5859 11.9375 12.3774C11.9375 12.1688 12.1063 12 12.3149 12H15.5224C15.6307 12 15.7332 12.0464 15.8054 12.1275L18.1079 14.7314C18.2457 14.8877 18.231 15.1257 18.0747 15.2643C18.0032 15.3277 17.9141 15.3586 17.8249 15.3586Z"
        fill="#C8C8C8"
      />
      <path
        d="M21.3114 23.6157L20.602 24.3176C20.3152 24.6044 19.8624 24.6044 19.5832 24.3251L19.2812 24.0232C19.2964 24.0081 19.3039 24.0006 19.319 23.9855L21.0096 22.2949L21.3114 22.5968C21.5907 22.8761 21.5907 23.3364 21.3114 23.6157Z"
        fill="#717474"
      />
      <path
        d="M27.1903 17.7368L26.4734 18.4462C26.1941 18.7254 25.7413 18.7254 25.462 18.4462L25.1602 18.1443L26.8507 16.4537C26.8658 16.4386 26.8733 16.4311 26.8884 16.416L27.1903 16.7179C27.4696 16.9971 27.4696 17.4575 27.1903 17.7368Z"
        fill="#717474"
      />
      <path
        d="M24.2489 20.6726L23.5395 21.3896C23.2603 21.6688 22.7999 21.6688 22.5207 21.3896L22.2188 21.0877L23.947 19.3594L24.2489 19.6613C24.5282 19.9405 24.5282 20.3933 24.2489 20.6726Z"
        fill="#717474"
      />
      <path
        d="M23.4103 13.2222L16.0819 20.5506L15.9989 20.4675C14.9951 19.4562 14.9951 17.8185 15.9989 16.8071L19.6744 13.1317C20.6857 12.1204 22.3235 12.1279 23.3273 13.1392L23.4103 13.2222Z"
        fill="#C8C8C8"
      />
      <path
        d="M25.7317 13.4018L26.3151 13.9852C26.8503 14.5204 26.8503 15.3889 26.3195 15.9197L18.7877 23.4515C18.2525 23.9867 17.384 23.9867 16.8488 23.4515L16.2654 22.8681C15.8706 22.4733 15.8706 21.8329 16.261 21.4424L24.306 13.3974C24.7008 13.0026 25.3369 13.007 25.7317 13.4018Z"
        fill="#717474"
      />
      <defs>
        <radialGradient
          id="paint0_radial_4380_50121"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(30 30) rotate(84.447) scale(36.1697 37.2555)"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#F1F1F1" />
        </radialGradient>
      </defs>
    </svg>
  );
};
export const ViewEmergencyRoomIcon = () => {
  return (
    <svg
      width="60"
      height="60"
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="30" cy="30" r="30" fill="url(#paint0_radial_4380_50124)" />
      <path
        d="M41.22 43.8848H18.6561C15.7809 43.8857 13.4501 46.2165 13.4492 49.0916H46.4269C46.4269 46.2156 44.0961 43.8848 41.22 43.8848Z"
        fill="#C8C8C8"
      />
      <path
        d="M29.9372 19.5859C23.8611 19.5859 19.5234 23.9245 19.5234 30.2972V42.0701H40.3509V30.2972C40.3509 23.9245 36.0159 19.5859 29.9372 19.5859ZM36.8833 32.6426C36.3824 32.6426 35.976 32.2361 35.976 31.7353C35.976 28.48 34.3774 25.4923 32.2562 24.7864C31.7798 24.6277 31.5222 24.1142 31.6809 23.6378C31.8397 23.1615 32.3532 22.9038 32.8296 23.0626C35.7038 24.0216 37.7905 27.6689 37.7905 31.7353C37.7905 32.2361 37.3841 32.6426 36.8833 32.6426Z"
        fill="#717474"
      />
      <path
        d="M16.0516 30.9063H10.8448C10.344 30.9063 9.9375 30.4999 9.9375 29.9991C9.9375 29.4983 10.344 29.0918 10.8448 29.0918H16.0516C16.5525 29.0918 16.9589 29.4983 16.9589 29.9991C16.9589 30.4999 16.5525 30.9063 16.0516 30.9063Z"
        fill="#717474"
      />
      <path
        d="M19.4496 20.8632C19.2091 20.8632 18.9778 20.768 18.8081 20.5974L15.3369 17.1253C14.9885 16.7651 14.9985 16.1908 15.3596 15.8424C15.7116 15.5031 16.2687 15.5031 16.6198 15.8424L20.091 19.3145C20.4449 19.6693 20.4449 20.2436 20.091 20.5974C19.9204 20.768 19.69 20.8632 19.4496 20.8632Z"
        fill="#717474"
      />
      <path
        d="M29.9385 17.0214C29.4377 17.0214 29.0312 16.615 29.0312 16.1141V10.9073C29.0312 10.4065 29.4377 10 29.9385 10C30.4393 10 30.8458 10.4065 30.8458 10.9073V16.1141C30.8458 16.615 30.4393 17.0214 29.9385 17.0214Z"
        fill="#717474"
      />
      <path
        d="M40.6221 20.667C40.1213 20.667 39.7148 20.2605 39.7148 19.7597C39.7148 19.5193 39.8101 19.2888 39.9807 19.1183L43.4519 15.647C43.8058 15.2923 44.381 15.2923 44.7357 15.6461C45.0905 16 45.0905 16.5752 44.7357 16.9299L41.2636 20.4012C41.0939 20.5717 40.8625 20.667 40.6221 20.667Z"
        fill="#717474"
      />
      <path
        d="M49.0321 30.9063H43.8252C43.3244 30.9063 42.918 30.4999 42.918 29.9991C42.918 29.4983 43.3244 29.0918 43.8252 29.0918H49.0321C49.5329 29.0918 49.9394 29.4983 49.9394 29.9991C49.9394 30.4999 49.5329 30.9063 49.0321 30.9063Z"
        fill="#717474"
      />
      <defs>
        <radialGradient
          id="paint0_radial_4380_50124"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(30 30) rotate(84.447) scale(36.1697 37.2555)"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#F1F1F1" />
        </radialGradient>
      </defs>
    </svg>
  );
};
export const InspectionIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2297_16009)">
        <path
          d="M12.3828 0C8.18271 0 4.76564 3.41707 4.76564 7.61719C4.76564 9.5068 5.45756 11.2377 6.60096 12.5704L5.63596 13.5355L5.22162 13.1211C4.99295 12.8925 4.62178 12.8923 4.39299 13.1211L0.171621 17.3425C-0.057207 17.5713 -0.057207 17.9423 0.171621 18.1711L1.82889 19.8284C2.05768 20.0572 2.42869 20.0572 2.65752 19.8284L6.87885 15.607C7.10768 15.3782 7.10768 15.0072 6.87885 14.7784L6.46451 14.3641L7.42955 13.399C8.76232 14.5425 10.4932 15.2344 12.3828 15.2344C16.5829 15.2344 20 11.8173 20 7.61719C20 3.41707 16.5829 0 12.3828 0ZM2.24322 18.5854L1.41459 17.7568L4.80729 14.3641L5.63592 15.1927L2.24322 18.5854ZM12.3828 14.0625C8.82889 14.0625 5.93752 11.1711 5.93752 7.61719C5.93752 4.06324 8.82885 1.17188 12.3828 1.17188C15.9368 1.17188 18.8281 4.06324 18.8281 7.61719C18.8281 11.1711 15.9368 14.0625 12.3828 14.0625Z"
          fill="#252525"
        />
        <path
          d="M12.3828 2.34375C9.47504 2.34375 7.10938 4.70941 7.10938 7.61719C7.10938 10.525 9.47504 12.8906 12.3828 12.8906C15.2906 12.8906 17.6562 10.525 17.6562 7.61719C17.6562 4.70941 15.2906 2.34375 12.3828 2.34375ZM12.3828 11.7188C10.1212 11.7188 8.28125 9.87879 8.28125 7.61719C8.28125 5.35559 10.1212 3.51562 12.3828 3.51562C14.6444 3.51562 16.4844 5.35559 16.4844 7.61719C16.4844 9.87879 14.6444 11.7188 12.3828 11.7188Z"
          fill="#252525"
        />
        <path
          d="M15.1409 6.031C14.9121 5.80217 14.5411 5.80217 14.3122 6.031L11.7969 8.54639L10.4534 7.20287C10.2246 6.97404 9.85357 6.97404 9.62475 7.20287C9.39592 7.4317 9.39592 7.80268 9.62475 8.0315L11.3826 9.78932C11.6113 10.0181 11.9824 10.0181 12.2112 9.78932L15.1409 6.85963C15.3697 6.63084 15.3697 6.25982 15.1409 6.031Z"
          fill="#252525"
        />
      </g>
      <defs>
        <clipPath id="clip0_2297_16009">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const PalpationIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.1276 8.66383C14.7146 7.68477 13.5659 7.26484 12.6276 7.72633C12.4158 7.22414 11.9866 6.83539 11.4587 6.67797C12.1059 5.93965 12.4584 5.00637 12.4584 4.02344C12.4584 1.80492 10.6535 0 8.43498 0C6.21647 0 4.41155 1.80492 4.41155 4.02344C4.41155 5.58867 5.30471 6.9407 6.59905 7.60391V11.1534C6.36807 10.8772 6.18702 10.6734 6.03678 10.5232C5.53795 10.0244 4.9158 9.72656 4.37244 9.72656C2.9967 9.72656 2.42846 10.457 2.32854 10.6034C2.17342 10.8307 2.19846 11.1324 2.3819 11.3311C2.4753 11.4871 2.88131 12.25 4.46061 15.8598C4.8385 16.7236 5.34819 17.3089 5.75768 17.7792C6.26432 18.3609 6.59901 18.7453 6.59901 19.4141C6.59901 19.7377 6.86135 20 7.18494 20H16.2474C16.571 20 16.8334 19.7377 16.8334 19.4141C16.8334 18.0326 17.7709 17.2981 17.7709 15.3125V10.3125C17.7709 8.95094 16.3365 8.06922 15.1276 8.66383ZM5.58338 4.02344C5.58338 2.45109 6.8626 1.17188 8.43494 1.17188C10.0073 1.17188 11.2865 2.45109 11.2865 4.02344C11.2865 4.8884 10.9058 5.67789 10.2709 6.20852V4.0625C10.2709 3.05016 9.44729 2.22656 8.43494 2.22656C7.4226 2.22656 6.59901 3.05016 6.59901 4.0625V6.20852C5.96405 5.67789 5.58338 4.8884 5.58338 4.02344ZM16.599 15.3125C16.599 16.8547 15.886 17.4807 15.701 18.8281H7.71272C7.42244 17.4239 6.19827 16.9079 5.53428 15.3902C5.08893 14.3722 4.07143 12.0573 3.56705 11.0639C3.73737 10.9783 3.99682 10.8985 4.37248 10.8985C4.5628 10.8985 4.89494 11.0387 5.20819 11.3518C5.49217 11.6359 5.96073 12.2123 6.726 13.1767C6.88092 13.372 7.14252 13.4479 7.37784 13.3658C7.61323 13.2838 7.77092 13.0618 7.77092 12.8125V4.0625C7.77092 3.69633 8.06881 3.39844 8.43498 3.39844C8.80116 3.39844 9.09905 3.69633 9.09905 4.0625V10.9375C9.09905 11.2611 9.36139 11.5234 9.68498 11.5234C10.0086 11.5234 10.2709 11.2611 10.2709 10.9375V8.4375C10.2709 8.07133 10.5688 7.77344 10.935 7.77344C11.3012 7.77344 11.599 8.07133 11.599 8.4375V10.9375C11.599 11.2611 11.8614 11.5234 12.185 11.5234C12.5086 11.5234 12.7709 11.2611 12.7709 10.9375V9.375C12.7709 9.00883 13.0688 8.71094 13.435 8.71094C13.8012 8.71094 14.099 9.00883 14.099 9.375V10.9375C14.099 11.2611 14.3614 11.5234 14.685 11.5234C15.0086 11.5234 15.2709 11.2611 15.2709 10.9375V10.3125C15.2709 9.94633 15.5688 9.64844 15.935 9.64844C16.3012 9.64844 16.599 9.94633 16.599 10.3125L16.599 15.3125Z"
        fill="#252525"
      />
    </svg>
  );
};
export const PercussionIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.5259 0.190362C10.6392 -0.183545 9.66021 0.0015726 8.97118 0.673449C8.95497 0.689269 8.93947 0.705753 8.9247 0.722902L4.50008 5.85955H3.12375C1.40133 5.85955 0 7.26088 0 8.9833V11.0137C0 12.7362 1.40133 14.1375 3.12375 14.1375H4.50012L8.92474 19.2741C8.9395 19.2913 8.95501 19.3078 8.97122 19.3236C9.42661 19.7676 10.0076 20 10.6051 20C10.9149 20 11.2292 19.9375 11.5325 19.8096C12.4152 19.4374 12.9635 18.6105 12.9635 17.6517C12.9635 17.2203 12.6139 16.8707 12.1826 16.8707C11.7512 16.8707 11.4016 17.2203 11.4016 17.6517C11.4016 18.1324 11.0374 18.3233 10.9257 18.3704C10.8142 18.4174 10.429 18.5431 10.0826 18.2252L5.44981 12.8469C5.30149 12.6747 5.08544 12.5757 4.85813 12.5757H3.12375C2.26254 12.5757 1.56188 11.875 1.56188 11.0138V8.98338C1.56188 8.12217 2.26254 7.42151 3.12375 7.42151H4.85813C5.08544 7.42151 5.30145 7.32244 5.44981 7.15025L10.0826 1.77193C10.4252 1.45767 10.8082 1.58286 10.9191 1.62958C11.0323 1.67728 11.4016 1.87083 11.4016 2.35673V13.7471C11.4016 14.1784 11.7512 14.528 12.1826 14.528C12.6139 14.528 12.9635 14.1784 12.9635 13.7471V2.35673C12.9636 1.39435 12.4127 0.564269 11.5259 0.190362Z"
        fill="#252525"
      />
      <path
        d="M16.2642 12.2457L16.2821 12.2128C16.4864 11.8382 16.8665 11.141 16.8665 9.99895C16.8665 8.81426 16.4552 8.08855 16.2575 7.73977C16.0448 7.36457 15.5683 7.23273 15.193 7.44543C14.8178 7.65812 14.686 8.13469 14.8987 8.50992C15.0603 8.79508 15.3046 9.22609 15.3046 9.99895C15.3046 10.7429 15.0677 11.1775 14.9109 11.4652L14.8917 11.5003C14.6859 11.8793 14.8262 12.3534 15.2052 12.5593C15.3237 12.6236 15.4513 12.6541 15.5773 12.6541C15.8543 12.6541 16.1227 12.5063 16.2642 12.2457Z"
        fill="#252525"
      />
      <path
        d="M17.4165 3.84134C17.11 3.53783 16.6155 3.54017 16.312 3.84662C16.0085 4.15306 16.0109 4.64752 16.3173 4.95103C17.6789 6.29971 18.4288 8.09123 18.4288 9.99553C18.4288 11.9037 17.6789 13.6974 16.3173 15.0461C16.0109 15.3496 16.0085 15.8441 16.312 16.1505C16.4647 16.3047 16.6658 16.3819 16.8669 16.3819C17.0655 16.3819 17.2642 16.3066 17.4164 16.1557C19.0764 14.5115 19.9906 12.3237 19.9906 9.99549C19.9906 7.67115 19.0765 5.48556 17.4165 3.84134Z"
        fill="#252525"
      />
    </svg>
  );
};
export const AuscultationIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2297_16006)">
        <path
          d="M17.0703 9.41406C15.6556 9.41406 14.4721 10.4222 14.1999 11.7578H13.4766C11.8612 11.7578 10.5469 13.0721 10.5469 14.6875V17.0703C10.5469 18.0396 9.75836 18.8281 8.78906 18.8281C7.81977 18.8281 7.03125 18.0396 7.03125 17.0703V15.1655C7.7118 14.9228 8.20312 14.2785 8.20312 13.5156V12.4804C10.9929 11.0778 12.8906 6.61148 12.8906 4.10156C12.8906 2.70301 12.763 2.0123 11.679 1.39109C11.5097 0.597461 10.8044 0 9.96094 0C8.99164 0 8.20312 0.788516 8.20312 1.75781C8.20312 2.72711 8.99164 3.51562 9.96094 3.51562C10.6016 3.51562 11.1576 3.1675 11.4648 2.65402C11.6836 2.88957 11.7188 3.23891 11.7188 4.10156C11.7188 6.9666 9.16441 11.7578 6.44531 11.7578C3.72621 11.7578 1.17188 6.9666 1.17188 4.10156C1.17188 3.23891 1.20707 2.88957 1.42578 2.65402C1.73305 3.1675 2.28902 3.51562 2.92969 3.51562C3.89898 3.51562 4.6875 2.72711 4.6875 1.75781C4.6875 0.788516 3.89898 0 2.92969 0C2.08625 0 1.38094 0.597461 1.21164 1.39109C0.127617 2.0123 0 2.70301 0 4.10156C0 6.61148 1.89773 11.0778 4.6875 12.4804V13.5156C4.6875 14.2785 5.17883 14.9228 5.85938 15.1655V17.0703C5.85938 18.6857 7.17371 20 8.78906 20C10.4044 20 11.7188 18.6857 11.7188 17.0703V14.6875C11.7188 13.7182 12.5073 12.9297 13.4766 12.9297H14.1999C14.4721 14.2653 15.6556 15.2734 17.0703 15.2734C18.6857 15.2734 20 13.9591 20 12.3438C20 10.7284 18.6857 9.41406 17.0703 9.41406ZM17.6562 12.9297H16.4844V11.7578H17.6562V12.9297Z"
          fill="#252525"
        />
      </g>
      <defs>
        <clipPath id="clip0_2297_16006">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const HygieneIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.60156 7.49961C5.92086 6.9477 7.85112 6.59961 10.0016 6.59961C12.152 6.59961 14.0823 6.9477 15.4016 7.49961"
        stroke="#252525"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M7.30078 9.75176C8.14655 9.46018 9.05503 9.30176 10.0008 9.30176C10.9465 9.30176 11.855 9.46018 12.7008 9.75176"
        stroke="#252525"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M6.39844 12.9004C7.45746 13.4728 8.687 13.8004 9.99844 13.8004C11.3099 13.8004 12.5394 13.4728 13.5984 12.9004"
        stroke="#252525"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M4.6 8.4C4.6 11.3314 2.95192 12.8477 1.95158 12.8987C1.91938 12.9003 1.89002 12.8827 1.87425 12.8546C1.1409 11.5469 1 10.0091 1 8.4C1 5.41766 1.80589 3 2.8 3C3.79411 3 4.6 5.41766 4.6 8.4Z"
        stroke="#252525"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.3984 8.4C15.3984 11.3314 17.0465 12.8477 18.0469 12.8987C18.0791 12.9003 18.1084 12.8827 18.1242 12.8546C18.8575 11.5469 18.9984 10.0091 18.9984 8.4C18.9984 5.41766 18.1926 3 17.1984 3C16.2043 3 15.3984 5.41766 15.3984 8.4Z"
        stroke="#252525"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.1016 12.9004C16.4847 15.5905 13.4628 17.4004 10.0016 17.4004C6.54037 17.4004 3.5184 15.5905 1.90156 12.9004"
        stroke="#252525"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const OrderCloseIcon = () => {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="28"
        height="28"
        viewBox="0 0 28 28"
        fill="none"
      >
        <rect width="28" height="28" rx="6" fill="#FFE7E5" />
        <path
          d="M18 10L10 18M10 10L18 18"
          stroke="#F44336"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};

export const SelectIcon = () => {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <circle cx="12" cy="12" r="12" fill="#026A26" />
        <path
          d="M16.8791 9.14258L11.1648 14.8566L8 11.809"
          stroke="white"
          strokeWidth="1.71429"
          strokeLinecap="round"
          strokeLinejoin="round"
        ></path>
      </svg>
    </>
  );
};
export const ZoomOutIcon = ({ onClick, className }) => {
  return (
    <>
      <svg
        width="31"
        height="31"
        viewBox="0 0 31 31"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        onClick={onClick}
        className={className}
      >
        <path
          d="M28.8742 28.6329L21.4076 21.845M24.8014 13.6996C24.8014 20.0726 19.6351 25.239 13.262 25.239C6.88902 25.239 1.72266 20.0726 1.72266 13.6996C1.72266 7.32652 6.88902 2.16016 13.262 2.16016C19.6351 2.16016 24.8014 7.32652 24.8014 13.6996Z"
          stroke="black"
          strokeWidth="3.39394"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.2701 8.26758V19.1282M18.7004 13.6979L7.83984 13.6979"
          stroke="black"
          strokeWidth="3.39394"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};
export const ZoomInIcon = ({ onClick, className }) => {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="31"
        height="31"
        viewBox="0 0 31 31"
        fill="none"
        onClick={onClick}
        className={className}
      >
        <path
          d="M28.8742 28.8634L21.4076 22.0755M24.8014 13.93C24.8014 20.3031 19.6351 25.4694 13.262 25.4694C6.88902 25.4694 1.72266 20.3031 1.72266 13.93C1.72266 7.55699 6.88902 2.39062 13.262 2.39062C19.6351 2.39062 24.8014 7.55699 24.8014 13.93Z"
          stroke="black"
          strokeOpacity="0.5"
          strokeWidth="3.39394"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18.7004 13.9297L7.83984 13.9297"
          stroke="black"
          strokeOpacity="0.5"
          strokeWidth="3.39394"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};

export const VideoIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="22"
      viewBox="0 0 13 12"
      fill="none"
    >
      <path
        d="M6.41406 0C3.10036 0 0.414062 2.68629 0.414062 6C0.414062 9.31371 3.10036 12 6.41406 12C9.72777 12 12.4141 9.31371 12.4141 6C12.4105 2.68777 9.72631 0.00354074 6.41406 0ZM8.9409 6.19117C8.89936 6.2745 8.83184 6.34205 8.74849 6.38358V6.38571L5.31992 8.10001C5.10818 8.20581 4.85079 8.11995 4.74497 7.90821C4.71488 7.84802 4.69939 7.78157 4.69977 7.7143V4.28573C4.69967 4.04903 4.89144 3.85707 5.12815 3.85695C5.19472 3.85692 5.26038 3.87239 5.31992 3.90215L8.74849 5.61644C8.96033 5.72201 9.04649 5.97933 8.9409 6.19117Z"
        fill="#026A26"
      />
    </svg>
  );
};

export const AudioIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="20"
      viewBox="0 0 10 12"
      fill="none"
    >
      <path
        d="M5.51172 1.40625L5.51172 8.95338"
        stroke="#026A26"
        strokeWidth="1.2128"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.51573 8.95277C5.51573 10.1434 4.55032 11.1087 3.35943 11.1087C2.16853 11.1087 1.20312 10.1434 1.20312 8.95277C1.20312 7.7621 2.16853 6.79688 3.35943 6.79688C4.55032 6.79688 5.51573 7.7621 5.51573 8.95277Z"
        stroke="#026A26"
        strokeWidth="1.2128"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.51172 1.40625C7.59578 1.40625 9.28525 3.0954 9.28525 5.17906C8.47663 4.3706 6.35028 3.1669 5.51172 4.34066"
        stroke="#026A26"
        strokeWidth="1.2128"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const PauseIcon = () => {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.5 0C3.34756 0 0 3.34756 0 7.5C0 11.6524 3.34756 15 7.5 15C11.6524 15 15 11.6524 15 7.5C15 3.34756 11.6524 0 7.5 0ZM10.4451 9.58537C10.4451 10.0427 10.0793 10.4268 9.60366 10.4268H5.41463C4.95732 10.4268 4.57317 10.061 4.57317 9.58537L4.59146 5.41463C4.59146 4.95732 4.95732 4.57317 5.43293 4.57317H9.60366C10.061 4.57317 10.4451 4.93902 10.4451 5.41463V9.58537Z"
        fill="white"
      />
    </svg>
  );
};

export const EyeOrganIcon = ({ fillColor }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
    >
      <circle cx="15" cy="15" r="15" fill={fillColor ? fillColor : "#8B8D95"} />
      <path
        d="M19.7204 11.7386C18.3408 10.9273 16.8432 10.502 15.2992 10.502C10.0404 10.502 7.10756 15.3919 7 15.495C7.11947 15.6096 9.88587 20.4917 15.2992 20.4917C20.5579 20.4917 23.5065 15.5831 23.5984 15.495C23.433 15.2998 22.2612 13.2289 19.7204 11.7386ZM15.2992 19.1014C13.312 19.1014 11.6964 17.4858 11.6964 15.4986C11.6964 13.5114 13.312 11.8959 15.2992 11.8959C17.2864 11.8959 18.9019 13.5114 18.9019 15.4986C18.9019 17.4858 17.2864 19.1014 15.2992 19.1014Z"
        fill="white"
      />
      <path
        d="M16.0753 14.719C15.5301 14.1739 15.6828 13.5353 15.6582 13.3525H15.3007C14.1182 13.3525 13.1562 14.3145 13.1562 15.497C13.1562 16.6593 14.1384 17.6415 15.3007 17.6415C16.4833 17.6415 17.4452 16.6796 17.4452 15.497V15.1396C17.2587 15.1142 16.6225 15.2655 16.0753 14.719Z"
        fill="white"
      />
      <path d="M14.9414 8H15.6562V9.44002H14.9414V8Z" fill="white" />
      <path
        d="M20.043 10.2559L21.0615 9.23735L21.5669 9.74282L20.5484 10.7613L20.043 10.2559Z"
        fill="white"
      />
      <path
        d="M9.02734 9.74121L9.5328 9.23575L10.5511 10.254L10.0456 10.7595L9.02734 9.74121Z"
        fill="white"
      />
      <path d="M14.9414 21.5596H15.6562V23H14.9414V21.5596Z" fill="white" />
      <path
        d="M9.02344 21.2598L10.0417 20.2415L10.5471 20.747L9.5289 21.7652L9.02344 21.2598Z"
        fill="white"
      />
      <path
        d="M20.0391 20.7451L20.5445 20.2397L21.563 21.2582L21.0576 21.7636L20.0391 20.7451Z"
        fill="white"
      />
      <defs>
        <radialGradient
          id="paint0_radial_10827_28452"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(15 15) rotate(84.447) scale(18.0849 18.6277)"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#F1F1F1" />
        </radialGradient>
      </defs>
    </svg>
  );
};

export const EarOrganIcon = ({ fillColor }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
    >
      <circle cx="15" cy="15" r="15" fill={fillColor ? fillColor : "#8B8D95"} />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.1468 18.6374C16.183 18.5823 16.2809 18.4362 16.376 18.317C16.6235 18.0093 16.9831 17.6062 17.3784 17.1439C18.0673 16.3383 18.8563 15.3585 19.3798 14.3803C19.7614 13.668 20 12.9524 20 12.2962C20 9.37271 17.5367 7 14.5016 7C11.4671 7 9.0033 9.37271 9.0033 12.2962C9.0033 13.7463 9 17.3923 9 18.5574C9 20.4572 10.6017 22 12.5739 22C14.5187 22 16.1028 20.5006 16.1468 18.6374ZM11.7492 13.1759H11.7497C12.6603 13.1759 13.3992 13.8878 13.3992 14.7648C13.3992 15.6419 12.6603 16.3537 11.7497 16.3537C11.4462 16.3537 11.1999 16.591 11.1999 16.8833C11.1999 17.1757 11.4462 17.4129 11.7497 17.4129C13.2673 17.4129 14.4989 16.226 14.4989 14.7648C14.4989 13.5017 13.579 12.4435 12.349 12.1797C12.5629 11.1888 13.4333 10.3483 14.4907 10.3483C15.7003 10.3483 16.6812 11.2979 16.6812 12.4668C16.6812 12.7591 16.9275 12.9964 17.231 12.9964C17.5345 12.9964 17.7809 12.7591 17.7809 12.4668C17.7809 10.7127 16.3062 9.28903 14.4907 9.28903C12.685 9.28903 11.1993 10.9017 11.1993 12.6463C11.1993 12.9387 11.4457 13.1759 11.7492 13.1759Z"
        fill="white"
      />
      <defs>
        <radialGradient
          id="paint0_radial_10827_28468"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(15 15) rotate(84.447) scale(18.0849 18.6277)"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#F1F1F1" />
        </radialGradient>
      </defs>
    </svg>
  );
};

export const NoseOrganIcon = ({ fillColor }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
    >
      <circle cx="15" cy="15" r="15" fill={fillColor ? fillColor : "#8B8D95"} />
      <path
        d="M19.4453 20.125C18.8983 20.125 18.5225 20.4743 18.125 20.9149C18.436 21.048 18.9045 21.1964 19.4453 21.1964C19.8808 21.1964 20.2488 20.9511 20.2488 20.6607C20.2488 20.3704 19.8808 20.125 19.4453 20.125Z"
        fill="white"
      />
      <path
        d="M11.409 20.125C10.9735 20.125 10.6055 20.3704 10.6055 20.6607C10.6055 20.9511 10.9735 21.1964 11.409 21.1964C11.9498 21.1964 12.4183 21.048 12.7293 20.9149C12.3321 20.474 11.956 20.125 11.409 20.125Z"
        fill="white"
      />
      <path
        d="M18.6616 14.0639C18.3177 13.2038 18.1355 12.1632 17.9596 11.1566C17.52 8.64598 17.1064 7 15.4283 7C13.7502 7 13.3363 8.64598 12.8971 11.1566C12.7211 12.1632 12.5389 13.2038 12.195 14.0639C11.6764 15.3601 10.9286 16.2164 10.2691 16.9718C9.56009 17.7834 9 18.4246 9 19.3214C9 20.1957 9.37955 20.7582 10.1523 21.0215C10.103 20.9087 10.0714 20.7887 10.0714 20.6607C10.0714 20.0599 10.6596 19.5893 11.4107 19.5893C12.2767 19.5893 12.7987 20.1807 13.3034 20.7526C13.8841 21.4086 14.4962 22 15.4286 22C16.3355 22 16.9888 21.3909 17.554 20.7526C18.0587 20.1807 18.5804 19.5893 19.4464 19.5893C20.1975 19.5893 20.7857 20.0599 20.7857 20.6607C20.7857 20.7885 20.7541 20.9087 20.7048 21.0215C21.4773 20.7582 21.8571 20.1957 21.8571 19.3214C21.8571 18.4244 21.2971 17.7834 20.588 16.9718C19.9283 16.2164 19.1804 15.3598 18.6621 14.0639H18.6616Z"
        fill="white"
      />
      <defs>
        <radialGradient
          id="paint0_radial_10827_28476"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(15 15) rotate(84.447) scale(18.0849 18.6277)"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#F1F1F1" />
        </radialGradient>
      </defs>
    </svg>
  );
};

export const MounthOrganIcon = ({ fillColor }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
    >
      <circle cx="15" cy="15" r="15" fill={fillColor ? fillColor : "#8B8D95"} />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.85 7C10.6191 7 8 9.74735 8 13.1364V15.8636C8 19.2527 10.6191 22 13.85 22H15.15C18.3809 22 21 19.2527 21 15.8636V13.1364C21 9.74735 18.3809 7 15.15 7H13.85ZM18.676 10.1196L18.5904 10.2094C18.4685 10.3373 18.3032 10.4091 18.1308 10.4091H10.8693C10.6969 10.4091 10.5315 10.3373 10.4096 10.2094L10.324 10.1196C11.1584 9.04788 12.428 8.36364 13.85 8.36364H15.15C16.572 8.36364 17.8417 9.04788 18.676 10.1196ZM13.85 18.25V18.258C13.8541 18.6309 14.1435 18.9318 14.4999 18.9318C14.8589 18.9318 15.1499 18.6266 15.1499 18.25C15.1499 16.932 16.1685 15.8636 17.4249 15.8636C18.3469 15.8636 19.1421 16.439 19.4995 17.2688C18.9277 19.2189 17.1966 20.6364 15.1499 20.6364H13.8499C13.4937 20.6364 13.147 20.5934 12.8143 20.5122C12.7969 20.5079 12.7794 20.5035 12.762 20.499C11.933 20.2857 11.1932 19.834 10.6125 19.2172C10.6042 19.1232 10.6 19.028 10.6 18.9318C10.6 17.2373 11.9096 15.8636 13.525 15.8636C13.8781 15.8636 14.2165 15.9292 14.5299 16.0495C14.1022 16.6676 13.85 17.4279 13.85 18.25Z"
        fill="white"
      />
      <defs>
        <radialGradient
          id="paint0_radial_10827_28487"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(15 15) rotate(84.447) scale(18.0849 18.6277)"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#F1F1F1" />
        </radialGradient>
      </defs>
    </svg>
  );
};

export const NeckOrganIcpon = ({ fillColor }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
    >
      <circle cx="15" cy="15" r="15" fill={fillColor ? fillColor : "#8B8D95"} />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.2495 22H10.0576C9.99881 22 9.94332 21.9729 9.90725 21.9264C9.87118 21.8799 9.85854 21.8194 9.87312 21.7625C10.091 20.9088 10.3978 20.2083 10.6945 19.5308C11.3171 18.1091 11.8088 16.9862 11.1097 15.2239C9.80731 11.9454 10.377 10.0152 11.0842 8.97322C11.9354 7.7192 13.483 7 15.3301 7C16.2713 7 17.2225 7.18963 18.081 7.54843C18.976 7.92254 19.7296 8.4664 20.2605 9.12125C21.0538 10.0999 21.3306 11.2911 21.061 12.5659C20.8492 13.5677 21.0185 13.9105 21.5393 14.7543C21.679 14.9802 21.7785 15.3125 21.6388 15.5671C21.5697 15.6929 21.4178 15.8437 21.0865 15.8479H20.6461L20.8356 16.2919C20.8662 16.3634 20.8501 16.4463 20.7951 16.5013L20.5594 16.737L20.763 17.044C20.8131 17.1195 20.803 17.2198 20.739 17.2839L20.3667 17.6562V18.2072C20.3667 18.8861 20.028 19.2754 19.4376 19.2755C19.4296 19.2755 19.4215 19.2754 19.4133 19.2752C18.9838 19.2679 17.9581 19.2396 17.5785 19.1358C17.539 19.1604 17.396 19.2869 17.1336 19.912C16.9457 20.3593 16.7682 20.8871 16.6256 21.3111C16.5414 21.5614 16.4749 21.7591 16.4263 21.8804C16.3973 21.9527 16.3273 22 16.2495 22ZM11.9906 15.0648C11.9149 15.0648 11.8432 15.0193 11.8136 14.9446C11.3344 13.7375 11.0899 12.6354 11.0868 11.6687C11.0825 10.3499 11.5332 9.33126 12.4261 8.64122C12.9405 8.24364 13.575 7.97578 14.3118 7.845C14.956 7.73066 15.6592 7.72837 16.3456 7.83845C16.4495 7.8551 16.5201 7.95279 16.5035 8.05664C16.4869 8.16046 16.3892 8.23118 16.2853 8.21453C14.8934 7.99125 13.5378 8.26348 12.659 8.94259C11.8647 9.55645 11.4639 10.4733 11.4677 11.6675C11.4706 12.5734 11.7126 13.658 12.1676 14.8041C12.2064 14.9019 12.1586 15.0126 12.0608 15.0514C12.0377 15.0605 12.014 15.0648 11.9906 15.0648Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.76781 17.8379H8.19043C8.08526 17.8379 8 17.7526 8 17.6475C8 17.5423 8.08526 17.457 8.19043 17.457H9.76781C9.87298 17.457 9.95824 17.5423 9.95824 17.6475C9.95824 17.7526 9.87294 17.8379 9.76781 17.8379Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.76679 16.4657C9.71538 16.4657 9.66418 16.4451 9.62662 16.4043L8.51124 15.1925C8.44003 15.1151 8.44502 14.9946 8.52242 14.9234C8.59976 14.8521 8.72026 14.8571 8.7915 14.9345L9.90688 16.1463C9.97809 16.2237 9.9731 16.3442 9.89574 16.4154C9.85911 16.4491 9.8129 16.4657 9.76679 16.4657Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.65133 20.4208C8.60522 20.4208 8.55901 20.4042 8.52242 20.3705C8.44501 20.2993 8.44003 20.1788 8.51127 20.1014L9.62662 18.8896C9.69783 18.8122 9.81833 18.8072 9.89569 18.8784C9.9731 18.9497 9.97808 19.0702 9.90688 19.1476L8.79153 20.3594C8.75397 20.4001 8.70274 20.4208 8.65133 20.4208Z"
        fill="white"
      />
      <defs>
        <radialGradient
          id="paint0_radial_10827_28495"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(15 15) rotate(84.447) scale(18.0849 18.6277)"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#F1F1F1" />
        </radialGradient>
      </defs>
    </svg>
  );
};

export const ShoulderOrganIcon = ({ fillColor }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
    >
      <circle cx="15" cy="15" r="15" fill={fillColor ? fillColor : "#8B8D95"} />
      <path
        d="M8.02164 15.2826C7.9455 15.0281 8.07668 14.7558 8.31473 14.6743L9.02179 14.4324C9.25985 14.3509 9.51453 14.4913 9.5907 14.7458C9.66683 15.0003 9.53566 15.2726 9.29761 15.3541L8.59054 15.596C8.35257 15.6774 8.09783 15.5372 8.02164 15.2826ZM9.90059 11.185C10.0159 10.9479 9.92961 10.6558 9.7079 10.5325L9.00084 10.1394C8.77907 10.0161 8.50586 10.1083 8.39058 10.3454C8.27528 10.5825 8.36157 10.8747 8.58327 10.998L9.29034 11.3911C9.51207 11.5144 9.78528 11.4221 9.90059 11.185ZM11.8995 8.93346C12.1171 8.80197 12.1938 8.50678 12.0708 8.27413L11.7031 7.57857C11.5801 7.34589 11.3041 7.26394 11.0865 7.39543C10.869 7.52692 10.7923 7.82211 10.9153 8.05475L11.2829 8.75031C11.4059 8.98299 11.682 9.06495 11.8995 8.93346ZM15.618 8.13465L15.7594 7.62054C15.8299 7.36416 15.6928 7.09522 15.453 7.01979C15.2132 6.94437 14.9617 7.0911 14.8912 7.34746L14.7498 7.86157C14.6646 8.17122 14.882 8.4821 15.1841 8.4821C15.3797 8.48213 15.56 8.34544 15.618 8.13465ZM21.5084 8.34498C19.6391 8.51815 17.8163 9.04889 16.1215 9.91332C13.2012 9.13468 10.3812 11.7198 11.0917 15.2168C10.2053 17.2992 10.2207 19.671 11.0957 21.7172C11.1692 21.8896 11.3301 22 11.5072 22H16.0239C16.193 22 16.348 21.899 16.4258 21.7384C17.4452 19.6271 17.5021 17.1178 16.8267 14.9337C16.7483 14.68 16.877 14.4063 17.1143 14.3224C17.3515 14.2386 17.6075 14.3762 17.686 14.6299C18.3303 16.7134 18.3641 19.0367 17.6527 21.2106C17.6207 21.3083 17.6504 21.4175 17.7272 21.4804C17.8661 21.594 18.0062 21.6935 18.1489 21.7825C18.2177 21.8254 18.2962 21.8476 18.3759 21.8476H21.5475C21.7974 21.8476 22 21.631 22 21.3637V8.82704C22 8.54394 21.7731 8.32088 21.5084 8.34498Z"
        fill="white"
      />
      <defs>
        <radialGradient
          id="paint0_radial_10827_28507"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(15 15) rotate(84.447) scale(18.0849 18.6277)"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#F1F1F1" />
        </radialGradient>
      </defs>
    </svg>
  );
};

export const ArmsOrganIcon = ({ fillColor }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
    >
      <circle cx="15" cy="15" r="15" fill={fillColor ? fillColor : "#8B8D95"} />
      <path
        d="M21.4478 21.0719C20.9052 21.6146 20.2047 21.8909 19.4548 21.9501C18.5471 22.0092 17.6296 21.9994 16.7219 21.9994C14.1665 21.9994 11.4335 21.9698 9.04583 20.9634C8.53278 20.7464 8.148 20.5392 8.10853 19.9274C8.0592 19.2269 8 18.5067 8 17.8062C8 16.2868 8.57225 14.9449 9.16423 13.5834C9.72661 12.2712 10.289 10.9688 10.881 9.66645C10.9895 9.43952 11.0783 9.18299 11.2164 8.9758C11.4138 8.66994 11.7393 8.43315 12.0057 8.19636C12.3807 7.8609 12.7457 7.51558 13.1404 7.19986C13.5942 6.84467 13.979 7.0124 14.3934 7.31825C14.6795 7.53531 14.9755 7.74251 15.2616 7.96943C15.4984 8.15689 15.8536 8.35422 15.9819 8.64035C16.0805 8.84754 16.0312 9.05473 15.9523 9.26192C15.9227 9.34086 15.7846 9.52832 15.8043 9.60725C15.824 9.70591 15.9819 9.81444 16.0016 9.95257C16.0312 10.1499 15.972 10.3966 15.8536 10.5446C15.6563 10.7912 15.38 10.732 15.0939 10.8011C14.7289 10.8899 14.4329 11.1267 14.0579 11.2155C13.8014 11.2747 13.3673 11.1464 13.1502 11.2549C12.9332 11.3635 12.7852 11.837 12.7062 12.0442C12.578 12.3501 12.4793 12.6757 12.4004 13.0013C12.2327 13.7116 12.1932 14.4418 12.2327 15.1719C12.2524 15.5665 12.2919 15.971 12.3215 16.3657C12.3511 16.7505 12.3017 17.2734 12.43 17.6385C12.6767 17.5595 12.9233 17.2142 13.1502 17.0662C13.4265 16.8886 13.7323 16.7406 14.0481 16.642C14.6401 16.4545 15.2814 16.4052 15.9029 16.5236C16.2187 16.5828 16.5147 16.6814 16.8107 16.8097C17.1954 16.9873 17.1165 17.0267 17.4125 16.7406C17.8762 16.2966 18.4583 15.9908 19.0996 15.9414C20.3033 15.8428 21.5268 16.5137 22.0201 17.6187C22.5134 18.7632 22.3555 20.1642 21.4478 21.0719Z"
        fill="white"
      />
      <defs>
        <radialGradient
          id="paint0_radial_10827_28515"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(15 15) rotate(84.447) scale(18.0849 18.6277)"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#F1F1F1" />
        </radialGradient>
      </defs>
    </svg>
  );
};

export const ForearmsOrganIcons = ({ fillColor }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="white"
    >
      <circle cx="15" cy="15" r="15" fill={fillColor ? fillColor : "#8B8D95"} />
      <path
        d="M19.3425 9.50259C19.4489 9.79972 19.4697 10.1208 19.4025 10.4292C19.3352 10.7375 19.1826 11.0208 18.9621 11.2466L17.2144 13.0487C17.4403 16.8206 18.2478 18.3048 18.1852 21.5255C18.1827 21.6524 18.1305 21.7733 18.0398 21.862C17.949 21.9508 17.827 22.0003 17.7001 22H11.5808C11.4556 22.0001 11.3352 21.9516 11.245 21.8648C11.1547 21.7779 11.1017 21.6594 11.097 21.5343C10.9709 18.1896 11.3979 17.0266 11.808 12.5397L11.0791 10.2263C10.8977 9.64684 11.0625 9.2649 11.2303 8.7003C11.3244 8.38023 11.5112 8.09517 11.767 7.88109C12.0229 7.667 12.3364 7.53346 12.668 7.49731C17.4612 6.96809 17.2099 6.97535 17.5032 7.01738C17.5455 7.0239 17.5853 7.04149 17.6185 7.06836C17.6517 7.09524 17.6773 7.13045 17.6925 7.1704C17.7077 7.21034 17.712 7.25361 17.7051 7.29579C17.6982 7.33797 17.6802 7.37755 17.6529 7.41052L17.1101 8.07128C16.6828 8.58538 16.4557 9.27427 16.5222 10.0938C16.5273 10.1571 16.5449 10.2189 16.5739 10.2754C16.6028 10.332 16.6427 10.3823 16.6911 10.4234C16.7889 10.5066 16.9157 10.5475 17.0436 10.5371C17.1069 10.532 17.1686 10.5145 17.2252 10.4855C17.2818 10.4565 17.3321 10.4167 17.3732 10.3683C17.4144 10.3199 17.4456 10.2638 17.4651 10.2033C17.4846 10.1429 17.492 10.0791 17.4869 10.0158C17.4476 9.53192 17.5335 9.09373 17.8601 8.68245L18.4199 8.00112C18.4463 7.96877 18.4807 7.94382 18.5197 7.92873C18.5587 7.91364 18.601 7.9089 18.6423 7.915C18.6837 7.92109 18.7228 7.9378 18.7558 7.96349C18.7887 7.98918 18.8145 8.02299 18.8305 8.0616C18.8493 8.10878 18.813 8.00868 19.3425 9.50259Z"
        fill="white"
      />
      <defs>
        <radialGradient
          id="paint0_radial_10827_28524"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(15 15) rotate(84.447) scale(18.0849 18.6277)"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#F1F1F1" />
        </radialGradient>
      </defs>
    </svg>
  );
};

export const HandOrganIcon = ({ fillColor }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
    >
      <circle cx="15" cy="15" r="15" fill={fillColor ? fillColor : "#8B8D95"} />
      <path
        d="M19.9396 12.0384C20.4175 12.0384 20.805 11.6509 20.805 11.173C20.805 10.6951 20.4175 10.3076 19.9396 10.3076C19.4617 10.3076 19.0742 10.6951 19.0742 11.173C19.0742 11.6509 19.4617 12.0384 19.9396 12.0384Z"
        fill="white"
      />
      <path
        d="M17.6349 10.3079C18.1129 10.3079 18.5003 9.92047 18.5003 9.44253C18.5003 8.96459 18.1129 8.57715 17.6349 8.57715C17.157 8.57715 16.7695 8.96459 16.7695 9.44253C16.7695 9.92047 17.157 10.3079 17.6349 10.3079Z"
        fill="white"
      />
      <path
        d="M15.3263 9.73077C15.8043 9.73077 16.1917 9.34332 16.1917 8.86538C16.1917 8.38745 15.8043 8 15.3263 8C14.8484 8 14.4609 8.38745 14.4609 8.86538C14.4609 9.34332 14.8484 9.73077 15.3263 9.73077Z"
        fill="white"
      />
      <path
        d="M13.0177 10.8851C13.4957 10.8851 13.8831 10.4976 13.8831 10.0197C13.8831 9.54174 13.4957 9.1543 13.0177 9.1543C12.5398 9.1543 12.1523 9.54174 12.1523 10.0197C12.1523 10.4976 12.5398 10.8851 13.0177 10.8851Z"
        fill="white"
      />
      <path
        d="M19.0756 11.1729V14.9229C19.0756 15.0822 18.9464 15.2114 18.7872 15.2114C18.6279 15.2114 18.4987 15.0822 18.4987 14.9229V9.44216H16.7679V14.346C16.7679 14.5052 16.6387 14.6345 16.4795 14.6345C16.3203 14.6345 16.191 14.5052 16.191 14.346V8.86523H14.4603V14.346C14.4603 14.5052 14.331 14.6345 14.1718 14.6345C14.0126 14.6345 13.8833 14.5052 13.8833 14.346V10.0191H12.1526V17.2306L10.9843 15.632C10.6381 15.0983 9.96256 14.9195 9.46756 15.2252C8.97429 15.5379 8.85198 16.2198 9.19352 16.7518C9.19352 16.7518 11.0778 19.6035 11.8808 20.8243C12.6839 22.045 13.9849 22.9998 16.4178 22.9998C20.4458 22.9998 20.8064 19.8891 20.8064 18.9614C20.8064 18.0337 20.8064 11.1729 20.8064 11.1729H19.0756Z"
        fill="white"
      />
      <defs>
        <radialGradient
          id="paint0_radial_10827_28533"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(15 15) rotate(84.447) scale(18.0849 18.6277)"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#F1F1F1" />
        </radialGradient>
      </defs>
    </svg>
  );
};

export const StomachOrganIcon = ({ fillColor }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
    >
      <circle cx="15" cy="15" r="15" fill={fillColor ? fillColor : "#8B8D95"} />
      <path
        d="M21.886 12.1655C21.5812 10.4194 20.2833 7.4655 17.3287 7.4655H17.3135C16.2067 7.4655 15.169 8.26515 14.9498 9.27963C14.9158 9.43598 14.8947 9.60665 14.8736 9.77016C14.8138 10.2476 14.7563 10.7071 14.4046 10.8837C14.3176 10.923 14.223 10.9419 14.1278 10.9391C14.0326 10.9362 13.9393 10.9115 13.8547 10.867C13.7379 10.8137 13.6338 10.7352 13.5498 10.6369C13.4658 10.5386 13.4038 10.4228 13.3681 10.2977C13.122 9.2644 13.0821 8.19133 13.2509 7.14206C13.2544 7.12454 13.2541 7.10644 13.2498 7.08908C13.2455 7.07173 13.2375 7.05557 13.2263 7.04181C13.2151 7.02855 13.2013 7.01794 13.1857 7.01073C13.1701 7.00351 13.1531 6.99986 13.136 7.00004H11.2483C11.2212 6.99936 11.1947 7.00827 11.1734 7.02524C11.152 7.04222 11.1371 7.06621 11.1311 7.09313C10.7794 8.71033 10.5449 11.1212 12.6741 13.3865C12.8722 13.5977 13.0903 13.7911 13.3013 13.9832C13.6324 14.2553 13.9331 14.5635 14.1982 14.9022C14.5746 15.425 14.7845 16.2366 14.3647 16.782C13.9649 17.3 13.1817 17.3179 12.5826 17.1627C12.3376 17.1007 12.0925 17.0123 11.8545 16.924C11.4465 16.7566 11.0189 16.6439 10.5824 16.5886C9.22352 16.4693 8.04051 17.473 7.47891 18.5174C6.97827 19.4507 6.99585 20.7206 7.00172 21.8401V21.8806C7.00172 21.9123 7.01407 21.9427 7.03606 21.965C7.05804 21.9874 7.08787 22 7.11896 22H8.60681C8.63579 22.0002 8.66381 21.9894 8.68547 21.9698C8.70712 21.9502 8.72086 21.9231 8.72405 21.8938C8.73578 21.7744 8.74281 21.6408 8.7475 21.5142C8.74824 21.3061 8.77223 21.0987 8.81902 20.896C8.93627 20.5201 9.13793 19.9973 9.56353 19.7956C10.165 19.5115 10.8075 19.9627 11.4289 20.3995L11.6857 20.5785C13.8313 22.031 17.1657 21.7291 19.4426 19.8779C21.2083 18.4457 21.9998 15.8869 21.9998 13.6359C22.0035 13.1434 21.9654 12.6514 21.886 12.1655ZM15.5548 13.334C15.5536 13.1685 15.6008 13.0064 15.6902 12.8682C15.7797 12.73 15.9075 12.622 16.0573 12.5579C16.2072 12.4937 16.3724 12.4763 16.532 12.5079C16.6916 12.5394 16.8384 12.6185 16.9537 12.7351C17.0691 12.8517 17.1478 13.0006 17.18 13.1628C17.2121 13.325 17.1962 13.4933 17.1343 13.6463C17.0723 13.7993 16.9671 13.9302 16.8321 14.0222C16.697 14.1143 16.5381 14.1634 16.3755 14.1634C16.1588 14.1635 15.951 14.0763 15.7972 13.9209C15.6435 13.7655 15.5563 13.5545 15.5548 13.334ZM16.1879 16.5564C16.1134 16.5567 16.0405 16.5344 15.9785 16.4924C15.9164 16.4505 15.868 16.3907 15.8394 16.3208C15.8107 16.2508 15.8031 16.1737 15.8175 16.0993C15.8318 16.0249 15.8676 15.9565 15.9202 15.9028C15.9728 15.8491 16.0398 15.8125 16.1129 15.7976C16.1859 15.7828 16.2616 15.7903 16.3305 15.8192C16.3993 15.8482 16.4582 15.8973 16.4996 15.9603C16.541 16.0234 16.5631 16.0975 16.5631 16.1733C16.5634 16.2242 16.5537 16.2747 16.5347 16.3218C16.5156 16.3688 16.4875 16.4116 16.452 16.4475C16.4166 16.4834 16.3744 16.5117 16.328 16.5308C16.2817 16.5499 16.232 16.5594 16.182 16.5588L16.1879 16.5564ZM17.2431 19.1248C17.1176 19.1248 16.9949 19.0869 16.8906 19.0159C16.7863 18.9449 16.705 18.844 16.657 18.726C16.609 18.6079 16.5965 18.478 16.6211 18.3528C16.6457 18.2275 16.7062 18.1124 16.795 18.0222C16.8838 17.9319 16.997 17.8705 17.1201 17.8457C17.2432 17.821 17.3708 17.8339 17.4867 17.883C17.6025 17.932 17.7015 18.015 17.7711 18.1213C17.8406 18.2276 17.8776 18.3526 17.8774 18.4804C17.8777 18.5662 17.8612 18.6513 17.8288 18.7305C17.7964 18.8098 17.7487 18.8816 17.6887 18.9419C17.6286 19.0022 17.5573 19.0496 17.479 19.0814C17.4007 19.1132 17.3169 19.1288 17.2326 19.1272L17.2431 19.1248ZM18.8376 15.1433C18.7634 15.1433 18.6909 15.1209 18.6292 15.079C18.5675 15.037 18.5194 14.9773 18.491 14.9075C18.4626 14.8378 18.4552 14.761 18.4697 14.6869C18.4841 14.6128 18.5199 14.5447 18.5723 14.4913C18.6248 14.4379 18.6917 14.4015 18.7644 14.3868C18.8372 14.3721 18.9127 14.3796 18.9812 14.4085C19.0498 14.4375 19.1084 14.4864 19.1496 14.5492C19.1908 14.612 19.2128 14.6859 19.2128 14.7614C19.2125 14.8626 19.1729 14.9596 19.1026 15.0311C19.0323 15.1027 18.9371 15.143 18.8376 15.1433Z"
        fill="white"
      />
      <defs>
        <radialGradient
          id="paint0_radial_10827_28568"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(15 15) rotate(84.447) scale(18.0849 18.6277)"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#F1F1F1" />
        </radialGradient>
      </defs>
    </svg>
  );
};

export const SmallIntestineOrganIcon = ({ fillColor }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
    >
      <circle cx="15" cy="15" r="15" fill={fillColor ? fillColor : "#8B8D95"} />
      <path
        d="M21.3688 13.4078C21.7578 13.8047 21.8875 14.3781 21.6969 14.9172C21.4875 15.514 20.9453 15.9 20.3141 15.9C19.9469 15.9 19.5969 15.764 19.3313 15.5219C18.761 16.0344 17.9094 16.0203 17.3625 15.5219C16.8156 16.0125 15.9625 16.039 15.3938 15.5219C14.8235 16.0344 13.9719 16.0203 13.425 15.5219C12.8547 16.0344 12.0032 16.0203 11.4563 15.5219C11.4391 15.5375 11.4219 15.5516 11.4031 15.5672C12.1203 16.15 12.1188 17.2562 11.4016 17.839C11.4813 17.9047 11.5547 17.9781 11.6188 18.0594C12.1985 17.325 13.3344 17.3203 13.9156 18.0594C14.4922 17.3297 15.6282 17.3187 16.2125 18.0578C16.5672 17.6016 17.136 17.4047 17.725 17.5562C18.3953 17.7281 18.8297 18.2844 18.8297 18.9734C18.8297 19.4672 18.5797 19.9281 18.1734 20.2V21.8437C18.1734 21.9313 18.1031 22 18.0172 22H17.3516C17.2875 22 17.2281 21.9594 17.2063 21.8984L16.5766 20.2156C16.4375 20.1281 16.3141 20.0172 16.2141 19.8906C15.6282 20.6312 14.4953 20.6266 13.9156 19.8906C13.336 20.6297 12.2016 20.6281 11.6188 19.8891C11.3422 20.2359 10.9219 20.4437 10.4719 20.4437C9.78438 20.4437 9.22656 20.0125 9.05158 19.3437C8.90002 18.7625 9.08907 18.1953 9.53908 17.8391C8.82501 17.2625 8.81722 16.1531 9.54064 15.5672C9.20313 15.2907 9 14.8735 9 14.4297C9 13.1313 10.5391 12.511 11.4563 13.3406C12.0125 12.8391 12.8641 12.836 13.425 13.3406C13.9781 12.8406 14.8297 12.8344 15.3937 13.3406C15.9484 12.8391 16.8015 12.836 17.3625 13.3406C17.8156 12.9313 18.4953 12.8375 19.0547 13.1453C18.7 12.5625 18.7875 11.7547 19.35 11.275C19.3437 11.2703 19.3375 11.2641 19.3297 11.2578C18.7672 11.7641 17.9203 11.7625 17.3625 11.2563C16.7969 11.7657 15.9484 11.7594 15.3937 11.2563C14.8281 11.7672 13.9797 11.7594 13.425 11.2563C12.8594 11.7672 12.0109 11.7594 11.4563 11.2563C11.1875 11.5 10.8359 11.636 10.4719 11.636C9.66096 11.636 9 10.9766 9 10.1657C9 9.67506 9.25 9.21566 9.65626 8.94537V7.15626C9.65626 7.07034 9.72657 7 9.81252 7H10.6359C10.7062 7 10.7688 7.04843 10.7875 7.11718L11.2625 8.92967C11.3312 8.97342 11.3969 9.02185 11.4563 9.07654C12.0109 8.57184 12.8609 8.56716 13.425 9.07654C13.9797 8.57343 14.8281 8.56716 15.3937 9.07654C15.9484 8.57343 16.7969 8.56716 17.3625 9.07654C17.9172 8.57343 18.7656 8.56716 19.3312 9.07654C20.2437 8.23747 21.7828 8.86874 21.7828 10.1656C21.7828 10.5953 21.5984 10.9969 21.2781 11.275C21.9063 11.8125 21.9641 12.7969 21.3688 13.4078Z"
        fill="white"
      />
      <defs>
        <radialGradient
          id="paint0_radial_10827_28576"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(15 15) rotate(84.447) scale(18.0849 18.6277)"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#F1F1F1" />
        </radialGradient>
      </defs>
    </svg>
  );
};

export const ColonOrganIcon = ({ fillColor }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
    >
      <circle cx="15" cy="15" r="15" fill={fillColor ? fillColor : "#8B8D95"} />
      <path
        d="M21.3688 13.4078C21.7578 13.8047 21.8875 14.3781 21.6969 14.9172C21.4875 15.514 20.9453 15.9 20.3141 15.9C19.9469 15.9 19.5969 15.764 19.3313 15.5219C18.761 16.0344 17.9094 16.0203 17.3625 15.5219C16.8156 16.0125 15.9625 16.039 15.3938 15.5219C14.8235 16.0344 13.9719 16.0203 13.425 15.5219C12.8547 16.0344 12.0032 16.0203 11.4563 15.5219C11.4391 15.5375 11.4219 15.5516 11.4031 15.5672C12.1203 16.15 12.1188 17.2562 11.4016 17.839C11.4813 17.9047 11.5547 17.9781 11.6188 18.0594C12.1985 17.325 13.3344 17.3203 13.9156 18.0594C14.4922 17.3297 15.6282 17.3187 16.2125 18.0578C16.5672 17.6016 17.136 17.4047 17.725 17.5562C18.3953 17.7281 18.8297 18.2844 18.8297 18.9734C18.8297 19.4672 18.5797 19.9281 18.1734 20.2V21.8437C18.1734 21.9313 18.1031 22 18.0172 22H17.3516C17.2875 22 17.2281 21.9594 17.2063 21.8984L16.5766 20.2156C16.4375 20.1281 16.3141 20.0172 16.2141 19.8906C15.6282 20.6312 14.4953 20.6266 13.9156 19.8906C13.336 20.6297 12.2016 20.6281 11.6188 19.8891C11.3422 20.2359 10.9219 20.4437 10.4719 20.4437C9.78438 20.4437 9.22656 20.0125 9.05158 19.3437C8.90002 18.7625 9.08907 18.1953 9.53908 17.8391C8.82501 17.2625 8.81722 16.1531 9.54064 15.5672C9.20313 15.2907 9 14.8735 9 14.4297C9 13.1313 10.5391 12.511 11.4563 13.3406C12.0125 12.8391 12.8641 12.836 13.425 13.3406C13.9781 12.8406 14.8297 12.8344 15.3937 13.3406C15.9484 12.8391 16.8015 12.836 17.3625 13.3406C17.8156 12.9313 18.4953 12.8375 19.0547 13.1453C18.7 12.5625 18.7875 11.7547 19.35 11.275C19.3437 11.2703 19.3375 11.2641 19.3297 11.2578C18.7672 11.7641 17.9203 11.7625 17.3625 11.2563C16.7969 11.7657 15.9484 11.7594 15.3937 11.2563C14.8281 11.7672 13.9797 11.7594 13.425 11.2563C12.8594 11.7672 12.0109 11.7594 11.4563 11.2563C11.1875 11.5 10.8359 11.636 10.4719 11.636C9.66096 11.636 9 10.9766 9 10.1657C9 9.67506 9.25 9.21566 9.65626 8.94537V7.15626C9.65626 7.07034 9.72657 7 9.81252 7H10.6359C10.7062 7 10.7688 7.04843 10.7875 7.11718L11.2625 8.92967C11.3312 8.97342 11.3969 9.02185 11.4563 9.07654C12.0109 8.57184 12.8609 8.56716 13.425 9.07654C13.9797 8.57343 14.8281 8.56716 15.3937 9.07654C15.9484 8.57343 16.7969 8.56716 17.3625 9.07654C17.9172 8.57343 18.7656 8.56716 19.3312 9.07654C20.2437 8.23747 21.7828 8.86874 21.7828 10.1656C21.7828 10.5953 21.5984 10.9969 21.2781 11.275C21.9063 11.8125 21.9641 12.7969 21.3688 13.4078Z"
        fill="white"
      />
      <defs>
        <radialGradient
          id="paint0_radial_10827_28576"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(15 15) rotate(84.447) scale(18.0849 18.6277)"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#F1F1F1" />
        </radialGradient>
      </defs>
    </svg>
  );
};

export const BladderOrganIcon = ({ fillColor }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
    >
      <circle cx="15" cy="15" r="15" fill={fillColor ? fillColor : "#8B8D95"} />
      <path
        d="M9.10499 12.3104C9.0224 12.5955 8.98126 12.8983 8.98126 13.2074C8.98126 15.0164 10.3348 16.855 12.3487 17.7823C13.068 18.1121 13.5516 18.8262 13.6076 19.6391L13.6815 20.7521C13.7317 21.451 14.3095 22 15.0026 22C15.3388 22 15.6571 21.8712 15.8991 21.6398C16.1469 21.4089 16.2942 21.0909 16.3179 20.7518L16.3946 19.6387C16.4507 18.8258 16.9342 18.1118 17.6536 17.7819C19.6675 16.855 21.021 15.016 21.021 13.207C21.021 12.898 20.9798 12.5981 20.9002 12.3101C20.7113 11.6471 20.8176 10.9242 21.1861 10.3212C21.6668 9.53829 21.9411 8.75834 21.9972 7.99915C22.0354 7.50126 21.6846 7.06334 21.201 7.00634C20.747 6.9523 20.3253 7.24918 20.219 7.69633C20.2074 7.74444 20.1954 7.79222 20.1808 7.84032C19.8239 9.04929 18.5562 9.76334 17.294 9.46612C16.5805 9.29807 15.811 9.21405 15.0029 9.21405C14.1919 9.21405 13.4194 9.29807 12.7088 9.46612C11.4437 9.76598 10.1761 9.04929 9.81915 7.84032C9.80749 7.79222 9.79259 7.74444 9.78384 7.69633C9.67761 7.24918 9.25591 6.95526 8.80183 7.00634C8.31795 7.06367 7.96686 7.50159 8.00249 7.99948C8.06143 8.75834 8.33576 9.53829 8.81641 10.3215C9.18466 10.9242 9.29089 11.6475 9.10499 12.3104ZM14.9669 18.148C15.3592 17.2541 16.0549 16.54 16.9248 16.141C18.2725 15.5202 19.2513 14.2872 19.2513 13.207C19.2513 13.042 19.3841 12.9072 19.546 12.9072C19.7083 12.9072 19.8407 13.0423 19.8407 13.207C19.8407 14.5119 18.7172 15.9759 17.1694 16.687C16.4293 17.029 15.8366 17.632 15.5033 18.3909C15.4531 18.5019 15.3472 18.5678 15.2351 18.5678C15.1937 18.5678 15.1525 18.5619 15.1143 18.5438C14.9669 18.4749 14.8993 18.298 14.9669 18.148Z"
        fill="white"
      />
      <defs>
        <radialGradient
          id="paint0_radial_10827_28594"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(15 15) rotate(84.447) scale(18.0849 18.6277)"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#F1F1F1" />
        </radialGradient>
      </defs>
    </svg>
  );
};

export const KidneysOrganIcon = ({ fillColor }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
    >
      <circle cx="15" cy="15" r="15" fill={fillColor ? fillColor : "#8B8D95"} />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.9463 12.6665C16.3946 12.6671 15.8657 12.8849 15.4756 13.2723C15.0856 13.6596 14.8662 14.1848 14.8656 14.7326V21.5578C14.8656 21.6751 14.9125 21.7876 14.996 21.8705C15.0795 21.9534 15.1928 22 15.3109 22C15.429 22 15.5423 21.9534 15.6258 21.8705C15.7093 21.7876 15.7562 21.6751 15.7562 21.5578V14.7326C15.7564 14.4833 15.836 14.2405 15.9835 14.0387C16.1309 13.8369 16.3388 13.6866 16.5774 13.6091C16.6002 13.6278 16.6249 13.6442 16.651 13.6581C17.0605 13.874 17.5577 14.2126 17.6003 14.5973C17.6437 14.9849 17.2279 15.4275 16.8712 15.7308C16.8058 15.7867 16.758 15.8601 16.7336 15.9423C16.5796 16.4703 16.6018 17.0337 16.7967 17.5482C16.9917 18.0628 17.349 18.5009 17.8153 18.7972C18.2361 19.0696 18.7272 19.2154 19.2295 19.2173C19.8254 19.2173 20.4425 19.0121 21.0448 18.6038C21.9662 17.9792 22.8111 16.897 23.3625 15.6349C23.9377 14.3177 24.1324 12.9716 23.9109 11.8448C23.6147 10.34 22.9269 9.0934 21.922 8.24004C21.0711 7.51753 20.0086 7.08636 18.8917 7.0104C18.1514 6.96286 17.4523 7.07897 16.87 7.34645C16.2434 7.63456 15.7988 8.08893 15.618 8.6258C15.3969 9.28353 15.388 10.61 17.7332 12.1974C17.6868 12.3703 17.4146 12.5398 17.1518 12.6665H16.9463ZM5.08913 11.8448C4.86752 12.9716 5.06237 14.3177 5.63799 15.6349C6.18908 16.897 7.03395 17.9792 7.95534 18.6038C8.55793 19.0121 9.17466 19.2173 9.77095 19.2173C10.2731 19.2154 10.7641 19.0695 11.1848 18.7972C11.6511 18.5009 12.0084 18.0628 12.2033 17.5482C12.3983 17.0337 12.4204 16.4703 12.2665 15.9423C12.242 15.8601 12.1942 15.7867 12.1287 15.7308C11.7723 15.4275 11.3565 14.9849 11.3998 14.5973C11.4423 14.2126 11.9396 13.874 12.3492 13.6581C12.3753 13.6442 12.3999 13.6278 12.4227 13.6091C12.6614 13.6865 12.8693 13.8368 13.0168 14.0386C13.1643 14.2404 13.2438 14.4833 13.2439 14.7326V21.5578C13.2439 21.6751 13.2909 21.7876 13.3744 21.8705C13.4579 21.9534 13.5711 22 13.6892 22C13.8073 22 13.9206 21.9534 14.0041 21.8705C14.0876 21.7876 14.1345 21.6751 14.1345 21.5578V14.7326C14.134 14.1848 13.9146 13.6596 13.5245 13.2723C13.1344 12.8849 12.6055 12.6671 12.0539 12.6665H11.8484C11.5856 12.5398 11.3132 12.3703 11.267 12.1974C13.6122 10.61 13.6032 9.28353 13.3821 8.6258C13.2013 8.08893 12.7568 7.6346 12.13 7.34645C11.5477 7.0789 10.8486 6.96286 10.1083 7.0104C8.99144 7.0865 7.92895 7.51765 7.07807 8.24004C6.07319 9.0934 5.38536 10.3399 5.08913 11.8448Z"
        fill="white"
      />
      <defs>
        <radialGradient
          id="paint0_radial_10827_28602"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(15 15) rotate(84.447) scale(18.0849 18.6277)"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#F1F1F1" />
        </radialGradient>
      </defs>
    </svg>
  );
};

export const AnusOrganIcon = ({ fillColor }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
    >
      <circle cx="15" cy="15" r="15" fill={fillColor ? fillColor : "#8B8D95"} />
      <path
        d="M21.0649 7H7.93506C7.33506 8.44412 7 10.0274 7 11.6875C7 13.9311 8.81875 15.7499 11.0626 15.7499C12.5119 15.7499 13.7809 14.9881 14.5 13.8456C15.2191 14.9882 16.4881 15.7499 17.9374 15.7499C20.1812 15.7499 22 13.9311 22 11.6875C22 10.0274 21.6649 8.44412 21.0649 7Z"
        fill="white"
      />
      <path
        d="M13.9022 15.7982C13.0819 16.3676 12.1005 16.6873 11.064 16.6873C9.50403 16.6873 8.10866 15.9684 7.19141 14.8447C7.47266 17.2489 8.07584 19.6548 9.04691 21.9999H13.9024L13.9022 15.7982Z"
        fill="white"
      />
      <path
        d="M17.9358 16.6873C16.8995 16.6873 15.918 16.3676 15.0977 15.7982V21.9999H19.9532C20.9242 19.6548 21.5274 17.2489 21.8087 14.8447C20.8907 15.9684 19.4958 16.6873 17.9358 16.6873Z"
        fill="white"
      />
      <defs>
        <radialGradient
          id="paint0_radial_10827_28610"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(15 15) rotate(84.447) scale(18.0849 18.6277)"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#F1F1F1" />
        </radialGradient>
      </defs>
    </svg>
  );
};

export const ReproductiveSystemOrganIcon = ({ fillColor }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
    >
      <circle cx="15" cy="15" r="15" fill={fillColor ? fillColor : "#8B8D95"} />
      <path
        d="M21.9667 7.83997C20.9867 7.12 19.6633 7.17 18.4934 7.93C17.8734 7.65997 16.2334 7 14.5333 7C12.8333 7 11.1933 7.65997 10.5733 7.93C9.40333 7.18 8.07 7.13 7.09997 7.84997C6.35297 8.39393 6.0002 9.27453 6 10.2667C5.99993 10.6425 6.01463 11.0344 6.13 11.43C5.84003 12.04 6.04997 12.9 6.71003 13.56C7.41 14.26 8.56337 14.57 9.22333 13.91C9.81337 13.32 9.66333 12.23 8.87337 11.44C8.31337 10.89 7.59003 10.65 7.01 10.76C6.9832 10.5917 7.0118 10.4266 7.012 10.2667C7.01297 9.59053 7.21283 9.0058 7.68997 8.64997C8.31997 8.19 9.19327 8.25 10.0133 8.76997C9.76327 11.55 10.7933 13.66 12.8133 16.37C12.5933 16.58 12.3933 16.89 12.2933 17.34C11.9733 18.78 12.7732 20.95 13.6833 21.85C13.7732 21.95 13.9032 22 14.0332 22H15.0332C15.1632 22 15.2932 21.95 15.3832 21.85C16.2932 20.95 17.0932 18.78 16.7732 17.34C16.6732 16.89 16.4732 16.58 16.2532 16.37C18.3525 13.5536 19.3128 11.6564 19.0532 8.76997C19.8732 8.25 20.7465 8.18 21.3765 8.64003C21.8625 9.00243 22.0626 9.60233 22.0545 10.3C22.0528 10.4493 22.0812 10.6031 22.0565 10.76C21.4765 10.65 20.7865 10.89 20.2265 11.44C19.4365 12.23 19.2865 13.32 19.8765 13.91C20.5365 14.58 21.6565 14.25 22.3565 13.56C23.0165 12.9 23.2265 12.04 22.9365 11.43C23.0479 11.0455 23.0628 10.6653 23.0665 10.3C23.077 9.28783 22.7236 8.3911 21.9667 7.83997ZM16.7533 10.95L15.0333 11.81V14.5C15.0333 14.78 14.8134 15 14.5333 15C14.2533 15 14.0333 14.78 14.0333 14.5V11.81L12.3134 10.95C12.0634 10.82 11.9633 10.5199 12.0833 10.28C12.2133 10.03 12.5133 9.93 12.7533 10.05L14.5333 10.94L16.3134 10.05C16.5534 9.93 16.8533 10.03 16.9833 10.28C17.1033 10.52 17.0033 10.82 16.7533 10.95Z"
        fill="white"
      />
      <defs>
        <radialGradient
          id="paint0_radial_10827_28621"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(15 15) rotate(84.447) scale(18.0849 18.6277)"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#F1F1F1" />
        </radialGradient>
      </defs>
    </svg>
  );
};

export const ButtocksOrganIcon = ({ fillColor }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
    >
      <circle cx="15" cy="15" r="15" fill={fillColor ? fillColor : "#8B8D95"} />
      <path
        d="M14.8394 18.5803C15.6075 18.2811 16.2383 17.9385 16.7145 17.5616C18.2304 16.3798 18.4064 14.8032 17.2383 12.8741C16.3142 11.3505 15.8259 9.63732 15.8259 7.92009V7H11V13.7259C11 15.0065 11.0524 16.3252 11.1559 17.6452L11.5065 22H16.6134V18.2918C16.1702 18.5787 15.6426 18.8428 15.0372 19.0785C15.0048 19.0911 14.9713 19.0972 14.9383 19.0972C14.8308 19.0972 14.7289 19.0327 14.6867 18.9271C14.6321 18.7895 14.7005 18.6341 14.8391 18.58L14.8394 18.5803Z"
        fill="white"
      />
      <defs>
        <radialGradient
          id="paint0_radial_10827_28630"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(15 15) rotate(84.447) scale(18.0849 18.6277)"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#F1F1F1" />
        </radialGradient>
      </defs>
    </svg>
  );
};

export const ThighOrganIcon = ({ fillColor }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
    >
      <circle cx="15" cy="15" r="15" fill={fillColor ? fillColor : "#8B8D95"} />
      <path
        d="M18.5484 8.2608C18.491 8.24615 18.4339 8.23179 18.3776 8.21744C13.3239 6.94096 12.0688 7.00043 8 7.00043V14.5002C10.054 14.9672 12.2466 14.8102 14.2218 14.0485C14.9009 13.7877 15.549 13.5712 16.3432 13.5686C15.2446 17.0113 15.8622 18.9704 16.3432 22H20.4041C20.8266 19.6867 21.1843 18.2344 20.6438 14.9502C20.4867 13.9978 20.916 12.5889 20.9912 11.9446C21.2552 10.28 20.1709 8.68238 18.5484 8.2608ZM10.4657 13.4214C10.1648 13.4175 9.86084 13.4005 9.56242 13.371L9.64896 12.4964C9.92251 12.5234 10.2011 12.539 10.4771 12.5425L10.4657 13.4214ZM11.3699 13.3945L11.3065 12.5179C11.5814 12.498 11.8587 12.466 12.1307 12.4229L12.2684 13.2909C11.9719 13.338 11.6696 13.3728 11.3699 13.3945ZM13.155 13.1112L12.9436 12.2581C13.2115 12.1917 13.4791 12.113 13.7389 12.0241L14.0234 12.8557C13.7396 12.9527 13.4475 13.0387 13.155 13.1112ZM14.8376 12.5586L14.5541 11.7267C14.886 11.6135 15.1731 11.5377 15.4575 11.4879L15.6091 12.3536C15.3706 12.3954 15.1255 12.4605 14.8376 12.5586Z"
        fill="white"
      />
      <path
        d="M13.1379 15.7559L12.4118 16.2511L12.8337 16.8697L12.1719 17.0973L13.2428 18.6672L13.9688 18.1719L13.5472 17.5538L14.2089 17.3262L13.1379 15.7559Z"
        fill="white"
      />
      <path
        d="M10.3998 16.8403L9.77082 16.5332L9.41797 18.4005L10.2816 18.5637L10.4205 17.8285L11.0493 18.1354L11.4025 16.2678L10.5389 16.1045L10.3998 16.8403Z"
        fill="white"
      />
      <defs>
        <radialGradient
          id="paint0_radial_10827_28638"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(15 15) rotate(84.447) scale(18.0849 18.6277)"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#F1F1F1" />
        </radialGradient>
      </defs>
    </svg>
  );
};

export const KneeOrganIcon = ({ fillColor }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
    >
      <circle cx="15" cy="15" r="15" fill={fillColor ? fillColor : "#8B8D95"} />
      <path
        d="M16.3078 10.4268H8.43945C8.19676 10.4268 8 10.6235 8 10.8662V16.2741C8 16.5033 8.17619 16.694 8.40468 16.7121C9.73654 16.8178 11.0568 16.6642 12.3289 16.2556L15.8554 15.137C16.0864 15.0628 16.3339 15.1899 16.4082 15.421C16.4824 15.6521 16.3553 15.8996 16.1242 15.9738L14.1906 16.595C13.773 18.0351 13.9627 19.2287 14.1481 20.3944C14.2075 20.7679 14.269 21.1542 14.3102 21.5459L14.3162 21.6047C14.3387 21.8294 14.5278 22.0004 14.7535 22.0004H14.7543L17.4676 21.9953C17.6857 21.9948 17.8705 21.8346 17.9017 21.6188L19.0623 13.609C19.3055 11.9303 18.002 10.4268 16.3078 10.4268ZM17.2705 13.2132C17.0336 13.2678 16.798 13.1198 16.7435 12.8837C16.7284 12.8181 16.6684 12.7705 16.6008 12.7705C16.3581 12.7705 16.1613 12.5737 16.1613 12.331C16.1613 12.0883 16.3581 11.8916 16.6008 11.8916C17.0812 11.8916 17.4921 12.2184 17.6 12.6863C17.6545 12.9228 17.507 13.1587 17.2705 13.2132Z"
        fill="white"
      />
      <path
        d="M20.4162 10.2141L20.5413 10.6617C20.6255 10.963 20.9906 11.0833 21.2374 10.8879L22.4989 9.8887C22.6892 9.73799 22.7212 9.46161 22.5705 9.27135C22.4198 9.0811 22.1434 9.04902 21.9532 9.19972L21.2098 9.78853L21.0847 9.34087C21.0004 9.03941 20.6352 8.91935 20.3885 9.11473L19.1744 10.0766C18.9841 10.2273 18.9521 10.5037 19.1028 10.6939C19.2536 10.8842 19.5299 10.9162 19.7202 10.7655L20.4162 10.2141Z"
        fill="white"
      />
      <path
        d="M16.9494 9.75228C17.1649 9.86592 17.4303 9.78237 17.5431 9.56853L17.9573 8.78313L18.2525 9.14211C18.4512 9.38375 18.8337 9.34646 18.9806 9.06799L19.7313 7.6445C19.8445 7.42982 19.7623 7.164 19.5476 7.0508C19.3329 6.93766 19.0671 7.01983 18.9539 7.23452L18.5115 8.07335L18.2163 7.71432C18.0177 7.47279 17.635 7.50997 17.4881 7.78847L16.7657 9.1586C16.6525 9.37326 16.7347 9.63907 16.9494 9.75228Z"
        fill="white"
      />
      <path
        d="M22.6102 13.301L21.6681 13.1916L21.8962 12.7866C22.0498 12.5139 21.8764 12.1707 21.5639 12.1345L20.0253 11.956C19.7841 11.9283 19.5661 12.1009 19.5381 12.3419C19.5102 12.583 19.6829 12.8011 19.924 12.8291L20.806 12.9314L20.578 13.3364C20.4242 13.6094 20.5981 13.9523 20.9102 13.9885C22.5942 14.1829 22.5126 14.177 22.5601 14.177C22.7801 14.1769 22.9701 14.012 22.996 13.7881C23.024 13.5471 22.8513 13.3289 22.6102 13.301Z"
        fill="white"
      />
      <defs>
        <radialGradient
          id="paint0_radial_10827_28649"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(15 15) rotate(84.447) scale(18.0849 18.6277)"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#F1F1F1" />
        </radialGradient>
      </defs>
    </svg>
  );
};

export const CalfOrganIcon = ({ fillColor }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
    >
      <circle cx="15" cy="15" r="15" fill={fillColor ? fillColor : "#8B8D95"} />
      <path
        d="M8.93325 9.23695L8.05308 9.1748C8.03178 9.47642 8.01655 9.77939 8.00781 10.0752L8.88978 10.1013C8.89817 9.81742 8.91281 9.52663 8.93325 9.23695Z"
        fill="white"
      />
      <path
        d="M8.88224 10.9639L8 10.9779C8.00491 11.2873 8.01765 11.5921 8.03779 11.8837L8.91809 11.8228C8.89894 11.5467 8.88691 11.2577 8.88224 10.9639Z"
        fill="white"
      />
      <path
        d="M9.00329 12.6758L8.12891 12.7942C8.17229 13.1145 8.22697 13.4237 8.29149 13.7133L9.1527 13.5214C9.09364 13.2561 9.04338 12.9715 9.00329 12.6758Z"
        fill="white"
      />
      <path
        d="M9.38783 14.3545L8.55469 14.6451C8.67513 14.9904 8.81675 15.3099 8.97563 15.5948L9.74625 15.1651C9.6121 14.9245 9.49154 14.6518 9.38783 14.3545Z"
        fill="white"
      />
      <path
        d="M9.46875 16.4519C9.5906 16.7124 9.68013 16.9769 9.7349 17.2379L10.5985 17.0568C10.5298 16.7293 10.4186 16.4 10.268 16.0781L9.46875 16.4519Z"
        fill="white"
      />
      <path
        d="M13.3303 13.3975C13.3303 11.7678 12.0662 10.3083 10.2443 9.82031C10.2191 11.7854 10.4083 14.2469 11.3257 15.6475C11.474 15.874 11.5951 16.0954 11.693 16.311C11.6958 16.3078 13.3303 15.2508 13.3303 13.3975Z"
        fill="white"
      />
      <path
        d="M21.2742 20.2353H20.9669C20.3631 20.2353 19.776 20.0268 19.3131 19.6391C18.8386 19.2417 18.1919 18.7947 17.4804 18.5659C16.4397 18.2311 15.6551 17.2856 15.6551 16.0685C15.6551 12.9594 16.3278 7.94088 16.4878 7H10.4331C10.3914 7.30215 10.3149 8.014 10.2734 8.92282L10.3698 8.94032C12.4957 9.46738 14.2154 11.1924 14.2154 13.3971C14.2154 15.8769 12.1211 17.0306 11.9797 17.1799C12.1494 18.0272 11.9819 18.7411 11.7698 19.2494C11.6392 19.562 11.5683 19.8965 11.5683 20.2353C11.5683 21.2099 12.3583 22 13.333 22H14.6689C14.9439 22 15.1983 21.865 15.3639 21.6453C15.8943 20.9411 16.9493 20.9425 17.4786 21.6453C17.6442 21.865 17.8986 22 18.1736 22H21.2742C21.7616 22 22.1566 21.605 22.1566 21.1176C22.1566 20.6306 21.7614 20.2353 21.2742 20.2353Z"
        fill="white"
      />
      <defs>
        <radialGradient
          id="paint0_radial_10827_28661"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(15 15) rotate(84.447) scale(18.0849 18.6277)"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#F1F1F1" />
        </radialGradient>
      </defs>
    </svg>
  );
};

export const ShinOrganIcon = ({ fillColor }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
    >
      <circle cx="15" cy="15" r="15" fill={fillColor ? fillColor : "#8B8D95"} />
      <path
        d="M22.5742 17.091L21.6265 17.0577L21.8213 16.6357C21.9524 16.3516 21.7524 16.0234 21.4377 16.0123L20.2596 15.9709C20.0175 15.9631 19.8135 16.1522 19.805 16.3947C19.7965 16.6373 19.9862 16.8408 20.2287 16.8493L20.7463 16.8675L20.5515 17.2895C20.4202 17.574 20.6211 17.9018 20.9351 17.9129L22.5434 17.9694C22.791 17.9775 22.9896 17.7839 22.998 17.5457C23.0065 17.3031 22.8168 17.0996 22.5742 17.091Z"
        fill="white"
      />
      <path
        d="M19.747 14.5472C19.9447 14.6881 20.219 14.642 20.3599 14.4444L20.6604 14.0226L20.905 14.4178C21.0713 14.6864 21.456 14.6948 21.6365 14.4416L22.5706 13.1311C22.7115 12.9334 22.6654 12.659 22.4678 12.5181C22.2702 12.3773 21.9958 12.4233 21.8549 12.6209L21.3044 13.3932L21.0598 12.998C20.8938 12.7298 20.5091 12.7204 20.3282 12.9742L19.6441 13.9343C19.5033 14.132 19.5493 14.4064 19.747 14.5472Z"
        fill="white"
      />
      <path
        d="M21.1129 20.5036L20.3327 19.9645L20.7243 19.7141C20.9879 19.5456 20.9964 19.1613 20.7374 18.9823L19.7674 18.3122C19.5677 18.1744 19.294 18.2244 19.1561 18.424C19.0181 18.6237 19.0682 18.8974 19.2678 19.0354L19.6939 19.3298L19.3024 19.5801C19.0388 19.7487 19.0303 20.133 19.2893 20.3119L20.6133 21.2267C20.8126 21.3644 21.0865 21.3151 21.2247 21.115C21.3627 20.9153 21.3126 20.6416 21.1129 20.5036Z"
        fill="white"
      />
      <path
        d="M17.7559 14.9395C17.0289 14.9395 16.4375 15.5309 16.4375 16.2578C16.4375 16.9848 17.0289 17.5762 17.7559 17.5762C18.4828 17.5762 19.0742 16.9848 19.0742 16.2578C19.0742 15.5309 18.4828 14.9395 17.7559 14.9395ZM17.7559 16.6973C17.5135 16.6973 17.3164 16.5001 17.3164 16.2578C17.3164 16.0155 17.5135 15.8184 17.7559 15.8184C17.9982 15.8184 18.1953 16.0155 18.1953 16.2578C18.1953 16.5001 17.9982 16.6973 17.7559 16.6973Z"
        fill="white"
      />
      <path
        d="M15.5586 16.2578C15.5586 15.0462 16.5443 14.0605 17.7559 14.0605C18.0111 14.0605 18.2561 14.1048 18.4842 14.1851L19.0623 10.1835C19.3053 8.50521 18.0031 7 16.3078 7H8.43945C8.19676 7 8 7.19676 8 7.43945V12.8497C8 13.0789 8.17616 13.2696 8.40468 13.2878C9.7366 13.3935 11.0569 13.2398 12.3289 12.831C12.3325 12.8298 15.9103 11.6838 15.9139 11.6826C16.145 11.6084 16.3925 11.7355 16.4668 11.9665C16.5411 12.1976 16.4139 12.4451 16.1829 12.5194L13.6384 13.3371C13.2385 14.6348 13.4368 15.9429 13.7863 17.2541C14.3449 19.3496 14.1874 21.5051 14.1858 21.5264C14.1763 21.6491 14.2186 21.7702 14.3025 21.8602C14.3856 21.9494 14.5021 22 14.624 22H14.6272L16.9805 21.9825C17.1977 21.9808 17.3812 21.8208 17.4122 21.6059L17.8678 18.4522C17.8307 18.4541 17.7934 18.4551 17.7559 18.4551C16.5443 18.4551 15.5586 17.4694 15.5586 16.2578ZM16.4543 8.90506C16.4543 8.66236 16.651 8.46561 16.8937 8.46561C17.3742 8.46561 17.7851 8.79247 17.8929 9.26052C17.9565 9.53635 17.7466 9.79873 17.4643 9.79873C17.2642 9.79873 17.0833 9.66118 17.0365 9.45786C17.0213 9.39218 16.9613 9.34451 16.8937 9.34451C16.651 9.34451 16.4543 9.14778 16.4543 8.90506Z"
        fill="white"
      />
      <defs>
        <radialGradient
          id="paint0_radial_10827_28676"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(15 15) rotate(84.447) scale(18.0849 18.6277)"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#F1F1F1" />
        </radialGradient>
      </defs>
    </svg>
  );
};

export const FootOrganIcon = ({ fillColor }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
    >
      <circle cx="15" cy="15" r="15" fill={fillColor ? fillColor : "#8B8D95"} />
      <path
        d="M13.6445 17.647C13.7263 19.0646 13.4311 19.6258 12.445 19.7837C11.4579 19.9416 10.5028 19.0918 10.3092 17.8839C10.2208 17.3292 10.1325 16.2021 10.0196 15.7086L9.17266 13.3246C9.12378 13.1141 8.56539 12.1101 8.47703 11.673C8.29748 10.7837 8.87091 9.91885 9.75831 9.73836C9.75831 9.73836 11.0781 9.47233 11.3103 9.42532C11.5425 9.37738 12.2353 9.33226 12.2353 9.33226C13.1867 9.33226 13.6454 9.8239 13.6454 10.7752C13.6454 11.327 12.6678 12.1759 12.6678 12.1759C12.6678 12.1759 11.284 13.5079 11.7681 14.4978C12.2504 15.4877 13.3521 15.7735 13.6445 17.647ZM12.5399 9.08879C12.9329 9.08879 13.2525 8.6197 13.2525 8.04345C13.2525 7.4672 12.9329 7 12.5399 7C12.1442 7 11.8245 7.46814 11.8245 8.04345C11.8255 8.6197 12.1442 9.08879 12.5399 9.08879ZM11.0217 8.98256C11.2746 8.94684 11.4372 8.61782 11.3837 8.24744C11.331 7.87706 11.0828 7.60633 10.83 7.64299C10.578 7.67871 10.4154 8.00773 10.4681 8.37811C10.5207 8.74755 10.7689 9.01828 11.0217 8.98256ZM9.93974 9.27586C10.1231 9.23261 10.2199 8.98068 10.1569 8.71371C10.093 8.44673 9.89368 8.26436 9.71131 8.30761C9.52894 8.35085 9.43118 8.60184 9.4951 8.86975C9.55808 9.13673 9.75643 9.3191 9.93974 9.27586ZM9.06456 9.84928C9.22437 9.7863 9.27889 9.54471 9.18583 9.31064C9.09276 9.07657 8.88877 8.93744 8.72896 9.00136C8.56915 9.06528 8.51463 9.30594 8.6077 9.54001C8.70076 9.77408 8.90475 9.91227 9.06456 9.84928ZM8.11135 9.91697C8.00513 9.95833 7.96846 10.1181 8.02957 10.2742C8.09067 10.4293 8.22698 10.5214 8.3332 10.4801C8.43943 10.4387 8.47609 10.2779 8.41499 10.1228C8.35294 9.96679 8.21758 9.87467 8.11135 9.91697ZM19.3336 12.1778C19.3336 12.1778 18.043 11.7989 17.8155 11.7331C17.588 11.6655 16.9017 11.5611 16.9017 11.5611C15.9532 11.4803 15.455 11.9315 15.3742 12.8791C15.3253 13.4271 16.2268 14.3568 16.2268 14.3568C16.2268 14.3568 17.4921 15.8026 16.9243 16.7464C16.3584 17.6902 15.2369 17.8829 14.7866 19.7226C14.5836 21.1261 14.8308 21.7117 15.7972 21.9552C16.7683 22.1978 17.791 21.4307 18.089 20.2462C18.2253 19.6991 18.4086 18.5842 18.5647 18.102L19.6119 15.7998C19.6786 15.593 20.3207 14.6416 20.4467 14.2139C20.7005 13.3444 20.2022 12.4325 19.3336 12.1778ZM16.6178 11.2904C17.0108 11.3242 17.3689 10.8862 17.4188 10.3108C17.4686 9.73554 17.1903 9.24295 16.7965 9.20911C16.4035 9.17527 16.0454 9.61333 15.9955 10.1886C15.9457 10.764 16.2249 11.2575 16.6178 11.2904ZM18.1398 11.3148C18.388 11.3722 18.6577 11.123 18.7423 10.7602C18.8251 10.3964 18.6925 10.0552 18.4444 9.99781C18.1962 9.94047 17.9264 10.1896 17.8427 10.5524C17.7581 10.9162 17.8925 11.2575 18.1398 11.3148ZM19.1926 11.6993C19.3703 11.7576 19.5837 11.594 19.6702 11.3336C19.7567 11.0732 19.6815 10.8138 19.5038 10.7555C19.3261 10.6972 19.1118 10.8608 19.0253 11.1212C18.9388 11.3816 19.014 11.641 19.1926 11.6993ZM20.4222 11.532C20.2671 11.4549 20.0509 11.5743 19.939 11.7999C19.8272 12.0255 19.861 12.2699 20.0161 12.347C20.1703 12.4241 20.3874 12.3047 20.4993 12.0791C20.6112 11.8535 20.5764 11.6081 20.4222 11.532ZM20.9599 12.4946C20.8575 12.4438 20.7136 12.5237 20.6384 12.6732C20.5651 12.8227 20.5867 12.9862 20.6901 13.037C20.7926 13.0887 20.9364 13.0088 21.0116 12.8584C21.0859 12.7089 21.0633 12.5463 20.9599 12.4946Z"
        fill="white"
      />
      <defs>
        <radialGradient
          id="paint0_radial_10827_28689"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(15 15) rotate(84.447) scale(18.0849 18.6277)"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#F1F1F1" />
        </radialGradient>
      </defs>
    </svg>
  );
};

export const FCIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="188"
      height="27"
      viewBox="0 0 188 27"
      fill="none"
    >
      <g clip-path="url(#clip0_4380_53545)">
        <path
          d="M3.776 0.36V0.952H1.312V2.904H3.4V3.472H1.312V6H0.584V0.36H3.776ZM7.13469 0.304C7.82269 0.304 8.39069 0.474667 8.83869 0.816C9.28669 1.152 9.59602 1.61333 9.76669 2.2H8.99869C8.85469 1.82667 8.62269 1.53067 8.30269 1.312C7.98269 1.088 7.59069 0.976 7.12669 0.976C6.75869 0.976 6.42802 1.06667 6.13469 1.248C5.84669 1.424 5.61735 1.68 5.44669 2.016C5.28135 2.34667 5.19869 2.736 5.19869 3.184C5.19869 3.62667 5.28135 4.01333 5.44669 4.344C5.61735 4.67467 5.84669 4.93067 6.13469 5.112C6.42802 5.288 6.75869 5.376 7.12669 5.376C7.59069 5.376 7.98269 5.26667 8.30269 5.048C8.62269 4.824 8.85469 4.52533 8.99869 4.152H9.76669C9.59602 4.73867 9.28669 5.20267 8.83869 5.544C8.39069 5.88 7.82269 6.048 7.13469 6.048C6.60669 6.048 6.14002 5.928 5.73469 5.688C5.32935 5.44267 5.01202 5.104 4.78269 4.672C4.55869 4.23467 4.44669 3.73867 4.44669 3.184C4.44669 2.624 4.55869 2.12533 4.78269 1.688C5.01202 1.25067 5.32935 0.912 5.73469 0.672C6.14002 0.426667 6.60669 0.304 7.13469 0.304Z"
          fill="#16EF27"
        />
        <path
          d="M29.4321 27L26.3327 1.93113L21.753 14.6623H17.497L16.1093 12.6954L14.4902 14.6623H12.0384L9.91043 18.7033L6.81102 11.0146L4.63681 14.6623H2V14.3046H4.35925L6.90354 10.049L10.003 17.6305L11.7146 14.3046H14.2589L16.1555 12.0159L17.7746 14.3046H21.4291L26.564 0L29.6634 25.0331L33.503 14.3046H37.1112L39.0541 12.8026L41.1358 14.3046H42.8012L45.0679 10.0848L47.3809 14.3046H49V14.6623H47.0571L45.0679 11.0146L43.125 14.6623H40.9508L39.0541 13.3033L37.2963 14.6623H33.8268L29.4321 27Z"
          fill="#16EF27"
        />
        <path
          d="M76.4321 27L73.3327 1.93113L68.753 14.6623H64.4508L63.1093 12.6954L61.4902 14.6623H59.0384L56.9104 18.7033L53.811 11.0146L51.6368 14.6623H49V14.3046H51.3593L53.9035 10.049L56.9567 17.6305L58.7146 14.3046H61.2589L63.1555 12.0159L64.7284 14.3046H68.4291L73.564 0L76.6634 25.0331L80.503 14.3046H84.1112L86.0541 12.8026L88.1358 14.3046H89.8012L92.0679 10.0848L94.3809 14.3046H96V14.6623H94.0571L92.0679 11.0146L90.0787 14.6623H87.9508L86.0541 13.3033L84.2963 14.6623H80.8268L76.4321 27Z"
          fill="#16EF27"
        />
        <path
          d="M123.432 27L120.333 1.93113L115.753 14.6623H111.451L110.109 12.6954L108.49 14.6623H105.992L103.91 18.7033L100.811 11.0146L98.6368 14.6623H96V14.3046H98.3593L100.904 10.049L103.957 17.6305L105.715 14.3046H108.213L110.156 12.0159L111.728 14.3046H115.383L120.564 0L123.663 25.0331L127.503 14.3046H131.111L133.008 12.8026L135.136 14.3046H136.801L139.068 10.0848L141.381 14.3046H143V14.6623H141.057L139.068 11.0146L137.079 14.6623H134.951L133.054 13.3033L131.296 14.6623H127.827L123.432 27Z"
          fill="#16EF27"
        />
        <path
          d="M170.459 27L167.357 1.93113L162.772 14.6623H158.466L157.123 12.6954L155.502 14.6623H153.002L150.918 18.7033L147.816 11.0146L145.639 14.6623H143V14.3046H145.315L147.862 10.049L150.965 17.6305L152.678 14.3046H155.225L157.169 12.0159L158.744 14.3046H162.402L167.588 0L170.644 25.0331L174.488 14.3046H178.1L180.044 12.8026L182.128 14.3046H183.795L186.11 10.0848L188.379 14.3046H190V14.6623H188.101L186.11 11.0146L184.119 14.6623H181.943L180.091 13.3033L178.331 14.6623H174.858L170.459 27Z"
          fill="#16EF27"
        />
        <path
          d="M49 14.3046H47.3809L45.0679 10.0848L42.8012 14.3046H41.1358L39.0541 12.8026L37.1112 14.3046H33.503L29.6634 25.0331L26.564 0L21.4291 14.3046H17.7746L16.1555 12.0159L14.2589 14.3046H11.7146L10.003 17.6305L6.90354 10.049L4.35925 14.3046H2V14.6623H4.63681L6.81102 11.0146L9.91043 18.7033L12.0384 14.6623H14.4902L16.1093 12.6954L17.497 14.6623H21.753L26.3327 1.93113L29.4321 27L33.8268 14.6623H37.2963L39.0541 13.3033L40.9508 14.6623H43.125L45.0679 11.0146L47.0571 14.6623H49M49 14.3046V14.6623M49 14.3046H51.3593L53.9035 10.049L56.9567 17.6305L58.7146 14.3046H61.2589L63.1555 12.0159L64.7284 14.3046H68.4291L73.564 0L76.6634 25.0331L80.503 14.3046H84.1112L86.0541 12.8026L88.1358 14.3046H89.8012L92.0679 10.0848L94.3809 14.3046H96M49 14.6623H51.6368L53.811 11.0146L56.9104 18.7033L59.0384 14.6623H61.4902L63.1093 12.6954L64.4508 14.6623H68.753L73.3327 1.93113L76.4321 27L80.8268 14.6623H84.2963L86.0541 13.3033L87.9508 14.6623H90.0787L92.0679 11.0146L94.0571 14.6623H96M96 14.3046V14.6623M96 14.3046H98.3593L100.904 10.049L103.957 17.6305L105.715 14.3046H108.213L110.156 12.0159L111.728 14.3046H115.383L120.564 0L123.663 25.0331L127.503 14.3046H131.111L133.008 12.8026L135.136 14.3046H136.801L139.068 10.0848L141.381 14.3046H143M96 14.6623H98.6368L100.811 11.0146L103.91 18.7033L105.992 14.6623H108.49L110.109 12.6954L111.451 14.6623H115.753L120.333 1.93113L123.432 27L127.827 14.6623H131.296L133.054 13.3033L134.951 14.6623H137.079L139.068 11.0146L141.057 14.6623H143M143 14.3046V14.6623M143 14.3046H145.315L147.862 10.049L150.965 17.6305L152.678 14.3046H155.225L157.169 12.0159L158.744 14.3046H162.402L167.588 0L170.644 25.0331L174.488 14.3046H178.1L180.044 12.8026L182.128 14.3046H183.795L186.11 10.0848L188.379 14.3046H190V14.6623H188.101L186.11 11.0146L184.119 14.6623H181.943L180.091 13.3033L178.331 14.6623H174.858L170.459 27L167.357 1.93113L162.772 14.6623H158.466L157.123 12.6954L155.502 14.6623H153.002L150.918 18.7033L147.816 11.0146L145.639 14.6623H143"
          stroke="#16EF27"
          stroke-width="0.5"
        />
      </g>
      <defs>
        <clipPath id="clip0_4380_53545">
          <rect width="188" height="27" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const RsepIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="190"
      height="22"
      viewBox="0 0 190 22"
      fill="none"
    >
      <path
        d="M0.6 6V0.44H3.872V1.184H1.512V2.824H3.352V3.568H1.512V6H0.6ZM7.66919 2.104C7.66919 1.544 7.34919 1.184 6.63719 1.184H5.62919V3.048H6.63719C7.34919 3.048 7.66919 2.656 7.66919 2.104ZM4.71719 0.44H6.63719C7.95719 0.44 8.60519 1.2 8.60519 2.104C8.60519 2.76 8.25319 3.464 7.31719 3.696L8.69319 6H7.60519L6.32519 3.776H5.62919V6H4.71719V0.44Z"
        fill="#FCFC00"
      />
      <g clip-path="url(#clip0_11927_28632)">
        <path
          d="M190.591 16.0106C189.641 16.8227 189.588 18.3026 189.541 19.6081C189.529 19.8788 189.523 20.1495 189.499 20.4022C189.476 20.1856 189.458 19.9209 189.44 19.5961C189.387 18.6696 189.369 17.5867 189.358 16.7204C189.346 15.9805 189.34 15.4451 189.316 15.2104C189.304 15.0961 189.281 14.8435 189.251 14.4945C189.104 12.786 188.767 8.78539 188.33 6.95052C188.319 6.90239 188.307 6.84825 188.301 6.78809C188.242 6.51737 188.153 6.01203 187.681 6.01203C187.238 6.01203 187.097 6.53542 186.961 7.63634C186.866 8.43646 186.79 9.51332 186.713 10.5601C186.618 11.9017 186.518 13.2913 186.376 14.1396C186.359 14.2599 186.341 14.3742 186.323 14.4825C186.181 15.409 186.14 15.6917 185.237 15.8241C183.566 16.0707 182.681 15.4872 181.901 14.9698C181.742 14.8675 181.594 14.7713 181.441 14.675C180.29 13.9892 179.534 14.4705 178.926 14.8555C178.649 15.03 178.389 15.1984 178.106 15.2646C177.686 15.3608 177.084 15.3247 176.5 15.2947C176.069 15.2706 175.667 15.2465 175.313 15.2706C173.259 15.415 172.273 15.2947 170.307 15.054L169.888 15.0059C169.345 14.9397 168.707 14.7051 168.087 14.4765C167.402 14.2238 166.7 13.9591 166.051 13.8929C165.637 13.8508 165.236 13.9651 164.781 14.0915C164.238 14.2419 163.559 14.4344 162.597 14.4344C162.207 14.4344 161.877 14.5727 161.534 14.7171C161.08 14.9096 160.613 15.1021 159.881 15.054C159.114 14.9999 158.258 13.7666 157.508 12.6717C156.635 11.4023 155.808 10.2052 154.799 10.0848C154.368 10.0307 153.948 10.1871 153.559 10.536C153.081 10.9632 152.62 11.7272 152.13 12.5333C151.469 13.6222 150.719 14.8495 149.999 15.0901C148.706 15.5233 147.744 15.5112 146.516 15.4992C146.292 15.4992 146.061 15.4932 145.819 15.4932C145.743 15.4932 145.625 15.4811 145.501 15.4691C144.975 15.421 144.255 15.3548 143.794 15.7819C143.552 16.0106 143.428 16.3294 143.428 16.7385C143.411 17.1476 142.679 20.2939 142.348 21.1722C142.295 20.9557 142.224 20.5105 142.171 19.584C142.118 18.6576 142.1 17.5747 142.088 16.7084C142.077 15.9684 142.071 15.433 142.047 15.1984C142.035 15.0841 142.012 14.8314 141.982 14.4825C141.835 12.774 141.498 8.77336 141.061 6.93849C141.049 6.89036 141.038 6.83622 141.032 6.77606C140.984 6.50534 140.89 6 140.418 6C139.975 6 139.833 6.52339 139.697 7.62431C139.603 8.42443 139.526 9.50129 139.45 10.5481C139.355 11.8896 139.255 13.2793 139.113 14.1276C139.095 14.2479 139.078 14.3622 139.06 14.4705C138.918 15.3969 138.877 15.6797 137.974 15.812C136.303 16.0587 135.417 15.4751 134.638 14.9578C134.479 14.8555 134.331 14.7592 134.178 14.663C133.027 13.9772 132.271 14.4584 131.663 14.8435C131.385 15.0179 131.126 15.1864 130.842 15.2525C130.423 15.3488 129.821 15.3127 129.236 15.2826C128.806 15.2586 128.404 15.2345 128.05 15.2586C125.995 15.4029 125.01 15.2826 123.044 15.042L122.625 14.9939C122.081 14.9277 121.444 14.6931 120.824 14.4645C120.139 14.2118 119.437 13.9471 118.787 13.8809C118.374 13.8388 117.973 13.9531 117.518 14.0794C116.975 14.2298 116.296 14.4223 115.334 14.4223C114.944 14.4223 114.614 14.5607 114.271 14.7051C113.817 14.8976 113.35 15.0901 112.618 15.042C111.851 14.9878 110.995 13.7546 110.245 12.6597C109.371 11.3903 108.545 10.1931 107.535 10.0728C107.104 10.0187 106.685 10.1751 106.296 10.524C105.817 10.9511 105.357 11.7152 104.867 12.5213C104.206 13.6102 103.456 14.8374 102.736 15.0781C101.443 15.5112 100.481 15.4992 99.2527 15.4872C99.0284 15.4872 98.7981 15.4811 98.5561 15.4811C98.4793 15.4811 98.3613 15.4691 98.2373 15.4571C97.7119 15.409 96.9917 15.3428 96.5312 15.7699C96.2891 15.9985 96.1652 16.3174 96.1652 16.7265C96.1475 17.1355 95.4154 20.2819 95.0848 21.1602C95.0317 20.9436 94.9609 20.4985 94.9077 19.572C94.8546 18.6455 94.8369 17.5627 94.8251 16.6964C94.8133 15.9564 94.8074 15.421 94.7838 15.1864C94.772 15.0721 94.7483 14.8194 94.7188 14.4705C94.5712 12.7619 94.2347 8.76132 93.7979 6.92646C93.7861 6.87833 93.7743 6.82419 93.7625 6.76403C93.6975 6.51737 93.6031 6.01203 93.1367 6.01203C92.6939 6.01203 92.5522 6.53542 92.4165 7.63634C92.322 8.43045 92.2453 9.51332 92.1685 10.5601C92.0741 11.9017 91.9737 13.2913 91.832 14.1396C91.8143 14.2599 91.7966 14.3742 91.7789 14.4825C91.6372 15.409 91.5959 15.6917 90.6926 15.8241C89.022 16.0707 88.1364 15.4872 87.3572 14.9698C87.1978 14.8675 87.0502 14.7713 86.8967 14.675C85.7455 13.9892 84.9899 14.4705 84.3818 14.8555C84.1044 15.03 83.8446 15.1984 83.5612 15.2646C83.1421 15.3608 82.5399 15.3247 81.9555 15.2947C81.5245 15.2706 81.1231 15.2465 80.7689 15.2706C78.7145 15.415 77.7286 15.2947 75.7627 15.054L75.3436 15.0059C74.8005 14.9397 74.1629 14.7051 73.543 14.4765C72.8582 14.2238 72.1557 13.9591 71.5063 13.8929C71.0931 13.8508 70.6916 13.9651 70.2371 14.0915C69.694 14.2419 69.0151 14.4344 68.0528 14.4344C67.6632 14.4344 67.3326 14.5727 66.9902 14.7171C66.5356 14.9096 66.0692 15.1021 65.3372 15.054C64.5697 14.9999 63.7137 13.7666 62.964 12.6717C62.0903 11.4023 61.2638 10.2052 60.2543 10.0848C59.8233 10.0307 59.4042 10.1871 59.0146 10.536C58.5364 10.9632 58.0759 11.7272 57.5859 12.5333C56.9247 13.6222 56.175 14.8495 55.4548 15.0901C54.1619 15.5233 53.1996 15.5112 51.9717 15.4992C51.7474 15.4992 51.5171 15.4932 51.2751 15.4932C51.1983 15.4932 51.0803 15.4811 50.9563 15.4691C50.4309 15.421 49.7107 15.3548 49.2502 15.7819C49.0082 16.0106 48.8842 16.3294 48.8842 16.7385C48.8665 17.1476 48.1344 20.2939 47.8038 21.1722C47.7507 20.9557 47.6799 20.5105 47.6267 19.584C47.5736 18.6576 47.5559 17.5747 47.5441 16.7084C47.5323 15.9684 47.5264 15.433 47.5028 15.1984C47.491 15.0841 47.4673 14.8314 47.4378 14.4825C47.2902 12.774 46.9537 8.77336 46.5169 6.93849C46.5051 6.89036 46.4933 6.83622 46.4874 6.77606C46.4224 6.51737 46.3339 6.01203 45.8616 6.01203C45.4188 6.01203 45.2772 6.53542 45.1414 7.63634C45.0469 8.43045 44.9702 9.51332 44.8934 10.5601C44.799 11.9017 44.6986 13.2913 44.5569 14.1396C44.5392 14.2599 44.5215 14.3742 44.5038 14.4825C44.3621 15.409 44.3208 15.6917 43.4176 15.8241C41.7469 16.0707 40.8613 15.4872 40.0821 14.9698C39.9227 14.8675 39.7751 14.7713 39.6216 14.675C38.4704 13.9892 37.7148 14.4705 37.1067 14.8555C36.8293 15.03 36.5695 15.1984 36.2861 15.2646C35.867 15.3608 35.2648 15.3247 34.6804 15.2947C34.2494 15.2706 33.848 15.2465 33.4938 15.2706C31.4394 15.415 30.4535 15.2947 28.4876 15.054L28.0685 15.0059C27.5254 14.9397 26.8878 14.7051 26.2679 14.4765C25.5831 14.2238 24.8806 13.9591 24.2312 13.8929C23.818 13.8508 23.4166 13.9651 22.962 14.0915C22.4189 14.2419 21.74 14.4344 20.7777 14.4344C20.3881 14.4344 20.0575 14.5727 19.7151 14.7171C19.2605 14.9096 18.7941 15.1021 18.0621 15.054C17.2946 14.9999 16.4386 13.7666 15.6889 12.6717C14.8152 11.4023 13.9887 10.2052 12.9792 10.0848C12.5482 10.0307 12.1291 10.1871 11.7395 10.536C11.2613 10.9632 10.8008 11.7272 10.3108 12.5333C9.64963 13.6222 8.89989 14.8495 8.17967 15.0901C6.8868 15.5233 5.92454 15.5112 4.69661 15.4992C4.47818 15.4992 4.25975 15.4932 4.02361 15.4932C4.01771 15.4932 4.0059 15.4932 4 15.4932V16.2151C4.24204 16.2151 4.47228 16.2151 4.69071 16.2211C5.97767 16.2331 6.99897 16.2452 8.39809 15.7759C9.36627 15.4511 10.1514 14.1637 10.9071 12.9123C11.3675 12.1543 11.8044 11.4324 12.2058 11.0775C12.442 10.8609 12.6663 10.7707 12.8965 10.8007C13.5932 10.885 14.3665 12.0039 15.1104 13.0868C15.9959 14.3682 16.9109 15.6977 18.0149 15.7699C18.9122 15.8301 19.5084 15.5834 19.9866 15.3789C20.2877 15.2525 20.5298 15.1503 20.7836 15.1503C21.8403 15.1503 22.5724 14.9457 23.1568 14.7833C23.5641 14.669 23.8888 14.5788 24.1722 14.6088C24.733 14.663 25.3942 14.9096 26.0377 15.1503C26.693 15.3969 27.3719 15.6436 27.9977 15.7218L28.4168 15.7699C30.365 16.0045 31.4335 16.1309 33.5528 15.9865C33.8598 15.9624 34.2435 15.9865 34.6509 16.0106C35.2826 16.0466 35.9378 16.0827 36.4574 15.9684C36.8588 15.8782 37.1835 15.6676 37.4964 15.4691C38.0808 15.1021 38.5 14.8314 39.2851 15.2947C39.4268 15.3789 39.5685 15.4691 39.7161 15.5714C40.5603 16.1249 41.6111 16.8167 43.5415 16.5279C44.9584 16.3174 45.0764 15.5533 45.224 14.5848C45.2417 14.4825 45.2594 14.3682 45.2772 14.2539C45.4247 13.3756 45.5251 11.9678 45.6196 10.6082C45.6904 9.61559 45.7849 8.26802 45.9029 7.41977C46.2926 9.31479 46.6054 12.9484 46.7412 14.5487C46.7707 14.9036 46.7943 15.1563 46.8062 15.2766C46.8298 15.4811 46.8357 16.0527 46.8475 16.7204C46.9065 20.6067 47.0305 21.6776 47.4673 21.9363C47.5736 22.0024 47.6917 22.0145 47.8097 21.9844H47.9632H48.0046C48.282 21.9543 48.406 21.7016 48.6244 21.0098C48.7838 20.5045 48.9491 19.8547 49.0613 19.3975C49.2915 18.459 49.6103 17.0152 49.6103 16.7505C49.6103 16.4497 49.7107 16.3535 49.7461 16.3234C49.9763 16.1068 50.5372 16.161 50.915 16.197C51.0626 16.2091 51.1865 16.2211 51.2987 16.2211C51.5407 16.2211 51.771 16.2211 51.9894 16.2271C53.2764 16.2392 54.2977 16.2512 55.6968 15.7819C56.665 15.4571 57.4501 14.1697 58.2058 12.9183C58.6663 12.1603 59.1031 11.4384 59.5045 11.0835C59.7407 10.8669 59.965 10.7767 60.1953 10.8067C60.8919 10.891 61.6652 12.0099 62.4091 13.0928C63.2946 14.3742 64.2096 15.7037 65.3136 15.7759C66.2109 15.8361 66.8072 15.5894 67.2853 15.3849C67.5864 15.2586 67.8285 15.1563 68.0823 15.1563C69.139 15.1563 69.8711 14.9517 70.4555 14.7893C70.8629 14.675 71.1875 14.5848 71.4709 14.6148C72.0317 14.669 72.6929 14.9156 73.3364 15.1563C73.9917 15.4029 74.6706 15.6496 75.2964 15.7278L75.7155 15.7759C77.6637 16.0106 78.7322 16.1369 80.8515 15.9925C81.1585 15.9684 81.5423 15.9925 81.9496 16.0166C82.5813 16.0527 83.2365 16.0888 83.7561 15.9745C84.1575 15.8842 84.4822 15.6737 84.7951 15.4751C85.3795 15.1082 85.7987 14.8374 86.5838 15.3007C86.7255 15.3849 86.8672 15.4751 87.0148 15.5774C87.859 16.1309 88.9098 16.8227 90.8402 16.5339C92.2571 16.3234 92.3751 15.5594 92.5227 14.5908C92.5404 14.4885 92.5581 14.3742 92.5759 14.2599C92.7234 13.3816 92.8238 11.9738 92.9183 10.6082C92.9891 9.61559 93.0836 8.26802 93.2016 7.41977C93.5913 9.31479 93.9041 12.9424 94.0399 14.5427C94.0694 14.8976 94.0931 15.1563 94.1049 15.2706C94.1285 15.4751 94.1344 16.0466 94.1462 16.7144C94.2052 20.6007 94.3292 21.6716 94.766 21.9303C94.8723 21.9964 94.9904 22.0085 95.1085 21.9784H95.2619H95.3033C95.5807 21.9483 95.7047 21.6956 95.9231 21.0038C96.0825 20.4985 96.2478 19.8487 96.36 19.3915C96.5902 18.453 96.909 17.0092 96.909 16.7445C96.909 16.4437 97.0094 16.3474 97.0448 16.3174C97.275 16.1008 97.8418 16.1549 98.2137 16.191C98.3613 16.2031 98.4852 16.2151 98.5915 16.2151C98.8335 16.2151 99.0638 16.2151 99.2822 16.2211C100.569 16.2331 101.59 16.2452 102.99 15.7759C103.958 15.4511 104.743 14.1637 105.499 12.9123C105.959 12.1543 106.396 11.4324 106.797 11.0775C107.033 10.8609 107.258 10.7707 107.488 10.8007C108.185 10.885 108.958 12.0039 109.702 13.0868C110.587 14.3682 111.502 15.6977 112.606 15.7699C113.504 15.8301 114.1 15.5834 114.578 15.3789C114.879 15.2525 115.121 15.1503 115.375 15.1503C116.432 15.1503 117.164 14.9457 117.748 14.7833C118.156 14.669 118.48 14.5788 118.764 14.6088C119.325 14.663 119.986 14.9096 120.629 15.1503C121.284 15.3969 121.963 15.6436 122.589 15.7218L123.008 15.7699C124.956 16.0045 126.025 16.1309 128.144 15.9865C128.451 15.9624 128.835 15.9865 129.242 16.0106C129.874 16.0466 130.529 16.0827 131.049 15.9684C131.45 15.8782 131.775 15.6676 132.088 15.4691C132.672 15.1021 133.091 14.8314 133.877 15.2947C134.018 15.3789 134.16 15.4691 134.308 15.5714C135.152 16.1249 136.203 16.8167 138.133 16.5279C139.55 16.3174 139.668 15.5533 139.816 14.5848C139.833 14.4825 139.851 14.3682 139.869 14.2539C140.016 13.3756 140.117 11.9678 140.211 10.6082C140.282 9.61559 140.376 8.26802 140.494 7.41977C140.884 9.31479 141.197 12.9424 141.333 14.5427C141.362 14.8976 141.386 15.1563 141.398 15.2706C141.421 15.4751 141.427 16.0466 141.439 16.7144C141.498 20.6007 141.622 21.6716 142.059 21.9303C142.165 21.9964 142.283 22.0085 142.401 21.9784H142.555H142.596C142.874 21.9483 142.997 21.6956 143.216 21.0038C143.375 20.4985 143.541 19.8487 143.653 19.3915C143.883 18.453 144.202 17.0092 144.202 16.7445C144.202 16.4437 144.302 16.3474 144.338 16.3174C144.568 16.1008 145.135 16.1549 145.506 16.191C145.654 16.2031 145.778 16.2151 145.89 16.2151C146.132 16.2151 146.362 16.2151 146.581 16.2211C147.868 16.2331 148.889 16.2452 150.288 15.7759C151.256 15.4511 152.042 14.1637 152.797 12.9123C153.258 12.1543 153.695 11.4324 154.096 11.0775C154.332 10.8609 154.557 10.7707 154.787 10.8007C155.483 10.885 156.257 12.0039 157.001 13.0868C157.886 14.3682 158.801 15.6977 159.905 15.7699C160.802 15.8301 161.399 15.5834 161.877 15.3789C162.178 15.2525 162.42 15.1503 162.674 15.1503C163.731 15.1503 164.463 14.9457 165.047 14.7833C165.454 14.669 165.779 14.5788 166.062 14.6088C166.623 14.663 167.284 14.9096 167.928 15.1503C168.583 15.3969 169.262 15.6436 169.888 15.7218L170.307 15.7699C172.255 16.0045 173.324 16.1309 175.443 15.9865C175.75 15.9624 176.134 15.9865 176.541 16.0106C177.173 16.0466 177.828 16.0827 178.348 15.9684C178.749 15.8782 179.074 15.6676 179.387 15.4691C179.971 15.1021 180.39 14.8314 181.175 15.2947C181.317 15.3789 181.459 15.4691 181.606 15.5714C182.45 16.1249 183.501 16.8167 185.432 16.5279C186.849 16.3174 186.967 15.5533 187.114 14.5848C187.132 14.4825 187.15 14.3682 187.167 14.2539C187.315 13.3756 187.415 11.9678 187.51 10.6082C187.581 9.61559 187.675 8.26802 187.793 7.41977C188.183 9.31479 188.496 12.9424 188.631 14.5427C188.661 14.8976 188.685 15.1563 188.696 15.2706C188.72 15.4751 188.726 16.0466 188.738 16.7144C188.797 20.6007 188.921 21.6716 189.358 21.9303C189.499 22.0145 189.659 22.0145 189.806 21.9363L189.877 21.9002L189.924 21.834C190.273 21.3527 190.302 20.5526 190.338 19.6201C190.379 18.4651 190.426 17.1536 191.14 16.546C191.542 16.2031 192.132 16.0888 192.953 16.2031L192.976 16.2091H193V15.4872C191.914 15.3729 191.135 15.5413 190.591 16.0106Z"
          fill="#FCFC00"
        />
      </g>
      <defs>
        <clipPath id="clip0_11927_28632">
          <rect
            width="188"
            height="16"
            fill="white"
            transform="translate(2 6)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const Oxygen = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="188"
      height="22"
      viewBox="0 0 188 22"
      fill="none"
    >
      <g clip-path="url(#clip0_11927_28637)">
        <path
          d="M188.591 16.0106C187.641 16.8227 187.588 18.3026 187.541 19.6081C187.529 19.8788 187.523 20.1495 187.499 20.4022C187.476 20.1856 187.458 19.9209 187.44 19.5961C187.387 18.6696 187.369 17.5867 187.358 16.7204C187.346 15.9805 187.34 15.4451 187.316 15.2104C187.304 15.0961 187.281 14.8435 187.251 14.4945C187.104 12.786 186.767 8.78539 186.33 6.95052C186.319 6.90239 186.307 6.84825 186.301 6.78809C186.242 6.51737 186.153 6.01203 185.681 6.01203C185.238 6.01203 185.097 6.53542 184.961 7.63634C184.866 8.43646 184.79 9.51332 184.713 10.5601C184.618 11.9017 184.518 13.2913 184.376 14.1396C184.359 14.2599 184.341 14.3742 184.323 14.4825C184.181 15.409 184.14 15.6917 183.237 15.8241C181.566 16.0707 180.681 15.4872 179.901 14.9698C179.742 14.8675 179.594 14.7713 179.441 14.675C178.29 13.9892 177.534 14.4705 176.926 14.8555C176.649 15.03 176.389 15.1984 176.106 15.2646C175.686 15.3608 175.084 15.3247 174.5 15.2947C174.069 15.2706 173.667 15.2465 173.313 15.2706C171.259 15.415 170.273 15.2947 168.307 15.054L167.888 15.0059C167.345 14.9397 166.707 14.7051 166.087 14.4765C165.402 14.2238 164.7 13.9591 164.051 13.8929C163.637 13.8508 163.236 13.9651 162.781 14.0915C162.238 14.2419 161.559 14.4344 160.597 14.4344C160.207 14.4344 159.877 14.5727 159.534 14.7171C159.08 14.9096 158.613 15.1021 157.881 15.054C157.114 14.9999 156.258 13.7666 155.508 12.6717C154.635 11.4023 153.808 10.2052 152.799 10.0848C152.368 10.0307 151.948 10.1871 151.559 10.536C151.081 10.9632 150.62 11.7272 150.13 12.5333C149.469 13.6222 148.719 14.8495 147.999 15.0901C146.706 15.5233 145.744 15.5112 144.516 15.4992C144.292 15.4992 144.061 15.4932 143.819 15.4932C143.743 15.4932 143.625 15.4811 143.501 15.4691C142.975 15.421 142.255 15.3548 141.794 15.7819C141.552 16.0106 141.428 16.3294 141.428 16.7385C141.411 17.1476 140.679 20.2939 140.348 21.1722C140.295 20.9557 140.224 20.5105 140.171 19.584C140.118 18.6576 140.1 17.5747 140.088 16.7084C140.077 15.9684 140.071 15.433 140.047 15.1984C140.035 15.0841 140.012 14.8314 139.982 14.4825C139.835 12.774 139.498 8.77336 139.061 6.93849C139.049 6.89036 139.038 6.83622 139.032 6.77606C138.984 6.50534 138.89 6 138.418 6C137.975 6 137.833 6.52339 137.697 7.62431C137.603 8.42443 137.526 9.50129 137.45 10.5481C137.355 11.8896 137.255 13.2793 137.113 14.1276C137.095 14.2479 137.078 14.3622 137.06 14.4705C136.918 15.3969 136.877 15.6797 135.974 15.812C134.303 16.0587 133.417 15.4751 132.638 14.9578C132.479 14.8555 132.331 14.7592 132.178 14.663C131.027 13.9772 130.271 14.4584 129.663 14.8435C129.385 15.0179 129.126 15.1864 128.842 15.2525C128.423 15.3488 127.821 15.3127 127.236 15.2826C126.806 15.2586 126.404 15.2345 126.05 15.2586C123.995 15.4029 123.01 15.2826 121.044 15.042L120.625 14.9939C120.081 14.9277 119.444 14.6931 118.824 14.4645C118.139 14.2118 117.437 13.9471 116.787 13.8809C116.374 13.8388 115.973 13.9531 115.518 14.0794C114.975 14.2298 114.296 14.4223 113.334 14.4223C112.944 14.4223 112.614 14.5607 112.271 14.7051C111.817 14.8976 111.35 15.0901 110.618 15.042C109.851 14.9878 108.995 13.7546 108.245 12.6597C107.371 11.3903 106.545 10.1931 105.535 10.0728C105.104 10.0187 104.685 10.1751 104.296 10.524C103.817 10.9511 103.357 11.7152 102.867 12.5213C102.206 13.6102 101.456 14.8374 100.736 15.0781C99.4429 15.5112 98.4806 15.4992 97.2527 15.4872C97.0284 15.4872 96.7981 15.4811 96.5561 15.4811C96.4793 15.4811 96.3613 15.4691 96.2373 15.4571C95.7119 15.409 94.9917 15.3428 94.5312 15.7699C94.2891 15.9985 94.1652 16.3174 94.1652 16.7265C94.1475 17.1355 93.4154 20.2819 93.0848 21.1602C93.0317 20.9436 92.9609 20.4985 92.9077 19.572C92.8546 18.6455 92.8369 17.5627 92.8251 16.6964C92.8133 15.9564 92.8074 15.421 92.7838 15.1864C92.772 15.0721 92.7483 14.8194 92.7188 14.4705C92.5712 12.7619 92.2347 8.76132 91.7979 6.92646C91.7861 6.87833 91.7743 6.82419 91.7625 6.76403C91.6975 6.51737 91.6031 6.01203 91.1367 6.01203C90.6939 6.01203 90.5522 6.53542 90.4165 7.63634C90.322 8.43045 90.2453 9.51332 90.1685 10.5601C90.0741 11.9017 89.9737 13.2913 89.832 14.1396C89.8143 14.2599 89.7966 14.3742 89.7789 14.4825C89.6372 15.409 89.5959 15.6917 88.6926 15.8241C87.022 16.0707 86.1364 15.4872 85.3572 14.9698C85.1978 14.8675 85.0502 14.7713 84.8967 14.675C83.7455 13.9892 82.9899 14.4705 82.3818 14.8555C82.1044 15.03 81.8446 15.1984 81.5612 15.2646C81.1421 15.3608 80.5399 15.3247 79.9555 15.2947C79.5245 15.2706 79.1231 15.2465 78.7689 15.2706C76.7145 15.415 75.7286 15.2947 73.7627 15.054L73.3436 15.0059C72.8005 14.9397 72.1629 14.7051 71.543 14.4765C70.8582 14.2238 70.1557 13.9591 69.5063 13.8929C69.0931 13.8508 68.6916 13.9651 68.2371 14.0915C67.694 14.2419 67.0151 14.4344 66.0528 14.4344C65.6632 14.4344 65.3326 14.5727 64.9902 14.7171C64.5356 14.9096 64.0692 15.1021 63.3372 15.054C62.5697 14.9999 61.7137 13.7666 60.964 12.6717C60.0903 11.4023 59.2638 10.2052 58.2543 10.0848C57.8233 10.0307 57.4042 10.1871 57.0146 10.536C56.5364 10.9632 56.0759 11.7272 55.5859 12.5333C54.9247 13.6222 54.175 14.8495 53.4548 15.0901C52.1619 15.5233 51.1996 15.5112 49.9717 15.4992C49.7474 15.4992 49.5171 15.4932 49.2751 15.4932C49.1983 15.4932 49.0803 15.4811 48.9563 15.4691C48.4309 15.421 47.7107 15.3548 47.2502 15.7819C47.0082 16.0106 46.8842 16.3294 46.8842 16.7385C46.8665 17.1476 46.1344 20.2939 45.8038 21.1722C45.7507 20.9557 45.6799 20.5105 45.6267 19.584C45.5736 18.6576 45.5559 17.5747 45.5441 16.7084C45.5323 15.9684 45.5264 15.433 45.5028 15.1984C45.491 15.0841 45.4673 14.8314 45.4378 14.4825C45.2902 12.774 44.9537 8.77336 44.5169 6.93849C44.5051 6.89036 44.4933 6.83622 44.4874 6.77606C44.4224 6.51737 44.3339 6.01203 43.8616 6.01203C43.4188 6.01203 43.2772 6.53542 43.1414 7.63634C43.0469 8.43045 42.9702 9.51332 42.8934 10.5601C42.799 11.9017 42.6986 13.2913 42.5569 14.1396C42.5392 14.2599 42.5215 14.3742 42.5038 14.4825C42.3621 15.409 42.3208 15.6917 41.4176 15.8241C39.7469 16.0707 38.8613 15.4872 38.0821 14.9698C37.9227 14.8675 37.7751 14.7713 37.6216 14.675C36.4704 13.9892 35.7148 14.4705 35.1067 14.8555C34.8293 15.03 34.5695 15.1984 34.2861 15.2646C33.867 15.3608 33.2648 15.3247 32.6804 15.2947C32.2494 15.2706 31.848 15.2465 31.4938 15.2706C29.4394 15.415 28.4535 15.2947 26.4876 15.054L26.0685 15.0059C25.5254 14.9397 24.8878 14.7051 24.2679 14.4765C23.5831 14.2238 22.8806 13.9591 22.2312 13.8929C21.818 13.8508 21.4166 13.9651 20.962 14.0915C20.4189 14.2419 19.74 14.4344 18.7777 14.4344C18.3881 14.4344 18.0575 14.5727 17.7151 14.7171C17.2605 14.9096 16.7941 15.1021 16.0621 15.054C15.2946 14.9999 14.4386 13.7666 13.6889 12.6717C12.8152 11.4023 11.9887 10.2052 10.9792 10.0848C10.5482 10.0307 10.1291 10.1871 9.73947 10.536C9.26128 10.9632 8.80081 11.7272 8.31082 12.5333C7.64963 13.6222 6.89989 14.8495 6.17967 15.0901C4.8868 15.5233 3.92454 15.5112 2.69661 15.4992C2.47818 15.4992 2.25975 15.4932 2.02361 15.4932C2.01771 15.4932 2.0059 15.4932 2 15.4932V16.2151C2.24204 16.2151 2.47228 16.2151 2.69071 16.2211C3.97767 16.2331 4.99897 16.2452 6.39809 15.7759C7.36627 15.4511 8.15143 14.1637 8.90707 12.9123C9.36755 12.1543 9.8044 11.4324 10.2058 11.0775C10.442 10.8609 10.6663 10.7707 10.8965 10.8007C11.5932 10.885 12.3665 12.0039 13.1104 13.0868C13.9959 14.3682 14.9109 15.6977 16.0149 15.7699C16.9122 15.8301 17.5084 15.5834 17.9866 15.3789C18.2877 15.2525 18.5298 15.1503 18.7836 15.1503C19.8403 15.1503 20.5724 14.9457 21.1568 14.7833C21.5641 14.669 21.8888 14.5788 22.1722 14.6088C22.733 14.663 23.3942 14.9096 24.0377 15.1503C24.693 15.3969 25.3719 15.6436 25.9977 15.7218L26.4168 15.7699C28.365 16.0045 29.4335 16.1309 31.5528 15.9865C31.8598 15.9624 32.2435 15.9865 32.6509 16.0106C33.2826 16.0466 33.9378 16.0827 34.4574 15.9684C34.8588 15.8782 35.1835 15.6676 35.4964 15.4691C36.0808 15.1021 36.5 14.8314 37.2851 15.2947C37.4268 15.3789 37.5685 15.4691 37.7161 15.5714C38.5603 16.1249 39.6111 16.8167 41.5415 16.5279C42.9584 16.3174 43.0764 15.5533 43.224 14.5848C43.2417 14.4825 43.2594 14.3682 43.2772 14.2539C43.4247 13.3756 43.5251 11.9678 43.6196 10.6082C43.6904 9.61559 43.7849 8.26802 43.9029 7.41977C44.2926 9.31479 44.6054 12.9484 44.7412 14.5487C44.7707 14.9036 44.7943 15.1563 44.8062 15.2766C44.8298 15.4811 44.8357 16.0527 44.8475 16.7204C44.9065 20.6067 45.0305 21.6776 45.4673 21.9363C45.5736 22.0024 45.6917 22.0145 45.8097 21.9844H45.9632H46.0046C46.282 21.9543 46.406 21.7016 46.6244 21.0098C46.7838 20.5045 46.9491 19.8547 47.0613 19.3975C47.2915 18.459 47.6103 17.0152 47.6103 16.7505C47.6103 16.4497 47.7107 16.3535 47.7461 16.3234C47.9763 16.1068 48.5372 16.161 48.915 16.197C49.0626 16.2091 49.1865 16.2211 49.2987 16.2211C49.5407 16.2211 49.771 16.2211 49.9894 16.2271C51.2764 16.2392 52.2977 16.2512 53.6968 15.7819C54.665 15.4571 55.4501 14.1697 56.2058 12.9183C56.6663 12.1603 57.1031 11.4384 57.5045 11.0835C57.7407 10.8669 57.965 10.7767 58.1953 10.8067C58.8919 10.891 59.6652 12.0099 60.4091 13.0928C61.2946 14.3742 62.2096 15.7037 63.3136 15.7759C64.2109 15.8361 64.8072 15.5894 65.2853 15.3849C65.5864 15.2586 65.8285 15.1563 66.0823 15.1563C67.139 15.1563 67.8711 14.9517 68.4555 14.7893C68.8629 14.675 69.1875 14.5848 69.4709 14.6148C70.0317 14.669 70.6929 14.9156 71.3364 15.1563C71.9917 15.4029 72.6706 15.6496 73.2964 15.7278L73.7155 15.7759C75.6637 16.0106 76.7322 16.1369 78.8515 15.9925C79.1585 15.9684 79.5423 15.9925 79.9496 16.0166C80.5813 16.0527 81.2365 16.0888 81.7561 15.9745C82.1575 15.8842 82.4822 15.6737 82.7951 15.4751C83.3795 15.1082 83.7987 14.8374 84.5838 15.3007C84.7255 15.3849 84.8672 15.4751 85.0148 15.5774C85.859 16.1309 86.9098 16.8227 88.8402 16.5339C90.2571 16.3234 90.3751 15.5594 90.5227 14.5908C90.5404 14.4885 90.5581 14.3742 90.5759 14.2599C90.7234 13.3816 90.8238 11.9738 90.9183 10.6082C90.9891 9.61559 91.0836 8.26802 91.2016 7.41977C91.5913 9.31479 91.9041 12.9424 92.0399 14.5427C92.0694 14.8976 92.0931 15.1563 92.1049 15.2706C92.1285 15.4751 92.1344 16.0466 92.1462 16.7144C92.2052 20.6007 92.3292 21.6716 92.766 21.9303C92.8723 21.9964 92.9904 22.0085 93.1085 21.9784H93.2619H93.3033C93.5807 21.9483 93.7047 21.6956 93.9231 21.0038C94.0825 20.4985 94.2478 19.8487 94.36 19.3915C94.5902 18.453 94.909 17.0092 94.909 16.7445C94.909 16.4437 95.0094 16.3474 95.0448 16.3174C95.275 16.1008 95.8418 16.1549 96.2137 16.191C96.3613 16.2031 96.4852 16.2151 96.5915 16.2151C96.8335 16.2151 97.0638 16.2151 97.2822 16.2211C98.5692 16.2331 99.5905 16.2452 100.99 15.7759C101.958 15.4511 102.743 14.1637 103.499 12.9123C103.959 12.1543 104.396 11.4324 104.797 11.0775C105.033 10.8609 105.258 10.7707 105.488 10.8007C106.185 10.885 106.958 12.0039 107.702 13.0868C108.587 14.3682 109.502 15.6977 110.606 15.7699C111.504 15.8301 112.1 15.5834 112.578 15.3789C112.879 15.2525 113.121 15.1503 113.375 15.1503C114.432 15.1503 115.164 14.9457 115.748 14.7833C116.156 14.669 116.48 14.5788 116.764 14.6088C117.325 14.663 117.986 14.9096 118.629 15.1503C119.284 15.3969 119.963 15.6436 120.589 15.7218L121.008 15.7699C122.956 16.0045 124.025 16.1309 126.144 15.9865C126.451 15.9624 126.835 15.9865 127.242 16.0106C127.874 16.0466 128.529 16.0827 129.049 15.9684C129.45 15.8782 129.775 15.6676 130.088 15.4691C130.672 15.1021 131.091 14.8314 131.877 15.2947C132.018 15.3789 132.16 15.4691 132.308 15.5714C133.152 16.1249 134.203 16.8167 136.133 16.5279C137.55 16.3174 137.668 15.5533 137.816 14.5848C137.833 14.4825 137.851 14.3682 137.869 14.2539C138.016 13.3756 138.117 11.9678 138.211 10.6082C138.282 9.61559 138.376 8.26802 138.494 7.41977C138.884 9.31479 139.197 12.9424 139.333 14.5427C139.362 14.8976 139.386 15.1563 139.398 15.2706C139.421 15.4751 139.427 16.0466 139.439 16.7144C139.498 20.6007 139.622 21.6716 140.059 21.9303C140.165 21.9964 140.283 22.0085 140.401 21.9784H140.555H140.596C140.874 21.9483 140.997 21.6956 141.216 21.0038C141.375 20.4985 141.541 19.8487 141.653 19.3915C141.883 18.453 142.202 17.0092 142.202 16.7445C142.202 16.4437 142.302 16.3474 142.338 16.3174C142.568 16.1008 143.135 16.1549 143.506 16.191C143.654 16.2031 143.778 16.2151 143.89 16.2151C144.132 16.2151 144.362 16.2151 144.581 16.2211C145.868 16.2331 146.889 16.2452 148.288 15.7759C149.256 15.4511 150.042 14.1637 150.797 12.9123C151.258 12.1543 151.695 11.4324 152.096 11.0775C152.332 10.8609 152.557 10.7707 152.787 10.8007C153.483 10.885 154.257 12.0039 155.001 13.0868C155.886 14.3682 156.801 15.6977 157.905 15.7699C158.802 15.8301 159.399 15.5834 159.877 15.3789C160.178 15.2525 160.42 15.1503 160.674 15.1503C161.731 15.1503 162.463 14.9457 163.047 14.7833C163.454 14.669 163.779 14.5788 164.062 14.6088C164.623 14.663 165.284 14.9096 165.928 15.1503C166.583 15.3969 167.262 15.6436 167.888 15.7218L168.307 15.7699C170.255 16.0045 171.324 16.1309 173.443 15.9865C173.75 15.9624 174.134 15.9865 174.541 16.0106C175.173 16.0466 175.828 16.0827 176.348 15.9684C176.749 15.8782 177.074 15.6676 177.387 15.4691C177.971 15.1021 178.39 14.8314 179.175 15.2947C179.317 15.3789 179.459 15.4691 179.606 15.5714C180.45 16.1249 181.501 16.8167 183.432 16.5279C184.849 16.3174 184.967 15.5533 185.114 14.5848C185.132 14.4825 185.15 14.3682 185.167 14.2539C185.315 13.3756 185.415 11.9678 185.51 10.6082C185.581 9.61559 185.675 8.26802 185.793 7.41977C186.183 9.31479 186.496 12.9424 186.631 14.5427C186.661 14.8976 186.685 15.1563 186.696 15.2706C186.72 15.4751 186.726 16.0466 186.738 16.7144C186.797 20.6007 186.921 21.6716 187.358 21.9303C187.499 22.0145 187.659 22.0145 187.806 21.9363L187.877 21.9002L187.924 21.834C188.273 21.3527 188.302 20.5526 188.338 19.6201C188.379 18.4651 188.426 17.1536 189.14 16.546C189.542 16.2031 190.132 16.0888 190.953 16.2031L190.976 16.2091H191V15.4872C189.914 15.3729 189.135 15.5413 188.591 16.0106Z"
          fill="#00C2FD"
        />
      </g>
      <path
        d="M3.168 0.28C3.69067 0.28 4.16267 0.402666 4.584 0.648C5.01067 0.893333 5.344 1.23733 5.584 1.68C5.82933 2.11733 5.952 2.61333 5.952 3.168C5.952 3.72267 5.82933 4.22133 5.584 4.664C5.344 5.10133 5.01067 5.44533 4.584 5.696C4.16267 5.94133 3.69067 6.064 3.168 6.064C2.64 6.064 2.16267 5.94133 1.736 5.696C1.31467 5.44533 0.981333 5.10133 0.736 4.664C0.490667 4.22133 0.368 3.72267 0.368 3.168C0.368 2.61333 0.490667 2.11733 0.736 1.68C0.981333 1.23733 1.31467 0.893333 1.736 0.648C2.16267 0.402666 2.64 0.28 3.168 0.28ZM3.168 1.128C2.80533 1.128 2.48267 1.21067 2.2 1.376C1.91733 1.54133 1.696 1.77867 1.536 2.088C1.38133 2.39733 1.304 2.75733 1.304 3.168C1.304 3.57867 1.38133 3.93867 1.536 4.248C1.696 4.55733 1.91733 4.79467 2.2 4.96C2.48267 5.12533 2.80533 5.208 3.168 5.208C3.52533 5.208 3.84267 5.12533 4.12 4.96C4.40267 4.79467 4.62133 4.55733 4.776 4.248C4.936 3.93867 5.016 3.57867 5.016 3.168C5.016 2.75733 4.936 2.39733 4.776 2.088C4.62133 1.77867 4.40267 1.54133 4.12 1.376C3.84267 1.21067 3.52533 1.128 3.168 1.128ZM10.0963 6L8.74431 3.912L7.53631 6H6.48831L8.24031 3.12L6.44831 0.352H7.53631L8.86431 2.4L10.0643 0.352H11.1123L9.36831 3.184L11.1843 6H10.0963ZM16.1285 0.352L14.2485 3.944V6H13.3285V3.944L11.4405 0.352H12.4965L13.7925 2.968L15.0885 0.352H16.1285ZM19.3938 0.304C20.0658 0.304 20.6258 0.469333 21.0738 0.8C21.5218 1.13067 21.8178 1.58133 21.9618 2.152H21.0018C20.8791 1.848 20.6765 1.60533 20.3938 1.424C20.1165 1.24267 19.7858 1.152 19.4018 1.152C19.0498 1.152 18.7325 1.23467 18.4498 1.4C18.1725 1.56533 17.9538 1.8 17.7938 2.104C17.6391 2.408 17.5618 2.76533 17.5618 3.176C17.5618 3.608 17.6418 3.97867 17.8018 4.288C17.9618 4.59733 18.1858 4.83467 18.4738 5C18.7671 5.16 19.1058 5.24 19.4898 5.24C19.9591 5.24 20.3618 5.096 20.6978 4.808C21.0338 4.51467 21.2365 4.11467 21.3058 3.608H19.2338V2.936H22.0738V3.808C22.0098 4.224 21.8605 4.60267 21.6258 4.944C21.3965 5.28 21.0898 5.54933 20.7058 5.752C20.3271 5.95467 19.8925 6.056 19.4018 6.056C18.8525 6.056 18.3671 5.93333 17.9458 5.688C17.5245 5.44267 17.1991 5.104 16.9698 4.672C16.7405 4.23467 16.6258 3.736 16.6258 3.176C16.6258 2.616 16.7405 2.12 16.9698 1.688C17.1991 1.25067 17.5218 0.912 17.9378 0.672C18.3591 0.426667 18.8445 0.304 19.3938 0.304ZM23.9093 1.088V2.8H25.9893V3.504H23.9093V5.256H26.2293V6H22.9973V0.352H26.2293V1.088H23.9093ZM31.6825 6H30.7705L28.0265 1.832V6H27.1145V0.36H28.0265L30.7705 4.544V0.36H31.6825V6Z"
        fill="#00C2FD"
      />
      <defs>
        <clipPath id="clip0_11927_28637">
          <rect
            width="188"
            height="16"
            fill="white"
            transform="translate(0 6)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const BPIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="190"
      height="26"
      viewBox="0 0 190 26"
      fill="none"
    >
      <g clip-path="url(#clip0_11912_28546)">
        <path
          d="M3.496 3.088C3.83733 3.15733 4.112 3.32 4.32 3.576C4.53333 3.832 4.64 4.13067 4.64 4.472C4.64 4.94133 4.48267 5.31467 4.168 5.592C3.85333 5.864 3.39733 6 2.8 6H0.552V0.352H2.76C3.32533 0.352 3.75733 0.48 4.056 0.736C4.36 0.986667 4.512 1.33333 4.512 1.776C4.512 2.13333 4.41867 2.424 4.232 2.648C4.04533 2.86667 3.8 3.01333 3.496 3.088ZM1.464 2.784H2.592C2.912 2.784 3.15467 2.70933 3.32 2.56C3.49067 2.41067 3.576 2.20267 3.576 1.936C3.576 1.67467 3.49067 1.46933 3.32 1.32C3.15467 1.17067 2.90133 1.096 2.56 1.096H1.464V2.784ZM2.616 5.248C2.96267 5.248 3.22933 5.17067 3.416 5.016C3.608 4.856 3.704 4.63467 3.704 4.352C3.704 4.06933 3.608 3.848 3.416 3.688C3.224 3.528 2.95467 3.448 2.608 3.448H1.464V5.248H2.616ZM6.40931 3.808V6H5.49731V0.352H7.41731C8.06798 0.352 8.55598 0.506667 8.88131 0.816C9.21198 1.12533 9.37731 1.54933 9.37731 2.088C9.37731 2.62133 9.20931 3.04267 8.87331 3.352C8.53731 3.656 8.05198 3.808 7.41731 3.808H6.40931ZM7.32131 3.064C8.07331 3.064 8.44931 2.73867 8.44931 2.088C8.44931 1.768 8.35865 1.52533 8.17731 1.36C8.00131 1.18933 7.71598 1.104 7.32131 1.104H6.40931V3.064H7.32131Z"
          fill="#FD270C"
        />
        <path
          d="M4 23.2554C11.9533 23.2554 25.5 21.4998 34.442 9.32424C43.5 -2 73.1116 18.0957 79.6937 20.6755C89.5667 23.9434 111.699 26.2483 121.243 9.32424C135.641 -5.63969 168.551 35.6389 192 20.6755"
          stroke="#FD270C"
        />
      </g>
      <defs>
        <clipPath id="clip0_11912_28546">
          <rect width="190" height="26" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const TempIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="192"
      height="24"
      viewBox="0 0 192 24"
      fill="none"
    >
      <g clip-path="url(#clip0_11912_28558)">
        <path
          d="M6.184 2.352V3.088H4.608V8H3.688V3.088H2.12V2.352H6.184ZM7.7765 3.088V4.8H9.8565V5.504H7.7765V7.256H10.0965V8H6.8645V2.352H10.0965V3.088H7.7765ZM16.8377 2.44V8H15.9177V3.832L14.3097 8H13.5097L11.8937 3.832V8H10.9817V2.44H12.0857L13.9257 6.88L15.7337 2.44H16.8377ZM18.8468 5.808V8H17.9348V2.352H19.8548C20.5055 2.352 20.9935 2.50667 21.3188 2.816C21.6495 3.12533 21.8148 3.54933 21.8148 4.088C21.8148 4.62133 21.6468 5.04267 21.3108 5.352C20.9748 5.656 20.4895 5.808 19.8548 5.808H18.8468ZM19.7588 5.064C20.5108 5.064 20.8868 4.73867 20.8868 4.088C20.8868 3.768 20.7961 3.52533 20.6148 3.36C20.4388 3.18933 20.1535 3.104 19.7588 3.104H18.8468V5.064H19.7588Z"
          fill="white"
        />
        <path
          d="M6.184 2.352V3.088H4.608V8H3.688V3.088H2.12V2.352H6.184ZM7.7765 3.088V4.8H9.8565V5.504H7.7765V7.256H10.0965V8H6.8645V2.352H10.0965V3.088H7.7765ZM16.8377 2.44V8H15.9177V3.832L14.3097 8H13.5097L11.8937 3.832V8H10.9817V2.44H12.0857L13.9257 6.88L15.7337 2.44H16.8377ZM18.8468 5.808V8H17.9348V2.352H19.8548C20.5055 2.352 20.9935 2.50667 21.3188 2.816C21.6495 3.12533 21.8148 3.54933 21.8148 4.088C21.8148 4.62133 21.6468 5.04267 21.3108 5.352C20.9748 5.656 20.4895 5.808 19.8548 5.808H18.8468ZM19.7588 5.064C20.5108 5.064 20.8868 4.73867 20.8868 4.088C20.8868 3.768 20.7961 3.52533 20.6148 3.36C20.4388 3.18933 20.1535 3.104 19.7588 3.104H18.8468V5.064H19.7588Z"
          fill="white"
        />
        <path
          d="M192.591 18.0106C191.641 18.8227 191.588 20.3026 191.541 21.6081C191.529 21.8788 191.523 22.1495 191.499 22.4022C191.476 22.1856 191.458 21.9209 191.44 21.5961C191.387 20.6696 191.369 19.5867 191.358 18.7204C191.346 17.9805 191.34 17.4451 191.316 17.2104C191.304 17.0961 191.281 16.8435 191.251 16.4945C191.104 14.786 190.767 10.7854 190.33 8.95052C190.319 8.90239 190.307 8.84825 190.301 8.78809C190.242 8.51737 190.153 8.01203 189.681 8.01203C189.238 8.01203 189.097 8.53542 188.961 9.63634C188.866 10.4365 188.79 11.5133 188.713 12.5601C188.618 13.9017 188.518 15.2913 188.376 16.1396C188.359 16.2599 188.341 16.3742 188.323 16.4825C188.181 17.409 188.14 17.6917 187.237 17.8241C185.566 18.0707 184.681 17.4872 183.901 16.9698C183.742 16.8675 183.594 16.7713 183.441 16.675C182.29 15.9892 181.534 16.4705 180.926 16.8555C180.649 17.03 180.389 17.1984 180.106 17.2646C179.686 17.3608 179.084 17.3247 178.5 17.2947C178.069 17.2706 177.667 17.2465 177.313 17.2706C175.259 17.415 174.273 17.2947 172.307 17.054L171.888 17.0059C171.345 16.9397 170.707 16.7051 170.087 16.4765C169.403 16.2238 168.7 15.9591 168.051 15.8929C167.637 15.8508 167.236 15.9651 166.781 16.0915C166.238 16.2419 165.559 16.4344 164.597 16.4344C164.207 16.4344 163.877 16.5727 163.534 16.7171C163.08 16.9096 162.613 17.1021 161.881 17.054C161.114 16.9999 160.258 15.7666 159.508 14.6717C158.635 13.4023 157.808 12.2052 156.799 12.0848C156.368 12.0307 155.948 12.1871 155.559 12.536C155.081 12.9632 154.62 13.7272 154.13 14.5333C153.469 15.6222 152.719 16.8495 151.999 17.0901C150.706 17.5233 149.744 17.5112 148.516 17.4992C148.292 17.4992 148.061 17.4932 147.819 17.4932C147.743 17.4932 147.625 17.4811 147.501 17.4691C146.975 17.421 146.255 17.3548 145.794 17.7819C145.552 18.0106 145.428 18.3294 145.428 18.7385C145.411 19.1476 144.679 22.2939 144.348 23.1722C144.295 22.9557 144.224 22.5105 144.171 21.584C144.118 20.6576 144.1 19.5747 144.088 18.7084C144.077 17.9684 144.071 17.433 144.047 17.1984C144.035 17.0841 144.012 16.8314 143.982 16.4825C143.835 14.774 143.498 10.7734 143.061 8.93849C143.049 8.89036 143.038 8.83622 143.032 8.77606C142.984 8.50534 142.89 8 142.418 8C141.975 8 141.833 8.52339 141.697 9.62431C141.603 10.4244 141.526 11.5013 141.45 12.5481C141.355 13.8896 141.255 15.2793 141.113 16.1276C141.095 16.2479 141.078 16.3622 141.06 16.4705C140.918 17.3969 140.877 17.6797 139.974 17.812C138.303 18.0587 137.417 17.4751 136.638 16.9578C136.479 16.8555 136.331 16.7592 136.178 16.663C135.027 15.9772 134.271 16.4584 133.663 16.8435C133.385 17.0179 133.126 17.1864 132.842 17.2525C132.423 17.3488 131.821 17.3127 131.236 17.2826C130.806 17.2586 130.404 17.2345 130.05 17.2586C127.995 17.4029 127.01 17.2826 125.044 17.042L124.625 16.9939C124.081 16.9277 123.444 16.6931 122.824 16.4645C122.139 16.2118 121.437 15.9471 120.787 15.8809C120.374 15.8388 119.973 15.9531 119.518 16.0794C118.975 16.2298 118.296 16.4223 117.334 16.4223C116.944 16.4223 116.614 16.5607 116.271 16.7051C115.817 16.8976 115.35 17.0901 114.618 17.042C113.851 16.9878 112.995 15.7546 112.245 14.6597C111.371 13.3903 110.545 12.1931 109.535 12.0728C109.104 12.0187 108.685 12.1751 108.296 12.524C107.817 12.9511 107.357 13.7152 106.867 14.5213C106.206 15.6102 105.456 16.8374 104.736 17.0781C103.443 17.5112 102.481 17.4992 101.253 17.4872C101.028 17.4872 100.798 17.4811 100.556 17.4811C100.479 17.4811 100.361 17.4691 100.237 17.4571C99.7119 17.409 98.9917 17.3428 98.5312 17.7699C98.2891 17.9985 98.1652 18.3174 98.1652 18.7265C98.1475 19.1355 97.4154 22.2819 97.0848 23.1602C97.0317 22.9436 96.9609 22.4985 96.9077 21.572C96.8546 20.6455 96.8369 19.5627 96.8251 18.6964C96.8133 17.9564 96.8074 17.421 96.7838 17.1864C96.772 17.0721 96.7483 16.8194 96.7188 16.4705C96.5712 14.7619 96.2347 10.7613 95.7979 8.92646C95.7861 8.87833 95.7743 8.82419 95.7625 8.76403C95.6975 8.51737 95.6031 8.01203 95.1367 8.01203C94.6939 8.01203 94.5522 8.53542 94.4165 9.63634C94.322 10.4304 94.2453 11.5133 94.1685 12.5601C94.0741 13.9017 93.9737 15.2913 93.832 16.1396C93.8143 16.2599 93.7966 16.3742 93.7789 16.4825C93.6372 17.409 93.5959 17.6917 92.6926 17.8241C91.022 18.0707 90.1364 17.4872 89.3572 16.9698C89.1978 16.8675 89.0502 16.7713 88.8967 16.675C87.7455 15.9892 86.9899 16.4705 86.3818 16.8555C86.1044 17.03 85.8446 17.1984 85.5612 17.2646C85.1421 17.3608 84.5399 17.3247 83.9555 17.2947C83.5245 17.2706 83.1231 17.2465 82.7689 17.2706C80.7145 17.415 79.7286 17.2947 77.7627 17.054L77.3436 17.0059C76.8005 16.9397 76.1629 16.7051 75.543 16.4765C74.8582 16.2238 74.1557 15.9591 73.5063 15.8929C73.0931 15.8508 72.6916 15.9651 72.2371 16.0915C71.694 16.2419 71.0151 16.4344 70.0528 16.4344C69.6632 16.4344 69.3326 16.5727 68.9902 16.7171C68.5356 16.9096 68.0692 17.1021 67.3372 17.054C66.5697 16.9999 65.7137 15.7666 64.964 14.6717C64.0903 13.4023 63.2638 12.2052 62.2543 12.0848C61.8233 12.0307 61.4042 12.1871 61.0146 12.536C60.5364 12.9632 60.0759 13.7272 59.5859 14.5333C58.9247 15.6222 58.175 16.8495 57.4548 17.0901C56.1619 17.5233 55.1996 17.5112 53.9717 17.4992C53.7474 17.4992 53.5171 17.4932 53.2751 17.4932C53.1983 17.4932 53.0803 17.4811 52.9563 17.4691C52.4309 17.421 51.7107 17.3548 51.2502 17.7819C51.0082 18.0106 50.8842 18.3294 50.8842 18.7385C50.8665 19.1476 50.1344 22.2939 49.8038 23.1722C49.7507 22.9557 49.6799 22.5105 49.6267 21.584C49.5736 20.6576 49.5559 19.5747 49.5441 18.7084C49.5323 17.9684 49.5264 17.433 49.5028 17.1984C49.491 17.0841 49.4673 16.8314 49.4378 16.4825C49.2902 14.774 48.9537 10.7734 48.5169 8.93849C48.5051 8.89036 48.4933 8.83622 48.4874 8.77606C48.4224 8.51737 48.3339 8.01203 47.8616 8.01203C47.4188 8.01203 47.2772 8.53542 47.1414 9.63634C47.0469 10.4304 46.9702 11.5133 46.8934 12.5601C46.799 13.9017 46.6986 15.2913 46.5569 16.1396C46.5392 16.2599 46.5215 16.3742 46.5038 16.4825C46.3621 17.409 46.3208 17.6917 45.4176 17.8241C43.7469 18.0707 42.8613 17.4872 42.0821 16.9698C41.9227 16.8675 41.7751 16.7713 41.6216 16.675C40.4704 15.9892 39.7148 16.4705 39.1067 16.8555C38.8293 17.03 38.5695 17.1984 38.2861 17.2646C37.867 17.3608 37.2648 17.3247 36.6804 17.2947C36.2494 17.2706 35.848 17.2465 35.4938 17.2706C33.4394 17.415 32.4535 17.2947 30.4876 17.054L30.0685 17.0059C29.5254 16.9397 28.8878 16.7051 28.2679 16.4765C27.5831 16.2238 26.8806 15.9591 26.2312 15.8929C25.818 15.8508 25.4166 15.9651 24.962 16.0915C24.4189 16.2419 23.74 16.4344 22.7777 16.4344C22.3881 16.4344 22.0575 16.5727 21.7151 16.7171C21.2605 16.9096 20.7941 17.1021 20.0621 17.054C19.2946 16.9999 18.4386 15.7666 17.6889 14.6717C16.8152 13.4023 15.9887 12.2052 14.9792 12.0848C14.5482 12.0307 14.1291 12.1871 13.7395 12.536C13.2613 12.9632 12.8008 13.7272 12.3108 14.5333C11.6496 15.6222 10.8999 16.8495 10.1797 17.0901C8.8868 17.5233 7.92454 17.5112 6.69661 17.4992C6.47818 17.4992 6.25975 17.4932 6.02361 17.4932C6.01771 17.4932 6.0059 17.4932 6 17.4932V18.2151C6.24204 18.2151 6.47228 18.2151 6.69071 18.2211C7.97767 18.2331 8.99897 18.2452 10.3981 17.7759C11.3663 17.4511 12.1514 16.1637 12.9071 14.9123C13.3675 14.1543 13.8044 13.4324 14.2058 13.0775C14.442 12.8609 14.6663 12.7707 14.8965 12.8007C15.5932 12.885 16.3665 14.0039 17.1104 15.0868C17.9959 16.3682 18.9109 17.6977 20.0149 17.7699C20.9122 17.8301 21.5084 17.5834 21.9866 17.3789C22.2877 17.2525 22.5298 17.1503 22.7836 17.1503C23.8403 17.1503 24.5724 16.9457 25.1568 16.7833C25.5641 16.669 25.8888 16.5788 26.1722 16.6088C26.733 16.663 27.3942 16.9096 28.0377 17.1503C28.693 17.3969 29.3719 17.6436 29.9977 17.7218L30.4168 17.7699C32.365 18.0045 33.4335 18.1309 35.5528 17.9865C35.8598 17.9624 36.2435 17.9865 36.6509 18.0106C37.2826 18.0466 37.9378 18.0827 38.4574 17.9684C38.8588 17.8782 39.1835 17.6676 39.4964 17.4691C40.0808 17.1021 40.5 16.8314 41.2851 17.2947C41.4268 17.3789 41.5685 17.4691 41.7161 17.5714C42.5603 18.1249 43.6111 18.8167 45.5415 18.5279C46.9584 18.3174 47.0764 17.5533 47.224 16.5848C47.2417 16.4825 47.2594 16.3682 47.2772 16.2539C47.4247 15.3756 47.5251 13.9678 47.6196 12.6082C47.6904 11.6156 47.7849 10.268 47.9029 9.41977C48.2926 11.3148 48.6054 14.9484 48.7412 16.5487C48.7707 16.9036 48.7943 17.1563 48.8062 17.2766C48.8298 17.4811 48.8357 18.0527 48.8475 18.7204C48.9065 22.6067 49.0305 23.6776 49.4673 23.9363C49.5736 24.0024 49.6917 24.0145 49.8097 23.9844H49.9632H50.0046C50.282 23.9543 50.406 23.7016 50.6244 23.0098C50.7838 22.5045 50.9491 21.8547 51.0613 21.3975C51.2915 20.459 51.6103 19.0152 51.6103 18.7505C51.6103 18.4497 51.7107 18.3535 51.7461 18.3234C51.9763 18.1068 52.5372 18.161 52.915 18.197C53.0626 18.2091 53.1865 18.2211 53.2987 18.2211C53.5407 18.2211 53.771 18.2211 53.9894 18.2271C55.2764 18.2392 56.2977 18.2512 57.6968 17.7819C58.665 17.4571 59.4501 16.1697 60.2058 14.9183C60.6663 14.1603 61.1031 13.4384 61.5045 13.0835C61.7407 12.8669 61.965 12.7767 62.1953 12.8067C62.8919 12.891 63.6652 14.0099 64.4091 15.0928C65.2946 16.3742 66.2096 17.7037 67.3136 17.7759C68.2109 17.8361 68.8072 17.5894 69.2853 17.3849C69.5864 17.2586 69.8285 17.1563 70.0823 17.1563C71.139 17.1563 71.8711 16.9517 72.4555 16.7893C72.8629 16.675 73.1875 16.5848 73.4709 16.6148C74.0317 16.669 74.6929 16.9156 75.3364 17.1563C75.9917 17.4029 76.6706 17.6496 77.2964 17.7278L77.7155 17.7759C79.6637 18.0106 80.7322 18.1369 82.8515 17.9925C83.1585 17.9684 83.5422 17.9925 83.9496 18.0166C84.5813 18.0527 85.2365 18.0888 85.7561 17.9745C86.1575 17.8842 86.4822 17.6737 86.7951 17.4751C87.3795 17.1082 87.7987 16.8374 88.5838 17.3007C88.7255 17.3849 88.8672 17.4751 89.0148 17.5774C89.859 18.1309 90.9098 18.8227 92.8402 18.5339C94.2571 18.3234 94.3751 17.5594 94.5227 16.5908C94.5404 16.4885 94.5581 16.3742 94.5759 16.2599C94.7234 15.3816 94.8238 13.9738 94.9183 12.6082C94.9891 11.6156 95.0836 10.268 95.2016 9.41977C95.5913 11.3148 95.9041 14.9424 96.0399 16.5427C96.0694 16.8976 96.0931 17.1563 96.1049 17.2706C96.1285 17.4751 96.1344 18.0466 96.1462 18.7144C96.2052 22.6007 96.3292 23.6716 96.766 23.9303C96.8723 23.9964 96.9904 24.0085 97.1085 23.9784H97.2619H97.3033C97.5807 23.9483 97.7047 23.6956 97.9231 23.0038C98.0825 22.4985 98.2478 21.8487 98.36 21.3915C98.5902 20.453 98.909 19.0092 98.909 18.7445C98.909 18.4437 99.0094 18.3474 99.0448 18.3174C99.275 18.1008 99.8418 18.1549 100.214 18.191C100.361 18.2031 100.485 18.2151 100.592 18.2151C100.834 18.2151 101.064 18.2151 101.282 18.2211C102.569 18.2331 103.59 18.2452 104.99 17.7759C105.958 17.4511 106.743 16.1637 107.499 14.9123C107.959 14.1543 108.396 13.4324 108.797 13.0775C109.033 12.8609 109.258 12.7707 109.488 12.8007C110.185 12.885 110.958 14.0039 111.702 15.0868C112.587 16.3682 113.502 17.6977 114.606 17.7699C115.504 17.8301 116.1 17.5834 116.578 17.3789C116.879 17.2525 117.121 17.1503 117.375 17.1503C118.432 17.1503 119.164 16.9457 119.748 16.7833C120.156 16.669 120.48 16.5788 120.764 16.6088C121.325 16.663 121.986 16.9096 122.629 17.1503C123.284 17.3969 123.963 17.6436 124.589 17.7218L125.008 17.7699C126.956 18.0045 128.025 18.1309 130.144 17.9865C130.451 17.9624 130.835 17.9865 131.242 18.0106C131.874 18.0466 132.529 18.0827 133.049 17.9684C133.45 17.8782 133.775 17.6676 134.088 17.4691C134.672 17.1021 135.091 16.8314 135.877 17.2947C136.018 17.3789 136.16 17.4691 136.308 17.5714C137.152 18.1249 138.203 18.8167 140.133 18.5279C141.55 18.3174 141.668 17.5533 141.816 16.5848C141.833 16.4825 141.851 16.3682 141.869 16.2539C142.016 15.3756 142.117 13.9678 142.211 12.6082C142.282 11.6156 142.376 10.268 142.494 9.41977C142.884 11.3148 143.197 14.9424 143.333 16.5427C143.362 16.8976 143.386 17.1563 143.398 17.2706C143.421 17.4751 143.427 18.0466 143.439 18.7144C143.498 22.6007 143.622 23.6716 144.059 23.9303C144.165 23.9964 144.283 24.0085 144.401 23.9784H144.555H144.596C144.874 23.9483 144.997 23.6956 145.216 23.0038C145.375 22.4985 145.541 21.8487 145.653 21.3915C145.883 20.453 146.202 19.0092 146.202 18.7445C146.202 18.4437 146.302 18.3474 146.338 18.3174C146.568 18.1008 147.135 18.1549 147.506 18.191C147.654 18.2031 147.778 18.2151 147.89 18.2151C148.132 18.2151 148.362 18.2151 148.581 18.2211C149.868 18.2331 150.889 18.2452 152.288 17.7759C153.256 17.4511 154.042 16.1637 154.797 14.9123C155.258 14.1543 155.695 13.4324 156.096 13.0775C156.332 12.8609 156.557 12.7707 156.787 12.8007C157.483 12.885 158.257 14.0039 159.001 15.0868C159.886 16.3682 160.801 17.6977 161.905 17.7699C162.802 17.8301 163.399 17.5834 163.877 17.3789C164.178 17.2525 164.42 17.1503 164.674 17.1503C165.731 17.1503 166.463 16.9457 167.047 16.7833C167.454 16.669 167.779 16.5788 168.062 16.6088C168.623 16.663 169.284 16.9096 169.928 17.1503C170.583 17.3969 171.262 17.6436 171.888 17.7218L172.307 17.7699C174.255 18.0045 175.324 18.1309 177.443 17.9865C177.75 17.9624 178.134 17.9865 178.541 18.0106C179.173 18.0466 179.828 18.0827 180.348 17.9684C180.749 17.8782 181.074 17.6676 181.387 17.4691C181.971 17.1021 182.39 16.8314 183.175 17.2947C183.317 17.3789 183.459 17.4691 183.606 17.5714C184.45 18.1249 185.501 18.8167 187.432 18.5279C188.849 18.3174 188.967 17.5533 189.114 16.5848C189.132 16.4825 189.15 16.3682 189.167 16.2539C189.315 15.3756 189.415 13.9678 189.51 12.6082C189.581 11.6156 189.675 10.268 189.793 9.41977C190.183 11.3148 190.496 14.9424 190.631 16.5427C190.661 16.8976 190.685 17.1563 190.696 17.2706C190.72 17.4751 190.726 18.0466 190.738 18.7144C190.797 22.6007 190.921 23.6716 191.358 23.9303C191.499 24.0145 191.659 24.0145 191.806 23.9363L191.877 23.9002L191.924 23.834C192.273 23.3527 192.302 22.5526 192.338 21.6201C192.379 20.4651 192.426 19.1536 193.14 18.546C193.542 18.2031 194.132 18.0888 194.953 18.2031L194.976 18.2091H195V17.4872C193.914 17.3729 193.134 17.5413 192.591 18.0106Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_11912_28558">
          <rect width="192" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const HeadIcon = ({ fillColor }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
    >
      <circle cx="15" cy="15" r="15" fill={fillColor ? fillColor : "#8B8D95"} />
      <path
        d="M8.00408 16.0363C8.04597 16.2233 8.16933 16.3816 8.33923 16.4583C8.34855 16.4631 8.36018 16.4679 8.36715 16.4727L8.79307 16.6358C8.83962 16.6502 8.88384 16.6717 8.92573 16.6957C8.92108 16.7005 8.9141 16.7389 8.87685 16.8156L8.86755 16.8324C8.80238 16.9547 8.6674 17.2137 8.78841 17.4559C8.83729 17.5566 8.92341 17.6333 9.02581 17.6717L9.0421 17.6813C9.01882 17.7149 9.00021 17.7508 8.98159 17.7868C8.90014 17.9379 8.89082 18.1177 8.95366 18.2784C9.02581 18.4462 9.16778 18.5685 9.34 18.6165C9.37026 18.6261 9.40052 18.6309 9.43311 18.6309C9.40285 18.7651 9.37492 18.9066 9.35397 19.0529C9.27252 19.3934 9.31674 19.7531 9.47966 20.0625C9.6868 20.391 10.0662 20.554 10.5991 20.5492C10.7178 20.5468 10.8388 20.5397 10.9599 20.5325C11.3206 20.5109 11.6581 20.2519 11.9164 20.3886C11.9327 20.3982 11.9886 21.4557 12.0119 22H18.0515C18.0631 21.6979 18.0864 21.3957 18.1213 21.096C18.2656 20.072 18.4215 19.1464 19.022 18.252C19.5294 17.5398 19.9809 16.7892 20.3719 16.0051C20.8094 15.1035 21.0235 14.1059 20.9979 13.0988C20.9258 10.3292 19.6155 8.15662 17.0483 7.33893C14.8187 6.59317 12.2679 7.10392 10.6992 8.61702C9.84971 9.43473 8.88384 10.6433 9.10262 12.8974C9.10495 12.919 9.19106 14.0292 8.22053 15.3553C8.05762 15.5399 7.98081 15.7869 8.00408 16.0363Z"
        fill="white"
      />
    </svg>
  );
};

export const AverageScoreIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="34"
      height="40"
      viewBox="0 0 34 40"
      fill="none"
    >
      <path
        d="M23.225 19.6039C24.8529 18.4659 26.1651 16.8834 26.9698 14.9916C29.2758 14.0917 30.9139 11.8555 30.9139 9.24401C30.9139 5.83557 28.0994 2.99565 24.5728 3.07558C20.3698 -1.01828 13.6442 -1.0321 9.42716 3.07558C5.89921 2.99565 3.08613 5.83619 3.08613 9.24401C3.08613 11.8562 4.72511 14.093 7.0322 14.9924C7.83714 16.8806 9.15113 18.4635 10.7802 19.6018C4.59887 22.0183 0 28.0608 0 35.3645V38.4375C0 39.3004 0.702545 40 1.56923 40H32.4308C33.2975 40 34 39.3004 34 38.4375V35.3645C34 28.0852 29.4239 22.0296 23.225 19.6039ZM17.0204 29.0521L13.218 22.0844C15.7084 21.3802 18.3883 21.3838 20.9042 22.1204L17.0204 29.0521ZM27.7754 9.24401C27.7754 10.9241 26.4027 12.291 24.7154 12.291C23.0281 12.291 21.6554 10.9241 21.6554 9.24401C21.6554 7.56389 23.0281 6.19706 24.7154 6.19706C26.4027 6.19706 27.7754 7.56397 27.7754 9.24401ZM21.0483 4.27201C19.9208 5.09875 19.0832 6.29558 18.7187 7.68147H15.2814C14.9169 6.29558 14.0794 5.09875 12.9517 4.27201C15.4341 2.7415 18.5664 2.74174 21.0483 4.27201ZM9.2846 6.19706C10.9719 6.19706 12.3446 7.56389 12.3446 9.24401C12.3446 10.9241 10.9719 12.291 9.2846 12.291C7.59728 12.291 6.22459 10.9241 6.22459 9.24401C6.22459 7.56389 7.59728 6.19706 9.2846 6.19706ZM10.7496 15.2404C12.9578 14.7054 14.7069 12.9907 15.2813 10.8066H18.7187C19.2932 12.9914 21.0432 14.7063 23.2523 15.2409C20.1903 19.4966 13.8241 19.5015 10.7496 15.2404ZM3.13846 35.3645C3.13846 30.1717 6.03378 25.6402 10.301 23.2846L15.4329 32.6886V36.8749H3.13846V35.3645ZM30.8615 36.8749H18.5715V32.6979L23.8108 23.3469C28.0168 25.7195 30.8616 30.2172 30.8616 35.3645V36.8749H30.8615Z"
        fill="#026A26"
      />
    </svg>
  );
};

export const ActivityIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="38"
      height="38"
      viewBox="0 0 38 38"
      fill="none"
    >
      <path
        d="M23.6667 5.00065C24.403 5.00065 25 4.40369 25 3.66732C25 2.93094 24.403 2.33398 23.6667 2.33398H18.253C14.9879 2.33397 12.4286 2.33397 10.3982 2.55395C8.32612 2.77845 6.64722 3.24478 5.21376 4.28625C4.34594 4.91676 3.58277 5.67992 2.95227 6.54773C1.91079 7.9812 1.44446 9.6601 1.21996 11.7322C0.999982 13.7626 0.999983 16.3219 1 19.587V19.7477C0.999983 23.0127 0.999982 25.572 1.21996 27.6024C1.44446 29.6746 1.91079 31.3534 2.95227 32.787C3.58277 33.6547 4.34594 34.4179 5.21374 35.0483C6.64722 36.0899 8.32612 36.5562 10.3982 36.7807C12.4286 37.0007 14.9879 37.0007 18.2528 37.0007H18.4139C21.6788 37.0007 24.238 37.0007 26.2684 36.7807C28.3406 36.5562 30.0194 36.0899 31.453 35.0483C32.3207 34.4179 33.0839 33.6547 33.7143 32.787C34.7559 31.3534 35.2222 29.6746 35.4468 27.6024C35.6667 25.572 35.6667 23.0127 35.6667 19.7479V14.334C35.6667 13.5976 35.0697 13.0007 34.3333 13.0007C33.597 13.0007 33 13.5976 33 14.334V19.6673C33 23.0302 32.9982 25.4451 32.7956 27.3153C32.5956 29.1605 32.2132 30.3164 31.557 31.2195C31.091 31.8609 30.5269 32.425 29.8855 32.891C28.9824 33.5471 27.8265 33.9295 25.9813 34.1295C24.1111 34.3322 21.6962 34.334 18.3333 34.334C14.9705 34.334 12.5555 34.3322 10.6854 34.1295C8.84023 33.9295 7.6843 33.5471 6.78117 32.891C6.13975 32.425 5.57568 31.8609 5.10965 31.2195C4.45349 30.3164 4.07102 29.1605 3.87111 27.3153C3.6685 25.4451 3.66667 23.0302 3.66667 19.6673C3.66667 16.3045 3.6685 13.8895 3.87111 12.0194C4.07102 10.1742 4.45349 9.01829 5.10965 8.11516C5.57568 7.47374 6.13975 6.90966 6.78117 6.44364C7.6843 5.78748 8.84023 5.40501 10.6854 5.2051C12.5555 5.00248 14.9705 5.00065 18.3333 5.00065H23.6667Z"
        fill="#026A26"
        stroke="#026A26"
      />
      <path
        d="M8.24594 24.159C7.92164 24.8201 8.19469 25.6191 8.85581 25.9433C9.51693 26.2676 10.3158 25.9945 10.6401 25.3334L13.2362 20.0409C14.0409 18.4004 16.406 18.4806 17.0978 20.1718C18.6608 23.9922 24.0037 24.1732 25.8217 20.4673L28.4179 15.1747C28.7422 14.5136 28.4691 13.7148 27.808 13.3905C27.1468 13.0662 26.3481 13.3392 26.0236 14.0003L23.4275 19.2929C22.6229 20.9334 20.2578 20.8532 19.566 19.162C18.003 15.3415 12.66 15.1605 10.8421 18.8665L8.24594 24.159Z"
        fill="#026A26"
        stroke="#026A26"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M28.1094 5.44444C28.1094 7.89904 30.0992 9.88889 32.5538 9.88889C35.0084 9.88889 36.9983 7.89904 36.9983 5.44444C36.9983 2.98985 35.0084 1 32.5538 1C30.0992 1 28.1094 2.98985 28.1094 5.44444ZM30.776 5.44444C30.776 6.42628 31.572 7.22222 32.5538 7.22222C33.5357 7.22222 34.3316 6.42628 34.3316 5.44444C34.3316 4.46261 33.5357 3.66667 32.5538 3.66667C31.572 3.66667 30.776 4.46261 30.776 5.44444Z"
        fill="#026A26"
        stroke="#026A26"
      />
    </svg>
  );
};

export const ScoopDummyIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="203"
      height="27"
      viewBox="0 0 203 27"
      fill="none"
    >
      <path
        d="M3.776 0.36V0.952H1.312V2.904H3.4V3.472H1.312V6H0.584V0.36H3.776ZM7.13469 0.304C7.82269 0.304 8.39069 0.474667 8.83869 0.816C9.28669 1.152 9.59602 1.61333 9.76669 2.2H8.99869C8.85469 1.82667 8.62269 1.53067 8.30269 1.312C7.98269 1.088 7.59069 0.976 7.12669 0.976C6.75869 0.976 6.42802 1.06667 6.13469 1.248C5.84669 1.424 5.61735 1.68 5.44669 2.016C5.28135 2.34667 5.19869 2.736 5.19869 3.184C5.19869 3.62667 5.28135 4.01333 5.44669 4.344C5.61735 4.67467 5.84669 4.93067 6.13469 5.112C6.42802 5.288 6.75869 5.376 7.12669 5.376C7.59069 5.376 7.98269 5.26667 8.30269 5.048C8.62269 4.824 8.85469 4.52533 8.99869 4.152H9.76669C9.59602 4.73867 9.28669 5.20267 8.83869 5.544C8.39069 5.88 7.82269 6.048 7.13469 6.048C6.60669 6.048 6.14002 5.928 5.73469 5.688C5.32935 5.44267 5.01202 5.104 4.78269 4.672C4.55869 4.23467 4.44669 3.73867 4.44669 3.184C4.44669 2.624 4.55869 2.12533 4.78269 1.688C5.01202 1.25067 5.32935 0.912 5.73469 0.672C6.14002 0.426667 6.60669 0.304 7.13469 0.304Z"
        fill="#16EF27"
      />
      <g clip-path="url(#clip0_13361_34148)">
        <path
          d="M200.995 19.7749H191.329C191.062 19.7749 190.812 19.8805 190.654 20.0565L190.218 20.5493L188.976 16.994C188.845 16.6244 188.458 16.3603 187.984 16.3207C187.516 16.2811 187.063 16.4748 186.84 16.8136L185.881 18.2744C185.445 18.9433 185.157 19.6561 185.026 20.4041L184.982 20.6461L184.181 0.64728C184.165 0.290865 183.811 0.00485272 183.37 0.00045253C182.928 -0.012748 182.558 0.264464 182.525 0.620879L180.814 19.3657L180.057 18.6044C179.73 18.2744 179.24 18.094 178.717 18.1116C178.194 18.1292 177.725 18.336 177.431 18.6836L177.093 19.0841L176.968 18.8113C176.45 17.7024 175.486 16.7432 174.249 16.1095L173.165 15.5507C172.598 15.2603 171.896 15.1679 171.247 15.3043C170.594 15.4407 170.038 15.7883 169.711 16.2635L168.861 17.5132L167.483 17.5924C166.725 17.6364 166.012 17.9004 165.478 18.336L164.159 19.4009C163.876 19.6297 163.451 19.7749 163.064 19.7749H151.65C151.383 19.7749 151.132 19.8805 150.974 20.0565L150.539 20.5493L149.296 16.994C149.166 16.6244 148.779 16.3603 148.305 16.3207C147.831 16.2811 147.384 16.4748 147.161 16.8136L146.202 18.2744C145.766 18.9433 145.477 19.6561 145.346 20.4041L145.303 20.6461L144.497 0.64728C144.48 0.290865 144.126 0.00485272 143.685 0.00045253C143.243 -0.012748 142.873 0.264464 142.84 0.620879L141.13 19.3657L140.372 18.6044C140.045 18.2744 139.555 18.094 139.032 18.1116C138.509 18.1292 138.04 18.336 137.746 18.6836L137.408 19.0841L137.283 18.8113C136.766 17.7024 135.801 16.7432 134.564 16.1095L133.48 15.5507C132.914 15.2603 132.211 15.1679 131.562 15.3043C130.909 15.4407 130.353 15.7883 130.026 16.2635L129.176 17.5132L127.798 17.5924C127.04 17.6364 126.327 17.9004 125.793 18.336L124.474 19.4009C124.191 19.6297 123.766 19.7749 123.379 19.7749H111.965C111.698 19.7749 111.448 19.8805 111.29 20.0565L110.854 20.5493L109.612 16.994C109.481 16.6244 109.094 16.3603 108.62 16.3207C108.146 16.2811 107.699 16.4748 107.476 16.8136L106.517 18.2744C106.081 18.9433 105.792 19.6561 105.662 20.4041L105.618 20.6461L104.812 0.64728C104.795 0.290865 104.441 0.00485272 104 0.00045253C103.559 -0.012748 103.188 0.264464 103.156 0.620879L101.445 19.3657L100.687 18.6044C100.361 18.2744 99.8702 18.094 99.3472 18.1116C98.8242 18.1292 98.3556 18.336 98.0614 18.6836L97.7236 19.0841L97.5983 18.8113C97.0807 17.7024 96.1164 16.7432 94.8797 16.1095L93.7955 15.5507C93.2289 15.2603 92.526 15.1679 91.8777 15.3043C91.2239 15.4407 90.6682 15.7883 90.3413 16.2635L89.4914 17.5132L88.113 17.5924C87.3557 17.6364 86.642 17.9004 86.108 18.336L84.7896 19.4009C84.5063 19.6297 84.0813 19.7749 83.6945 19.7749H72.2805C72.0135 19.7749 71.7629 19.8805 71.6049 20.0565L71.169 20.5493L69.9268 16.994C69.7961 16.6244 69.4093 16.3603 68.9353 16.3207C68.4613 16.2811 68.0145 16.4748 67.7911 16.8136L66.8322 18.2744C66.3964 18.9433 66.1076 19.6561 65.9769 20.4041L65.9333 20.6461L65.127 0.64728C65.1106 0.290865 64.7565 0.00485272 64.3152 0.00045253C63.8739 -0.012748 63.5034 0.264464 63.4707 0.620879L61.76 19.3657L61.0027 18.6044C60.6758 18.2744 60.1854 18.094 59.6624 18.1116C59.1394 18.1292 58.6708 18.336 58.3766 18.6836L58.0388 19.0841L57.9135 18.8113C57.3959 17.7024 56.4316 16.7432 55.1949 16.1095L54.1107 15.5507C53.5441 15.2603 52.8412 15.1679 52.1929 15.3043C51.5391 15.4407 50.9834 15.7883 50.6565 16.2635L49.7848 17.5132L48.4064 17.5924C47.6491 17.6364 46.9354 17.9004 46.4014 18.336L45.083 19.4009C44.7997 19.6297 44.3747 19.7749 43.9879 19.7749H32.5739C32.3069 19.7749 32.0563 19.8805 31.8983 20.0565L31.4624 20.5493L30.2202 16.994C30.0895 16.6244 29.7027 16.3603 29.2287 16.3207C28.7547 16.2811 28.3079 16.4748 28.0845 16.8136L27.1257 18.2744C26.6898 18.9433 26.401 19.6561 26.2703 20.4041L26.2267 20.6461L25.4258 0.64728C25.4095 0.290865 25.0553 0.00485272 24.614 0.00045253C24.1727 -0.012748 23.8022 0.264464 23.7696 0.620879L22.0588 19.3657L21.3015 18.6044C20.9746 18.2744 20.4843 18.094 19.9613 18.1116C19.4382 18.1292 18.9697 18.336 18.6755 18.6836L18.3377 19.0841L18.2124 18.8113C17.6948 17.7024 16.7305 16.7432 15.4937 16.1095L14.4095 15.5507C13.8429 15.2603 13.1401 15.1679 12.4917 15.3043C11.838 15.4407 11.2822 15.7883 10.9554 16.2635L10.0945 17.5132L8.71613 17.5924C7.95883 17.6364 7.24512 17.9004 6.71119 18.336L5.39272 19.4009C5.10942 19.6297 4.68446 19.7749 4.29763 19.7749H-4V20.9893H4.29763C5.08218 20.9893 5.89396 20.7165 6.45512 20.2589L7.77359 19.1941C8.0569 18.9653 8.42738 18.8289 8.83055 18.8025L10.574 18.7012C10.8518 18.6836 11.1025 18.556 11.2387 18.358L12.2629 16.8488C12.3882 16.664 12.6007 16.532 12.8568 16.4792C13.1128 16.4264 13.3744 16.4616 13.5977 16.576L14.6819 17.1348C15.6463 17.632 16.3981 18.38 16.8013 19.2425L17.3842 20.4877C17.4932 20.7209 17.7547 20.8837 18.0598 20.9145C18.3704 20.9453 18.6646 20.8353 18.8444 20.6285L19.9122 19.3745C19.9449 19.3349 19.9885 19.3261 20.0212 19.3261C20.0539 19.3261 20.0975 19.3305 20.1301 19.3657L21.9607 21.2006C22.1787 21.4162 22.5274 21.4998 22.8543 21.4206C23.1811 21.337 23.41 21.1082 23.4318 20.8309L24.3362 10.9261L24.9573 26.296C24.9736 26.6744 25.3386 26.9736 25.8072 26.9956C25.8235 26.9956 25.8399 26.9956 25.8562 26.9956C26.303 26.9956 26.6789 26.736 26.7443 26.3708L27.7631 20.5757C27.8721 19.9685 28.1063 19.3833 28.4605 18.8421L29.0107 18.0016L30.035 20.9409C30.1876 21.3854 30.6343 21.7066 31.1955 21.7858C31.7566 21.865 32.3124 21.6802 32.6447 21.3062L32.9226 20.9893H43.9879C44.7724 20.9893 45.5842 20.7165 46.1454 20.2589L47.4638 19.1941C47.7472 18.9653 48.1176 18.8289 48.5208 18.8025L50.2642 18.7012C50.5421 18.6836 50.7927 18.556 50.9289 18.358L51.9532 16.8532C52.0785 16.6684 52.291 16.5364 52.547 16.4836C52.8031 16.4308 53.0646 16.466 53.288 16.5804L54.3722 17.1392C55.3365 17.6364 56.0884 18.3844 56.4915 19.2469L57.0745 20.4921C57.1835 20.7253 57.445 20.8881 57.7501 20.9189C58.0606 20.9497 58.3548 20.8397 58.5346 20.6329L59.6025 19.3789C59.6352 19.3393 59.6787 19.3305 59.7114 19.3305C59.7441 19.3305 59.7877 19.3349 59.8204 19.3701L61.651 21.205C61.8689 21.4206 62.2176 21.5042 62.5445 21.425C62.8714 21.3414 63.1002 21.1126 63.122 20.8353L64.0264 10.9305L64.6475 26.3004C64.6639 26.6788 65.0289 26.978 65.4974 27C65.5138 27 65.5301 27 65.5465 27C65.9932 27 66.3692 26.7404 66.4345 26.3752L67.4533 20.5757C67.5623 19.9685 67.7966 19.3833 68.1507 18.8421L68.701 18.0016L69.7253 20.9409C69.8778 21.3854 70.3246 21.7066 70.8857 21.7858C71.4469 21.865 72.0026 21.6802 72.3349 21.3062L72.6128 20.9893H83.6781C84.4627 20.9893 85.2745 20.7165 85.8356 20.2589L87.1541 19.1941C87.4374 18.9653 87.8079 18.8289 88.211 18.8025L89.9545 18.7012C90.2323 18.6836 90.4829 18.556 90.6192 18.358L91.6434 16.8488C91.7687 16.664 91.9812 16.532 92.2373 16.4792C92.4933 16.4264 92.7549 16.4616 92.9782 16.576L94.0624 17.1348C95.0268 17.632 95.7786 18.38 96.1818 19.2425L96.7647 20.4877C96.8737 20.7209 97.1352 20.8837 97.4403 20.9145C97.7509 20.9453 98.0451 20.8353 98.2249 20.6285L99.2927 19.3745C99.3254 19.3349 99.369 19.3261 99.4017 19.3261C99.4344 19.3261 99.478 19.3305 99.5106 19.3657L101.341 21.2006C101.559 21.4162 101.908 21.4998 102.235 21.4206C102.562 21.337 102.79 21.1082 102.812 20.8309L103.717 10.9261L104.338 26.296C104.354 26.6744 104.719 26.9736 105.188 26.9956C105.204 26.9956 105.22 26.9956 105.237 26.9956C105.683 26.9956 106.059 26.736 106.125 26.3708L107.144 20.5713C107.253 19.9641 107.487 19.3789 107.841 18.8377L108.391 17.9972L109.415 20.9365C109.568 21.381 110.015 21.7022 110.576 21.7814C111.137 21.8606 111.693 21.6758 112.025 21.3018L112.303 20.9849H123.368C124.153 20.9849 124.965 20.7121 125.526 20.2545L126.844 19.1897C127.128 18.9609 127.498 18.8245 127.901 18.7981L129.645 18.6968C129.923 18.6792 130.173 18.5516 130.309 18.3536L131.334 16.8444C131.459 16.6596 131.671 16.5276 131.928 16.4748C132.184 16.422 132.445 16.4572 132.668 16.5716L133.753 17.1304C134.717 17.6276 135.469 18.3756 135.872 19.2381L136.455 20.4833C136.564 20.7165 136.825 20.8793 137.131 20.9101C137.441 20.9409 137.735 20.8309 137.915 20.6241L138.983 19.3701C139.016 19.3305 139.059 19.3217 139.092 19.3217C139.125 19.3217 139.168 19.3261 139.201 19.3613L141.031 21.1962C141.249 21.4118 141.598 21.4954 141.925 21.4162C142.252 21.3326 142.481 21.1038 142.503 20.8265L143.407 10.9217L144.028 26.2916C144.044 26.67 144.409 26.9692 144.878 26.9912C144.894 26.9912 144.911 26.9912 144.927 26.9912C145.374 26.9912 145.75 26.7316 145.815 26.3664L146.834 20.5669C146.943 19.9597 147.177 19.3745 147.531 18.8333L148.081 17.9928L149.106 20.9321C149.258 21.3766 149.705 21.6978 150.266 21.777C150.827 21.8562 151.383 21.6714 151.715 21.2974L151.993 20.9805H163.059C163.843 20.9805 164.655 20.7077 165.216 20.2501L166.535 19.1853C166.818 18.9565 167.188 18.8201 167.592 18.7937L169.335 18.6924C169.613 18.6748 169.863 18.5472 170 18.3492L171.024 16.84C171.149 16.6552 171.362 16.5232 171.618 16.4704C171.874 16.4176 172.135 16.4528 172.359 16.5672L173.443 17.126C174.407 17.6232 175.159 18.3712 175.562 19.2337L176.145 20.4789C176.254 20.7121 176.516 20.8749 176.821 20.9057C177.131 20.9365 177.426 20.8265 177.605 20.6197L178.673 19.3657C178.706 19.3261 178.749 19.3173 178.782 19.3173C178.815 19.3173 178.858 19.3217 178.891 19.3569L180.722 21.1918C180.94 21.4074 181.288 21.491 181.615 21.4118C181.942 21.3282 182.171 21.0994 182.193 20.8221L183.097 10.9173L183.718 26.2872C183.735 26.6656 184.1 26.9648 184.568 26.9868C184.585 26.9868 184.601 26.9868 184.617 26.9868C185.064 26.9868 185.44 26.7272 185.505 26.362L186.524 20.5625C186.633 19.9553 186.867 19.3701 187.221 18.8289L187.772 17.9884L188.796 20.9277C188.949 21.3722 189.395 21.6934 189.956 21.7726C190.518 21.8518 191.073 21.667 191.406 21.293L191.684 20.9761H201V19.7749H200.995Z"
          fill="#FF5F1B"
        />
      </g>
      <defs>
        <clipPath id="clip0_13361_34148">
          <rect width="188" height="27" fill="white" transform="translate(2)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const DownloadIcon = ({ onClick, fillColor }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      onClick={onClick}
      style={{ cursor: "pointer" }}
    >
      <path
        d="M19 13V14.2C19 15.8802 19 16.7202 18.673 17.362C18.3854 17.9265 17.9265 18.3854 17.362 18.673C16.7202 19 15.8802 19 14.2 19H5.8C4.11984 19 3.27976 19 2.63803 18.673C2.07354 18.3854 1.6146 17.9265 1.32698 17.362C1 16.7202 1 15.8802 1 14.2V13M15 8L10 13M10 13L5 8M10 13V1"
        // stroke="var(--primary-bg-color)"
        stroke={fillColor ? fillColor : "var(--primary-bg-color)"}
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
